const NAMESPACE = 'tds';
const CSS_NS = `${NAMESPACE}-`;
const MULTISELECT_CLASSES = {
  MULTISELECT: `${CSS_NS}multiselect`,
  CONTROL: `${CSS_NS}multiselect__control`,
  POPUP: `${CSS_NS}multiselect__popup`,
  SELECT_ALL: `${CSS_NS}multiselect__select-all`,
  SELECT_ALL_CHECKBOX: `checkbox-ind-all`,
  CHECK: `${CSS_NS}check`,
  CHECKBOX: `${CSS_NS}check__box`,
  CHECK_SELECTED: `${CSS_NS}check--selected`,
  CHECKLABEL: `${CSS_NS}check__label`,
  INPUT: `${CSS_NS}field__input`,
  FIELD: `${CSS_NS}field`,
  DISPLAY_SELECTED: `${CSS_NS}multiselect__input-div`,
  FIELDLABEL: `${CSS_NS}field__label`,
  COUNT: `item--count`,
  CARET: `item--caret`,
  EXPANDED: `expanded`,
  SELECTED: `selected`
};
const FILE_UPLOAD_CLASSES = {
  FILEUPLOAD: `${CSS_NS}fileupload`,
  DROPAREA: `${CSS_NS}filepicker`,
  INPUT: `${CSS_NS}filepicker__input`,
  BUTTON: `${CSS_NS}filepicker__trigger`,
  LABEL: `${CSS_NS}filepicker__label`,
  LIST: `${CSS_NS}fileupload__list`,
  LIST_TITLE: `${CSS_NS}fileupload__list-title`,
  DELETE_BUTTON: `${CSS_NS}file--delete`,
  FILE_STATUS: `${CSS_NS}file--status`,
  FILE_ACTIONS: `${CSS_NS}file__actions`,
  FILE_DETAIL: `${CSS_NS}file__detail`,
  FILE_NAME: `${CSS_NS}file__detail-name`,
  FILE_SIZE: `${CSS_NS}file__detail-size`,
  FILE_ERROR_MESSAGE: `${CSS_NS}file__detail-error-message`
};

/**
 * Functional wrapper around MutationObserver so we only have to check if it is defined once.
 * This is to prevent code does not run in the DOM (e.g. SSR, jsdom tests) from failing.
 * It also reduces the boilerplate code for working with the MutationObserver
 * @param target {node} The node to watch
 * @param options {MutationObserverInit} The options for MutationObserver
 * @param callback {MutationCallback} The callback function
 * @returns A function to disconnect the observer.
 */
function watchForChanges(target, options, callback) {
  let observer;
  const targets = Array.isArray(target) ? target : [target];
  if (typeof MutationObserver !== 'undefined') {
    observer = new MutationObserver(callback);
    targets.forEach(t => observer.observe(t, options));
  }
  return () => {
    observer && observer.disconnect();
    observer = undefined;
  };
}

/**
 * Calls a function when the DOM is loaded
 * @param callback {function} The function to call when the DOM is loaded
 */
const whenDOMReady = callback => {
  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', callback, {
      once: true
    });
  } else {
    callback();
  }
};

let watching$1 = false;
let nextId$d = 1;
const listeners = [];
const deferredNodes = [];
let deferredNodesRemoved = [];
function onDomChanges(selector, onNodeAdded, onNodeRemoved) {
  const id = nextId$d++;
  listeners.push({
    id,
    selector,
    onNodeAdded,
    onNodeRemoved
  });
  whenDOMReady(() => {
    if ('function' === typeof onNodeAdded) {
      const existingNodes = document.body.querySelectorAll(selector);
      onChildListUpdates(existingNodes);
    }
    if (!watching$1) {
      watchForChanges(document.body, {
        childList: true,
        subtree: true
      }, observerCallback);
      watching$1 = true;
    }
  });
  const cancel = () => {
    for (let i = 0; i < listeners.length; i++) {
      if (listeners[i].id === id) {
        listeners.splice(i, 1);
        break;
      }
    }
  };
  return cancel;
}
function resumeAutoEnhance() {
  if (typeof window !== 'undefined') {
    window.tdsPauseAutoEnhance = false;
    while (deferredNodes.length) {
      const {
        addedNodes,
        removedNodes
      } = deferredNodes.shift();
      onChildListUpdates(addedNodes, removedNodes);
    }
  }
}
function observerCallback(mutationList) {
  ////////////////////////////////////////////////////////////////////////
  // NOTE: The following is used by jest.setup.unit.js to support unit tests. Do not remove.
  // This is the onDomChangesMutationObserver
  ////////////////////////////////////////////////////////////////////////
  mutationList.forEach(mutation => {
    if (mutation.type === 'childList') {
      onChildListUpdates(mutation.addedNodes, mutation.removedNodes);
    }
  });
}
function onChildListUpdates(addedNodes, removedNodes) {
  if (typeof window !== 'undefined' && window.tdsPauseAutoEnhance) {
    deferredNodes.push({
      addedNodes,
      removedNodes
    });
    return;
  }
  if (removedNodes) {
    for (let i = 0; i < removedNodes.length; i++) {
      deferredNodesRemoved.push(removedNodes[i]);
    }
  }
  const nodesAdded = [];
  for (let i = 0; i < addedNodes.length; i++) {
    const node = addedNodes[i];
    const removedIX = deferredNodesRemoved.indexOf(node);
    if (removedIX > -1) {
      deferredNodesRemoved.splice(removedIX, 1);
    } else {
      nodesAdded.push(node);
    }
  }
  // handle the adds first, defer the removed a bit to be sure they just weren't moved.
  listeners.forEach(_ref => {
    let {
      selector,
      onNodeAdded
    } = _ref;
    if ('function' === typeof onNodeAdded && addedNodes && addedNodes.length) {
      dispatchUpdates(selector, nodesAdded, onNodeAdded);
    }
  });
  window.setTimeout(() => {
    // filter out nodes that have been reattached. In some cases, when a node is moved,
    // it will trigger a node removal but not a node add. 
    // So, filter out nodes that have been reattached (!document.contains(node))
    const nodesRemoved = deferredNodesRemoved.filter(node => !document.contains(node));
    deferredNodesRemoved = [];
    listeners.forEach(_ref2 => {
      let {
        selector,
        onNodeRemoved
      } = _ref2;
      if ('function' === typeof onNodeRemoved && nodesRemoved && nodesRemoved.length) {
        dispatchUpdates(selector, nodesRemoved, onNodeRemoved);
      }
    });
  }, 500);
}
function dispatchUpdates(selector, nodeList, callback) {
  const matchedNodes = [];
  for (let i = 0; i < nodeList.length; i++) {
    const node = nodeList[i];
    if (node instanceof HTMLElement) {
      if (node.matches(selector)) {
        matchedNodes.push(node);
      }
      const childNodes = node.querySelectorAll(selector);
      for (let j = 0; j < childNodes.length; j++) {
        matchedNodes.push(childNodes[j]);
      }
    }
  }
  matchedNodes.forEach(node => callback(node));
}

const storeInstances = {};
let id$7 = 1;
const instances$1 = {
  set(element, key, instance) {
    const el = element;
    if (typeof el.tdsEnhancers === 'undefined') {
      el.tdsEnhancers = {};
    }
    if (typeof el.tdsEnhancers[key] === 'undefined') {
      el.tdsEnhancers[key] = {
        id: id$7
      };
      id$7++;
    }
    storeInstances[el.tdsEnhancers[key].id] = instance;
  },
  get(element, key) {
    const el = element;
    if (!el || typeof el.tdsEnhancers === 'undefined' || typeof el.tdsEnhancers[key] === 'undefined') {
      return null;
    }
    return storeInstances[el.tdsEnhancers[key].id] || null;
  },
  remove(element, key) {
    const el = element;
    if (!el || typeof el.tdsEnhancers === 'undefined' || typeof el.tdsEnhancers[key] === 'undefined') {
      return;
    }
    delete storeInstances[el.tdsEnhancers[key].id];
    delete el.tdsEnhancers[key];
    if (Object.keys(el.tdsEnhancers).length === 0) {
      delete el.tdsEnhancers;
    }
  }
};

function store(initialValue) {
  let value = initialValue;
  const subscribers = [];
  function set(newValue) {
    if (newValue !== value) {
      value = newValue;
      subscribers.forEach(run => run(value));
    }
  }
  function update(v) {
    if (typeof v === 'function') {
      const fn = v;
      set(fn(value));
    } else {
      set({
        ...value,
        ...v
      });
    }
  }
  function get() {
    return value;
  }
  function subscribe(run) {
    subscribers.push(run);
    run(value);
    return () => {
      const index = subscribers.indexOf(run);
      if (index !== -1) {
        subscribers.splice(index, 1);
      }
    };
  }
  return {
    set,
    get,
    update,
    subscribe
  };
}

const ID_PARSER_RX$1 = /\b\S+\b/g;
const hasShadowDom = el => {
  return !!el.shadowRoot && !!el.attachShadow;
};
/**
 * The CustomElement polyfill StencilJS provides does something odd with the `children` property
 * of elements that would be in the shadow DOM. This function works around that by using `childNodes`
 * and filtering nodes that are Elements.
 * @param parentEl The parent element to return chuld elements of
 * @param selector Optional. if provided, returns just those elements that match the selector
 * @returns An arry of child elements
 */
function getChildElements(parentEl, selector) {
  const children = parentEl ? Array.from(parentEl.childNodes).filter(node => node.nodeType === Node.ELEMENT_NODE) : [];
  return selector ? children.filter(el => el.matches(selector)) : children;
}
function configFromDataAttributes(el) {
  let defaultConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let conversions = arguments.length > 2 ? arguments[2] : undefined;
  const config = {
    ...defaultConfig
  };
  for (let data in el.dataset) {
    const value = el.dataset[data];
    config[data] = value === 'true' || value === '' ? true : value === 'false' ? false : value;
    if (conversions) {
      convertDataAttribute(config, data, value, conversions);
    }
  }
  return config;
}
function watchDataAttributeChange(element, callback, conversions) {
  return watchForChanges(element, {
    attributes: true
  }, records => {
    records.forEach(_ref => {
      let {
        type,
        attributeName
      } = _ref;
      if (type === 'attributes' && attributeName) {
        const match = /^data-(.+)/.exec(attributeName);
        if (match) {
          const prop = match[1].replace(/-./g, m => m[1].toUpperCase());
          const value = element.getAttribute(attributeName);
          const config = {
            [prop]: value
          };
          if (conversions) {
            convertDataAttribute(config, prop, value, conversions);
          }
          callback(config);
        }
      }
    });
  });
}
function convertDataAttribute(config, property, value, conversions) {
  const propConversions = conversions.filter(conversion => {
    var _conversion$names;
    return conversion.convert && ((_conversion$names = conversion.names) === null || _conversion$names === void 0 ? void 0 : _conversion$names.includes(property));
  });
  propConversions.forEach(propConversion => {
    const {
      convert
    } = propConversion;
    let convertedValue;
    if (typeof convert === 'function') {
      convertedValue = convert(value, property, config);
    } else if (typeof convert === 'string') {
      switch (convert) {
        case 'integer':
          convertedValue = parseInt(value);
          break;
        case 'number':
          convertedValue = parseFloat(value);
          break;
        case 'function':
        case 'object':
          convertedValue = convertStringRef(value, convert);
          break;
        case 'json':
          if (/^[\{\[\"].+[\}\]\"]$/.test(value)) {
            try {
              convertedValue = JSON.parse(value);
            } catch {}
          }
          break;
      }
    }
    if (typeof convertedValue !== 'undefined') {
      config[property] = convertedValue;
    }
  });
}
function getConfigObjectFromString(name) {
  let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const parts = name.split('.');
  let ref = context;
  while (ref && parts.length > 1) {
    ref = ref[parts.shift()];
  }
  return ref && ref[parts[0]];
}
function convertStringRefs(config, names, type) {
  names.forEach(name => {
    const obj = convertStringRef(config[name], type);
    if (typeof obj !== 'undefined') {
      config[name] = obj;
    }
  });
}
function convertStringRef(value, type) {
  if ('string' === typeof value) {
    const obj = getConfigObjectFromString(value);
    if (type === typeof obj) {
      return obj;
    }
  }
  return undefined;
}
function getLabelledByLabel(el) {
  const labelledByIds = el.getAttribute('aria-labelledby');
  return labelledByIds ? labelledByIds.match(ID_PARSER_RX$1).map(id => {
    const labelledByEl = el.ownerDocument.getElementById(id);
    return labelledByEl && (labelledByEl.getAttribute('aria-label') || labelledByEl.textContent || '').trim();
  }).filter(label => label).join(' ').trim() : '';
}
function getLabelFor(el) {
  // start with aria label attributes
  let label = el.getAttribute('aria-label');
  let labelledby = el.getAttribute('aria-labelledby');
  if (!label && !labelledby && el.labels instanceof NodeList) {
    const labels = Array.from(el.labels);
    const ids = labels.map(label => label.id).filter(Boolean);
    if (ids.length === labels.length) {
      // all labels have ids, so set labelledby
      labelledby = ids.join(' ');
    } else {
      label = labels.map(label => {
        var _label$textContent;
        return (_label$textContent = label.textContent) === null || _label$textContent === void 0 ? void 0 : _label$textContent.trim();
      }).join(' ');
    }
  }
  return {
    label: label || undefined,
    labelledby: labelledby || undefined,
    describedby: el.getAttribute('aria-describedby') || undefined
  };
}
function htmlEncode(text) {
  return (text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
}
/**
 * Splits text between visual text and visually hidden text. Use this
 * for converting text from i18n or from configuration into markup that
 * visually hides portion of the text. Square brackets are used to demark
 * screen-reader-only text. e.g. "[show] menu" would become
 * "<span class="tds-sr-only">Show<span><span> menu</span>"
 * @param text The text to split
 * @param formatter A function to convert the text as needed. e.g.
 * Core would format html string and WC would retrun JSX
 * @returns An array of the items returns by formattter
 */
function splitTextForScreenReader(text, formatter) {
  const rx = /(\[[^\[\]]+\])/g;
  const parts = text.split(rx).filter(Boolean);
  return parts.map(part => {
    const srOnly = rx.test(part);
    part = srOnly ? part.substring(1, part.length - 1) : part;
    return formatter(part, srOnly);
  });
}
let _positionStickySupport;
function positionStickySupported() {
  if (typeof _positionStickySupport === 'undefined') {
    const style = document.createElement('div').style;
    style.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
    _positionStickySupport = style.position.indexOf('sticky') !== -1;
  }
  return _positionStickySupport;
}
let _pointerEventsSupport;
function pointerEventsSupported() {
  if (typeof _pointerEventsSupport === 'undefined') {
    const style = document.createElement('div').style;
    style.cssText = 'pointer-events:none';
    _pointerEventsSupport = !!style.pointerEvents && style.pointerEvents == 'none';
  }
  return _pointerEventsSupport;
}
/**
 * Returns the text an array of strings where split by the matching text.
 * The array items alternate between text before the matching text, then the matching text.
 * e.g. text = 'Banana Cream' and match = 'a' returns:
 * ['B', 'a', 'n', 'a', 'Cre', 'a', 'm']
 * This function is useful for highlighting matched text in a filter list.
 * When processing the array, (index % 2 === 0) is non-matching text, (index % 2 === 1) is the matching text
 * @param text The full text string
 * @param match The string to match on
 * @returns An array of alternating non-match and matching text
 */
function splitTextByMatch(text, match) {
  if (!match) {
    return [text];
  }
  const result = [];
  const parts = text.toLowerCase().split(match.toLowerCase());
  let length = 0;
  parts.forEach(part => {
    result.push(text.substr(length, part.length));
    length += part.length;
    if (length < text.length) {
      result.push(text.substr(length, match.length));
      length += match.length;
    }
  });
  return result;
}
/**
 * Visually hides an element so it is only read by a screen reader. Updates the element's style property
 * Use this when creating elements and you cann;t be certain that the `tds-sr-only` or similar class
 * is implemented.
 *
 * @param el
 */
function visuallyHide(el) {
  el.style.position = 'absolute';
  el.style.left = '-10000px';
  el.style.top = 'auto';
  el.style.width = '1px';
  el.style.height = '1px';
  el.style.overflow = 'hidden';
}
//////////////////////////////////////////////////////////////////////////////////////////
// courtesy of https://github.com/microsoft/sonder-ui/blob/master/src/shared/utils.ts
// check if an element is currently scrollable
function isScrollable(element) {
  return element && element.clientHeight < element.scrollHeight;
}
// ensure given child element is within the parent's visible scroll area
function maintainScrollVisibility(activeElement, scrollParent, includeMargin, scrollToTop) {
  const {
    offsetHeight,
    offsetTop
  } = activeElement;
  const {
    marginTop,
    marginBottom
  } = getComputedStyle(activeElement);
  const {
    clientHeight: parentClientHeight,
    scrollTop: parentScrollTop
  } = scrollParent;
  const isAbove = offsetTop < parentScrollTop;
  const isBelow = offsetTop + offsetHeight > parentScrollTop + parentClientHeight;
  if (isAbove || scrollToTop) {
    scrollParent.scrollTo(0, includeMargin ? offsetTop - parseInt(marginTop, 10) : offsetTop);
  } else if (isBelow) {
    scrollParent.scrollTo(0, offsetTop - parentClientHeight + (includeMargin ? offsetHeight + parseInt(marginBottom, 10) : offsetHeight));
  }
}
//////////////////////////////////////////////////////////////////////////////////////////
/**
 * Iterates through an array of class names applying each class name to the element until
 * it finds the one that positions element fully within the browser window. (Or, if in
 * a container with overflow not visible, that container's boundaries) If a class name is
 * not found, reverts to the first setting in the array. This is used primarily for
 * positioning popups for components such as combobox.
 * @param element The element whose position is checked as classes are applied
 * @param classes: string[] An array of classes to apply. An array item could be an empty string,
 * meaning check the element without any class names applied (likely the first item).
 * An array item could also be a space delimited list of multiple classes to apply.
 * @param applyClassTo The element to apply the class names to. If not passed, applies the class names to element.
 */
function bestPositionElement(element, classes) {
  let applyClassTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : element;
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  classes.forEach(classNames => {
    classNames.split(' ').forEach(cls => cls && applyClassTo.classList.remove(cls));
  });
  // add first option to end of list to fallback to the default
  classes = [...classes, classes[0]];
  let minTop = 0;
  let minLeft = 0;
  let maxRight = windowWidth;
  let maxBottom = windowHeight;
  // if the element is contained in an element that does not show overflow, constrain the element to those dimensions;
  // This logic is not 100%. An absolutely position element can break from its clipping ancestor its offset parent is also
  // positioned absolute. But that's too complicated and this serves our purpose for now
  let container = getOverflowParent(element);
  if (container) {
    const restoreHidden = element.hidden;
    element.hidden = true; // hide the element so it does not add scrollbars and change the dimensions of the container
    const {
      top: pTop,
      bottom: pBottom,
      left: pLeft,
      right: pRight
    } = container.getBoundingClientRect();
    minTop = Math.max(pTop, 0);
    minLeft = Math.max(pLeft, 0);
    maxRight = Math.min(pRight, windowWidth);
    maxBottom = Math.min(pBottom, windowHeight);
    element.hidden = restoreHidden;
  }
  for (let i = 0; i < classes.length; i++) {
    const classNames = classes[i];
    classNames.split(' ').forEach(cls => cls && applyClassTo.classList.add(cls));
    // if we are on the last (default) setting, keep that setting and don't retest
    if (i < classes.length - 1) {
      const {
        top,
        bottom,
        left,
        right
      } = element.getBoundingClientRect();
      if (top >= minTop && left >= minLeft && right <= maxRight && bottom <= maxBottom) {
        // fits
        break;
      }
      classNames.split(' ').forEach(cls => cls && applyClassTo.classList.remove(cls));
    }
  }
}
/**
 * Finds the parent element that clips overflow. Recognizes if element is slotted and steps through shadow DOM if needed
 * @param element The element to start from
 * @returns overflow parent or null if none found
 */
function getOverflowParent(element) {
  let parent = element.parentElement;
  if (element.assignedSlot) {
    parent = element.assignedSlot.parentElement;
  }
  if (!parent && element.parentNode) {
    parent = element.parentNode.host;
  }
  if (parent) {
    let {
      overflowX,
      overflowY
    } = window.getComputedStyle(parent);
    overflowX = overflowX || 'visible'; // to make the unit test pass
    overflowY = overflowY || 'visible'; // to make the unit test pass
    if (overflowX === 'visible' && overflowY == 'visible') {
      parent = getOverflowParent(parent);
    }
  }
  return parent;
}
/**
 * Applies attributes to an element using key value pairs. For each key in the attribute map,
 * if the key's value is undefined or null, removes the attribute; otherwise it sets the attribute,
 * converting the value to a string. Keys can be either camelCase or kebab-case.
 *
 * @param el The element to update.
 * @param attributes The attributes to set as a key/value map.
 */
function applyAttributes(el, attributes) {
  const {
    innerHTML,
    ...theRest
  } = attributes;
  attributes = theRest;
  Object.keys(attributes).forEach(key => {
    var _attributes$key;
    const attr = toKebabCase(key);
    const value = (_attributes$key = attributes[key]) === null || _attributes$key === void 0 ? void 0 : _attributes$key.toString();
    if (typeof value === 'undefined' || value === null) {
      el.removeAttribute(attr);
    } else if (el.getAttribute(attr) !== value) {
      el.setAttribute(attr, value);
    }
  });
}
/**
 * Uses a map to add or remove classes from an element. If the value of the key is true,
 * the key is added as a class; otherwise it is removed. Keys must be the exact class name to apply.
 *
 * @param el The element to update
 * @param classes A map of class names mapped to either true to add the class or false to remove it
 */
function applyClasses(el, classes) {
  Object.keys(classes).forEach(cls => {
    const mthd = classes[cls] ? 'add' : 'remove';
    el.classList[mthd](cls);
  });
}
/**
 * Updates the style property of an element using a map of key/values, where the key
 * is a style property. If the property is falsy, it is removed from the style; otherise
 * it is set.
 *
 * @param el The lement to update
 * @param styles The styles to apply as a key/value map
 */
function applyStyles(el, styles) {
  const cssStyles = Object.keys(styles);
  cssStyles.forEach(cssStyle => {
    const value = styles[cssStyle];
    const prop = toKebabCase(cssStyle);
    if (!value) {
      el.style.removeProperty(prop);
    } else {
      el.style.setProperty(prop, value);
    }
  });
}
/**
 * This function is a work around for jsdom, which throws the error "':focus-within' is not a valid selector".
 * (https://github.com/jsdom/jsdom/issues/3055)
 * This seems to be related to an issue with the nwsapi package. (https://github.com/dperini/nwsapi/issues/47)
 * We could update nwsapi to the latest version, but we can't be certain other applications
 * using TDS will be current. So, to prevent their unit tests from failing, we'll fallback
 * to checking if it contains a focused element.
 */
function hasFocus(element) {
  return element.matches(':focus') || !!element.querySelector(':focus');
}
/**
 * Replaces the content of an element with the content passed. Content can either by a string or an element,
 * or an array of these.
 *
 * @param el The element to update.
 * @param content The content to apply
 */
function applyContent(el, content) {
  while (el.lastChild) {
    el.lastChild.remove();
  }
  if (!Array.isArray(content)) {
    content = [content];
  }
  content.forEach(c => {
    if (c instanceof Element) {
      el.append(c);
    } else if (typeof c === 'string') {
      el.append((el.ownerDocument || document).createTextNode(c));
    }
  });
}
function toKebabCase(str) {
  return str.replace(/[A-Z]/g, function (M, i) {
    const m = M.toLowerCase();
    return i === 0 ? m : `-${m}`;
  }).replace(/--/g, '-');
}
/**
 * Adds a leading 0 to single digits. Returns one of three strings:
 * - If the number is less than 10, returns the number with a leading 0
 * - If the number is greater than 10, returns the number unchanged
 * - If a string is provided and it evaluates to NaN, returns an empty string
 *
 * @param value The digit to append to. Can be a string or a number.
 */
function to2Digits$1(value) {
  const num = typeof value === 'string' ? parseInt(value, 10) : value;
  return !isNaN(num) ? num < 10 ? `0${num}` : num.toString() : '';
}

/**
 * Tests whether or not the parameter passed in is a valid date instance
 * Only validates against a Date object. Does not validate strings
 * @param date The date instance to evaluate
 * @return {boolean} True if the parameter is a Date instance with a valid date
 */
function isValidDateInstance(date) {
  return !!(date && date instanceof Date && !isNaN(date.getDate()));
}
/**
 * Parses a string into a date.
 * @param str {string} The string to parse
 * @param localeFormat {string} The locale format, e.g. MM-DD-YYYY
 * @return Date or null if not valid date
 */
function parseDate(str, localeFormat) {
  const ISO_RX = /^(\d{4})-(\d{2})-(\d{2})/; // YYYY-MM-DD
  const DELIMITED_RX = /^(\d+)\D(\d+)\D(\d+)$/; // 3 sets of numbers with any delimiter
  const NOT_DELIMITER_RX = /^\d{8}$/; // 8 numbers
  const ISO_ATTEMPT_RX = /^([^-]{0,4})-([^-]{0,2})-([^-]{0,2})$/; // has 2 dashes with optional characters in between
  let dateStr = str;
  let date = null;
  if (str) {
    if (!ISO_RX.test(str)) {
      const formatParts = localeFormat.split('/');
      let parts;
      // try to convert other formats into an ISO formatted string
      const delimitedMatch = DELIMITED_RX.exec(str);
      if (delimitedMatch) {
        // try locally formatted date such as MM/DD/YYYY or DD.MM.YYYY
        parts = formatParts.reduce((map, placeholder, i) => {
          map[placeholder] = delimitedMatch[i + 1];
          return map;
        }, {});
      } else if (NOT_DELIMITER_RX.test(str)) {
        // 8-digits
        // try local date formatted without
        let offset = 0;
        parts = formatParts.reduce((map, placeholder) => {
          map[placeholder] = dateStr.substring(offset, offset + placeholder.length);
          offset += placeholder.length;
          return map;
        }, {});
      }
      if (parts) {
        dateStr = `${parts.YYYY}-${`0${parts.MM}`.slice(-2)}-${`0${parts.DD}`.slice(-2)}`;
      }
    }
    const ISO_MATCH = ISO_RX.exec(dateStr);
    if (ISO_MATCH) {
      date = new Date(parseInt(ISO_MATCH[1]), parseInt(ISO_MATCH[2]) - 1, parseInt(ISO_MATCH[3]), 0, 0, 0, 0);
      const dateStr2 = toISODate(date);
      if (dateStr.substring(0, 10) !== dateStr2.substring(0, 10)) {
        // if date parts change, e.g 2020-04-31 becomes 2020-05-01,
        // then it is not a valid date
        date = null;
      }
    }
    if (!isValidDateInstance(date) && !ISO_ATTEMPT_RX.test(str)) {
      // try string as entered
      date = new Date(str);
      if (!isValidDateInstance(date)) {
        date = null;
      }
    }
  }
  return date;
}
function getHours(hour, period) {
  const hourNum = parseInt(hour, 10);
  if (period) {
    if (period.toLowerCase() === 'am' && hour === '12') {
      return {
        hour12: hour,
        hour24: '00'
      };
    }
    if (period.toLowerCase() === 'pm' && hourNum < 12) {
      return {
        hour12: hour,
        hour24: (hourNum + 12).toString()
      };
    }
  } else {
    if (hourNum === 0) {
      return {
        hour12: '12',
        hour24: hour
      };
    }
    if (hourNum > 12) {
      return {
        hour12: (hourNum - 12).toString(),
        hour24: hour
      };
    }
  }
  return {
    hour12: hour,
    hour24: hour
  };
}
function parseTime(str) {
  const TIME_RX = /^(?<hour>\d?\d)?:?(?<minute>\d\d)? ?(?<period>AM|PM)?$/i;
  const result = TIME_RX.exec(str.replace(/\s/g, ''));
  if (!result) {
    return null;
  }
  const {
    groups: {
      hour,
      minute,
      period
    }
  } = result;
  if (!hour || !minute || period && parseInt(hour, 10) > 12 || !period && parseInt(hour, 10) > 23 || parseInt(minute, 10) > 59) {
    return {
      parts: {
        hour12: hour ?? '',
        hour24: hour ?? '',
        minute: minute ?? '',
        period: (period === null || period === void 0 ? void 0 : period.toUpperCase()) ?? ''
      }
    };
  }
  const date = new Date();
  const {
    hour12,
    hour24
  } = getHours(hour, period);
  date.setHours(parseInt(hour24, 10), parseInt(minute, 10), 0, 0);
  const periodValue = period ? period.toUpperCase() : parseInt(hour24, 10) < 12 ? 'AM' : 'PM';
  return {
    date,
    parts: {
      hour12: to2Digits$1(hour12),
      hour24: to2Digits$1(hour24),
      minute: to2Digits$1(minute),
      period: periodValue
    }
  };
}
/**
 * Formats a Date in ISO format without time (YYYY-MM-DD)
 * @param date {Date} The date to format
 * @return {string} The formatted date
 */
function toISODate(date) {
  const yy = date.getFullYear();
  const mm = `0${date.getMonth() + 1}`.slice(-2);
  const dd = `0${date.getDate()}`.slice(-2);
  return [yy, mm, dd].join('-');
}
/**
 * Formats a date into a readable string - day date month year. e.g. Monday 4 February 2019
 * @param date
 * @param lang
 * @return {*}
 */
function toReadableDate(date, lang) {
  if (!date || isNaN(date.getDate())) {
    return '';
  }
  const day = lang.days[date.getDay()].name;
  const month = lang.months[date.getMonth()].name;
  return `${day} ${date.getDate()} ${month} ${date.getFullYear()}`;
}
function configureDates(config, format) {
  const dateConfig = {
    dueDate: stringifyConfigDate(config.dueDate, format),
    ...setMinMaxOptions(config.min, config.max, format),
    ...configureDisabledDates(config)
  };
  return {
    ...config,
    ...removeUndefined(dateConfig)
  };
}
function stringifyConfigDate(date, format) {
  if (date) {
    switch (typeof date) {
      case 'string':
        const dt = parseDate(date, format);
        return dt && toISODate(dt) || undefined;
      default:
        return isValidDateInstance(date) && toISODate(date) || undefined;
    }
  }
  return undefined;
}
function setMinMaxOptions(minIn, maxIn, format) {
  const min_max = [minIn, maxIn].map(d => stringifyConfigDate(d, format));
  let [min, max] = min_max;
  if (min && max && min > max) {
    min = max = null;
  }
  return {
    min,
    max
  };
}
function configureDisabledDates(config) {
  const DATE_RANGE_RX = /(\d{4}-\d{2}-\d{2})\s*-\s*(\d{4}-\d{2}-\d{2})/;
  let {
    disabledDates
  } = config;
  if (typeof disabledDates === 'string' && disabledDates.length && disabledDates[0].match(/\"|{|\[/)) {
    try {
      disabledDates = JSON.parse(disabledDates);
    } catch {}
  }
  if (typeof disabledDates === 'string') {
    disabledDates = disabledDates.split(',').filter(s => !!s).map(s => s.trim());
  }
  if (disabledDates) {
    disabledDates = [].concat(disabledDates);
    for (let i = 0; i < disabledDates.length; i++) {
      if (typeof disabledDates[i] === 'string') {
        // if formatted as a range (YYYY-MM-DD - YYYY-MM-DD), convert to range object
        const rangeMatch = DATE_RANGE_RX.exec(disabledDates[i]);
        if (rangeMatch) {
          disabledDates[i] = {
            from: rangeMatch[1],
            to: rangeMatch[2]
          };
        } else {
          // check if it's a disable function
          const fn = getConfigObjectFromString(disabledDates[i]);
          if ('function' === typeof fn) {
            disabledDates[i] = fn;
          }
        }
      } else if (disabledDates[i] instanceof Date) {
        disabledDates[i] = stringifyConfigDate(disabledDates[i]);
      } else if (typeof disabledDates[i] === 'object') {
        // assume a range object, convert dates to YYYY-MM-DD format
        if (disabledDates[i].from instanceof Date) {
          disabledDates[i].from = stringifyConfigDate(disabledDates[i].from);
        }
        if (disabledDates[i].to instanceof Date) {
          disabledDates[i].to = stringifyConfigDate(disabledDates[i].to);
        }
      }
    }
  }
  return disabledDates ? {
    disabledDates: [].concat(disabledDates)
  } : {};
}
function getDateValidity(config, valueAsDate, valueAsISOString) {
  const {
    min,
    max,
    disabledDates,
    required
  } = config;
  const validity = {
    valid: true
  };
  if (valueAsISOString) {
    if (!valueAsDate) {
      validity.badInput = true;
      validity.valid = false;
    } else {
      if (min && valueAsISOString < min) {
        validity.rangeUnderflow = true;
        validity.valid = false;
      }
      if (max && valueAsISOString > max) {
        validity.rangeOverflow = true;
        validity.valid = false;
      }
      if (isDateDisabled(disabledDates, valueAsDate, valueAsISOString)) {
        validity.unavailable = true;
        validity.valid = false;
      }
    }
  } else if (required) {
    validity.valueMissing = true;
    validity.valid = false;
  }
  return validity;
}
function getTimeValidity(value, config) {
  var _parseTime, _parseTime2, _parseTime3;
  const {
    min,
    max,
    required,
    minuteIncrement,
    cycle
  } = config;
  const date = typeof value === 'string' ? (_parseTime = parseTime(value)) === null || _parseTime === void 0 ? void 0 : _parseTime.date : value;
  const minAsDate = min && ((_parseTime2 = parseTime(min)) === null || _parseTime2 === void 0 ? void 0 : _parseTime2.date);
  const maxAsDate = max && ((_parseTime3 = parseTime(max)) === null || _parseTime3 === void 0 ? void 0 : _parseTime3.date);
  const timeEntered = !!value && !!value.trim();
  if (required && !timeEntered) {
    return {
      valid: false,
      valueMissing: true
    };
  }
  if (!date) {
    if (timeEntered) {
      return {
        valid: false,
        badInput: true
      };
    }
  } else {
    if (isNaN(date.getTime())) {
      return {
        valid: false,
        badInput: true
      };
    }
    if (cycle === '12' && !value.match(/AM|PM/)) {
      return {
        valid: false,
        badInput: true
      };
    }
    if (minuteIncrement > 1) {
      const minutes = date.getMinutes();
      if (minutes % minuteIncrement > 0) {
        return {
          valid: false,
          badInput: true
        };
      }
    }
    if (minAsDate && date < minAsDate) {
      return {
        valid: false,
        rangeUnderflow: true
      };
    }
    if (maxAsDate && date > maxAsDate) {
      return {
        valid: false,
        rangeOverflow: true
      };
    }
  }
  return {
    valid: true
  };
}
function isDateDisabled(disabledDates, date) {
  let dateStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : toISODate(date);
  let disabled = false;
  if (disabledDates) {
    for (let i = 0; i < disabledDates.length; i++) {
      switch (typeof disabledDates[i]) {
        case 'string':
          {
            disabled = disabledDates[i] === dateStr;
            break;
          }
        case 'object':
          {
            const from = disabledDates[i].from;
            const to = disabledDates[i].to;
            disabled = from && dateStr >= from && to && dateStr <= to;
            break;
          }
        case 'function':
          {
            const fn = disabledDates[i];
            disabled = fn(date);
            break;
          }
      }
      if (disabled) break;
    }
  }
  return disabled;
}
function endOfMonth(month, year) {
  return new Date(year, month + 1, 0);
}
function startOfMonth(month, year) {
  return new Date(year, month, 1);
}
function removeUndefined(config) {
  const configOut = {};
  for (const key of Object.keys(config)) {
    const val = config[key];
    if ('undefined' !== typeof val) {
      configOut[key] = val;
    }
  }
  return configOut;
}

function checkFlag(el, flag) {
  var _el$closest;
  const attrName = `data-${flag.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)}`;
  const flagValue = (_el$closest = el.closest(`[${attrName}]`)) === null || _el$closest === void 0 || (_el$closest = _el$closest.dataset) === null || _el$closest === void 0 ? void 0 : _el$closest[flag];
  return flagValue !== undefined && flagValue !== 'false';
}

const languages = {
  default: 'en',
  en: {
    // date-input/calendar
    year: 'Year',
    month: 'Month',
    current: 'current',
    minimum: 'minimum',
    maximum: 'maximum',
    today: 'Today',
    nextYear: 'Next year',
    nextMonth: 'Next month',
    prevYear: 'Previous year',
    prevMonth: 'Previous month',
    calendar: 'Calendar',
    pageUp: 'Page Up',
    pageDown: 'Page Down',
    escapeLabel: "Press escape to close calendar",
    altKey: 'Alt',
    optionKey: 'Option',
    day: 'Day',
    showCalendar: 'show calendar',
    months: [{
      name: 'January',
      abbr: 'Jan'
    }, {
      name: 'February',
      abbr: 'Feb'
    }, {
      name: 'March',
      abbr: 'Mar'
    }, {
      name: 'April',
      abbr: 'Apr'
    }, {
      name: 'May',
      abbr: 'May'
    }, {
      name: 'June',
      abbr: 'Jun'
    }, {
      name: 'July',
      abbr: 'Jul'
    }, {
      name: 'August',
      abbr: 'Aug'
    }, {
      name: 'September',
      abbr: 'Sep'
    }, {
      name: 'October',
      abbr: 'Oct'
    }, {
      name: 'November',
      abbr: 'Nov'
    }, {
      name: 'December',
      abbr: 'Dec'
    }],
    days: [{
      name: 'Sunday',
      abbr: 'Sun',
      initial: 'S'
    }, {
      name: 'Monday',
      abbr: 'Mon',
      initial: 'M'
    }, {
      name: 'Tuesday',
      abbr: 'Tue',
      initial: 'T'
    }, {
      name: 'Wednesday',
      abbr: 'Wed',
      initial: 'W'
    }, {
      name: 'Thursday',
      abbr: 'Thu',
      initial: 'T'
    }, {
      name: 'Friday',
      abbr: 'Fri',
      initial: 'F'
    }, {
      name: 'Saturday',
      abbr: 'Sat',
      initial: 'S'
    }],
    // accordion
    accordionCollapsed: 'content collapsed, button',
    accordionExpanded: 'content expanded, button',
    // search
    searchButtonLabel: 'submit search',
    searchButtonTitle: "Search",
    searchLabel: 'Enter your search below',
    // sorted content
    ascending: 'ascending',
    descending: 'descending',
    htmlTableIs: 'Table {0} is ',
    tableSortStateDescription: 'sorted by {0}, {1}',
    notSorted: 'not sorted',
    sortColumnDescription: "Sorts by this column",
    dismissAlert: "dismiss message",
    dismissModal: "dismiss dialog",
    column: 'column',
    // row selection
    rowSelectorHeading: 'Row selector',
    singleRowSelectorHeading: 'Single row selector',
    selectRowLabel: 'Select row',
    selectAllRowsLabel: 'Select all rows',
    // expandable rows
    expandColumnHeader: 'expand or collapse row',
    expandableRowToggleLabel: 'expand this row',
    expandadedRowHeader: 'additional information for the prior row',
    // combo box, et al
    noOptionsMessage: 'No results',
    hasOptionsMessage: '{0} results available',
    hasOneOptionMessage: '1 result available',
    optionsLoadingMessage: 'Loading options...',
    addOtherPrompt: 'add "{name}"',
    optionsSelectedTpl: '{count} items selected; 1 item selected',
    optionsSPluselectedTpl: '+{count} more',
    optionsSearchLabel: "Search list of options",
    optionTagDescription: "click to deselect",
    listboxLabel: "options",
    selectDialogLabel: "options list",
    selectDialogDescriptionFilter: 'a search box before the list',
    selectDialogDescriptionActions: 'select all and clear buttons after the list',
    // multiSelect
    optionsSelected: '{0} options selected',
    allOptionsSelected: 'All {0} options selected',
    // for unit test
    color: 'color',
    interpolate: '{0} {1} {2} - {2} {1} {0}',
    //file upload
    uploadStarted: "upload started",
    fileUploadErrorAlert: "Upload failed",
    filePickerLabel: "browse",
    filePickerAriaLabel: "Choose files to upload",
    dragdropLabel: "Drag and drop or",
    fileTitleErrorAlert: "File not selected;Files not selected",
    fileSizeErrorAlert: "exceeds the maximum file size of {maxsize}. Please try selecting a different file.",
    fileTypeErrorAlert: "is not a valid file type. Please try selecting a different file.",
    fileMaxExceededErrorAlert: "Number of files selected ({filecount}) would exceed the maximum files allowed of {maxcount}.",
    fileMaxAllowedErrorAlert: "You have already selected the maximum number of files allowed ({maxcount}). To select other files, remove one or more files.",
    fileDuplicateErrorAlert: "has already been selected",
    fileAsycUploadTitle: "File uploaded;Files uploaded",
    fileSyncUploadTitle: "File upload preview;Files upload preview",
    confirmRemovalOf: 'Remove the file',
    // search pagination
    paginationLabel: 'Pagination',
    paginationDescr: 'page {page} of {total}',
    paginationPageLabel: 'Go to page {page}',
    paginationPrevLabel: 'Previous page',
    paginationNextLabel: 'Next page',
    paginationPlaceholderRange: 'skipping {start} to {end}',
    paginationPlaceholderMany: 'skipping {start} and higher',
    // table pagination
    rowPerPageText: 'Rows per page {size}',
    pageXofY: "Page {page} of {total}",
    pageX: "Page {page}",
    manyText: "many",
    all: "all",
    showingRecordsTextWithoutTotal: "Showing {start}–{end}",
    showingRecordsText: "Showing {start}–{end} of {total}",
    previousLabel: "previous",
    nextLabel: "next",
    // editable table
    nowEditingRow: "Now editing row {0}",
    rowColumnsEditable: "Columns {0} are editable",
    rowColumnEditable: "Column {0} are editable",
    rowActionsColumn: "Save and Cancel buttons are in column {0}",
    applyingUpdates: "Applying updates",
    updatesComplete: "Updates complete",
    updatesCompleteWithErrors: "Updates not applied. Please review columns {0}",
    updatesCompleteWithOneError: "Updates not applied. Please review column {0}",
    // menu nav toggle
    showMenu: '[Show] Menu',
    closeMenu: 'Close [menu]',
    // general
    and: 'and',
    with: 'with',
    home: 'Home',
    close: 'Close',
    show: 'Show',
    menu: 'Menu',
    loading: 'Loading',
    undo: 'Undo',
    remove: 'Remove',
    cancel: 'Cancel',
    save: 'Save',
    editable: 'editable',
    readonly: 'read only',
    other: 'Other',
    clear: 'Clear',
    selectAll: 'Select All',
    selected: 'Selected',
    search: 'Search',
    hour: "Hour",
    minute: 'Minute',
    period: "AM PM",
    toggleTimePicker: 'Toggle time picker',
    timePicker: 'Time picker'
  },
  // additional languages are for unit tests now
  "en-gb": {
    color: 'colour'
  },
  fr: {
    year: 'Année',
    ascending: 'ascendant',
    descending: 'descendant',
    sortColumnDescription: "Trie cette colonne",
    tableSortStateDescription: 'trié par {0}, {1}'
  },
  "fr-ca": {
    tire: 'robeur'
  }
};
function translations(lang) {
  if ('string' !== typeof lang) {
    // hopefully, it's an Element
    lang = getLang(lang);
  }
  lang = lang.toLowerCase();
  const langParts = lang.split('-');
  const language = langParts.reduce((acc, _, index) => {
    const langCode = langParts.slice(0, index + 1).join('-');
    const l = languages[langCode];
    return l ? {
      ...acc,
      ...l
    } : acc;
  }, lang.indexOf(languages.default) === -1 ? languages[languages.default] : {});
  return {
    t: function (key) {
      for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        replacements[_key - 1] = arguments[_key];
      }
      return translate(language, key, ...replacements);
    },
    html: function (key) {
      for (var _len2 = arguments.length, replacements = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        replacements[_key2 - 1] = arguments[_key2];
      }
      return htmlEncode(translate(language, key, ...replacements));
    },
    language
  };
}
function translate(language, key) {
  let value = language[key] || '';
  if ('string' === typeof value) {
    for (var _len3 = arguments.length, replacements = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      replacements[_key3 - 2] = arguments[_key3];
    }
    // replace positional substitions.
    // e.g. {0} is replaced with replacements[0], {1} is replaced with replacements[1], etc.
    value = replacements.reduce((v, r, i) => {
      return v.replace(new RegExp(`\\{${i}\\}`, 'g'), r);
    }, value);
  }
  return value;
}
function getLang(element) {
  let lang;
  let node = element;
  while (!lang && node) {
    lang = node.lang;
    node = node.parentNode || node.host;
  }
  return lang || window.navigator.language || 'en-US'; //default is fallback for unit tests
}

const firstDayOfWeekMap = {
  Sunday: ['us', 'ar', 'bz', 'bo', 'br', 'ca', 'ch', 'cn', 'co', 'cr', 'do', 'ec', 'sv', 'gt', 'hn', 'hk', 'il', 'jm', 'jp', 'ke', 'mo', 'mx', 'ni', 'pa', 'pe', 'ph', 'pr', 'za', 'kr', 'tw', 've', 'zm'],
  Saturday: ['af', 'dz', 'bh', 'eg', 'ir', 'iq', 'jo', 'kw', 'ly', 'om', 'qa', 'sa', 'sy', 'ae', 'zm']
};
function getLocale(element) {
  const host = element ? element.getRootNode().host : null;
  element = host || element;
  const langAttr = getLang(element).toLowerCase();
  const locale = !checkFlag(element, 'useBrowserLocale') ? langAttr : window.navigator.language;
  const lang = translations(langAttr).language;
  const country = locale.toLowerCase().split('-')[1] || ((locale || '').toLowerCase() === 'en' ? 'us' : 'iso');
  const dateFormat = deriveDateFormat(locale);
  const firstDayOfWeek = getFirstDayOfWeek(country);
  const dateFormatLabel = dateFormat.replace(/MM/i, lang.month).replace(/DD/i, lang.day).replace(/YYYY/i, lang.year).replace(/\//g, ' ').toLowerCase();
  const hourCycle = new Intl.DateTimeFormat(locale, {
    // needs some sort of time config for hour12 to be defined
    hour: 'numeric'
  }).resolvedOptions().hour12 ? '12' : '24';
  return {
    dateFormat,
    firstDayOfWeek,
    dateFormatLabel,
    hourCycle
  };
}
function getFirstDayOfWeek(country) {
  if (firstDayOfWeekMap.Sunday.indexOf(country) > -1) {
    return 0;
  }
  if (firstDayOfWeekMap.Saturday.indexOf(country) > -1) {
    return 6;
  }
  return 1; // Monday
}

function deriveDateFormat(lang) {
  const dateStr = Intl.DateTimeFormat(lang).format(new Date(1987, 11, 30, 0, 0, 0)).replace(/\D/g, '');
  // dateStr is an 8 digit string, convert to MM, DD, YYYY
  return dateStr.split(/(1987|12|30)/).filter(Boolean).join('/').replace('12', 'MM').replace('30', 'DD').replace('1987', 'YYYY');
}

function calcGoToDate(activeDate, action, locale, dateStr) {
  const {
    firstDayOfWeek
  } = locale;
  let goToYear = activeDate.getFullYear();
  let goToMonth = activeDate.getMonth();
  let goToDay = activeDate.getDate();
  let change = 1;
  action = action.replace(/^([+-])/, $ => {
    if ($ === '-') {
      change = -1;
    }
    return '';
  });
  switch (action) {
    case 'year':
      goToYear += change;
      break;
    case 'month':
      goToMonth += change;
      break;
    case 'day':
      goToDay += change;
      break;
    case 'week':
      goToDay += change * 7;
      break;
    case 'eow':
      const relativeDayOfWeek = (activeDate.getDay() + 7 - firstDayOfWeek) % 7;
      goToDay += (change === -1 ? 0 : 6) - relativeDayOfWeek;
      break;
    case 'today':
      const today = new Date();
      goToYear = today.getFullYear();
      goToMonth = today.getMonth();
      goToDay = today.getDate();
      break;
    case 'goto':
      const dateParts = dateStr.split('-');
      goToYear = parseInt(dateParts[0]);
      goToMonth = parseInt(dateParts[1]) - 1;
      goToDay = parseInt(dateParts[2]);
  }
  if (goToYear !== activeDate.getFullYear() || goToMonth !== activeDate.getMonth() || goToDay !== activeDate.getDate()) {
    const newActiveDate = new Date(goToYear, goToMonth, goToDay);
    if (goToDay === activeDate.getDate() && newActiveDate.getMonth() !== (goToMonth + 12) % 12) {
      // moved from one month to another month without that day
      // move to end of month
      newActiveDate.setDate(0);
    }
    return newActiveDate;
  } else {
    return activeDate;
  }
}

function createStore$8(calendar) {
  const {
    selectedDate
  } = calendar;
  let date;
  if (selectedDate) {
    date = 'string' === typeof selectedDate ? parseDate(selectedDate, 'YYYY-MM-DD') : selectedDate;
  }
  return store({
    activeDate: date || new Date()
  });
}
function getCalendarData(calendar) {
  return buildMonthData(calendar);
}
///////////////////////////////////////////////////////////////////////////////////////
function buildMonthData(calendar) {
  const localeInfo = getLocale(calendar.el);
  const {
    firstDayOfWeek
  } = localeInfo;
  const lang = translations(getLang(calendar.el)).language;
  const activeDate = calendar.state.activeDate;
  const month = activeDate.getMonth();
  const year = activeDate.getFullYear();
  const monthName = lang.months[month].name;
  const week = [0, 1, 2, 3, 4, 5, 6];
  const weekdays = week.map(ix => {
    const day = (ix + firstDayOfWeek) % 7;
    return {
      name: lang.days[day].name,
      abbreviation: lang.days[day].initial
    };
  });
  const calendarLabel = lang.calendar;
  return {
    calendarLabel,
    month,
    year,
    monthName,
    title: `${monthName} ${year}`,
    weekdays,
    weeks: buildCalendarDays(calendar, localeInfo, lang),
    controls: buildControlLabels(calendar, localeInfo, lang)
  };
}
function buildControlLabels(calendar, localeInfo, lang) {
  const activeDate = calendar.state.activeDate;
  const {
    min,
    max
  } = calendar.config;
  const isMac = /^mac/i.test(window.navigator.platform);
  const metaKeyTitle = isMac ? '&#x2325;' : lang.altKey;
  const metaKeyLabel = isMac ? lang.optionKey : lang.altKey;
  const prevYearTitle = `${lang.prevYear} (${metaKeyTitle}+${lang.pageUp})`;
  const prevYearLabel = `${lang.prevYear} (${metaKeyLabel}+${lang.pageUp})`;
  const nextYearTitle = `${lang.nextYear} (${metaKeyTitle}+${lang.pageDown})`;
  const nextYearLabel = `${lang.nextYear} (${metaKeyLabel}+${lang.pageDown})`;
  const prevMonthLabel = `${lang.prevMonth} (${lang.pageUp})`;
  const nextMonthLabel = `${lang.nextMonth} (${lang.pageDown})`;
  const todayLabel = lang.today;
  const todaysDate = toISODate(new Date());
  const todayAccesskey = lang.today.toLowerCase().substring(0, 1);
  const disabledDates = calendar.config.disabledDates;
  const outOfRange = min && min > todaysDate || max && max < todaysDate;
  const excludeToday = outOfRange || isDateDisabled(disabledDates, new Date(), todaysDate);
  return {
    prevYear: {
      label: prevYearLabel,
      title: prevYearTitle,
      disabled: actionDisabled(activeDate, '-year', min, max, localeInfo)
    },
    nextYear: {
      label: nextYearLabel,
      title: nextYearTitle,
      disabled: actionDisabled(activeDate, '+year', min, max, localeInfo)
    },
    prevMonth: {
      label: prevMonthLabel,
      title: prevMonthLabel,
      disabled: actionDisabled(activeDate, '-month', min, max, localeInfo)
    },
    nextMonth: {
      label: nextMonthLabel,
      title: nextMonthLabel,
      disabled: actionDisabled(activeDate, '+month', min, max, localeInfo)
    },
    today: {
      label: todayLabel,
      title: `( ${todayAccesskey.toUpperCase()} )`,
      accessKey: todayAccesskey,
      include: !(calendar.config.notoday || excludeToday),
      action: 'select',
      date: todaysDate
    }
  };
}
function buildCalendarDays(calendar, localeInfo, lang) {
  const {
    selectedDate
  } = calendar;
  const activeDate = calendar.state.activeDate;
  const {
    firstDayOfWeek
  } = localeInfo;
  const {
    config
  } = calendar;
  const min = config.min && ensureDateString$1(config.min);
  const max = config.max && ensureDateString$1(config.max);
  const dueDate = config.dueDate && ensureDateString$1(config.dueDate);
  const disabledDates = config.disabledDates;
  const year = activeDate.getFullYear();
  const month = activeDate.getMonth();
  const activeDateStr = toISODate(activeDate);
  const todayStr = toISODate(new Date());
  const start = startOfMonth(month, year);
  const end = endOfMonth(month, year);
  const startDayOfWeek = (start.getDay() + 7 - firstDayOfWeek) % 7;
  const endDate = end.getDate();
  // Builds an array of numbers for as many full weeks needed to display the month
  // Each number represents the number of days into the month
  // if a month starts after 1st day of the week, first numbers will be negative
  const totalDays = 7 * Math.ceil((endDate + startDayOfWeek) / 7);
  const monthDay1 = -startDayOfWeek + 1;
  const days = [];
  for (let i = 0; i < totalDays; i++) {
    days[i] = monthDay1 + i;
  }
  const dayData = days.map(day => {
    const date = new Date(year, month, day, 0, 0, 0);
    const dateStr = toISODate(date);
    const isCurrentDate = dateStr === todayStr;
    const labelDescriptors = [];
    if (isCurrentDate) {
      labelDescriptors.push(lang.current);
    }
    if (dateStr === min) {
      labelDescriptors.push(lang.minimum);
    }
    if (dateStr === max) {
      labelDescriptors.push(lang.maximum);
    }
    const labelDescription = labelDescriptors.length ? ` (${labelDescriptors.join()})` : '';
    const label = `${toReadableDate(date, lang)}${labelDescription}`;
    const outOfRange = min && min > dateStr || max && max < dateStr;
    const disabled = outOfRange || isDateDisabled(disabledDates, date, dateStr);
    const current = isCurrentDate ? 'date' : null;
    const action = outOfRange ? false : disabled ? 'goto' : 'select';
    const active = activeDateStr === dateStr;
    const selected = selectedDate === dateStr;
    const isOutsideOfMonth = month !== date.getMonth();
    const isDueDate = dateStr === dueDate;
    return {
      date,
      dateStr,
      label,
      isOutsideOfMonth,
      isDueDate,
      isCurrentDate: current,
      selected,
      attributes: {
        role: "button",
        tabindex: action ? active ? '0' : '-1' : undefined,
        'aria-pressed': selected ? 'true' : undefined,
        'aria-label': label,
        'aria-disabled': disabled ? 'true' : undefined,
        'aria-current': current ? 'date' : undefined,
        'data-action': action || undefined,
        'data-date': dateStr
      }
    };
  }).reduce((acc, day, i) => {
    if (i % 7 === 0) {
      acc.push([]);
    }
    const week = acc[acc.length - 1];
    week.push(day);
    return acc;
  }, []);
  return dayData;
}
function actionDisabled(activeDate, action, min, max, locale) {
  let disabled = false;
  const minDateStr = ensureDateString$1(min);
  const maxDateStr = ensureDateString$1(max);
  if (min || max) {
    const goToDate = calcGoToDate(activeDate, action, locale);
    switch (action) {
      case '-year':
        disabled = min && `${goToDate.getFullYear()}-12-31` < minDateStr;
        break;
      case '+year':
        disabled = max && `${goToDate.getFullYear()}-01-01` > maxDateStr;
        break;
      case '-month':
        const endOfMonth = min && toISODate(new Date(goToDate.getFullYear(), goToDate.getMonth() + 1, 0));
        disabled = min && minDateStr > endOfMonth;
        break;
      case '+month':
        const startOfMonth = max && toISODate(new Date(goToDate.getFullYear(), goToDate.getMonth(), 1));
        disabled = max && maxDateStr < startOfMonth;
        break;
    }
  }
  return !!disabled;
}
function ensureDateString$1(date) {
  if (typeof date === 'string') {
    return date;
  } else if (date instanceof Date) {
    return toISODate(date);
  }
  return null;
}

class EventListeners {
  constructor() {
    this.bindings = [];
  }
  addListener(target, type, listener, option) {
    const binding = {
      target,
      type,
      listener,
      option
    };
    target.addEventListener(type, listener, option);
    this.bindings.push(binding);
    return binding;
  }
  removeListener(binding) {
    const index = this.bindings.indexOf(binding);
    if (index > -1) {
      const {
        target,
        type,
        listener,
        option
      } = this.bindings[index];
      target.removeEventListener(type, listener, option);
      this.bindings.splice(index, 1);
    }
  }
  removeListeners() {
    this.bindings.forEach(_ref => {
      let {
        target,
        type,
        listener,
        option
      } = _ref;
      target.removeEventListener(type, listener, option);
    });
    this.bindings = [];
  }
}

/**
 * Cross-browser (meaning IE) function to create an Event to dispatch. Creates a Custom Event
 * @param eventType {string} - The name of the event
 * @param eventInit {object} - Dictionary with the event initialization values as defined in https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent.
 *        For this function, though, bubbles defaults to true
 * @return {CustomEvent} A CustomEvent object
 */
function createCustomEvent(eventType) {
  let eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  eventInit = {
    ...eventInit
  };
  const additionalProperties = stripNonCustomEventInitProperties(eventInit);
  let event;
  const init = {
    ...{
      bubbles: true,
      cancelable: false,
      detail: undefined
    },
    ...eventInit
  };
  if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventType, init);
  } else {
    event = document.createEvent('CustomEvent');
    const bubbles = !!init.bubbles;
    const cancelable = !!init.cancelable;
    const details = init.detail;
    event.initCustomEvent(eventType, bubbles, cancelable, details);
  }
  // add any additional properties as read-only
  Object.keys(additionalProperties).forEach(key => {
    Object.defineProperty(event, key, {
      get() {
        return additionalProperties[key];
      }
    });
  });
  return event;
}
function stripNonCustomEventInitProperties(eventInit) {
  const properties = 'detail bubbles cancelable composed';
  const strippedProperties = {};
  Object.keys(eventInit).forEach(key => {
    if (properties.indexOf(key) === -1) {
      strippedProperties[key] = eventInit[key];
      delete eventInit[key];
    }
  });
  return strippedProperties;
}

const normalizeKeyMap = {
  'Esc': 'Escape',
  'Left': 'ArrowLeft',
  'Right': 'ArrowRight',
  'Up': 'ArrowUp',
  'Down': 'ArrowDown',
  'Space': ' ',
  'Spacebar': ' '
};
/**
 * Normalizes key values to standard strings. e.g. "Down" to "ArrowDown"
 * @param keyEvent
 * @return {*}
 */
function normalizeKey(keyEvent) {
  let key = keyEvent.key || keyEvent.code;
  if (key) {
    key = normalizeKeyMap[key] || key;
  }
  return key;
}
/**
 * Determines whether or not a key event is the user typing.
 * Returns true if the key length is 1 and the ctrl and meta keys are not pressed
 * @param keyEvent
 */
function isTyping(keyEvent) {
  let key = keyEvent.key || keyEvent.code || '';
  return key.length === 1 && !keyEvent.ctrlKey && !keyEvent.metaKey && !keyEvent.altKey;
}
/**
 * Determines whether or not a key event is the user typing.
 * Returns true if the key length is 1 and the ctrl and meta keys are not pressed
 * @param keyEvent
 */
function isTypingOrDeleting(keyEvent) {
  const key = normalizeKey(keyEvent);
  return key === 'Delete' || key === 'Backspace' || isTyping(keyEvent);
}

function bindCalendar(calendar) {
  const {
    el
  } = calendar;
  const eventListeners = new EventListeners();
  eventListeners.addListener(el, 'keydown', keyHandler(calendar));
  eventListeners.addListener(el, 'click', actionHandler(calendar));
  return () => {
    eventListeners.removeListeners();
  };
}
function focusOnActiveDate(calendarEl) {
  // use timeout to allow render to complete
  setTimeout(() => {
    const el = calendarEl.attachShadow && calendarEl.shadowRoot || calendarEl;
    const focusOn = el.querySelector(`[data-date][tabindex="0"]`) || el.querySelector(`[data-action]`);
    if (focusOn) {
      focusOn.focus();
    }
  }, 100); //timeout needs to wait for render timeout as well
}

function setActiveDate(calendar, activeDate) {
  calendar.store.update(v => {
    return {
      ...v,
      activeDate: constrainActiveDate(calendar, activeDate)
    };
  });
}
////////////////////////////////////////////////////////////////////////////////
// - event handlers
function keyHandler(calendar) {
  return event => {
    let goToDateAction = '';
    const key = normalizeKey(event);
    switch (key) {
      case ' ':
      case 'Enter':
        const target = event.target;
        const action = target.getAttribute('data-action');
        if (action === 'select') {
          const dateStr = target.getAttribute('data-date');
          selectDate(calendar, dateStr);
          event.preventDefault(); //ensure no side effects from any change of focus
        }

        return;
      case 'PageDown':
        goToDateAction = event.altKey ? '+year' : '+month';
        break;
      case 'PageUp':
        goToDateAction = event.altKey ? '-year' : '-month';
        break;
      case 'Home':
        goToDateAction = '-eow';
        break;
      case 'End':
        goToDateAction = '+eow';
        break;
      case 'ArrowRight':
        goToDateAction = event.metaKey ? '+eow' : '+day';
        break;
      case 'ArrowLeft':
        goToDateAction = event.metaKey ? '-eow' : '-day';
        break;
      case 'ArrowUp':
        goToDateAction = '-week';
        break;
      case 'ArrowDown':
        goToDateAction = '+week';
        break;
      default:
        if (key.length === 1) {
          const btn = calendar.el.querySelector(`[accessKey="${key.toLowerCase()}"]`);
          if (btn) {
            btn.click();
          }
        }
        return;
    }
    if (goToDateAction) {
      event.preventDefault();
      goToDate(calendar, goToDateAction);
      focusOnActiveDate(calendar.el);
    }
  };
}
function actionHandler(calendar) {
  const ACTION_ATTR = 'data-action';
  return _ref => {
    let {
      target
    } = _ref;
    const actionButton = target.closest(`[${ACTION_ATTR}]`);
    if (actionButton) {
      const action = actionButton.getAttribute(ACTION_ATTR);
      const disabled = actionButton.getAttribute('aria-disabled') === 'true';
      switch (action) {
        case 'select':
          if (!disabled) {
            selectDate(calendar, actionButton.getAttribute('data-date'));
          }
          break;
        default:
          if (!disabled || action === 'goto') {
            goToDate(calendar, action, action === 'goto' ? actionButton.getAttribute('data-date') : null);
          }
      }
    } else {
      focusOnActiveDate(calendar.el);
    }
  };
}
////////////////////////////////////////////////////////////////////////////////////////
function goToDate(calendar, action, dateStr) {
  const {
    activeDate
  } = calendar.state;
  const newActiveDate = calcGoToDate(activeDate, action, getLocale(calendar.el), dateStr);
  if (newActiveDate !== activeDate) {
    if (action.substring(1) === 'week' && constrainActiveDate(calendar, newActiveDate) !== newActiveDate) {
      // keyboard navigation to previous or next week bumped into dates not in range
      // ignore action (otherwise, arrow up|down unexpectedly goes to start/end of week)
      return;
    }
    setActiveDate(calendar, newActiveDate);
  }
}
function constrainActiveDate(calendar, activeDate) {
  const {
    min,
    max
  } = calendar.config;
  const {
    dateFormat
  } = getLocale(calendar.el);
  const minDateStr = ensureDateString(min);
  const maxDateStr = ensureDateString(max);
  if (min || max) {
    const activeDateStr = toISODate(activeDate);
    if (maxDateStr && activeDateStr > maxDateStr) {
      activeDate = parseDate(maxDateStr, dateFormat);
    } else if (minDateStr && activeDateStr < minDateStr) {
      activeDate = parseDate(minDateStr, dateFormat);
    }
  }
  return activeDate;
}
function ensureDateString(date) {
  if (typeof date === 'string') {
    return date;
  } else if (date instanceof Date) {
    return toISODate(date);
  }
  return null;
}
function selectDate(calendar, dateStr) {
  const [year, month, day] = dateStr.split('-');
  const selectedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  calendar.selectedDate = dateStr;
  calendar.el.dispatchEvent(createCustomEvent('selected', {
    detail: {
      date: selectedDate
    }
  }));
  setActiveDate(calendar, selectedDate);
}

const CALENDAR_CLASS$1 = `${CSS_NS}calendar`;
const CALENDAR_MONTH_CLASS = `${CALENDAR_CLASS$1}__month`;
const CALENDAR_HEADER_CLASS = `${CALENDAR_CLASS$1}__header`;
const CALENDAR_FOOTER_CLASS = `${CALENDAR_CLASS$1}__footer`;
const CALENDAR_BODY_CLASS = `${CALENDAR_CLASS$1}__body`;
const SELECTABLE_DAY_CLASS = `${CALENDAR_CLASS$1}__select-date`;
const SELECTED_DAY_CLASS = `${SELECTABLE_DAY_CLASS}--selected`;
const CURRENT_DATE_CLASS = `${SELECTABLE_DAY_CLASS}--current-date`;
const DUE_DATE_CLASS = `${SELECTABLE_DAY_CLASS}--due-date`;
const DAY_OUTSIDE_MONTH_CLASS = `${SELECTABLE_DAY_CLASS}--outside-month`;
const INSTANCE_KEY$l = `${NAMESPACE}Calendar`;
const defaultConfig$7 = {};
class _CalendarInstance {
  constructor(element) {
    this.onDestroy = [];
    this._rendered = false;
    this._activeDateStr = '';
    this.el = element;
    element.dataset.enhancedCalendar = "true";
    init(this);
    const unwatchForChanges = watchForChanges(element, {
      attributes: true,
      attributeFilter: ['selected-date', 'active-date']
    }, records => {
      records.forEach(record => {
        switch (record.attributeName) {
          case 'selected-date':
            this.onSelectedDateUpdate();
            break;
          case 'active-date':
            this.onActiveDateUpdate();
            break;
        }
      });
    });
    const store = this.store = createStore$8(this);
    this.onDestroy = [store.subscribe(this.onStateUpdate.bind(this)), bindCalendar(this), unwatchForChanges];
    instances$1.set(element, INSTANCE_KEY$l, this);
  }
  onStateUpdate(state) {
    this.state = state;
    // defer the re-render to allow current click handlers to work with current DOM
    window.setTimeout(() => {
      if (this.el) {
        // may have been destroyed since
        this.render();
      }
    }, 10);
  }
  render() {
    const data = getCalendarData(this);
    renderCalendarTemplate(this, data);
    const monthRendered = renderMonth(this, data);
    updateCalendarDays(this, data);
    enableHeaderActions(this, data);
    if (monthRendered) {
      onDayCreatedHook(this);
    }
    this._rendered = true;
  }
  get selectedDate() {
    return this.el ? this.el.getAttribute('selected-date') : '';
  }
  set selectedDate(dateStr) {
    if (dateStr) {
      this.el.setAttribute('selected-date', dateStr);
    } else {
      this.el.removeAttribute('selected-date');
      this.setActiveDate(new Date());
    }
  }
  get activeDate() {
    return this.el ? this.el.getAttribute('active-date') : '';
  }
  set activeDate(dateStr) {
    if (dateStr) {
      this.el.setAttribute('active-date', dateStr);
    } else {
      this.el.removeAttribute('active-date');
      this.setActiveDate(new Date());
    }
  }
  onSelectedDateUpdate() {
    const selectedDateStr = this.selectedDate;
    const {
      dateFormat
    } = getLocale(this.el);
    const activeDateStr = toISODate(this.state.activeDate);
    let selectedDate = parseDate(selectedDateStr, dateFormat);
    if (isValidDateInstance(selectedDate)) {
      const selectedDateStr = toISODate(selectedDate);
      if (selectedDateStr !== activeDateStr) {
        this.setActiveDate(selectedDate);
      }
    } else {
      this.el.removeAttribute('selected-date');
      this.setActiveDate(new Date());
    }
  }
  onActiveDateUpdate() {
    const dateStr = this.activeDate;
    const {
      dateFormat
    } = getLocale(this.el);
    const newActiveDate = parseDate(dateStr, dateFormat);
    if (isValidDateInstance(newActiveDate)) {
      const newActiveDateStr = toISODate(newActiveDate);
      const activeDateStr = toISODate(this.state.activeDate);
      if (newActiveDateStr !== activeDateStr) {
        this.setActiveDate(newActiveDate);
      }
    } else {
      this.el.removeAttribute('active-date');
      this.setActiveDate(new Date());
    }
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const currentOptions = this.config || {};
    this.config = {
      ...currentOptions,
      ...configureDates(config, getLocale(this.el).dateFormat)
    };
    if (this._rendered) {
      this.render();
    }
  }
  setActiveDate(date) {
    setActiveDate(this, date || new Date());
  }
  /**
   * Focuses on the selected date; otherwise first button
   */
  focus() {
    focusOnActiveDate(this.el);
  }
  destroy() {
    if (this.el) {
      while (this.onDestroy && this.onDestroy.length) {
        this.onDestroy.pop()();
      }
      instances$1.remove(this.el, INSTANCE_KEY$l);
      delete this.el.dataset.enhancedCalendar;
      this.el = this.state = this.store = this.config = null;
      this._rendered = false;
    }
  }
}
function init(calendar) {
  const element = calendar.el;
  //initialize config with default config and data attributes
  const config = {
    ...defaultConfig$7
  };
  const dataConfig = configFromDataAttributes(element);
  convertStringRefs(dataConfig, ['onDayCreated'], 'function');
  calendar.setConfig({
    ...config,
    ...dataConfig
  });
}
////////////////////////////////////////////////
// - Render functions
function renderCalendarTemplate(calendar, data) {
  const container = calendar.el;
  const prevRenderState = calendar._prevRenderState || {};
  const lang = getLang(container);
  const notoday = (calendar.config || {}).notoday;
  const calendarMonth = container.querySelector(`.${CALENDAR_MONTH_CLASS}`);
  if (calendarMonth && lang === prevRenderState.lang && notoday === prevRenderState.notoday) {
    return;
  }
  calendar._prevRenderState = {
    lang,
    notoday
  };
  const {
    weekdays,
    controls
  } = data;
  const calendarTemplate = `
      ${renderCalendarHeader(data)}
      <table class="${CALENDAR_BODY_CLASS}">
        <thead>
          <tr>
            ${weekdays.map(weekday => {
    return `<th scope="col"><abbr title="${htmlEncode(weekday.name)}">${htmlEncode(weekday.abbreviation)}</abbr></th>`;
  }).join(' ')}
          </tr>
        </thead>
        <tbody></tbody>
      </table>
      ${renderCalendarFooter(controls)}`;
  if (calendarMonth) {
    calendarMonth.innerHTML = calendarTemplate;
  } else {
    container.insertAdjacentHTML('afterbegin', `<div class="${CALENDAR_MONTH_CLASS}">${calendarTemplate}</div>`);
    container.setAttribute('tabindex', '-1');
  }
}
function renderCalendarHeader(data) {
  const {
    controls,
    monthName,
    year
  } = data;
  const {
    prevYear,
    nextYear,
    prevMonth,
    nextMonth
  } = controls;
  return `
    <div class="${CALENDAR_HEADER_CLASS}">
      ${renderActionButton('-year', prevYear)}
      ${renderActionButton('-month', prevMonth)}
      <span class="${CALENDAR_CLASS$1}__title">${monthName} ${year}</span>
      ${renderActionButton('+month', nextMonth)}
      ${renderActionButton('+year', nextYear)}
    </div>`;
}
function renderActionButton(action, actionData) {
  const {
    title,
    label
  } = actionData;
  return `
    <button class="${CALENDAR_CLASS$1}__action" type="button" data-action="${action}" title="${htmlEncode(title)}" aria-label="${htmlEncode(label)}"></button>
  `;
}
function renderCalendarFooter(controls) {
  const {
    today
  } = controls;
  const include = today && today.include;
  return !include ? '' : `
    <div class="${CALENDAR_FOOTER_CLASS}">
      <button type="button" class="${CSS_NS}button--tertiary ${CSS_NS}button--small" data-action="${today.action}"  data-date="${today.date}" accesskey="${today.accessKey}" title="${htmlEncode(today.title)}">${htmlEncode(today.label)}</button>
    </div>
  `;
}
function renderMonth(calendar, data) {
  const element = calendar.el;
  const activeDate = calendar.state.activeDate;
  const prevState = calendar._prevState || {};
  const prevActiveDate = prevState.activeDate;
  const tbody = element.querySelector(`.${CALENDAR_MONTH_CLASS} tbody`);
  if (tbody.innerHTML && activeDate && prevActiveDate && activeDate.getMonth() === prevActiveDate.getMonth() && activeDate.getFullYear() === prevActiveDate.getFullYear()) {
    return false;
  }
  calendar._prevState = calendar.state;
  const {
    monthName,
    year,
    weeks
  } = data;
  const title = element.querySelector(`.${CALENDAR_CLASS$1}__title`);
  title.innerText = `${monthName} ${year}`;
  tbody.innerHTML = weeks.map(renderWeek).join('');
  return true;
}
function renderWeek(week) {
  return `
    <tr>${week.map(renderDay).join(' ')}</tr>
  `;
}
function renderDay(day) {
  return `
      <td data-date="${day.attributes['data-date']}">
        <span class="${CALENDAR_CLASS$1}__day">${day.date.getDate()}
      </span></td>
      `;
}
function enableHeaderActions(calendar, data) {
  const container = calendar.el;
  const {
    prevYear,
    nextYear,
    prevMonth,
    nextMonth
  } = data.controls;
  const actionMap = {
    '-year': prevYear,
    '-month': prevMonth,
    '+year': nextYear,
    '+month': nextMonth
  };
  Object.keys(actionMap).forEach(action => {
    const control = actionMap[action];
    const button = container.querySelector(`button[data-action="${action}"]`);
    if (control.disabled) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  });
}
function updateCalendarDays(calendar, data) {
  const container = calendar.el;
  const {
    weeks
  } = data;
  for (let w = 0; w < weeks.length; w++) {
    const days = weeks[w];
    for (let i = 0; i < days.length; i++) {
      const day = days[i];
      const dayEl = container.querySelector(`[data-date="${day.attributes['data-date']}"]`);
      if (dayEl) {
        const classes = {
          [SELECTED_DAY_CLASS]: day.selected,
          [SELECTABLE_DAY_CLASS]: true,
          [CURRENT_DATE_CLASS]: day.isCurrentDate,
          [DUE_DATE_CLASS]: day.isDueDate,
          [DAY_OUTSIDE_MONTH_CLASS]: day.isOutsideOfMonth
        };
        for (let cls in classes) {
          const method = classes[cls] ? 'add' : 'remove';
          dayEl.classList[method](cls);
        }
        const attributes = dayEl.attributes;
        for (let i = 0; i < attributes.length; i++) {
          if (attributes[i].name !== 'class' && !day.attributes[attributes[i].name]) {
            dayEl.removeAttribute(attributes[i].name);
          }
        }
        for (let attr in day.attributes) {
          if (day.attributes[attr]) {
            dayEl.setAttribute(attr, day.attributes[attr]);
          } else {
            dayEl.removeAttribute(attr);
          }
        }
      }
    }
  }
}
function onDayCreatedHook(calendar) {
  const {
    config
  } = calendar;
  const {
    onDayCreated
  } = config || {};
  if (onDayCreated) {
    const container = calendar.el;
    const days = container.querySelectorAll('td[data-date]');
    for (let i = 0; i < days.length; i++) {
      const dayEl = days[i];
      const dataStr = dayEl.getAttribute('data-date');
      const date = parseDate(dataStr, getLocale(container).dateFormat);
      onDayCreated(dayEl, date, dataStr);
    }
  }
}
//////////////////////////////////////////////////////////////////////////////////////////////////////
onDomChanges(`.${CALENDAR_CLASS$1}`, function onCalendarAdded(element) {
  if (!element.dataset.enhancedCalendar) {
    new _CalendarInstance(element);
  }
}, function onCalendarRemoved(element) {
  if (element.dataset.enhancedCalendar === 'true') {
    new Calendar(element).destroy();
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////
class Calendar {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$l) || new _CalendarInstance(element);
    if (config) {
      this.setConfig(config);
    }
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this._instance.setConfig(config);
  }
  get element() {
    return this._instance.el;
  }
  get selectedDate() {
    return this._instance.selectedDate;
  }
  setActiveDate(date) {
    this._instance.setActiveDate(date);
  }
  /**
   * Focuses on the selected date; otherwise first button
   */
  focus() {
    this._instance.focus();
  }
  destroy() {
    if (this._instance) {
      this._instance.destroy();
      delete this._instance;
    }
  }
}

function createStore$7(el) {
  //todo: also check for value= on DateInput
  let monthValue = '',
    dayValue = '',
    yearValue = '';
  const inputs = el.querySelectorAll('input[data-date-part]');
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    const value = input.value;
    switch (input.dataset.datePart) {
      case "year":
        yearValue = value;
        break;
      case "month":
        monthValue = value;
        break;
      case "day":
        dayValue = value;
        break;
    }
  }
  if (!yearValue && !monthValue && !dayValue) {
    // see if it it initialized using a hidden element
    const hiddenInput = el.querySelector('input[type="hidden"]');
    if (hiddenInput && hiddenInput.value) {
      // strip anything that is not a number or dash 
      let value = hiddenInput.value.replace(/[^\d-]/g, '');
      const parts = value.split('-');
      if (parts.length === 3) {
        // then its in an ISO-like format
        yearValue = parts[0];
        monthValue = parts[1];
        dayValue = parts[2];
      }
    }
  }
  return store({
    yearValue,
    monthValue,
    dayValue,
    validity: {
      valid: true
    },
    calendarOpenState: 'closed',
    hasFocus: false
  });
}

const TAB_TRAP_ATTRIBUTE = 'data-dialog-tab-trap';
function containTabFocus(element) {
  const tabTraps = getTabTraps(element);
  const tabTrapFocusHandler = onTabTrapFocus(element, tabTraps);
  tabTraps.forEach(tabTrap => tabTrap.addEventListener('focus', tabTrapFocusHandler));
  return function uncontainTabFocus() {
    tabTraps.forEach(tabTrap => tabTrap.removeEventListener('focus', tabTrapFocusHandler));
  };
}
const FOCUSABLE_ELEMENTS = ['a[href]:not([tabindex^="-"]):not([inert])', 'area[href]:not([tabindex^="-"]):not([inert])', 'input:not([disabled]):not([inert])', 'select:not([disabled]):not([inert])', 'textarea:not([disabled]):not([inert])', 'button:not([disabled]):not([inert])', 'iframe:not([tabindex^="-"]):not([inert])', 'audio:not([tabindex^="-"]):not([inert])', 'video:not([tabindex^="-"]):not([inert])', '[contenteditable]:not([tabindex^="-"]):not([inert])', `[tabindex]:not([tabindex^="-"]):not([inert]):not([${TAB_TRAP_ATTRIBUTE}])`];
function getFocusableChildren(element) {
  // This logic only checks for shadow root elements one level deep.
  // If a shadow root has an element with a shadow DOM, those won't be picked up
  // Also does not account for the possibility that slotted children may be placed 
  // in a different order, but not sure this changes the tab order anyhow.
  const shadowRoots = Array.from(element.querySelectorAll('*')).concat([element]).filter(el => hasShadowDom(el)).map(el => el.shadowRoot);
  const rootElements = [element].concat(shadowRoots);
  const focusables = rootElements.reduce((arr, root) => {
    return arr.concat(Array.from(root.querySelectorAll(FOCUSABLE_ELEMENTS.join(','))));
  }, []);
  return focusables.filter(child => {
    return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length) && getComputedStyle(child).visibility !== 'hidden';
  });
}
function getConfigElement(id_selector_or_node, context) {
  return id_selector_or_node && (id_selector_or_node instanceof HTMLElement ? id_selector_or_node : context.querySelector(id_selector_or_node) || document.getElementById(id_selector_or_node));
}
function focus(el, dlg) {
  let focusOn = el;
  // if focusing on a radio button, focus on the selected radio button
  if (el.getAttribute('type') === 'radio' && !el.checked) {
    const name = el.getAttribute('name');
    focusOn = dlg.querySelector(`input[name="${name}"]:checked`) || dlg.querySelector(`input[name="${name}"]`) || el;
  }
  if (focusOn.focus) {
    focusOn.focus();
  }
}
function createTabTrap() {
  const span = document.createElement('span');
  span.innerHTML = tabTrapHTML();
  return span.firstElementChild;
}
function tabTrapHTML() {
  return `<span ${TAB_TRAP_ATTRIBUTE} tabindex="0" style="height: 1px; width: 1px; position: absolute; overflow:hidden"></span>`;
}
// ===============================================================================
function getTabTraps(element) {
  let parent = element;
  let tabTraps = Array.from(parent.querySelectorAll(`[${TAB_TRAP_ATTRIBUTE}]`));
  if (!tabTraps.length && hasShadowDom(parent)) {
    parent = parent.shadowRoot;
    tabTraps = Array.from(parent.querySelectorAll(`[${TAB_TRAP_ATTRIBUTE}]`));
  }
  if (!tabTraps.length) {
    tabTraps.push(parent.insertBefore(createTabTrap(), parent.firstChild));
    tabTraps.push(parent.appendChild(createTabTrap()));
  }
  return tabTraps;
}
function onTabTrapFocus(element, tabTraps) {
  return event => {
    const {
      target,
      relatedTarget
    } = event;
    const focusables = getFocusableChildren(element);
    // if on the last tabTrap, or focusing from the dialog into its contents, focus on first
    // else focus on last
    const index = target === tabTraps[1] || relatedTarget && relatedTarget.contains(target) ? 0 : focusables.length - 1;
    if (focusables[index]) {
      focus(focusables[index], element);
    }
  };
}

const TOP = 'top';
const TOP_START = 'top-start';
const TOP_END = 'top-end';
const TOP_LEFT_CENTER = 'top-left-center';
const TOP_RIGHT_CENTER = 'top-right-center';
const BOTTOM = 'bottom';
const BOTTOM_START = 'bottom-start';
const BOTTOM_END = 'bottom-end';
const BOTTOM_LEFT_CENTER = 'bottom-left-center';
const BOTTOM_RIGHT_CENTER = 'bottom-right-center';
const LEFT = 'left';
const LEFT_START = 'left-start';
const LEFT_END = 'left-end';
const LEFT_TOP_CENTER = 'left-top-center';
const LEFT_BOTTOM_CENTER = 'left-bottom-center';
const RIGHT = 'right';
const RIGHT_START = 'right-start';
const RIGHT_END = 'right-end';
const RIGHT_TOP_CENTER = 'right-top-center';
const RIGHT_BOTTOM_CENTER = 'right-bottom-center';
const defaultOptions$3 = {
  placement: BOTTOM_START,
  transitionName: 'popover',
  transitionEnterTimeout: 800,
  transitionLeaveTimeout: 0
};
function createPopover(element, reference) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = {
    ...defaultOptions$3,
    ...options
  };
  let elementParent = element.parentNode;
  let elementSibling = element.nextSibling;
  let container = createPopoverContainer(element);
  // initialize dataset.placementApplied (data-placement-applied) to start 
  // in case this attribute is needed for CSS purposes. Will be set properly when positioned  
  element.dataset.placementApplied = 'tbd';
  onEnter(element, options);
  let runPoll = false;
  let lastResult;
  function reposition() {
    if (!reference.isConnected) {
      // reference has been removed from DOM
      destroyPopover();
      return;
    }
    if (runPoll && container) {
      const result = postionPopover(container, reference, options, lastResult);
      if (result) {
        lastResult = result;
        element.dataset.placementApplied = reference.dataset.popoverPlacementApplied = result.placementApplied;
        if (result.pause) {
          setTimeout(reposition, 800); // what until window.scrollBy completes
          return;
        }
      }
      /*********************************************************************************************
       * This seems OK. Need to better peformance test. If not, then we would have to listen
       * for scroll and resize  events using doWhileEventing. But, scroll events would also have
       * to be listened for in any ancestors that may be scrollable. (Scroll event does not bubble).
       * But, changes to the size of elements on the page may cause a reflow. So we would have to
       * watch for anything that may cause a reflow. So, for now, try to make requestAnimationFrame
       * as efficient as possible
       *********************************************************************************************/
      requestAnimationFrame(reposition);
    }
  }
  let hideEventListeners = new EventListeners();
  runPoll = true;
  reposition();
  async function destroyPopover() {
    runPoll = false;
    if (container) {
      await onLeave(element, options);
      delete element.dataset.placementApplied;
      delete reference.dataset.popoverPlacementApplied;
      if (container) {
        // could have been removed during await onLeave(...) 
        container.remove();
        if (elementParent) {
          elementParent.insertBefore(element, elementSibling);
        } else if (element.parentNode === container) {
          container.removeChild(element);
        }
        container = elementParent = elementSibling = hideEventListeners = undefined;
      }
    }
  }
  setupHideHandlers(element, reference, options, hideEventListeners, destroyPopover);
  return destroyPopover;
}
function createPopoverContainer(element) {
  const doc = element.ownerDocument;
  const container = doc.createElement('div');
  // as this is placed at the end of the body element, setting this role to
  // avoid the axe dev tool error that all elements must be in a landmark role.
  container.role = 'region';
  const style = container.style;
  style.position = 'absolute';
  style.zIndex = '5000';
  style.top = '0';
  style.left = '0';
  container.dataset.popoverContainer = '';
  container.appendChild(element);
  return doc.body.appendChild(container);
}
function postionPopover(popover, reference, options, lastResult) {
  const refRect = reference.getBoundingClientRect();
  const popoverWidth = popover.offsetWidth;
  const popoverHeight = popover.offsetHeight;
  const docElement = reference.ownerDocument.documentElement;
  const viewportHeight = docElement.clientHeight;
  const viewportWidth = docElement.clientWidth;
  const {
    top: adjY,
    left: adjX
  } = popover.parentElement.getBoundingClientRect();
  if (lastResult) {
    const lastRect = lastResult.refRect;
    // To keep requestAnimationFrame as efficient as possible,
    // only run calculations if any of the variable have changed
    if (lastRect.x === refRect.x && lastRect.y === refRect.y && lastRect.width === refRect.width && lastRect.height === refRect.height && lastResult.popoverWidth === popoverWidth && lastResult.popoverHeight === popoverHeight && lastResult.viewportWidth === viewportWidth && lastResult.viewportHeight === viewportHeight && lastResult.adjX === adjX && lastResult.adjY === adjY) return;
  }
  let x = 0;
  let y = 0;
  let x1;
  let y1;
  const placement = options.placement || BOTTOM_START;
  const alternatePlacements = options.alternatePlacements && options.alternatePlacements.length ? options.alternatePlacements : getAlternatePostions(placement);
  // start with the desired placement, if none fit, default to the desired placement
  let placements = [placement, ...alternatePlacements, placement];
  if (lastResult && lastResult.placementApplied !== placement) {
    const lastApplied = lastResult.placementApplied;
    // To keep the popup from unnecessarily moving once it is shown,
    // start with the current placement. If it still fits, use it 
    placements = [lastApplied, ...placements.filter(p => p !== lastApplied), lastApplied];
  }
  let placementApplied;
  for (let i = 0; i < placements.length; i++) {
    placementApplied = placements[i];
    x = calculateOffsetX(refRect, popoverWidth, placementApplied);
    y = calculateOffsetY(refRect, popoverHeight, placementApplied);
    x1 = x + popoverWidth;
    y1 = y + popoverHeight;
    if (x >= 0 && y >= 0 && x1 <= viewportWidth && y1 < viewportHeight) {
      break;
    }
  }
  popover.style.transform = `translate(${x - adjX}px, ${y - adjY}px)`;
  let pause = false;
  if (!lastResult) {
    // first positioning only
    const scrollX = x1 > viewportWidth ? x1 - viewportWidth : x < 0 ? x : 0;
    const scrollY = y1 > viewportHeight ? y1 - viewportHeight : y < 0 ? y : 0;
    if (scrollX || scrollY) {
      window.scrollBy({
        top: scrollY,
        left: scrollX,
        behavior: 'smooth'
      });
      pause = true; // pause the polling while scroll happens to prevent unnecessary recalcs
    }
  }

  return {
    refRect,
    popoverWidth,
    popoverHeight,
    viewportWidth,
    viewportHeight,
    placementApplied,
    adjX,
    adjY,
    pause
  };
}
function calculateOffsetX(refRect, popoverWidth, placement) {
  switch (placement) {
    case LEFT:
    case LEFT_START:
    case LEFT_END:
    case LEFT_TOP_CENTER:
    case LEFT_BOTTOM_CENTER:
      return refRect.x - popoverWidth;
    case RIGHT:
    case RIGHT_START:
    case RIGHT_END:
    case RIGHT_TOP_CENTER:
    case RIGHT_BOTTOM_CENTER:
      return refRect.right;
    case TOP:
    case BOTTOM:
      return refRect.x + (refRect.width - popoverWidth) / 2;
    case TOP_START:
    case BOTTOM_START:
    default:
      return refRect.x;
    case TOP_END:
    case BOTTOM_END:
      return refRect.right - popoverWidth;
    case TOP_LEFT_CENTER:
    case BOTTOM_LEFT_CENTER:
      return refRect.x + refRect.width / 2;
    case TOP_RIGHT_CENTER:
    case BOTTOM_RIGHT_CENTER:
      return refRect.x - popoverWidth + refRect.width / 2;
  }
}
function calculateOffsetY(refRect, popoverHeight, placement) {
  switch (placement) {
    case TOP:
    case TOP_START:
    case TOP_END:
    case TOP_LEFT_CENTER:
    case TOP_RIGHT_CENTER:
      return refRect.y - popoverHeight;
    case BOTTOM:
    case BOTTOM_START:
    case BOTTOM_END:
    case BOTTOM_LEFT_CENTER:
    case BOTTOM_RIGHT_CENTER:
    default:
      return refRect.bottom;
    case LEFT:
    case RIGHT:
      return refRect.y + (refRect.height - popoverHeight) / 2;
    case LEFT_START:
    case RIGHT_START:
      return refRect.y;
    case LEFT_END:
    case RIGHT_END:
      return refRect.bottom - popoverHeight;
    case LEFT_TOP_CENTER:
    case RIGHT_TOP_CENTER:
      return refRect.y + refRect.height / 2;
    case LEFT_BOTTOM_CENTER:
    case RIGHT_BOTTOM_CENTER:
      return refRect.y - popoverHeight + refRect.height / 2;
  }
}
function getAlternatePostions(placement) {
  switch (placement) {
    case TOP:
      return [TOP_START, TOP_END, BOTTOM, BOTTOM_START, BOTTOM_END];
    case TOP_START:
      return [TOP, TOP_END, BOTTOM_START, BOTTOM, BOTTOM_END];
    case TOP_END:
      return [TOP, TOP_START, BOTTOM_END, BOTTOM, BOTTOM_START];
    case TOP_LEFT_CENTER:
      return [TOP_RIGHT_CENTER, BOTTOM_LEFT_CENTER, BOTTOM_RIGHT_CENTER];
    case TOP_RIGHT_CENTER:
      return [TOP_LEFT_CENTER, BOTTOM_RIGHT_CENTER, BOTTOM_LEFT_CENTER];
    case BOTTOM:
      return [BOTTOM_START, BOTTOM_END, TOP, TOP_START, TOP_END];
    case BOTTOM_START:
    default:
      return [BOTTOM, BOTTOM_END, TOP_START, TOP, TOP_END];
    case BOTTOM_END:
      return [BOTTOM, BOTTOM_START, TOP_END, TOP, TOP_START];
    case BOTTOM_LEFT_CENTER:
      return [BOTTOM_RIGHT_CENTER, TOP_LEFT_CENTER, TOP_RIGHT_CENTER];
    case BOTTOM_RIGHT_CENTER:
      return [BOTTOM_LEFT_CENTER, BOTTOM_RIGHT_CENTER, BOTTOM_LEFT_CENTER];
    case LEFT:
      return [LEFT_START, LEFT_END, RIGHT, RIGHT_START, RIGHT_END];
    case LEFT_START:
      return [LEFT, LEFT_END, RIGHT_START, RIGHT, RIGHT_END];
    case LEFT_END:
      return [LEFT, LEFT_START, RIGHT_END, RIGHT, RIGHT_START];
    case LEFT_TOP_CENTER:
      return [LEFT_BOTTOM_CENTER, RIGHT_TOP_CENTER, RIGHT_BOTTOM_CENTER];
    case LEFT_BOTTOM_CENTER:
      return [LEFT_TOP_CENTER, RIGHT_BOTTOM_CENTER, RIGHT_TOP_CENTER];
    case RIGHT:
      return [RIGHT_START, RIGHT_END, LEFT, LEFT_START, LEFT_END];
    case RIGHT_START:
      return [RIGHT, RIGHT_END, LEFT_START, LEFT, LEFT_END];
    case RIGHT_END:
      return [RIGHT, RIGHT_START, LEFT_END, LEFT, LEFT_START];
    case RIGHT_TOP_CENTER:
      return [RIGHT_BOTTOM_CENTER, LEFT_TOP_CENTER, LEFT_BOTTOM_CENTER];
    case RIGHT_BOTTOM_CENTER:
      return [RIGHT_TOP_CENTER, LEFT_BOTTOM_CENTER, LEFT_TOP_CENTER];
  }
}
function setupHideHandlers(popover, reference, options, eventListeners, destroy) {
  const hideOn = options.hideOn;
  const hide = reason => {
    const onHide = options.onHide;
    if (typeof onHide === 'function') {
      onHide(reason) && destroy();
    }
  };
  if (hideOn !== null && hideOn !== void 0 && hideOn.escapeKey) {
    eventListeners.addListener(document, 'keydown', e => {
      const key = normalizeKey(e);
      if (key === 'Escape') {
        hide('escape');
        e.stopPropagation();
      }
    });
  }
  if (hideOn !== null && hideOn !== void 0 && hideOn.clickOutside) {
    eventListeners.addListener(document, 'mousedown', e => {
      const target = e.target;
      if (!popover.contains(target) && !reference.contains(target)) {
        hide('clickoutside');
      }
    });
  }
  // We need one for when popover or reference loses focus, but that is more complicated
  // address it when there is a need in the code 
}

function onEnter(element, options) {
  const enterClass = `${options.transitionName}-enter`;
  const enterActiveClass = `${options.transitionName}-enter-active`;
  element.classList.add(enterClass);
  setTimeout(() => {
    element.classList.add(enterActiveClass);
    setTimeout(() => {
      element.classList.remove(enterClass, enterActiveClass);
    }, options.transitionEnterTimeout);
  });
}
async function onLeave(element, options) {
  const leaveClass = `${options.transitionName}-leave`;
  const leaveActiveClass = `${options.transitionName}-leave-active`;
  element.classList.add(leaveClass);
  return new Promise(resolve => {
    setTimeout(() => {
      element.classList.add(leaveActiveClass);
      setTimeout(() => {
        element.classList.remove(leaveClass, leaveActiveClass);
        resolve();
      }, options.transitionLeaveTimeout);
    });
  });
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * the number of milliseconds specified. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * (inspired by https://davidwalsh.name/javascript-debounce-function)
 * @param {*} fn The function to call
 * @param {*} delay The number of milliseconds to wait. Defaults to 300
 * @param {*} immediate If true, performs the function on the leading edge of the timeout
 */
const debounce = function (fn) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) fn.apply(context, args);
    }, delay);
    if (callNow) fn.apply(context, args);
  };
};

const CALENDAR_TRIGGER_SELECTOR = '[data-trigger="calendar"]';
const DATE_FORMAT_HINT_SELECTOR = `[data-date-format-label]:not([data-date-format-label="done"])`;
/////////////////////////////////////////////////////
// - exports
function bindDateInput(dateInput) {
  const {
    el,
    store
  } = dateInput;
  const inputs = orderDateInputs(dateInput);
  inputs.forEach(input => {
    input.maxLength = input.dataset.datePart === 'year' ? 4 : 2;
  });
  setFormatHints$1();
  getA11ySpan$1(dateInput);
  const eventListeners = new EventListeners();
  eventListeners.addListener(el, 'paste', pasteHandler$1(dateInput));
  eventListeners.addListener(el, 'input', inputHandler$1(dateInput, inputs));
  eventListeners.addListener(el, 'change', changeHandler$2(dateInput, inputs));
  eventListeners.addListener(el, 'keydown', keydownHandler$2(dateInput));
  eventListeners.addListener(el, 'keyup', keyupHandler$1(dateInput));
  eventListeners.addListener(el, 'focusin', focusHandler$1(dateInput));
  const manageFocusState = debounce(() => {
    setFocusState$1(dateInput);
  }, 100, false);
  eventListeners.addListener(el, 'focusin', manageFocusState);
  eventListeners.addListener(el, 'focusout', manageFocusState);
  const trigger = getCalendarTrigger(dateInput);
  if (trigger) {
    eventListeners.addListener(trigger, 'click', triggerHandler$1(dateInput));
  }
  eventListeners.addListener(el, 'click', dateInputClickHandler(dateInput));
  eventListeners.addListener(document, 'click', documentClickHandler$1(dateInput));
  const calendarEventListeners = new EventListeners();
  const unsubscribe = store.subscribe(onStateUpdate$1(dateInput, calendarEventListeners, manageFocusState));
  let currentState;
  // subscribe / unsubscribe to get current state
  store.subscribe(s => currentState = s)();
  const hiddenInput = getHiddenInput$1(dateInput);
  if (hiddenInput && !hiddenInput.value) {
    synchHiddenRelatedElements(currentState, dateInput);
  }
  const validity = getValidityState$1(dateInput, currentState);
  if (!validity.valid) {
    // this will fire 'invalid' event if date input starts invalid because occurs after subscribe
    store.update(s => {
      return {
        ...s,
        validity
      };
    });
  }
  const unbind = () => {
    closeCalendar(dateInput);
    eventListeners.removeListeners();
    calendarEventListeners.removeListeners();
    unsubscribe();
  };
  return unbind;
}
function getValueAsISOString(state) {
  const {
    yearValue = '',
    monthValue = '',
    dayValue = ''
  } = state;
  const value = `${yearValue}-${monthValue}-${dayValue}`;
  return value === '--' ? '' : value;
}
function getValueAsDate$1(state) {
  const {
    yearValue = '',
    monthValue = '',
    dayValue = ''
  } = state;
  try {
    const year = parseInt(yearValue.trim());
    const month = parseInt(monthValue.trim());
    const day = parseInt(dayValue.trim());
    if (isNaN(year + month + day)) {
      return null;
    } else if (month < 1 || month > 12) {
      return null;
    } else if (day < 1 || day > 31) {
      return null;
    } else if (yearValue.trim().length < 4) {
      return null;
    }
    const date = new Date(year, month - 1, day, 0, 0, 0, 0);
    // this is here as a sanity check, but can't really create an invalid date when the
    // above checks pass. 
    /* istanbul ignore next */
    if (!isValidDateInstance(date)) {
      return null;
    }
    // if date entered resolves to a different date, then an invalid day value was
    // entered. For instance, 4/31/20XX would resolved to 5/1/20XX.
    // Consider this bad input and return null
    return date.getDate() === day ? date : null;
  } catch (err) {
    /* istanbul ignore next */
    return null;
  }
}
function setDateValue$1(value, dateInput) {
  const {
    dateFormat
  } = getLocale(dateInput.host);
  setChangeMethod('api');
  setValue$1(value, dateInput, dateFormat);
}
///////////////////////////////////////////////////////////
// - internal functions
function setValue$1(value, dateInput, dateFormat) {
  let date;
  if (value && !(value instanceof Date)) {
    date = parseDate(value.toString(), dateFormat);
  } else {
    date = value;
  }
  let yearValue = date ? date.getFullYear() + '' : '';
  let monthValue = date ? to2Digits(date.getMonth() + 1) : '';
  let dayValue = date ? to2Digits(date.getDate()) : '';
  const ISO_DASH_RX = /^([^-]*)-([^-]*)-([^-]*)$/;
  if (!date && typeof value === 'string' && ISO_DASH_RX.test(value)) {
    const parts = value.split('-');
    const nonDigitRx = /\D/g;
    yearValue = (parts[0] || '').replace(nonDigitRx, '');
    monthValue = (parts[1] || '').replace(nonDigitRx, '');
    dayValue = (parts[2] || '').replace(nonDigitRx, '');
  }
  dateInput.store.update(s => {
    const newState = {
      ...s,
      yearValue,
      monthValue,
      dayValue
    };
    return {
      ...newState,
      validity: getValidityState$1(dateInput, newState)
    };
  });
}
function getValidityState$1(dateInput, state) {
  const {
    config
  } = dateInput;
  const valueAsDate = getValueAsDate$1(state);
  const valueAsISOString = getValueAsISOString(state);
  return getDateValidity(config, valueAsDate, valueAsISOString);
}
function orderDateInputs(dateInput) {
  const {
    dateFormat
  } = getLocale(dateInput.el);
  const map = {
    'MM': 'month',
    'DD': 'day',
    'YYYY': 'year'
  };
  const inputs = getInputs$1(dateInput);
  const dateParts = dateFormat.toUpperCase().split('/').map(part => {
    return map[part] || part;
  });
  const outOfOrder = dateParts.find((part, ix) => !inputs[ix] || part !== inputs[ix].getAttribute('data-date-part'));
  if (outOfOrder) {
    inputs.sort((a, b) => {
      const orderA = dateParts.indexOf(a.getAttribute('data-date-part'));
      const orderB = dateParts.indexOf(b.getAttribute('data-date-part'));
      return orderA - orderB;
    });
    inputs.map(input => input.parentElement).forEach((input, ix, arr) => {
      const lastIX = arr.length - 1;
      if (ix < lastIX) {
        const lastInput = arr[lastIX];
        lastInput.parentNode.insertBefore(input, lastInput);
      }
    });
  }
  return inputs;
}
function setFormatHints$1() {
  //todo: how to cross shadow dom
  //todo: do not change if in correct format
  const hintLabels = document.querySelectorAll(DATE_FORMAT_HINT_SELECTOR);
  for (let i = 0; i < hintLabels.length; i++) {
    const hintLabel = hintLabels[i];
    const {
      dateFormat,
      dateFormatLabel
    } = getLocale(hintLabel);
    const hint = dateFormat.toUpperCase();
    const date_format_label_new = hintLabel.textContent && hintLabel.textContent.trim().match(/^\(.*\)$/) ? "(" + hint + ")" : hint;
    hintLabel.innerText = date_format_label_new;
    hintLabel.setAttribute("aria-label", dateFormatLabel);
    hintLabel.setAttribute("data-date-format-label", "done");
  }
}
function getHiddenInput$1(dateInput) {
  const {
    el,
    host
  } = dateInput;
  const selector = 'input[type="hidden"]';
  return el.querySelector(selector) || host.querySelector(selector);
}
function getA11ySpan$1(dateInput) {
  const container = dateInput.el;
  let a11ySpan = container.querySelector(`[data-a11y="true"]`);
  if (!a11ySpan) {
    a11ySpan = document.createElement('span');
    a11ySpan.setAttribute("aria-live", "assertive");
    a11ySpan.dataset.a11y = 'true';
    a11ySpan.classList.add(`${CSS_NS}sr-only`);
    container.appendChild(a11ySpan);
  }
  return a11ySpan;
}
////////////////////////////////////////////////
// - calendar actions
function toggleCalendar(dateInput) {
  if (isCalendarOpenState(dateInput, 'opened', 'opening')) {
    closeCalendar(dateInput);
  } else {
    openCalendar(dateInput);
  }
}
function openCalendar(dateInput) {
  const {
    state,
    store,
    calendar,
    calendarDialog
  } = dateInput;
  if (!isCalendarOpenState(dateInput, 'opened', 'opening')) {
    const selectedDate = getValueAsDate$1(state) || null;
    if (selectedDate) {
      const selectedDateStr = toISODate(selectedDate);
      calendar.setAttribute('selected-date', selectedDateStr);
      calendar.setAttribute('active-date', selectedDateStr);
    } else {
      calendar.removeAttribute('selected-date');
      calendar.setAttribute('active-date', toISODate(new Date()));
    }
    // Setting calendarOpenState to 'ready-open' puts the calendar in a state
    // ready to transition open. As there is no other reference this state 
    // in the code, this may be unclear. It basically makes the calendar "not closed"
    // which effectively changes the CSS display from 'none' to 'block' but keeps 
    // visibility to hidden. 
    store.update(v => {
      return {
        ...v,
        calendarOpenState: 'ready-open'
      };
    });
    // timeout is used to let 'display:block' establish before transitioning from hidden to visible 
    setTimeout(() => {
      updateCalendarOpenState(dateInput, 'opening');
      calendarDialog.uncontainTabFocus = containTabFocus(calendarDialog);
    }, 50);
  }
}
function closeCalendar(dateInput) {
  const {
    calendarDialog
  } = dateInput;
  if (isCalendarOpenState(dateInput, 'opened')) {
    updateCalendarOpenState(dateInput, 'closing');
    if (calendarDialog && calendarDialog.uncontainTabFocus) {
      calendarDialog.uncontainTabFocus();
      delete calendarDialog.uncontainTabFocus;
    }
  }
}
function onCalendarReadyOpen(dateInput) {
  const {
    calendarDialog,
    legacyPopover
  } = dateInput;
  const method = legacyPopover ? 'add' : 'remove';
  calendarDialog.classList[method]('legacy-popover');
  if (!legacyPopover) {
    calendarDialog.destroyPopover = createPopover(calendarDialog, dateInput.host, {
      transitionEnterTimeout: 0,
      transitionLeaveTimeout: 0,
      placement: 'bottom-start'
    });
  }
}
function onCalendarOpening(dateInput, calendarEventListeners, manageFocusState) {
  const calendar = dateInput.calendar;
  calendarEventListeners.addListener(calendar, 'selected', dateSelectedHandler(dateInput));
  calendarEventListeners.addListener(calendar, 'keydown', keydownHandlerCalendar(dateInput));
  // stop propagation of these events to prevent loss focus handlers when used as editable table cell editor 
  calendarEventListeners.addListener(calendar, 'mousedown', stopPropagation$1);
  calendarEventListeners.addListener(calendar, 'touchstart', stopPropagation$1);
  calendarEventListeners.addListener(calendar, 'click', stopPropagation$1);
  calendarEventListeners.addListener(calendar, 'focusin', manageFocusState);
  calendarEventListeners.addListener(calendar, 'focusout', manageFocusState);
  focusOnActiveDate(dateInput.calendar);
}
function onCalendarClosing(dateInput) {
  // setCalendarFocusState(dateInput);
  const trigger = getCalendarTrigger(dateInput);
  if (trigger) {
    const {
      calendar
    } = dateInput;
    let focusedEl = calendar.querySelector(':focus');
    if (!focusedEl && hasShadowDom(calendar)) {
      focusedEl = calendar.shadowRoot.querySelector(':focus');
    }
    // only focus on trigger if focus is inside calendar 
    if (focusedEl) {
      trigger.focus();
    }
  }
}
function onCalendarClosed(dateInput) {
  const {
    calendarDialog
  } = dateInput;
  if (calendarDialog && calendarDialog.destroyPopover) {
    calendarDialog.destroyPopover();
    delete calendarDialog.destroyPopover;
  }
}
function getCalendarTrigger(dateInput) {
  return dateInput.el.querySelector(CALENDAR_TRIGGER_SELECTOR) || dateInput.host.querySelector(CALENDAR_TRIGGER_SELECTOR);
}
//////////////////////////////////////////////////
// - event handlers
function inputHandler$1(dateInput, inputs) {
  return event => {
    const input = event.target;
    if (inputs.indexOf(input) > -1) {
      setChangeMethod('input');
      applyDateInputUpdate(dateInput);
    }
  };
}
function changeHandler$2(dateInput, inputs) {
  return event => {
    const input = event.target;
    if (inputs.indexOf(input) > -1) {
      const state = dateInput.state;
      const value = input.value;
      const resolvedValue = value && input.dataset.datePart !== 'year' ? to2Digits(value) : value;
      if (resolvedValue !== value) {
        input.value = resolvedValue;
      }
      if (state[`${input.dataset.datePart}Value`] !== resolvedValue) {
        setChangeMethod('input');
        applyDateInputUpdate(dateInput);
      }
    }
  };
}
function keydownHandler$2(dateInput) {
  return event => {
    const target = event.target;
    const key = normalizeKey(event);
    const inputs = getInputs$1(dateInput);
    const inputIX = inputs.indexOf(target);
    if (inputIX > -1) {
      const nextInput = inputs[inputIX + 1];
      const prevInput = inputs[inputIX - 1];
      switch (key) {
        case '/':
        case '-':
        case '.':
          event.preventDefault();
          if (target.value.length && target.selectionStart === target.value.length) {
            if (nextInput) {
              nextInput.focus();
              nextInput.select();
            }
          }
          break;
        case 'ArrowLeft':
          if (prevInput && target.selectionStart === 0) {
            prevInput.focus();
            prevInput.selectionStart = prevInput.value.length;
            event.preventDefault();
          }
          break;
        case 'ArrowRight':
          if (nextInput && target.selectionStart === target.value.length) {
            nextInput.focus();
            nextInput.selectionStart = 0;
            event.preventDefault();
          }
          break;
        case 'ArrowUp':
        case 'ArrowDown':
        case 'Home':
        case 'End':
          incrementDateField(key, target, dateInput);
          event.preventDefault();
          break;
        case 'Backspace':
          //if backspacing from 2nd or 3rd empty input, shift focus to previous input
          if (prevInput && target.value.length === 0) {
            prevInput.focus();
            prevInput.selectionStart = prevInput.value.length;
            // by not preventing default, backspace will continue at start of previous field
          }

          break;
        default:
          {
            if (isTyping(event) && !key.match(/\d/)) {
              event.preventDefault();
            }
          }
      }
    }
  };
}
function keydownHandlerCalendar(dateInput) {
  return event => {
    const key = normalizeKey(event);
    if (key === 'Escape') {
      closeCalendar(dateInput);
      event.stopPropagation();
    }
  };
}
function stopPropagation$1(event) {
  event.stopPropagation();
}
function incrementDateField(key, input, dateInput) {
  let inputValue = input.value ? parseInt(input.value) : 0;
  if (isNaN(inputValue)) {
    inputValue = 0;
  }
  const maxValue = input.dataset.datePart === 'month' ? 12 : input.dataset.datePart === 'day' ? 31 : 9999;
  switch (key) {
    case 'ArrowUp':
      if (inputValue < maxValue) {
        inputValue++;
      }
      break;
    case 'ArrowDown':
      if (inputValue > 1) {
        inputValue--;
      }
      break;
    case 'Home':
      if (input.dataset.datePart !== 'year') {
        inputValue = 1;
      }
      break;
    case 'End':
      if (input.dataset.datePart !== 'year') {
        inputValue = maxValue;
      }
      break;
  }
  const value = inputValue ? input.dataset.datePart === 'year' ? `${inputValue}` : to2Digits(inputValue) : '';
  if (value !== input.value) {
    input.value = value;
    setChangeMethod('input');
    applyDateInputUpdate(dateInput);
  }
}
function applyDateInputUpdate(dateInput) {
  const {
    store,
    state
  } = dateInput;
  const inputs = getInputs$1(dateInput);
  const updates = {};
  inputs.forEach(input => updates[`${input.dataset.datePart}Value`] = input.value.trim());
  updates.validity = getValidityState$1(dateInput, {
    ...state,
    ...updates
  });
  store.update(v => {
    return {
      ...v,
      ...updates
    };
  });
}
function keyupHandler$1(dateInput) {
  return event => {
    const target = event.target;
    const inputs = getInputs$1(dateInput);
    const inputIX = inputs.indexOf(target);
    if (inputIX > -1) {
      const key = normalizeKey(event);
      const nextInput = inputs[inputIX + 1];
      if (key && key.match(/\d/) && target.selectionStart === target.maxLength && nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  };
}
function triggerHandler$1(dateInput) {
  return () => {
    const trigger = getCalendarTrigger(dateInput);
    if (trigger && !trigger.closest('[aria-disabled="true"]')) {
      toggleCalendar(dateInput);
    }
  };
}
function updateCalendarOpenState(dateInput, openState) {
  dateInput.store.update(v => {
    return {
      ...v,
      calendarOpenState: openState,
      calendarHasFocus: openState === 'opening'
    };
  });
  setTimeout(() => {
    const endOpenState = openState === 'opening' ? 'opened' : 'closed';
    dateInput.store.update(v => {
      return {
        ...v,
        calendarOpenState: endOpenState
      };
    });
  }, 200); // NOTE: 200ms maps to 'a-calendar-transition-duration' in data-input.yml.
}

function onStateUpdate$1(dateInput, calendarEventListeners, manageFocusState) {
  let prevState = null;
  return state => {
    const oldState = prevState;
    prevState = state;
    onDateUpdate$1(dateInput, state, oldState);
    onCalendarUpdate(dateInput, state, oldState, calendarEventListeners, manageFocusState);
    setChangeMethod(undefined);
  };
}
function onDateUpdate$1(dateInput, state, oldState) {
  const events = [];
  if (oldState) {
    const {
      yearValue = '',
      monthValue = '',
      dayValue = ''
    } = state;
    const {
      yearValue: oldYear = '',
      monthValue: oldMonth = '',
      dayValue: oldDay = ''
    } = oldState;
    if (yearValue === oldYear && monthValue === oldMonth && dayValue === oldDay) {
      return;
    }
    synchHiddenRelatedElements(state, dateInput);
    const changeMethod = getChangeMethod() || 'api'; //if not set, assume it was programmatic
    events.push(['change', {
      detail: {
        dateInput: dateInput,
        changeMethod
      }
    }]);
    const validity = state.validity;
    const oldValidity = oldState.validity;
    const props = Object.keys(validity).concat(Object.keys(oldValidity));
    const changed = props.find(prop => oldValidity[prop] !== validity[prop]);
    if (changed) {
      events.push([validity.valid ? 'valid' : 'invalid', {
        detail: {
          validity: validity
        }
      }]);
    }
    events.forEach(_ref => {
      let [type, eventInit] = _ref;
      dateInput.sendEvent(type, eventInit);
    });
  }
}
function onCalendarUpdate(dateInput, state, oldState, calendarEventListeners, manageFocusState) {
  if (oldState && oldState.calendarOpenState !== state.calendarOpenState) {
    let eventType;
    switch (state.calendarOpenState) {
      case 'ready-open':
        onCalendarReadyOpen(dateInput);
        break;
      case 'opening':
        eventType = 'calendaropening';
        onCalendarOpening(dateInput, calendarEventListeners, manageFocusState);
        break;
      case 'opened':
        eventType = 'calendaropened';
        break;
      case 'closing':
        calendarEventListeners.removeListeners();
        eventType = 'calendarclosing';
        onCalendarClosing(dateInput);
        break;
      case 'closed':
        eventType = 'calendarclosed';
        onCalendarClosed(dateInput);
        break;
    }
    if (eventType) {
      dateInput.sendEvent(eventType);
    }
  }
}
function pasteHandler$1(dateInput) {
  return event => {
    const target = event.target;
    const inputs = getInputs$1(dateInput);
    const order = inputs.indexOf(target);
    if (order === 0 && !target.matches(':read-only, :disabled, [aria-disabled="true"], [aria-readonly="true"]')) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (clipboardData) {
        event.preventDefault();
        const text = clipboardData.getData('text');
        setTimeout(() => {
          const date = parseDate(text, getLocale(dateInput.el).dateFormat);
          setChangeMethod('paste');
          setValue$1(date, dateInput);
          // if valid date, focus on end of date, else focus on beginning
          const focusOn = date ? inputs[2] : inputs[0];
          focusOn.focus();
          const cursorPos = date ? focusOn.maxLength || focusOn.value.length : 0;
          focusOn.selectionStart = focusOn.selectionEnd = cursorPos;
        }, 0);
      }
    } else if (order > -1) {
      event.preventDefault();
    }
  };
}
function dateSelectedHandler(dateInput) {
  return event => {
    if (event.detail && event.detail.date) {
      setChangeMethod('calendar');
      setValue$1(event.detail.date, dateInput);
      closeCalendar(dateInput);
    }
  };
}
function focusHandler$1(dateInput) {
  // todo: needed if we have contrain focus and document click handler?
  return _ref2 => {
    let {
      target
    } = _ref2;
    if (isCalendarOpenState(dateInput, 'opening', 'opened')) {
      const inputs = getInputs$1(dateInput);
      if (inputs.indexOf(target) > -1) {
        closeCalendar(dateInput);
      }
    }
  };
}
function documentClickHandler$1(dateInput) {
  /**
   * Checks for clicks outside of the date input component to close the calendar
   * Checks inside the component handled by next handler
   */
  return event => {
    const {
      target
    } = event;
    if (isCalendarOpenState(dateInput, 'opened')) {
      var _dateInput$calendar;
      const hasTarget = dateInput.host.contains(target) || ((_dateInput$calendar = dateInput.calendar) === null || _dateInput$calendar === void 0 ? void 0 : _dateInput$calendar.contains(target));
      if (!hasTarget) {
        closeCalendar(dateInput);
      }
    }
  };
}
function dateInputClickHandler(dateInput) {
  return event => {
    /**
     * Checks for clicks within the date input component that are not
     * in the calendar or the trigger to close the calendar
     * Separate from document-level click checker so it can work in shadow dom
     */
    const {
      target
    } = event;
    if (isCalendarOpenState(dateInput, 'opened')) {
      const trigger = getCalendarTrigger(dateInput);
      const {
        calendar
      } = dateInput;
      const keepOpen = calendar && calendar.contains(target) || trigger && trigger.contains(target);
      if (!keepOpen) {
        closeCalendar(dateInput);
      }
    }
  };
}
function setFocusState$1(dateInput) {
  const {
    calendar,
    state,
    store,
    el
  } = dateInput;
  let focusedEl = el.querySelector(':focus');
  if (!focusedEl && calendar) {
    const calendarRoot = hasShadowDom(calendar) ? calendar.shadowRoot : calendar;
    focusedEl = calendarRoot.querySelector(':focus');
  }
  const hasFocus = !!focusedEl;
  if (hasFocus !== state.hasFocus) {
    const eventType = hasFocus ? 'tdsFocus' : 'tdsBlur';
    dateInput.sendEvent(eventType, {
      cancelable: false,
      bubbles: true
    });
    store.update({
      hasFocus
    });
  }
}
function synchHiddenRelatedElements(state, dateInput) {
  const hiddenInput = getHiddenInput$1(dateInput);
  if (hiddenInput) {
    hiddenInput.value = getValueAsISOString(state);
  }
  const a11ySpan = getA11ySpan$1(dateInput);
  if (a11ySpan) {
    a11ySpan.innerText = toReadableDate(getValueAsDate$1(state), translations(getLang(dateInput.el)).language);
  }
}
function isCalendarOpenState(dateInput) {
  const {
    state
  } = dateInput;
  for (var _len = arguments.length, openState = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    openState[_key - 1] = arguments[_key];
  }
  const result = openState.find(s => s === state.calendarOpenState);
  return !!result;
}
////////////////////////////////////////////////////////////////////////////////////////////////
// This section manages capturing and returning the method used to change a date. This value is 
// passed with the 'change' event. The change event is fired in the state update handler. 
// There is nothing in DateInputState to tell us this information, so we need a way of saving this  
// to be retrieved when firing the event.
let lastChangeMethod;
function setChangeMethod(method) {
  lastChangeMethod = method;
}
function getChangeMethod() {
  return lastChangeMethod;
}
////////////////////////////////////////////////
// - Helper functions
function getInputs$1(dateInput) {
  return Array.from(dateInput.el.querySelectorAll('[data-date-part="year"],[data-date-part="month"],[data-date-part="day"]'));
}
function to2Digits(value) {
  return `00${value}`.slice(-2);
}

/**
 * Gets the target element from an element's attribute. Used by elements that 'trigger' another component
 * Target reference can be an id or a selector
 * Checks 3 atttributes
 * - aria-controls
 * - attribute, which defaults to 'data-target'
 * - href
 * @param element with the target or href attribute
 * @param attribute - The attribute to check after aria-controls. Defaults to 'data-target'
 * @return The target element found or null if not found
 */
function getTargetElement(element, attribute) {
  try {
    const selector = getTargetSelector(element, attribute);
    return document.getElementById(selector) || document.querySelector(selector) || null;
  } catch (err) {
    return null;
  }
}
/**
 * Returns an array of 'target' elements from an element's attribute.
 * Used by elements that 'trigger' one or more components.
 * Target reference can be an id or a selector
 * Checks 3 atttributes
 * - aria-controls
 * - attribute, which defaults to 'data-target'
 * - href
 * @param element with the target or href attribute
 * @param attribute - The attribute to check after aria-controls. Defaults to 'data-target'
 * @return The target element found or null if not found
 */
function getTargetElements(element, attribute) {
  try {
    const selector = getTargetSelector(element, attribute);
    const elements = Array.from(document.querySelectorAll(selector));
    if (elements.length === 0) {
      const element = document.getElementById(selector);
      if (element) {
        elements.push(element);
      }
    }
    return elements;
  } catch (err) {
    return [];
  }
}
/**
 * Gets the selector (or id) for a target element from an element's attribute. Used by elements that 'trigger' another component
 * Target reference can be an id or a selector
 * Checks 3 atttributes
 * - aria-controls
 * - attribute, which defaults to 'data-target'
 * - href
 * @param element with the target or href attribute
 * @param attribute - The attribute to check after aria-controls. Defaults to 'data-target'
 * @return The target element found or null if not found
 * @param element
 * @param attribute
 */
function getTargetSelector(element) {
  let attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-target';
  let selector = element.getAttribute('aria-controls') || element.getAttribute(attribute);
  if (!selector || selector === "true") {
    const href = element.getAttribute('href');
    selector = href && href[0] === '#' && href.length > 1 ? href.trim() : '';
  }
  return selector;
}

// finally got tired of writing unique id logic
function uid(base) {
  let id;
  do {
    id = base + (Math.floor(Math.random() * (1001 - 101 + 1)) + 101);
  } while (!!document.getElementById(id));
  return id;
}

const CALENDAR_CLASS = `${CSS_NS}calendar`;
const DATE_INPUT_CLASS = `${CSS_NS}date-input`;
const WITH_CALENDAR_CLASS = `${DATE_INPUT_CLASS}--with-calendar`;
const CALENDAR_OPEN = `${DATE_INPUT_CLASS}--calendar-open`;
const HAS_FOCUS_CLS = `${DATE_INPUT_CLASS}--focus-within`;
const INSTANCE_KEY$k = `${NAMESPACE}DateInput`;
const ESCAPE_LABEL = /*#__PURE__*/uid(`__${CSS_NS}calendar-escape-label--`);
const TRIGGER_SELECTOR$2 = '[data-trigger="calendar"]';
let nextId$c = 1;
class _DateInputInstance {
  constructor(element) {
    this.onDestroy = [];
    this.el = this.host = element;
    this.setConfig(configFromDataAttributes(element));
    this.store = createStore$7(element);
    element.dataset.enhancedDate = "true";
    // it is important that subscribe occurs before bind so that, when behavior throws a change event
    // when the store updates, this module will have the current state when calling get value or valueAsDate 
    const unsubscribe = this.store.subscribe(this.onStateUpdate.bind(this));
    const unbind = bindDateInput(this);
    this.onDestroy = [unbind, unsubscribe];
    instances$1.set(element, INSTANCE_KEY$k, this);
    const trigger = element.querySelector(TRIGGER_SELECTOR$2);
    if (trigger) {
      trigger.hidden = false;
      element.classList.add(WITH_CALENDAR_CLASS);
    }
  }
  get calendar() {
    return this._calendar || (this._calendar = getCalendarElement(this));
  }
  get calendarDialog() {
    return this.calendar;
  }
  get legacyPopover() {
    var _this$config;
    return !((_this$config = this.config) !== null && _this$config !== void 0 && _this$config.optimizedPopover);
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const currentConfig = this.config || {};
    this.config = this.configureRequired({
      ...currentConfig,
      ...config,
      ...configureDates(config, getLocale(this.el).dateFormat)
    });
    if (this._calendar) {
      new Calendar(this._calendar).setConfig(this.config);
    }
  }
  configureRequired(config) {
    const inputs = Array.from(this.el.querySelectorAll(`[data-date-part]`));
    // this logic accounts for required being set to false afterwards
    // assuming if any input is required, the date is required. Not getting into complexity of only some inputs required 
    const required = typeof config.required === 'boolean' ? config.required : !!inputs.find(input => input.required);
    inputs.forEach(input => input.required = required);
    return {
      ...config,
      required
    };
  }
  /**
   * Returns a concatenated date in ISO format (YYYY-MM-DD) based input values.
   * The value may or may not be a valid date string.
   *
   * If using this value as input to new Date() or Date.parse(), append 'T00:00' to return a date for the current
   * timezone; otherwise, the date will set for UTC
   */
  get value() {
    return getValueAsISOString(this.state);
  }
  set value(value) {
    setDateValue$1(value, this);
  }
  /**
   * If inputs contain valid date values, returns input as a Date object; otherwise returns null
   */
  get valueAsDate() {
    return getValueAsDate$1(this.state);
  }
  get isValid() {
    return this.state ? this.state.validity.valid : true;
  }
  get validity() {
    return this.state ? this.state.validity : {
      valid: true
    };
  }
  toReadableDate() {
    const s = toReadableDate(this.valueAsDate, translations(getLang(this.el)).language);
    return s;
  }
  onStateUpdate(state) {
    const {
      el
    } = this;
    const prevState = this.state || {};
    this.state = state;
    const calendar = this.calendar;
    if (calendar) {
      calendar.dataset.dialogOpenState = state.calendarOpenState;
    }
    const expanded = `${state.calendarOpenState === 'opening' || state.calendarOpenState === 'opened'}`;
    let trigger = this.el.querySelector(TRIGGER_SELECTOR$2);
    if (trigger) {
      if (expanded !== trigger.getAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', expanded);
      }
    }
    el.classList[expanded === 'true' ? 'add' : 'remove'](CALENDAR_OPEN);
    el.classList[state.hasFocus ? 'add' : 'remove'](HAS_FOCUS_CLS);
    const parts = ['month', 'day', 'year'];
    parts.forEach(part => {
      const input = el.querySelector(`[data-date-part="${part}"]`);
      const value = state[`${part}Value`];
      const prevValue = prevState[`${part}Value`];
      if (value !== prevValue && input && input.value !== value) {
        input.value = value;
      }
    });
    const invalids = [];
    const validity = state.validity;
    for (let prop in validity) {
      if (prop !== 'valid' && validity[prop]) {
        invalids.push(prop);
      }
    }
    if (invalids.length) {
      el.dataset.validity = invalids.join();
    } else {
      el.removeAttribute('data-validity');
    }
  }
  sendEvent(eventType, eventInit) {
    return this.el.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.el) {
      delete this.el.dataset.enhancedDate;
    }
    instances$1.remove(this.el, INSTANCE_KEY$k);
    this.el = this.host = this.state = this.store = this._calendar = this.config = null;
  }
}
/////////////////////////////////////////////////////////////////
// - helper functions
function getCalendarElement(dateInput) {
  const container = dateInput.el;
  let calendarEl = null;
  let trigger = container.querySelector(TRIGGER_SELECTOR$2);
  const lang = translations(getLang(container)).language;
  if (trigger) {
    calendarEl = getTargetElement(trigger) || container.querySelector(`.${CALENDAR_CLASS}`);
    if (!calendarEl) {
      calendarEl = document.createElement('div');
      new Calendar(calendarEl, dateInput.config);
      container.appendChild(calendarEl);
    } else {
      new Calendar(calendarEl).setConfig(dateInput.config);
    }
    if (!calendarEl.id) {
      calendarEl.id = container.id ? `${container.id}__${CALENDAR_CLASS}` : `${CALENDAR_CLASS}-${nextId$c++}`;
    }
    calendarEl.setAttribute('role', 'dialog');
    if (!calendarEl.hasAttribute('aria-label') && !calendarEl.hasAttribute('aria-labelledby')) {
      calendarEl.setAttribute('aria-label', lang.calendar);
    }
    const describedBy = `${calendarEl.getAttribute('aria-describedby') || ''} ${ESCAPE_LABEL}`.trim();
    calendarEl.setAttribute('aria-describedby', describedBy);
    calendarEl.classList.add(CALENDAR_CLASS);
    calendarEl.lang = container.lang;
    trigger.setAttribute('aria-controls', calendarEl.id);
    if (document.getElementById(ESCAPE_LABEL) === null) {
      var escapeLabel = document.createElement('span');
      escapeLabel.setAttribute("id", ESCAPE_LABEL);
      escapeLabel.innerText = lang.escapeLabel;
      escapeLabel.hidden = true;
      document.body.appendChild(escapeLabel);
    }
  }
  return calendarEl;
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////
onDomChanges(`.${DATE_INPUT_CLASS}`, function onDateAdded(element) {
  if (!element.dataset.enhancedDate) {
    new _DateInputInstance(element);
  }
}, function onDateRemoved(element) {
  if (element.dataset.enhancedDate === 'true') {
    new DateInput(element).destroy();
  }
});
// ////////////////////////////////////////////////////////////////////////////////////////////////////////
class DateInput {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$k) || new _DateInputInstance(element);
    if (config) {
      this.setConfig(config);
    }
  }
  setConfig(config) {
    this._instance.setConfig(config);
  }
  /**
   * Returns a concatenated date in ISO format (YYYY-MM-DD) based input values.
   * The value may or may not be a valid date string.
   *
   * If using this value as input to new Date() or Date.parse(), append 'T00:00' to return a date for the current
   * timezone; otherwise, the date will set for UTC
   */
  get value() {
    return this._instance.value;
  }
  set value(date) {
    this._instance.value = date;
  }
  /**
   * If inputs contain valid date values, returns inout as a Date object; otherwise returns null
   */
  get valueAsDate() {
    return this._instance.valueAsDate;
  }
  get isValid() {
    return this._instance.isValid;
  }
  get validity() {
    return this._instance.validity;
  }
  toReadableDate() {
    return this._instance.toReadableDate();
  }
  destroy() {
    if (this._instance) {
      this._instance.destroy();
      delete this._instance;
    }
  }
}
// // todo: how to disable? => disable fieldset. Not sure about aria-disabled. Read-only instead?
// // todo: example of showing invalid states
// // todo: placement of calendar when off-screen

function enableDropdownMenu(dropdown) {
  if (dropdown.dataset.enhancedDropdownMenu === 'true') return null;
  dropdown.dataset.enhancedDropdownMenu = 'true';
  let state = {
    lastKeyboardTimeout: 0,
    keyboardChange: false,
    restoreValue: ''
  };
  function onChange(event) {
    if (!event.isMenuAction) {
      state.keyboardChange = !!state.lastKeyboardTimeout;
      if (!state.keyboardChange) {
        fireMenuActionEvent();
      }
    }
  }
  function onKeyDown(event) {
    const key = event.key || event.code;
    switch (key) {
      case 'Enter':
        if (state.keyboardChange) {
          event.preventDefault();
          fireMenuActionEvent();
        }
        break;
      case 'Esc':
      case 'Escape':
        if (state.keyboardChange) {
          event.preventDefault();
          dropdown.value = state.restoreValue;
          initState();
        }
        break;
      case 'ArrowUp':
      case 'Up':
      case 'ArrowDown':
      case 'Down':
      case 'ArrowLeft':
      case 'Left':
      case 'ArrowRight':
      case 'Right':
        setLastKeyBoardTimeout();
        break;
      default:
        if (key.length === 1) {
          // character pressed
          setLastKeyBoardTimeout();
        }
    }
  }
  function onFocus() {
    initState();
  }
  function onBlur() {
    if (state.keyboardChange) {
      fireMenuActionEvent();
    }
  }
  function fireMenuActionEvent() {
    window.setTimeout(() => {
      const eventType = 'change';
      let event;
      if ('Event' in window && typeof window.Event === 'function') {
        event = new Event(eventType, {
          bubbles: true,
          cancelable: false
        });
      } else /* istanbul ignore next */
        {
          event = document.createEvent('Event');
          event.initEvent(eventType, true, false);
        }
      event.isMenuAction = true;
      dropdown.dispatchEvent(event);
      initState();
    });
  }
  function initState() {
    if (state.lastKeyboardTimeout) {
      window.clearTimeout(state.lastKeyboardTimeout);
    }
    state.lastKeyboardTimeout = 0;
    state.keyboardChange = false;
    state.restoreValue = dropdown.value;
  }
  function setLastKeyBoardTimeout() {
    if (state.lastKeyboardTimeout) {
      window.clearTimeout(state.lastKeyboardTimeout);
    }
    state.lastKeyboardTimeout = window.setTimeout(() => {
      state.lastKeyboardTimeout = 0;
    }, 100);
  }
  initState();
  dropdown.addEventListener('change', onChange);
  dropdown.addEventListener('keydown', onKeyDown);
  dropdown.addEventListener('focus', onFocus);
  dropdown.addEventListener('blur', onBlur);
  return function disableDropdownMenu() {
    dropdown.removeEventListener('change', onChange);
    dropdown.removeEventListener('keydown', onKeyDown);
    dropdown.removeEventListener('focus', onFocus);
    dropdown.removeEventListener('blur', onBlur);
    delete dropdown.dataset.enhancedDropdownMenu;
  };
}

class DropdownMenu {
  constructor(element) {
    this._disableDropdownMenu = enableDropdownMenu(element);
  }
  /**
   * Detaches from the element, removes event listeners, and frees resources.
   */
  destroy() {
    if (this._disableDropdownMenu) {
      this._disableDropdownMenu();
    }
    delete this._disableDropdownMenu;
  }
}
const selector = 'select[data-dropdown-menu="true"]';
document.addEventListener('focusin', e => {
  const el = e.target;
  if (el.matches(selector)) {
    // TODO: Look into this. we never actually call DropdownMenu, which
    // means listeners are never removed. May not be a memory-leak issue though 
    enableDropdownMenu(el);
  }
});

/**
 * Returns the value of an object using a dot notation path. Useful for retrieving
 * deep values in an object through configuration values;
 *
 * Example:
 * ```js
 * const person = {
 *   name: {
 *     first: 'Joe',
 *     last: 'Smith'
 *   }
 *   id: 123
 * }
 *
 * const path1 = 'name.last';
 * const path2 = 'id';
 * const lastName = getObjectValue(person, path1); // returns 'Smith'
 * const id = getObjectValue(person, path2); // returns 123
 * ```
 *
 * @param o The object to retrieve the value from
 * @param path dot delimited property path of the value to retrieve
 * @returns The value if found; otherwise null;
 */
function getObjectValue(o, path) {
  const props = path.split('.');
  const value = props.reduce((obj, prop) => {
    return obj ? obj[prop] : null;
  }, o);
  return value;
}
/**
 * Returns a string constructed with values from an object as configured in a template.
 * Object paths delimited by `{ }` are replaced by the object's value for that path.
 *
 * Example:
 * ```js
 * const person = {
 *   name: {
 *     first: 'Joe',
 *     last: 'Smith'
 *   }
 *   id: 123
 * }
 * console.log(interpolate(person, 'Hello, {name.first} {name.last}')); //outputs 'Hello, Joe Smith'
 * ```
 * @param o
 * @param template
 * @returns
 */
function interpolate(o, template) {
  const rx = /{([^{}]+)}/g; // looks for text inside { } delimiters
  return template.replace(rx, (_, path) => {
    return getObjectValue(o, path);
  });
}

const isDevelopment = /*#__PURE__*/checkIsDevelopment();
const noop = () => {};
const devConsole = {
  log: isDevelopment ? /*#__PURE__*/writeToConsole('log') : noop,
  info: isDevelopment ? /*#__PURE__*/writeToConsole('info') : noop,
  warn: isDevelopment ? /*#__PURE__*/writeToConsole('warn') : noop,
  error: isDevelopment ? /*#__PURE__*/writeToConsole('error') : noop
};
function writeToConsole(level) {
  return function () {
    for (var _len = arguments.length, msgs = new Array(_len), _key = 0; _key < _len; _key++) {
      msgs[_key] = arguments[_key];
    }
    console[level]('%cTDS', 'color: white;background:#004257;font-weight: bold; font-size:10px; padding:2px 6px; border-radius: 6px', ...msgs);
  };
}
function checkIsDevelopment() {
  const hostname = typeof window !== 'undefined' && window.location && window.location.hostname;
  return !!hostname && /(^localhost|^127\.0\.0\.1$|^0\.0\.0\.0$)/.test(hostname);
}

const ATTR_AUTOCOMPLETE = 'autocomplete';
function bindCombobox(combobox) {
  const {
    store,
    host,
    config
  } = combobox;
  let lastFilterApplied;
  //TODO: Can we remove this or change this to stop IE11 support?
  // used as workaround for bug in IE where input event fires on focus/blur when there is a placeholder
  // See onInput()
  let lastInputValue;
  let lastCommittedValue;
  let ignoreInlineComplete = false;
  let state;
  let debounceInput;
  let loadingMessageTimeout;
  const unsubscribe = store.subscribe(s => state = s);
  const {
    input,
    select,
    datalist
  } = setupCombobox(combobox);
  lastInputValue = input.value;
  let savedAutocomplete = input.getAttribute(ATTR_AUTOCOMPLETE);
  const t = translations(input).t;
  initializeFromComponentProperties();
  const eventListeners = new EventListeners();
  eventListeners.addListener(input, 'keydown', ifEnabled(onKeydown));
  eventListeners.addListener(input, 'input', ifEnabled(onInput));
  eventListeners.addListener(input, 'paste', ifEnabled(onPaste));
  eventListeners.addListener(input, 'focus', manageInputAutocomplete);
  eventListeners.addListener(input, 'blur', manageInputAutocomplete);
  eventListeners.addListener(host, 'click', ifEnabled(onClick));
  eventListeners.addListener(document, 'click', onClickOutside);
  if (config.autoFocus) {
    setTimeout(input.focus.bind(input), 100);
  }
  // a function that "unbinds". Remove event listeners, unsubscribe from store, etc.
  const unbind = () => {
    unsubscribe();
    eventListeners.removeListeners();
  };
  ///////////////////////////////////////////////
  // apply component values
  // These functions initialize from and apply updates to the component values: 
  // inputValue, selectedValue, - selectedItem
  function initializeFromComponentProperties() {
    const {
      inputValue,
      selectedValue,
      selectedItem
    } = combobox;
    const initInputValue = inputValue || input.value;
    if (initInputValue) {
      applyInputValueProperty(initInputValue);
    }
    const initSelectedValue = selectedValue || select && select.value;
    if (initSelectedValue) {
      applySelectedValueProperty(initSelectedValue);
    }
    if (selectedItem) {
      applySelectedItemProperty(selectedItem);
    }
    lastCommittedValue = input.value;
  }
  function updateProperty(property, value) {
    if (!value) {
      input.value = lastInputValue = '';
      if (select) {
        select.value = '';
      }
      updateState({
        selectedOption: undefined
      });
      return;
    }
    switch (property) {
      case 'inputValue':
        applyInputValueProperty(value);
        break;
      case 'selectedValue':
        applySelectedValueProperty(value);
        break;
      case 'selectedItem':
        applySelectedItemProperty(value);
        break;
    }
    lastInputValue = input.value;
  }
  function applyInputValueProperty(value) {
    applyFilter(value, options => {
      const index = getExactMatchIndex(options, value);
      const option = options[index];
      const codeValue = option ? option.value : '';
      input.value = value;
      if (select) {
        select.value = codeValue || '';
      }
      updateState({
        selectedOption: option
      });
    }, false);
  }
  function applySelectedValueProperty(value) {
    applyFilter('', options => {
      const option = options.find(o => o.value == value); // == is purposeful. Want to match string to number if applicable
      input.value = option ? option.name : '';
      const codeValue = option ? option.value : '';
      if (select) {
        select.value = codeValue || '';
      }
      updateState({
        selectedOption: option
      });
    }, false);
  }
  function applySelectedItemProperty(item) {
    const {
      optionValue,
      optionName
    } = combobox.config;
    const itemOption = item && toSelectOption$1(item, optionName, optionValue);
    applyFilter('', options => {
      const option = options.find(o => {
        if (itemOption.value) {
          return itemOption.value === o.value;
        }
        return itemOption.name === o.name;
      });
      input.value = option ? option.name : '';
      const codeValue = option ? option.value : '';
      if (select) {
        select.value = codeValue || '';
      }
      updateState({
        selectedOption: option
      });
    }, false);
  }
  ///////////////////////////////////////////////
  // event handlers
  function onInput() {
    // this was trigger in IE by bug that fires input event when placeholder disappears on focus
    // or appears on blur
    // https://stackoverflow.com/questions/48138865/ie-10-11-how-to-prevent-the-triggering-of-input-events-on-focus-from-text-inpu
    // If the input's value is not blank, or it is blank and the lastInputValue is not blank, then this is not caused by the placeholder coming and going   
    if (input.value || lastInputValue) {
      lastInputValue = input.value;
      const {
        nofilter,
        filterDelay
      } = config;
      const filter = !nofilter;
      let handler;
      if (filter && filterDelay) {
        handler = debounceInput || (debounceInput = debounce(onInputHandler, filterDelay));
      } else {
        debounceInput = null;
        handler = onInputHandler;
      }
      handler();
    }
  }
  function onInputHandler() {
    const filter = !combobox.config.nofilter;
    if (filter) {
      filterByInputValue();
    } else {
      updateState({
        activeIndex: getExactMatchIndex()
      });
      doInlineComplete();
    }
  }
  function onKeydown(event) {
    const key = normalizeKey(event);
    onTypingKey(event);
    const {
      showList
    } = state;
    switch (key) {
      case 'Backspace':
      case 'Delete':
        const {
          inlineComplete
        } = combobox.config;
        if (inlineComplete && input.value) {
          ignoreInlineComplete = true;
        }
        return;
      case 'Enter':
      case 'Tab':
        commitCurrentValue();
        if (showList && key === 'Enter') {
          event.preventDefault();
        }
        return;
    }
    if (showList) {
      onKeydownList(event);
    } else {
      onKeydownCombobox(event);
    }
  }
  function onKeydownCombobox(event) {
    const key = normalizeKey(event);
    switch (key) {
      case 'ArrowDown':
        event.preventDefault();
        showOptionsList(event);
        break;
    }
  }
  function onKeydownList(event) {
    const {
      altKey
    } = event;
    const {
      activeIndex,
      options
    } = state;
    const key = normalizeKey(event);
    let updateActiveIndex = activeIndex;
    const max = options ? options.length : 0;
    switch (key) {
      case 'ArrowDown':
        if (!altKey) {
          updateActiveIndex = Math.min(activeIndex + 1, max - 1);
          event.preventDefault();
        }
        break;
      case 'ArrowUp':
        if (altKey) {
          selectOption(activeIndex);
        } else if (activeIndex > 0) {
          // not using Math.max() because we don't want ArrowUp to increment -1 to 0
          updateActiveIndex = activeIndex - 1;
        }
        event.preventDefault();
        break;
      case 'Home':
        event.preventDefault();
        updateActiveIndex = 0;
        break;
      case 'End':
        event.preventDefault();
        updateActiveIndex = max - 1;
        break;
      case 'Escape':
        updateInputValue(lastCommittedValue);
        dismissOptionsList();
        event.preventDefault();
        return;
    }
    if (updateActiveIndex !== activeIndex) {
      updateState({
        activeIndex: updateActiveIndex
      });
      const option = state.options[updateActiveIndex];
      if (option) {
        updateInputValue(option.name);
      }
    }
  }
  function onTypingKey(event) {
    if (combobox.config.restrict) {
      const key = normalizeKey(event);
      if (isTypingOrDeleting(event)) {
        const newText = key.length === 1 ? key : '';
        if (!allowPotentialInput(newText, key)) {
          event.preventDefault();
        }
      }
    }
  }
  function onPaste(event) {
    if (combobox.config.restrict) {
      let text = (event.clipboardData || window.clipboardData).getData('text');
      if (text) {
        if (!allowPotentialInput(text)) {
          event.preventDefault();
        }
      }
    }
  }
  function manageInputAutocomplete(event) {
    switch (event.type) {
      case 'focus':
        // prevent Chrome from trying to guess autocomplete by setting to an arbitrary value
        savedAutocomplete = input.getAttribute(ATTR_AUTOCOMPLETE);
        input.setAttribute(ATTR_AUTOCOMPLETE, 'none');
        break;
      case 'blur':
        input.setAttribute(ATTR_AUTOCOMPLETE, savedAutocomplete);
        break;
    }
  }
  function allowPotentialInput(newText, key) {
    const {
      datasource,
      optionName,
      optionValue
    } = combobox.config;
    if (typeof datasource === 'function') {
      // we only support 'restrict' when datasource is array or derived 
      return true;
    }
    const {
      selectionStart,
      selectionEnd,
      value
    } = input;
    const textSelected = selectionEnd > selectionStart;
    const beforeTextEnd = key === 'Backspace' && !textSelected && selectionStart ? selectionStart - 1 : selectionStart;
    const afterTextStart = key === 'Delete' && !textSelected && selectionEnd < value.length - 1 ? selectionEnd + 1 : selectionEnd;
    const beforeText = value.substring(0, beforeTextEnd);
    const afterText = value.substring(afterTextStart);
    const newValue = beforeText + newText + afterText;
    const allOptions = toSelectOptions$1(datasource || deriveOptionsList(), optionName, optionValue);
    const index = getStartsWithIndex(allOptions, newValue.toLowerCase());
    return index > -1;
  }
  function onClick(event) {
    if (state.showList) {
      if (!handleSelectOption(event)) {
        selectOption(state.activeIndex);
      }
    } else {
      showOptionsList(event);
    }
    if (event.target !== input) {
      input.focus();
    }
  }
  function onClickOutside(event) {
    const target = event.target;
    const {
      host
    } = combobox;
    const internalClick = target === host || host.contains(target);
    if (!internalClick) {
      commitCurrentValue();
    }
  }
  function handleSelectOption(event) {
    const {
      optionElements = []
    } = combobox;
    const target = event.target;
    for (let i = 0; i < optionElements.length; i++) {
      if (optionElements[i].contains(target)) {
        selectOption(i);
        return true;
      }
    }
    return false;
  }
  function commitCurrentValue() {
    const {
      showList,
      activeIndex
    } = state;
    const filter = !combobox.config.nofilter;
    if (showList && activeIndex > -1) {
      selectOption(state.activeIndex);
    } else if (input.value !== lastCommittedValue) {
      // update selected value based on current input
      applyFilter(filter ? input.value : '', options => {
        updateState({
          options
        });
        // update with exact match or no option 
        selectOption(getExactMatchIndex(options, input.value));
      });
    } else if (showList) {
      dismissOptionsList();
    }
  }
  ///////////////////////////////////////////////////////////////////////////////////
  let filterByInputValueToken = 0;
  function filterByInputValue() {
    const filterText = input.value;
    const thisToken = ++filterByInputValueToken;
    applyFilter(filterText, function () {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // ensures thet we are handling the latest request in case filter is applied by a service call
      if (thisToken === filterByInputValueToken) {
        // possible input changed when not focused due to browser autocomplete. Only show list when focused
        const showList = (options.length > 0 || !!filterText) && input.matches(':focus');
        updateState({
          options,
          showList
        });
        doInlineComplete();
      }
    });
  }
  function showOptionsList(_ref) {
    let {
      type: eventType
    } = _ref;
    if (!state.showList) {
      const wrapUp = options => {
        let activeIndex = getExactMatchIndex(options);
        if (eventType === 'keydown') {
          if (activeIndex < 0) {
            activeIndex = Math.max(getStartsWithIndex(options), 0);
          }
          const activeOption = options[activeIndex];
          if (activeOption) {
            updateInputValue(activeOption.name);
          }
        }
        updateState({
          showList: true,
          options,
          activeIndex
        });
      };
      const filter = !combobox.config.nofilter;
      const inputValue = input.value.trim();
      const filterBy = filter ? inputValue : '';
      // start by applying the current input value as a filter, if applicable
      applyFilter(filterBy, options => {
        if (filterBy && (options.length === 0 || getExactMatchIndex(options) > -1)) {
          // if filtering and no options returned, or there is an exact match, then get the full list
          // otherwise, the only way see the full list is by clearing the input.
          applyFilter('', wrapUp);
        } else {
          wrapUp(options);
        }
      });
    }
  }
  function dismissOptionsList() {
    if (state.showList) {
      updateState({
        showList: false,
        activeIndex: -1
      });
    }
  }
  function getExactMatchIndex() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.options;
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : input.value.trim();
    // returns the index of the option that matches exactly (ignoring case) or -1 if not found
    let activeIndex = -1;
    value = value.toLowerCase();
    options.forEach((option, index) => {
      const optionText = option.name.toLowerCase().trim();
      if (activeIndex === -1 && optionText === value) {
        activeIndex = index;
      }
    });
    return activeIndex;
  }
  function getStartsWithIndex() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.options;
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : input.value;
    // returns the index of the option that starts with the input value (ignoring case), giving precedence to an exact match.
    let index = getExactMatchIndex(options, value);
    if (index < 0) {
      value = value.toLowerCase();
      options.forEach((option, i) => {
        const optionText = option.name.toLowerCase().trim();
        if (index === -1 && optionText.indexOf(value) === 0) {
          index = i;
        }
      });
    }
    return index;
  }
  function applyFilter() {
    let filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    let showLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const {
      datasource,
      optionName,
      optionValue
    } = combobox.config;
    function returnResults(results) {
      if (loadingMessageTimeout) {
        clearTimeout(loadingMessageTimeout);
        loadingMessageTimeout = undefined;
      }
      callback(toSelectOptions$1(results, optionName, optionValue) || []);
    }
    lastFilterApplied = filter;
    let datasourceFn = datasource;
    if (typeof datasourceFn !== 'function') {
      const allOptions = datasource ? toSelectOptions$1(datasource, optionName, optionValue) : deriveOptionsList();
      datasourceFn = simpleOptionsListFilter(allOptions);
    }
    const result = datasourceFn(filter);
    if (result && typeof result.then === 'function') {
      if (showLoading) {
        if (loadingMessageTimeout) {
          clearTimeout(loadingMessageTimeout);
        }
        loadingMessageTimeout = setTimeout(() => {
          loadingMessageTimeout = undefined;
          updateState({
            loading: true
          });
        }, 300);
      }
      result.then(returnResults).catch(() => returnResults([]));
    } else {
      returnResults(result);
    }
  }
  function doInlineComplete() {
    if (ignoreInlineComplete) {
      ignoreInlineComplete = false;
      return;
    }
    const {
      inlineComplete,
      nofilter
    } = combobox.config;
    if (inlineComplete) {
      const options = state.options;
      if (nofilter && (!options || options.length === 0)) {
        // options not loaded yet
        // (not sure if this would be the case now that initilization logic is in place, so)
        /* istanbul ignore next */
        applyFilter('', options => {
          updateState({
            options
          });
          doInlineComplete();
        });
        /* istanbul ignore next */
        return;
      }
      const startsWithIndex = getStartsWithIndex();
      const option = state.options && state.options[startsWithIndex];
      if (option) {
        const currSelStart = input.selectionStart;
        updateInputValue(option.name);
        input.setSelectionRange(currSelStart, input.value.length);
        if (startsWithIndex !== state.activeIndex) {
          updateState({
            activeIndex: startsWithIndex
          });
        }
      }
    }
  }
  function selectOption(index) {
    const {
      options
    } = state;
    const option = options[index];
    if (option) {
      updateInputValue(option.name);
    }
    updateSelectValue(option);
    updateState({
      activeIndex: index,
      showList: false,
      selectedOption: option
    });
    if (lastCommittedValue !== input.value) {
      combobox.sendEvent('tdsChange', {
        selectedItem: option && (option.item || option),
        value: input.value,
        codeValue: option && option.value || ''
      });
      lastCommittedValue = input.value;
    }
  }
  function updateInputValue(value) {
    // call this function whenever updating the input value because of user action so we can fire the change event
    if (value !== input.value) {
      // why this nonsense? React overrides input value setter, which, in the end, prevents the synthetic onChange event
      // from firing. Going to the native
      const valueDescriptor = typeof HTMLInputElement !== 'undefined' && Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
      const valueSetter = valueDescriptor && valueDescriptor.set;
      if (valueSetter) {
        valueSetter.call(input, value);
      } else {
        /* istanbul ignore next */
        input.value = value;
      }
      lastInputValue = value;
      dispatchChangeEvent(input);
    }
  }
  function updateSelectValue(option) {
    if (select) {
      const optionValue = option && option.value || '';
      // why this nonsense? See updateInputValue above
      const valueDescriptor = typeof HTMLSelectElement !== 'undefined' && Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, "value");
      const valueSetter = valueDescriptor && valueDescriptor.set;
      if (valueSetter) {
        valueSetter.call(select, optionValue);
      } else {
        /* istanbul ignore next */
        select.value = optionValue;
      }
      dispatchChangeEvent(select);
    }
  }
  function dispatchChangeEvent(element) {
    let event;
    /* istanbul ignore else */
    if (typeof Event === 'function') {
      event = new Event('change', {
        bubbles: true,
        cancelable: false
      });
    } else {
      event = document.createEvent('Event');
      event.initEvent('change', true, false);
    }
    element.dispatchEvent(event);
  }
  function updateState(newState) {
    const {
      restrict
    } = combobox.config;
    newState = {
      ...newState
    };
    if (newState.loading) {
      newState.options = [];
      newState.activeIndex = -1;
    } else if (typeof newState.options !== 'undefined') {
      newState.loading = false;
    }
    if (typeof newState.activeIndex === 'undefined' && newState.options) {
      newState.activeIndex = getExactMatchIndex(newState.options);
    }
    // not sure if this would ever be called now
    if (restrict && newState.activeIndex === -1 && input.value.trim()) {
      // always ensure a row is selected
      const options = (typeof newState.options === 'undefined' ? state.options : newState.options) || [];
      if (options.length) {
        newState.activeIndex = 0;
      }
    }
    store.update(s => {
      return deriveStatusMessages({
        ...s,
        filterText: lastFilterApplied,
        ...newState
      });
    });
  }
  // derives other state values based on state values passed here
  function deriveStatusMessages(state) {
    const {
      options,
      loading,
      filterText
    } = state;
    const {
      loadingText,
      noOptionsText
    } = combobox.config;
    const optionCount = options && options.length || 0;
    let ariaLiveMessage = '';
    let optionsStatus = '';
    let showList = state.showList;
    if (loading) {
      ariaLiveMessage = loadingText || t('optionsLoadingMessage');
      optionsStatus = ariaLiveMessage;
      showList = true;
    } else if (filterText && optionCount === 0 && noOptionsText !== '' && noOptionsText !== 'false') {
      optionsStatus = noOptionsText || t('noOptionsMessage');
      if (optionsStatus) {
        // convert "{value}" to the the input's value
        optionsStatus = optionsStatus.replace(/\{value\}/g, input.value);
      }
    }
    if (showList && !loading) {
      const count = options && options.length || 0;
      const msg = count === 0 ? optionsStatus : count === 1 ? t('hasOneOptionMessage') : t('hasOptionsMessage', `${count}`);
      ariaLiveMessage = msg;
    }
    return {
      ...state,
      showList,
      optionsStatus,
      ariaLiveMessage
    };
  }
  function ifEnabled(handler) {
    return event => {
      const {
        host
      } = combobox;
      const hostEnabled = host.getAttribute('aria-disabled') !== 'true';
      const inputEnabled = !input.disabled && input.getAttribute('aria-disabled') !== 'true' && !input.readOnly;
      if (hostEnabled && inputEnabled) {
        handler(event);
      } else if (event.type === 'keydown' && isTypingOrDeleting(event)) {
        event.preventDefault();
      }
    };
  }
  function deriveOptionsList() {
    const optionsParent = select || datalist;
    if (optionsParent) {
      const isSelect = optionsParent.matches('select');
      const options = Array.from(optionsParent.querySelectorAll('option'));
      return options.filter(option => {
        const value = option.value || '';
        return isSelect ? !!value.trim() : true;
      }).map(option => {
        return {
          name: option.textContent.trim() || option.value,
          value: option.value
        };
      });
    }
    return [];
  }
  return {
    unbind,
    updateProperty
  };
}
function setupCombobox(combobox) {
  const {
    host,
    config
  } = combobox;
  const select = host.querySelector('select');
  if (select) {
    select.setAttribute('aria-hidden', 'true');
  }
  let input = host.querySelector('input');
  if (!input) {
    const {
      inputAttributes,
      setupInput
    } = config;
    input = document.createElement('input');
    input.setAttribute('type', 'text');
    applyInputAttributes(input, inputAttributes);
    host.appendChild(input);
    if (select) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.value) {
        input.value = selectedOption.textContent.trim() || selectedOption.value;
      }
    }
    if (typeof setupInput === 'function') {
      setupInput(input);
    }
  } else {
    input.hidden = false;
  }
  const {
    placeholder,
    name
  } = config;
  if (placeholder) {
    input.placeholder = placeholder;
  }
  if (name) {
    input.name = name;
  }
  if (select && !input.placeholder) {
    const noSelectionOption = select.querySelector('option[value=""], option:not([value])');
    if (noSelectionOption) {
      input.placeholder = noSelectionOption.textContent.trim();
    }
  }
  const autoAttributes = [[ATTR_AUTOCOMPLETE, config.autocomplete || 'off'], ['autocapitalize', 'off'], ['autocorrect', 'off'], ['spellcheck', 'false']];
  autoAttributes.forEach(_ref2 => {
    let [attr, value] = _ref2;
    if (!input.getAttribute(attr)) {
      input.setAttribute(attr, value);
    }
  });
  setupInputLabel(input, select, combobox);
  const datalist = input.list || host.querySelector('datalist');
  input.removeAttribute('list');
  if (datalist) {
    // this is a hack to make Chrome stop rendering the datalist down arrow
    // setting input::-webkit-calendar-picker-indicator in CSS doesn't seem to work
    const parent = datalist.parentNode;
    const sibling = datalist.nextElementSibling;
    parent.removeChild(datalist);
    parent.insertBefore(datalist, sibling);
  }
  return {
    input,
    datalist,
    select
  };
}
let nextId$b = 0;
function setupInputLabel(input, select, combobox) {
  const {
    config,
    host
  } = combobox;
  if (input.getAttribute('aria-label') || input.getAttribute('aria-labelledby') || input.closest('label')) {
    return; // already labelled
  }

  if (input.id && input.ownerDocument.querySelector(`label[for="${input.id}"]`)) {
    return; // already labelled
  }

  let label;
  let ariaLabel;
  let ariaLabelledby;
  // pull from select element if it exists
  if (select) {
    label = select.id && select.ownerDocument.querySelector(`label[for="${select.id}"]`);
    ariaLabel = select.getAttribute('aria-label');
    ariaLabelledby = select.getAttribute('aria-labelledby');
  }
  // if no label found, check for a label in the component
  label = label || host.querySelector('label');
  if (label) {
    const labelId = label.id || (label.id = `${label.id}__combobox-label-${++nextId$b}`);
    input.setAttribute('aria-labelledby', labelId);
    return;
  }
  // apply aria-labelledby if it exists
  ariaLabelledby = ariaLabelledby || config.labelledby;
  if (ariaLabelledby) {
    input.setAttribute('aria-labelledby', ariaLabelledby);
    return;
  }
  // apply aria-label if it exists
  ariaLabel = ariaLabel || config.label;
  if (ariaLabel) {
    input.setAttribute('aria-label', ariaLabel);
    return;
  }
  //No label could be determined
  devConsole.error('TDS Combobox not properly label. Either include an explicit label, set aria-label, set aria-labelledby, or provide a properly labelled input or select element');
}
function applyInputAttributes(input, attributes) {
  if (typeof attributes === 'string' && /^\{.+\}$/.test(attributes)) {
    attributes = JSON.parse(attributes);
  }
  if (attributes && typeof attributes === 'object') {
    Object.keys(attributes).forEach(key => {
      input.setAttribute(key, attributes[key]);
    });
  }
}
function simpleOptionsListFilter(options) {
  return filterBy => {
    filterBy = filterBy && filterBy.toLowerCase().trim();
    const ret = options.filter(option => {
      return filterBy ? option.name.toLowerCase().indexOf(filterBy) > -1 : option;
    });
    return ret;
  };
}
function toSelectOptions$1(options, optionName, optionValue) {
  return (options || []).map(option => {
    return toSelectOption$1(option, optionName, optionValue);
  });
}
function toSelectOption$1(option, optionName, optionValue) {
  if (typeof option === 'string') {
    return {
      name: option
    };
  }
  if (option.hasOwnProperty('name') && option.hasOwnProperty('value')) {
    return option;
  }
  const name = optionName ? getObjectValue(option, optionName) : null;
  const value = optionValue ? getObjectValue(option, optionValue) : null;
  return {
    name,
    value,
    item: option
  };
}

// initialize the pattern state. May have to pass in main element to determine initial state
// Alternatively, this can be implemented in the pattern behavior module if it shares common logic. 
function createStore$6() {
  return store({
    showList: false,
    options: [],
    loading: false,
    activeIndex: -1
  });
}

function renderOptionText(optionEl, option, isActive, comboxbox, state) {
  const {
    filterText
  } = state;
  const {
    highlight,
    optionRenderer
  } = comboxbox.config;
  if (typeof optionRenderer === 'function') {
    const item = option.item || option;
    if (optionRenderer({
      item,
      isActive,
      el: optionEl,
      filterText
    }) !== false) {
      return;
    }
  }
  const optionText = option.name;
  if (!highlight || !filterText) {
    optionEl.textContent = optionText;
    return;
  }
  const parts = splitTextByMatch(optionText, filterText);
  const elements = [];
  parts.forEach((part, i) => {
    if (part) {
      const tag = i % 2 ? 'mark' : 'span';
      const el = document.createElement(tag);
      el.textContent = part;
      elements.push(el);
    }
  });
  optionEl.innerHTML = '';
  elements.forEach(el => optionEl.appendChild(el));
}

/**
 * Runs a callback function while an event is active. This is most useful
 * for efficiently monitoring events such as resizing or scrollng and applying
 * updates to the DOM in without jankiness.
 */
const defaultOptions$2 = {
  runImmediate: true,
  timeoutDelay: 300
};
var doWhileEventing = (function (el, events, callback) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (typeof options === 'boolean') {
    options = {
      runImmediate: options
    };
  }
  const {
    runImmediate,
    timeoutDelay
  } = {
    ...defaultOptions$2,
    ...options
  };
  const eventList = events.split(' ').filter(e => e);
  let timeout = 0;
  const requestAnimationFrame = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : run => window.setTimeout(run, 60);
  function onEvent() {
    if (timeout) {
      window.clearTimeout(timeout);
    } else {
      requestAnimationFrame(run);
    }
    timeout = window.setTimeout(() => {
      timeout = 0;
    }, timeoutDelay);
  }
  function run() {
    callback();
    if (timeout) {
      requestAnimationFrame(run);
    }
  }
  eventList.forEach(event => {
    el.addEventListener(event, onEvent);
  });
  if (runImmediate) {
    requestAnimationFrame(run);
  }
  return () => {
    eventList.forEach(event => {
      el.removeEventListener(event, onEvent);
    });
  };
});

const ENHANCED_FLAG$h = 'enhancedCombobox';
const INSTANCE_KEY$j = `${NAMESPACE}Combobox`;
const COMBOBOX_CLASS = `${CSS_NS}combobox`;
const COMBOBOX_LIST_HIDDEN_CLASS = `${COMBOBOX_CLASS}--list-hidden`;
const COMBOBOX_LIST_CLASS = `${COMBOBOX_CLASS}__list`;
const COMBOBOX_OPTION_CLASS = `${COMBOBOX_CLASS}__option`;
const COMBOBOX_OPTION_STATUS_CLASS = `${COMBOBOX_CLASS}__list-status`;
const PATTERN_SELECTOR$9 = `.${COMBOBOX_CLASS}`;
const defaultConfig$6 = {
  optionName: 'name',
  optionValue: 'value'
};
// todo: validation? is active index and/or input.value sufficient?   
let nextId$a = 0;
class _ComboboxInstance {
  constructor(element) {
    this.firstRender = true;
    this._updateConfig = {};
    this._deprecationWarned = {};
    this.onDestroy = [];
    this.root = this.host = element;
    this.id = element.id || `__tds-combobox-${++nextId$a}`;
    this.store = createStore$6();
    element.dataset[ENHANCED_FLAG$h] = "true";
    const {
      unbind,
      updateProperty
    } = bindCombobox(this);
    const unsubscribe = this.store.subscribe(this.onStateUpdate.bind(this));
    const unwatch = watchDataAttributeChange(element, configData => {
      this._dataConfig = undefined;
      this.updateInputAttributes(configData);
      this.render();
    });
    this.onDestroy = [unbind, unsubscribe, unwatch];
    this.updateProperty = updateProperty;
    instances$1.set(element, INSTANCE_KEY$j, this);
  }
  onStateUpdate(state) {
    this.state = state;
    this.render();
  }
  sendEvent(eventType, detail) {
    return this.host.dispatchEvent(createCustomEvent(eventType, {
      detail: detail
    }));
  }
  render() {
    const {
      firstRender,
      state,
      input,
      host
    } = this;
    const {
      showList
    } = state;
    const list = this.renderList();
    const {
      label,
      labelledby
    } = getLabelFor(input);
    if (label) {
      list.setAttribute('aria-label', label);
    } else {
      list.removeAttribute('aria-label');
    }
    if (labelledby) {
      list.setAttribute('aria-labelledby', labelledby);
    } else {
      list.removeAttribute('aria-labelledby');
    }
    const activeOption = this.renderOptions(list);
    this.renderOptionStatus(list);
    this.renderLiveRegion();
    input.setAttribute('aria-expanded', `${showList}`);
    if (activeOption) {
      input.setAttribute('aria-activedescendant', activeOption.id);
    } else {
      input.removeAttribute('aria-activedescendant');
    }
    if (firstRender) {
      this.setupInput();
      this.firstRender = false;
    }
    host.classList[showList ? 'remove' : 'add'](COMBOBOX_LIST_HIDDEN_CLASS);
    if (showList && activeOption && isScrollable(list)) {
      maintainScrollVisibility(activeOption, list);
    }
    if (showList) {
      if (this.undoWhileEventing) {
        this.positionPopover();
      } else {
        this.undoWhileEventing = doWhileEventing(window, 'resize scroll', this.positionPopover.bind(this));
      }
    } else if (this.undoWhileEventing) {
      this.undoWhileEventing();
      this.undoWhileEventing = null;
    }
  }
  renderList() {
    const {
      id,
      host
    } = this;
    let list;
    while (!(list = host.querySelector(`.${COMBOBOX_LIST_CLASS}`))) {
      host.insertAdjacentHTML('beforeend', `<div id="${id}__listbox" role="listbox" class="${COMBOBOX_LIST_CLASS}"></div>`);
    }
    return list;
  }
  renderOptions(listbox) {
    const {
      state,
      id
    } = this;
    const {
      options,
      activeIndex
    } = state;
    let optionEls = this.optionElements;
    if (optionEls.length !== options.length) {
      listbox.innerHTML = options.map((_, i) => `<div role="option" id="${id}__option-${i}" class="${COMBOBOX_OPTION_CLASS}"></div>`).join('');
      optionEls = this.optionElements;
    }
    options.forEach((option, i) => {
      const optionEl = optionEls[i];
      const isActive = i === activeIndex;
      renderOptionText(optionEl, option, isActive, this, this.state);
      if (isActive) {
        optionEl.setAttribute('aria-selected', 'true');
      } else {
        optionEl.removeAttribute('aria-selected');
      }
    });
    const selectedOption = optionEls[activeIndex];
    return selectedOption;
  }
  renderOptionStatus(listbox) {
    const {
      optionsStatus
    } = this.state;
    let optionsStatusEl = listbox.querySelector(`.${COMBOBOX_OPTION_STATUS_CLASS}`);
    if (optionsStatus) {
      if (!optionsStatusEl) {
        optionsStatusEl = document.createElement('div');
        optionsStatusEl.classList.add(COMBOBOX_OPTION_STATUS_CLASS);
        listbox.appendChild(optionsStatusEl);
      }
      optionsStatusEl.textContent = optionsStatus;
    } else if (optionsStatusEl) {
      optionsStatusEl.parentNode.removeChild(optionsStatusEl);
    }
  }
  renderLiveRegion() {
    const {
      host,
      state
    } = this;
    const {
      ariaLiveMessage = ''
    } = state;
    let liveRegion;
    while (!(liveRegion = host.querySelector('[aria-live]'))) {
      host.insertAdjacentHTML('beforeend', `
      <div aria-live="polite" role="status" class="${CSS_NS}sr-only">
      </div>
      `);
    }
    liveRegion.textContent = ariaLiveMessage;
  }
  positionPopover() {
    const COMBOBOX_LIST_TOP_CLASS = `${COMBOBOX_CLASS}--list-top`;
    const {
      state,
      listElement,
      host
    } = this;
    const {
      showList,
      activeIndex
    } = state;
    const sizes = ['9', '8', '7', '6', '5'];
    //build an array of classes
    // first part is no class plus the class for each size, then repeat with COMBOBOX_LIST_TOP_CLASS
    // ['', '*--9', '*--8], (etc), '*--top', '*--top *--9', setupInput'*--top *--8', (etc)] 
    const classes = [].concat('', sizes.map(s => `${COMBOBOX_CLASS}--list-${s}`), COMBOBOX_LIST_TOP_CLASS, sizes.map(s => `${COMBOBOX_LIST_TOP_CLASS} ${COMBOBOX_CLASS}--list-${s}`));
    bestPositionElement(listElement, classes, host);
    if (showList && isScrollable(listElement)) {
      const activeOption = this.optionElements[activeIndex];
      if (activeOption) {
        maintainScrollVisibility(activeOption, listElement);
      }
    }
  }
  setupInput() {
    const {
      host,
      input
    } = this;
    const listbox = host.querySelector('[role="listbox"]');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-controls', listbox.id);
    input.setAttribute('aria-owns', listbox.id);
    input.setAttribute('aria-haspopup', listbox.getAttribute('role'));
    this.setAriaAutocomplete();
  }
  setAriaAutocomplete() {
    const {
      config,
      input
    } = this;
    const {
      nofilter,
      inlineComplete
    } = config;
    const filter = !nofilter;
    const ariaAutocomplete = filter && inlineComplete ? 'both' : filter ? 'list' : inlineComplete ? 'inline' : 'none';
    input.setAttribute('aria-autocomplete', ariaAutocomplete);
  }
  updateInputAttributes(config) {
    const {
      input
    } = this;
    if (input) {
      const propsMap = {
        label: 'aria-label',
        labelledby: 'aria-labelledby',
        autocomplete: 'autocomplete'
      };
      Object.keys(config).forEach(prop => {
        const attr = propsMap[prop];
        if (attr) {
          const value = config[prop];
          if (!!value) {
            input.setAttribute(attr, value.toString());
          } else if (input.hasAttribute(attr)) {
            input.removeAttribute(attr);
          }
        }
      });
    }
  }
  updateConfig(config) {
    const updateConfig = this._updateConfig = {
      ...this._updateConfig,
      ...this.handleDeprecatedProperties(config)
    };
    this.updateInputAttributes(updateConfig);
    this.render();
    this.setAriaAutocomplete();
  }
  handleDeprecatedProperties(config) {
    const {
      _deprecationWarned: deprecationWarned
    } = this;
    const deprecatedProperties = {
      'autoComplete': 'inlineComplete',
      'inputLabel': 'label',
      'inputLabelledby': 'labelledby'
    };
    const toDataAttr = attr => 'data-' + attr.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
    Object.keys(deprecatedProperties).forEach(prop => {
      const dataProp = toDataAttr(prop);
      const useProp = deprecatedProperties[prop];
      const useDataProp = toDataAttr(useProp);
      if (config.hasOwnProperty(prop)) {
        if (!deprecationWarned[prop]) {
          // display as an error because less ignorable than warnings
          devConsole.error(`The configuration property "${prop}" ("${dataProp}") is deprecated. Use "${useProp}" ("${useDataProp}") instead.`);
          deprecationWarned[prop] = true;
        }
        config[useProp] = config[useProp] ?? config[prop];
      }
    });
    return config;
  }
  get config() {
    if (!this._dataConfig) {
      this._dataConfig = this.handleDeprecatedProperties(configFromDataAttributes(this.host));
      convertStringRefs(this._dataConfig, ['datasource', 'optionRenderer', 'setupInput'], 'function');
    }
    return {
      ...defaultConfig$6,
      ...this._dataConfig,
      ...this._updateConfig
    };
  }
  get input() {
    return this.host.querySelector('input');
  }
  get listElement() {
    return this.host.querySelector(`.${COMBOBOX_LIST_CLASS}`);
  }
  get optionElements() {
    return Array.from(this.host.querySelectorAll(`.${COMBOBOX_LIST_CLASS} [role="option"]`));
  }
  get inputValue() {
    let value = '';
    if (!this.updateProperty) {
      // bind hasn't returned yet, so this call is from bindCombobox
      // check if configured with data attribute
      value = this.config.inputValue;
    }
    if (!value) {
      const {
        input
      } = this;
      if (input) {
        value = input.value;
      }
    }
    return value;
  }
  set inputValue(value) {
    this.updateProperty('inputValue', value);
  }
  get selectedValue() {
    let selectedValue = '';
    if (!this.updateProperty) {
      // bind hasn't returned yet, so this call is from bindCombobox
      // check if configured with data attribute
      selectedValue = this.config.selectedValue;
    }
    if (!selectedValue) {
      const selectedOption = this.state && this.state.selectedOption;
      if (selectedOption) {
        selectedValue = selectedOption.value;
      }
    }
    return selectedValue;
  }
  set selectedValue(value) {
    this.updateProperty('selectedValue', value);
  }
  get selectedItem() {
    const selectedOption = this.state && this.state.selectedOption;
    let selectedItem = selectedOption && (selectedOption.item || selectedOption);
    if (!selectedItem && !this.updateProperty) {
      // bind hasn't returned yet, so this call is from bindCombobox
      // check if passed in configuration 
      selectedItem = this.config.selectedItem;
    }
    return selectedItem;
  }
  set selectedItem(item) {
    this.updateProperty('selectedItem', item);
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.undoWhileEventing) {
      this.undoWhileEventing();
      this.undoWhileEventing = null;
    }
    if (this.root) {
      delete this.root.dataset[ENHANCED_FLAG$h];
    }
    instances$1.remove(this.host, INSTANCE_KEY$j);
    this.root = this.host = this.store = null;
  }
}
class Combobox {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$j) || new _ComboboxInstance(element);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    return this._instance.updateConfig(config);
  }
  get inputValue() {
    return this._instance.inputValue;
  }
  set inputValue(value) {
    this._instance.inputValue = value;
  }
  get selectedValue() {
    return this._instance.selectedValue;
  }
  set selectedValue(value) {
    this._instance.selectedValue = value;
  }
  get selectedItem() {
    return this._instance.selectedItem;
  }
  set selectedItem(item) {
    this._instance.selectedItem = item;
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`${PATTERN_SELECTOR$9}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$h]) {
    new Combobox(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$h] === "true") {
    new Combobox(element).destroy();
  }
});

const SpecializedGroupName = {
  Selected: "__selected__",
  Other: "__other__"
};

function getBestMatchIndex(options, text, ignoreOther) {
  let index = -1;
  if (text) {
    text = text.toLowerCase();
    for (let i = 0; i < options.length; i++) {
      if (options[i].other && ignoreOther) {
        continue;
      }
      const name = options[i].name.toLowerCase();
      if (name.startsWith(text)) {
        if (index === -1 || name === text && !options[i].other) {
          // give exact match precedence
          index = i;
        }
      }
    }
  }
  return index;
}
function getExactMatchIndex(options, text) {
  text = text.toLowerCase();
  for (let i = 0; i < options.length; i++) {
    const name = options[i].name.toLowerCase();
    if (name === text) {
      return i;
    }
  }
  return -1;
}
function isIncluded(option, options) {
  return !!options.find(o => isSame(o, option));
}
function isSame(option1, option2) {
  return option1.option === option2.option ||
  // comparing `other` as well in case text was added that happens to match the id of an existing option 
  option1.id === option2.id && !!option1.other === !!option2.other;
}
function isDisabled(option, context) {
  const {
    optionDisabled,
    maxSelection = 0,
    selectedOptions = []
  } = context;
  if (maxSelection > 0 && selectedOptions.length >= maxSelection && !isIncluded(option, selectedOptions)) {
    return true;
  }
  if (optionDisabled) {
    switch (typeof optionDisabled) {
      case 'string':
        return !!getObjectValue(option.option, optionDisabled);
      case 'function':
        return !!optionDisabled(option.option, {
          isSelected: isIncluded(option, selectedOptions),
          isOther: !!option.other
        });
    }
  }
  return false;
}
function toSelectOptions(options, def) {
  return options.map(option => toSelectOption(option, def));
}
function toSelectOption(option, def) {
  const {
    optionValue = 'value',
    optionName = 'name',
    optionShortName,
    optionId,
    groupBy
  } = def;
  if (typeof option === 'string') {
    return {
      id: option,
      value: option,
      name: option,
      groupName: groupBy ? SpecializedGroupName.Other : '',
      option
    };
  }
  const value = (getObjectValue(option, optionValue || optionName) || '').toString();
  const id = optionId ? getObjectValue(option, optionId) : value;
  const name = (getObjectValue(option, optionName) || '').toString();
  const shortName = optionShortName ? (getObjectValue(option, optionShortName) || '').toString() : '';
  const groupName = groupBy ? (getObjectValue(option, groupBy) || '').toString() : '';
  return {
    id,
    value,
    name,
    shortName,
    groupName,
    option
  };
}
function resolveAllowOther(allowOther) {
  switch (allowOther) {
    case 'true':
    case 'false':
    case 'prompt':
      return allowOther;
    default:
      return allowOther === '' ? 'true' : 'false';
  }
}
function getFilterPlacement(filter, tags, allowOther) {
  const allowOtherResolved = resolveAllowOther(allowOther);
  // if filter property not set, default to true when other values can be entered; false if not
  const filterableable = filter ?? (allowOtherResolved !== 'false' || tags === 'outside');
  // If cannot enter other values, place filter in the list (withlist), otherwise in the control (inline);
  return filterableable ? allowOtherResolved !== 'false' || tags === 'outside' ? 'inline' : 'withlist' : undefined;
}
function getPopupType(selectAll, filterPlacement) {
  return selectAll || filterPlacement === 'withlist' ? 'dialog' : 'listbox';
}
function manageInputAutocomplete() {
  const ATTR_AUTOCOMPLETE = 'autocomplete';
  let savedAutocomplete;
  return event => {
    const input = event.target.matches(`input[${ATTR_AUTOCOMPLETE}]`) ? event.target : undefined;
    if (input) {
      switch (event.type) {
        case 'focus':
          // prevent Chrome from trying to guess autocomplete by setting to an arbitrary value
          savedAutocomplete = input.getAttribute(ATTR_AUTOCOMPLETE);
          input.setAttribute(ATTR_AUTOCOMPLETE, 'none');
          break;
        case 'blur':
          input.setAttribute(ATTR_AUTOCOMPLETE, savedAutocomplete);
          break;
      }
    }
  };
}
function renderSelectedOptionsList(optionsSelector, config, state, translate) {
  const {
    summarizeAfter,
    summarizeFormat,
    summarizeAllTpl,
    delimiter,
    multiple,
    orderAsListed
  } = config;
  const {
    selectedOptions,
    orderedOptions
  } = state;
  const selectedOptionsToRender = orderAsListed ? orderOptionsAsListed(selectedOptions, optionsSelector) : selectedOptions;
  const length = selectedOptionsToRender.length;
  if (multiple && summarizeAfter > -1 && length > summarizeAfter) {
    if (summarizeFormat === 'all') {
      const tpl = summarizeAllTpl || translate('optionsSelectedTpl');
      const total = Array.isArray(optionsSelector.options) ? optionsSelector.options.length : orderedOptions.length;
      const values = interpolate({
        count: selectedOptionsToRender.length,
        total
      }, tpl).split(';');
      return length === 1 && values[1] || values[0];
    }
    const options = selectedOptionsToRender.slice(0, summarizeAfter);
    const difference = selectedOptionsToRender.length - summarizeAfter;
    const plusMoreTpl = translate('optionsSPluselectedTpl');
    const plusMore = interpolate({
      count: difference
    }, plusMoreTpl);
    const optionsList = options.map(option => option.shortName || option.name).join(delimiter + ' ');
    return `${optionsList}, ${plusMore}`;
  }
  return selectedOptionsToRender.map(option => option.shortName || option.name).join(delimiter + ' ');
}
function getAriaAutocomplete(_ref) {
  let {
    inlineComplete,
    applyFilter
  } = _ref;
  return applyFilter && inlineComplete ? 'both' : applyFilter ? 'list' : inlineComplete ? 'inline' : 'none';
}
function orderOptionsAsListed(optionsToOrder, optionsSelector) {
  const orderedOptions = [...optionsToOrder];
  const options = optionsSelector.options;
  if (options && Array.isArray(options)) {
    const selectOptions = toSelectOptions(options, optionsSelector);
    orderedOptions.sort((a, b) => {
      let indexA = selectOptions.findIndex(o => isSame(o, a));
      let indexB = selectOptions.findIndex(o => isSame(o, b));
      if (indexA < 0) {
        indexA = selectOptions.length;
      }
      if (indexB < 0) {
        indexB = selectOptions.length;
      }
      return indexA - indexB;
    });
  }
  return orderedOptions;
}
/**
 * Returns starting active index for a listbox as specified by WAI-ARIA pattern:
 * https://www.w3.org/WAI/ARIA/apg/patterns/listbox/
 * @param state SelectState
 * @param force boolean - if true, always return 0
 * @returns
 */
function getStartingActiveIndex(state, force) {
  const index = state.orderedOptions.findIndex(o => isIncluded(o, state.selectedOptions));
  return force ? Math.max(index, 0) : index;
}
function getFindByTyping(select) {
  ///////////////////////////////////////////
  // non-editable typeahead
  let startsWith = '';
  let startsWithTimeout;
  return findByTyping;
  function findByTyping(char) {
    startsWith += char.toLowerCase();
    startsWithTimeout && clearTimeout(startsWithTimeout);
    startsWithTimeout = setTimeout(resetStartsWith, 400);
    const {
      multiple
    } = select;
    const {
      orderedOptions,
      activeIndex,
      showList
    } = select.selectContext.store.get();
    let matchedOption;
    let matchedIndex;
    function findOption(s) {
      // Only start at the next index when starting to type; otherwise start from current index
      const start = multiple && !showList ? 0 :
      // if multiple and list is closed, always start from 0
      s.length === 1 ? activeIndex + 1 :
      // if it's the 1st char typed, start from the next option (or 0 if active index is -1) so that hitting key repeatedly cycles through items starting with char
      Math.max(activeIndex, 0); // if multiple chars typed, start from where we are (or 0 if active index is -1) in case active option still matches text string.
      const length = orderedOptions.length;
      const end = start + length;
      for (let i = start; i < end; i++) {
        // will wrap around to the start. Modulus will resolve index
        const index = i % length;
        const option = orderedOptions[index];
        const optionText = (option.name || '').toLowerCase();
        if (optionText.startsWith(s)) {
          matchedOption = option;
          matchedIndex = index;
          break;
        }
      }
    }
    findOption(startsWith);
    if (!matchedOption && Array.from(startsWith).every(c => c === startsWith[0])) {
      // user typed same letter 2x. Unless looking for aardvark, assume repeating the same letter to quickly
      // scroll through items starting with that letter
      findOption(startsWith[0]);
    }
    if (matchedOption) {
      // show list if needed
      select.selectContext.store.update({
        activeIndex: matchedIndex,
        showList: true
      });
    }
  }
  function resetStartsWith() {
    startsWith = '';
    startsWithTimeout = undefined;
  }
}

function bindListbox(listBoxContext) {
  const optionSelector = '[role="option"]';
  const {
    listbox,
    controller
  } = listBoxContext;
  let state;
  const unsub = listBoxContext.selectContext.store.subscribe(s => state = s);
  const eventListeners = new EventListeners();
  eventListeners.addListener(listbox, 'click', onClick);
  eventListeners.addListener(listbox, 'mousedown', onMousedown);
  eventListeners.addListener(listbox, 'focus', onFocus);
  eventListeners.addListener(controller, 'keydown', onKeydown);
  let ignoreFocus = false;
  function unbind() {
    unsub();
    eventListeners.removeListeners();
  }
  function onMousedown(event) {
    const target = event.target;
    const optionEl = event.target.closest(optionSelector);
    // if listbox does not have focus, and pressing an option elemenet, this is the start of a click event,
    // so ignore the focus handler logic. See onFocus() for more details.
    ignoreFocus = !!optionEl && target.ownerDocument.activeElement !== target;
    if (event.shiftKey && listBoxContext.multiple) {
      // prevent selection of text when shift key pressed for group selection
      event.preventDefault();
    }
  }
  function onClick(event) {
    const optionEl = event.target.closest(optionSelector);
    if (!optionEl) return;
    const optionEls = Array.from(listBoxContext.listbox.querySelectorAll(optionSelector));
    const optionIndex = optionEls.indexOf(optionEl);
    const {
      orderedOptions
    } = state;
    const option = orderedOptions[optionIndex];
    const activeIndex = state.activeIndex; // save this before updating state
    const context = listBoxContext.selectContext;
    context.store.update({
      activeIndex: optionIndex
    });
    if (event.shiftKey && listBoxContext.multiple) {
      context.selectionActions.selectRange(Math.max(activeIndex || 0, 0), option);
    } else {
      context.selectionActions.updateOption(option);
      checkClose();
    }
  }
  function onKeydown(event) {
    const key = normalizeKey(event);
    const target = event.target;
    const inputEl = target.matches('input') ? target : null;
    if (inputEl && inputEl.value && ['ArrowDown', 'ArrowUp', 'Enter'].indexOf(key) === -1) {
      return; // if target is input and it's not one of the above keys, ignore
    }

    const {
      altKey,
      shiftKey,
      ctrlKey
    } = event;
    const {
      multiple,
      selectContext
    } = listBoxContext;
    const {
      activeIndex,
      orderedOptions
    } = state;
    let updateActiveIndex = activeIndex;
    const noOfOptions = orderedOptions ? orderedOptions.length : 0;
    const actions = selectContext.selectionActions;
    switch (key) {
      case 'ArrowDown':
        event.preventDefault();
        if (activeIndex < noOfOptions - 1) {
          updateActiveIndex = activeIndex + 1;
          if (multiple && shiftKey) {
            actions.shiftArrow(true);
          }
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (activeIndex > 0 && !altKey) {
          updateActiveIndex = activeIndex - 1;
          if (multiple && shiftKey) {
            actions.shiftArrow(false);
          }
        }
        break;
      case 'Home':
        event.preventDefault();
        updateActiveIndex = 0;
        if (multiple && shiftKey) {
          actions.selectRange(0, activeIndex);
        }
        break;
      case 'End':
        event.preventDefault();
        updateActiveIndex = noOfOptions - 1;
        if (multiple && shiftKey) {
          actions.selectRange(activeIndex, noOfOptions - 1);
        }
        break;
      case 'Enter':
      case ' ':
        if (target.matches('button')) {
          return;
        }
        if (activeIndex > -1 && !(event.defaultPrevented && key === 'Enter')) {
          // enter not handled
          actions.onEnter(shiftKey);
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          checkClose();
        }
        break;
      case 'a':
      case 'A':
        if (multiple && ctrlKey) {
          event.preventDefault();
          actions.toggleSelectAll();
          break;
        }
    }
    if (updateActiveIndex !== activeIndex) {
      selectContext.store.update({
        activeIndex: updateActiveIndex
      });
    }
  }
  function onFocus() {
    // ignore this logic if focus is caused by the start of a click event. Otherwise, when clicking an
    // option that the user scrolled to using the scrollwheel, this logic would scroll to the top
    // and effectively cancel the click event. See https://github.prodlb.travp.net/travelers/tds/issues/1604
    if (!ignoreFocus) {
      const {
        activeIndex,
        orderedOptions,
        activeOptionId
      } = state;
      if (activeIndex < 0 || activeIndex >= orderedOptions.length) {
        const activeIndex = getStartingActiveIndex(state, true);
        listBoxContext.selectContext.store.update({
          activeIndex
        });
      }
      const activeOption = activeOptionId ? listbox.querySelector(`#${activeOptionId}`) : null;
      if (activeOption) {
        maintainScrollVisibility(activeOption, listbox);
      }
    }
    ignoreFocus = false;
  }
  function checkClose() {
    const {
      multiple,
      selectContext
    } = listBoxContext;
    if (!multiple) {
      selectContext.hideOptionsPopup(true);
    }
  }
  return unbind;
}

function createStore$5() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return store({
    showList: false,
    filteredOptions: [],
    orderedOptions: [],
    selectedOptions: [],
    selectionTick: 0,
    activeIndex: -1,
    filterText: '',
    ...initialState
  });
}

function updateOrderedOptions(store, context) {
  const {
    filteredOptions,
    selectedOptions
  } = store.get();
  store.update(orderOptions(filteredOptions, selectedOptions, context));
}
function orderOptions(options, selectedOptions, context) {
  if (context.groupBy) {
    return groupOptions(options, selectedOptions, context);
  } else if (context.selectedFirst && context.multiple) {
    return orderSelectedFirst(options, selectedOptions);
  } else {
    return {
      orderedOptions: options,
      groupedOptions: undefined
    };
  }
}
function groupOptions(options, selectedOptions, context) {
  const {
    selectedFirst,
    multiple
  } = context;
  const groupedOptions = options.reduce((groups, option) => {
    const isSelected = selectedFirst && multiple && isIncluded(option, selectedOptions);
    const groupName = isSelected ? SpecializedGroupName.Selected : option.groupName; // rendering the Selected group name will be a component concern
    let group = groups.find(group => group.name === groupName);
    if (!group) {
      group = {
        name: groupName,
        options: []
      };
      const method = selectedFirst && isSelected ? 'unshift' : 'push';
      groups[method](group);
    }
    group.options.push(option);
    return groups;
  }, []);
  const orderedOptions = groupedOptions.reduce((list, group) => {
    return [...list, ...group.options];
  }, []);
  return {
    orderedOptions,
    groupedOptions
  };
}
function orderSelectedFirst(options, selectedOptions) {
  const firstOptions = [];
  const lastOptions = [];
  options.forEach(option => {
    const arr = isIncluded(option, selectedOptions) ? firstOptions : lastOptions;
    arr.push(option);
  });
  return {
    orderedOptions: [...firstOptions, ...lastOptions],
    groupedOptions: undefined
  };
}

function createOptionsGetter(context, store) {
  let loadingTimeout;
  let lastOptionsRequest;
  const {
    options
  } = context;
  const asyncOptions = typeof options === 'function';
  const startingOptions = asyncOptions ? [] : options;
  const filteredOptions = toSelectOptions(startingOptions, context);
  if (filteredOptions.length) {
    store.update({
      filteredOptions
    });
  }
  return function getOptions() {
    let filterText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const {
      options: configOptions
    } = context;
    filterText = filterText.trim();
    const promise = typeof configOptions === 'function' ? getOptionsAsync(configOptions, filterText).then(options => toSelectOptions(options, context)) : Promise.resolve(filterOptions(toSelectOptions(configOptions, context), filterText));
    return promise.then(selectOptions => {
      selectOptions = addCreatedSelectedOptions(selectOptions, filterText);
      selectOptions = addCreateOption(selectOptions, filterText);
      return setOptions(selectOptions, filterText);
    }).catch(() => {
      return setOptions([], filterText);
    });
  };
  function addCreatedSelectedOptions(options, filterText) {
    const createdOptions = store.get().selectedOptions.filter(o => {
      return o.other && optionMatches(o, filterText) && !isIncluded(o, options);
    });
    return [...options, ...createdOptions];
  }
  function addCreateOption(options, filterText) {
    const allowOther = resolveAllowOther(context.allowOther);
    if (allowOther === 'prompt' && filterText) {
      const exactIndex = getExactMatchIndex(options, filterText);
      if (exactIndex < 0) {
        const newOption = toSelectOption(filterText, context);
        newOption.other = true;
        return [...options, newOption];
      }
    }
    return options;
  }
  function setOptions(options, filterText) {
    const selectedOptions = store.get().selectedOptions;
    store.update({
      filteredOptions: options,
      filterText: filterText,
      ...orderOptions(options, selectedOptions, context)
    });
    return options;
  }
  function getOptionsAsync(loadOptions, filterText) {
    if (lastOptionsRequest && lastOptionsRequest.filterText === filterText) {
      //  is a way to prevent unintentional multiple calls for the same set of options
      return Promise.resolve(lastOptionsRequest.response);
    }
    const lastRequest = lastOptionsRequest && {
      ...lastOptionsRequest
    };
    const thisRequest = lastOptionsRequest = {
      filterText,
      response: undefined,
      resolved: false
    };
    // updating here so handoff will work
    store.update({
      filterText: filterText
    });
    showLoading(true);
    return thisRequest.response = Promise.resolve(!filterText && context.defaultOptions || loadOptions(filterText, lastRequest)).then(response => {
      thisRequest.response = response;
      thisRequest.resolved = true;
      if (thisRequest !== lastOptionsRequest && lastOptionsRequest.resolved) {
        return lastOptionsRequest.response; // did not complete before later request, so return latest 
      }

      return response;
    }).catch(err => {
      //todo: how to respond to error?
      thisRequest.response = [];
      thisRequest.resolved = true;
      if (thisRequest !== lastOptionsRequest && lastOptionsRequest.resolved) {
        return lastOptionsRequest.response; // did not complete before later request, so return latest 
      }

      throw err;
    }).finally(() => {
      if (thisRequest === lastOptionsRequest) {
        showLoading(false);
      }
    });
  }
  function showLoading(loading) {
    if (loadingTimeout) {
      clearTimeout(loadingTimeout);
      loadingTimeout = undefined;
    }
    if (loading === store.get().loading) return;
    if (loading) {
      loadingTimeout = setTimeout(() => {
        store.update({
          loading: true,
          filteredOptions: [],
          orderedOptions: [],
          groupedOptions: []
        });
        loadingTimeout = undefined;
      }, 300); // why 300? See https://lawsofux.com/doherty-threshold/
    } else {
      store.update({
        loading: false
      });
    }
  }
  function filterOptions(options, filterText) {
    return options.filter(option => optionMatches(option, filterText));
  }
  function optionMatches(option, filterText) {
    return applyFilterPredicate(option, filterText) ?? isMatch(option, filterText);
  }
  function applyFilterPredicate(option, filterText) {
    const {
      filterPredicate
    } = context;
    return typeof filterPredicate === 'function' ? filterPredicate(option.option, filterText, {
      isSelected: isIncluded(option, store.get().selectedOptions),
      isOther: option.other
    }) : undefined;
  }
  function isMatch(option, filterText) {
    const text = filterText.toLowerCase();
    let name = option.name.toLowerCase();
    let matches = name.includes(text);
    if (!matches) {
      const rx = /[^\w\d\s]|_/g;
      const dashes = ['-', '_', '–', '—'];
      if (rx.test(name) && !rx.test(text)) {
        // if name contains punction and user has not typed punctuation, strip punctuation from name and try again
        const nopunctuation = name.replace(rx, match => dashes.includes(match) ? ' ' : '');
        matches = nopunctuation.includes(text);
      }
    }
    return matches;
  }
}

function createSelectActions(context, store) {
  return {
    updateOption,
    selectOptions,
    deselectOption,
    selectRange,
    toggleSelectAll,
    clear,
    selectAll,
    onEnter,
    shiftArrow,
    textEntry
  };
  function updateOption(option) {
    const {
      multiple
    } = context;
    const selected = isIncluded(option, store.get().selectedOptions);
    if (multiple) {
      if (selected) {
        deselectOption(option);
      } else {
        selectOptions([option], option.other && !option.otherHasBeenSelected ? 'create' : 'select');
      }
    } else if (!selected && optionEnabled(option)) {
      updateSelectedOptions([option], {
        type: 'select',
        affectedOptions: toOptionObjectArray([option])
      });
    }
  }
  function selectOptions(options) {
    let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'select';
    const selectedOptions = store.get().selectedOptions;
    options = options.filter(optionEnabled).filter(o => !isIncluded(o, selectedOptions));
    if (!options.length) {
      return;
    }
    updateSelectedOptions([...selectedOptions, ...options], {
      type: action,
      affectedOptions: toOptionObjectArray(options)
    });
  }
  function deselectOption(option) {
    if (optionEnabled(option)) {
      updateSelectedOptions(store.get().selectedOptions.filter(o => !isSame(o, option)), {
        type: 'deselect',
        affectedOptions: toOptionObjectArray([option])
      });
    }
  }
  function selectRange(option1, option2) {
    let action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-range';
    const {
      orderedOptions
    } = store.get();
    const addedOptions = [];
    const index1 = typeof option1 === 'number' ? option1 : orderedOptions.indexOf(option1);
    const index2 = typeof option2 === 'number' ? option2 : orderedOptions.indexOf(option2);
    const from = Math.max(Math.min(index1, index2), 0);
    const to = Math.min(Math.max(index1, index2, 0), orderedOptions.length);
    for (let i = from; i <= to; i++) {
      const option = orderedOptions[i];
      addedOptions.push(option);
    }
    if (addedOptions.length) {
      selectOptions(addedOptions, action);
    }
  }
  function toggleSelectAll() {
    const orderedOptions = store.get().orderedOptions.filter(optionEnabled);
    const selectedOptions = store.get().selectedOptions.filter(optionEnabled);
    if (orderedOptions.length === selectedOptions.length) {
      clear();
    } else {
      selectAll();
    }
  }
  function clear() {
    const {
      selectedOptions
    } = store.get();
    const clearEnabledSelectedOptions = selectedOptions.filter(optionEnabled);
    const keepDisabledSelectedOptions = selectedOptions.filter(o => !isIncluded(o, clearEnabledSelectedOptions));
    if (clearEnabledSelectedOptions.length || context.value && !context.multiple) {
      updateSelectedOptions(keepDisabledSelectedOptions, {
        type: 'clear',
        affectedOptions: toOptionObjectArray(clearEnabledSelectedOptions)
      });
    }
  }
  function selectAll() {
    selectRange(0, store.get().orderedOptions.length - 1, 'select-all');
  }
  function onEnter(shiftKey) {
    const {
      multiple
    } = context;
    const {
      activeIndex,
      selectedOptions,
      orderedOptions
    } = store.get();
    const activeOption = orderedOptions[activeIndex];
    if (!activeOption) return;
    if (multiple) {
      if (shiftKey && selectedOptions.length) {
        const lastSelectedOption = selectedOptions[selectedOptions.length - 1];
        selectRange(activeOption, lastSelectedOption);
        return;
      }
    }
    if (activeOption) {
      updateOption(activeOption);
    }
  }
  function shiftArrow(down) {
    const {
      orderedOptions,
      activeIndex
    } = store.get();
    const fromIndex = activeIndex;
    const toIndex = fromIndex + (down ? 1 : -1);
    const fromOption = orderedOptions[fromIndex];
    const toOption = orderedOptions[toIndex];
    if (!fromOption || !toOption) return;
    const selectedOptions = store.get().selectedOptions;
    // if 'from' is selected and 'to' is not selected, select 'to'
    // if both 'from' and 'to' are selected, deselect 'from'
    // if 'from' is not selected, select both 'to' and 'from'?
    if (isIncluded(fromOption, selectedOptions)) {
      if (isIncluded(toOption, selectedOptions)) {
        deselectOption(fromOption);
      } else {
        selectOptions([toOption]);
      }
    } else {
      selectOptions([fromOption, toOption], 'select-range');
    }
  }
  function textEntry(value) {
    // Note: disabled options are ignored here. Not sure how to handle a custom entry that matches
    // a disabled entry.
    if (context.multiple) return;
    const autoSelect = !context.noAutoSelect;
    const state = store.get();
    // assume clearing current selection to start
    let affectedOptions = [...state.selectedOptions];
    let selectedOptions = [];
    if (autoSelect) {
      const exactOption = state.orderedOptions[getExactMatchIndex(state.orderedOptions, value)];
      if (exactOption) {
        if (isIncluded(exactOption, state.selectedOptions)) {
          return; // if selected, nothing to do
        }
        // if not selected, select it
        affectedOptions = [exactOption];
        selectedOptions = [exactOption];
      }
    }
    updateSelectedOptions(selectedOptions, {
      type: 'text-entry',
      affectedOptions: toOptionObjectArray(affectedOptions),
      textValue: value
    });
  }
  function updateSelectedOptions(selectedOptions, selectChangeAction) {
    selectedOptions.forEach(option => {
      if (option.other) {
        // listbox needs to know when added option has been selected, even if no longer selected
        option.otherHasBeenSelected = true;
      }
    });
    store.update({
      selectedOptions,
      selectChangeAction
    });
  }
  function optionEnabled(option) {
    return !isDisabled(option, {
      optionDisabled: context.optionDisabled,
      maxSelection: context.maxSelection,
      selectedOptions: store.get().selectedOptions
    });
  }
}
function toOptionObjectArray(options) {
  return options.map(o => o.option);
}

const contextMap = /*#__PURE__*/new WeakMap();
class SelectContext {
  static getInstance(el, selector) {
    if (!contextMap.has(el)) {
      contextMap.set(el, new SelectContext(el));
    }
    const context = contextMap.get(el);
    if (selector) {
      context.init(selector);
    }
    return context;
  }
  constructor(el) {
    this._el = el;
    this._store = createStore$5();
    this._unsub = this._store.subscribe(this.onStateUpdate.bind(this));
  }
  init(select) {
    this._select = select;
    this._getOptions = createOptionsGetter(select, this._store);
    this._selectionActions = createSelectActions(select, this._store);
    updateOrderedOptions(this._store, select);
  }
  get store() {
    return this._store;
  }
  get state() {
    return this._state;
  }
  get selectionActions() {
    return this._selectionActions;
  }
  get optionSelector() {
    return this._select;
  }
  getOptions() {
    let filterText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return this._getOptions(filterText);
  }
  hideOptionsPopup() {
    let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (this._state.showList) {
      this._store.update({
        showList: false,
        activeOptionId: undefined
      });
      const {
        _select
      } = this;
      if (focus && _select.focusCombobox) {
        _select.focusCombobox();
      }
    }
  }
  destroy() {
    this._unsub && this._unsub();
    contextMap.delete(this._el);
  }
  onStateUpdate(s) {
    const oldState = this._state;
    this._state = s;
    if (oldState && oldState.selectedOptions !== s.selectedOptions && this._select.selectedFirst) {
      updateOrderedOptions(this._store, this._select);
    }
  }
}

function renderOptionContent(name, data, config, translate) {
  var _data$filterText;
  const filterText = (_data$filterText = data.filterText) === null || _data$filterText === void 0 ? void 0 : _data$filterText.trim();
  const optionRenderer = config.optionRenderer;
  const renderedOption = optionRenderer && optionRenderer(data);
  const otherPrompt = data.isOther && formatOtherPrompt(name, config.addOtherTpl, translate);
  const highlighted = config.highlight && filterText && highlightMatches(name, filterText);
  const content = renderedOption || otherPrompt || highlighted || name;
  return content;
}
function formatOtherPrompt(name, addOtherTpl, translate) {
  const tpl = addOtherTpl || translate('addOtherPrompt');
  return interpolate({
    name
  }, tpl);
}
function highlightMatches(name, filterText) {
  const parts = splitTextByMatch(name, filterText);
  const elements = [];
  parts.forEach((part, i) => {
    if (part) {
      const tag = i % 2 ? 'mark' : 'span';
      const el = document.createElement(tag);
      el.textContent = part;
      elements.push(el);
    }
  });
  return elements;
}

const ENHANCED_FLAG$g = 'enhancedListbox';
const INSTANCE_KEY$i = `${NAMESPACE}Listbox`;
const BASE_CLASS$5 = 'tds-listbox';
const CLASSES$3 = {
  status: `${BASE_CLASS$5}__status`,
  groupLabel: `${BASE_CLASS$5}__groupLabel`,
  multiple: `${BASE_CLASS$5}--multiple`,
  selectedFirst: `${BASE_CLASS$5}--selectedFirst`,
  condensed: `${BASE_CLASS$5}--condensed`,
  activeOption: `${BASE_CLASS$5}__option--active`
};
let nextId$9 = 1;
class _ListboxInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    this._clearListbox = true;
    this.listbox = element;
    this._apiConfig = config;
    element.dataset[ENHANCED_FLAG$g] = "true";
    this._baseId = this.listbox.id || `__tds-listbox-${nextId$9++}`;
    const passedContext = this.config.selectContext;
    const context = this._selectContext = passedContext || SelectContext.getInstance(element, this);
    this.store = context.store;
    this.onDestroy = [this.store.subscribe(this.onStateUpdate.bind(this))];
    if (!passedContext) {
      this.onDestroy.push(bindListbox(this), context.destroy.bind(context));
    }
    this.render();
    this.render = debounce(this.render.bind(this), 0);
    instances$1.set(element, INSTANCE_KEY$i, this);
  }
  onStateUpdate(state) {
    var _this$state;
    const groupedOptions = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.groupedOptions;
    this.state = state;
    if (this._rendered) {
      if (!!groupedOptions !== !!state.groupedOptions) {
        this._clearListbox = true; // to force a restructing of the listbox
      }

      const activeOption = state.orderedOptions[state.activeIndex];
      const activeOptionId = activeOption ? this.getOptionElementId(activeOption) : '';
      if (activeOptionId !== state.activeOptionId) {
        this.store.update({
          activeOptionId
        });
        return; // this will be called again after store.update 
      }

      this.render();
    }
  }
  updateConfig(config) {
    if (this._apiConfig !== config) {
      const lastGroupBy = this.config.groupBy;
      this._apiConfig = {
        ...this._apiConfig,
        ...config
      };
      this._config = undefined;
      if (this._rendered) {
        if (lastGroupBy !== this.config.groupBy) {
          this._clearListbox = true; // to force a restructing of the listbox
        }

        this.render();
      }
    }
  }
  get config() {
    return this._config || (this._config = {
      optionName: 'name',
      optionValue: 'value',
      options: [],
      // only using data attributes for testing as standalone component, so not bothering with string conversions
      // watching for attribue changes
      ...configFromDataAttributes(this.listbox),
      ...(this._apiConfig || {})
    });
  }
  render() {
    if (!this.listbox) return; // instance destroyed before debounce timeout
    const {
      multiple,
      selectedFirst,
      condensed,
      label,
      labelledby,
      groupBy
    } = this.config;
    const {
      listbox,
      controller
    } = this;
    const {
      groupedOptions,
      orderedOptions
    } = this.state;
    this._translate = translations(this.listbox).t;
    if (this._clearListbox) {
      while (this.listbox.lastChild) {
        this.listbox.lastChild.remove();
      }
      this._clearListbox = false;
    }
    const classes = {
      [CLASSES$3.multiple]: multiple,
      [CLASSES$3.selectedFirst]: selectedFirst,
      [CLASSES$3.condensed]: condensed
    };
    applyClasses(listbox, classes);
    const attributes = {
      role: "listbox",
      tabindex: controller === listbox ? 0 : undefined,
      'aria-multiselectable': multiple ? 'true' : undefined,
      'aria-label': label,
      'aria-labelledby': labelledby
    };
    applyAttributes(listbox, attributes);
    this.renderOptionsStatus();
    if (groupedOptions && groupBy) {
      this.renderGroups();
    } else {
      this.renderOptions(orderedOptions, listbox, this.optionStatusItem);
    }
    this._rendered = true;
    this.postRender();
  }
  renderGroups() {
    const groupedOptions = this.state.groupedOptions;
    const listbox = this.listbox;
    const optionStatusEl = this.optionStatusItem;
    const groups = Array.from(listbox.querySelectorAll('div[role="group"]'));
    while (groups.length > groupedOptions.length) {
      groups.pop().remove();
    }
    groupedOptions.forEach((group, i) => {
      const id = `${this._baseId}__listgrouplabel-${i}`;
      const display = this.formatGroupName(group.name);
      let groupEl = groups[i];
      if (!groupEl) {
        groupEl = listbox.ownerDocument.createElement('div');
        groupEl.setAttribute('role', 'group');
        groupEl.setAttribute('aria-labelledby', id);
        listbox.insertBefore(groupEl, optionStatusEl);
      }
      let groupLabelEl;
      while (!(groupLabelEl = groupEl.querySelector(`div.${CLASSES$3.groupLabel}`))) {
        groupEl.insertAdjacentHTML('afterbegin', `<div class="${CLASSES$3.groupLabel}" role="presentation"></div>`);
      }
      groupLabelEl.id = id;
      groupLabelEl.textContent = display;
      this.renderOptions(group.options, groupEl);
    });
  }
  renderOptions(options, parent, insertBefore) {
    const optionEls = Array.from(parent.querySelectorAll('div[role="option"]'));
    while (optionEls.length > options.length) {
      optionEls.pop().remove();
    }
    options.forEach((option, i) => {
      let optionEl = optionEls[i];
      if (!optionEl) {
        optionEl = parent.ownerDocument.createElement('div');
        optionEl.setAttribute('role', 'option');
        parent.insertBefore(optionEl, insertBefore);
      }
      this.renderOption(optionEl, option);
    });
  }
  renderOption(optionEl, option) {
    const {
      multiple,
      optionDisabled,
      maxSelection,
      prepElement
    } = this.config;
    const {
      selectedOptions,
      filterText
    } = this.state;
    const isSelected = isIncluded(option, selectedOptions);
    const name = option.name;
    const ariaSelected = isSelected ? 'true' : multiple ? 'false' : undefined;
    const ariaDisabled = isDisabled(option, {
      optionDisabled,
      maxSelection,
      selectedOptions
    }) ? 'true' : undefined;
    const id = this.getOptionElementId(option);
    const active = id === this.state.activeOptionId;
    optionEl.id = id;
    const classes = {
      [CLASSES$3.activeOption]: active,
      disabled: !!ariaDisabled
    };
    const styles = {};
    const attributes = {};
    const optionData = {
      type: 'option',
      option: option.option,
      isSelected,
      isActive: active,
      isDisabled: !!ariaDisabled,
      isOther: !!option.other && !option.otherHasBeenSelected,
      filterText
    };
    if (prepElement) {
      prepElement(optionData, classes, styles, attributes);
    }
    attributes.ariaSelected = ariaSelected;
    attributes.ariaDisabled = ariaDisabled;
    applyClasses(optionEl, classes);
    applyAttributes(optionEl, attributes);
    applyStyles(optionEl, styles);
    const content = renderOptionContent(name, optionData, this.config, this._translate);
    applyContent(optionEl, content);
  }
  renderOptionsStatus() {
    const {
      optionStatusRenderer,
      prepElement
    } = this.config;
    const {
      optionsStatus,
      loading,
      filterText
    } = this.state;
    const listbox = this.listbox;
    let optionStatusEl;
    while (!(optionStatusEl = this.optionStatusItem)) {
      listbox.insertAdjacentHTML('beforeend', `<div class="${CLASSES$3.status}" role="presentation"></div>`);
    }
    optionStatusEl.hidden = !optionsStatus;
    if (optionsStatus) {
      const classes = {};
      const styles = {};
      const attributes = {};
      const data = {
        type: loading ? 'loading' : 'nooptions',
        filterText,
        message: optionsStatus
      };
      if (prepElement) {
        prepElement(data, classes, styles, attributes);
        applyClasses(optionStatusEl, classes);
        applyAttributes(optionStatusEl, attributes);
        applyStyles(optionStatusEl, styles);
      }
      const renderedOptionStatus = optionStatusRenderer && optionStatusRenderer(data);
      applyContent(optionStatusEl, renderedOptionStatus || optionsStatus);
    } else {
      optionStatusEl.textContent = '';
    }
  }
  postRender() {
    const {
      listbox
    } = this;
    const isVisible = !!(listbox.offsetHeight && listbox.offsetWidth);
    const activeOption = listbox.querySelector(`.${CLASSES$3.activeOption}[role="option"]`);
    const activedescendant = activeOption ? activeOption.id : '';
    if (activeOption && isVisible) {
      maintainScrollVisibility(activeOption, listbox);
    }
    if (!this.config.controller) {
      listbox.setAttribute('aria-activedescendant', activedescendant);
    }
  }
  formatGroupName(name) {
    if (name === SpecializedGroupName.Other) {
      return this.config.otherGroupName || this._translate('other');
    } else if (name === SpecializedGroupName.Selected) {
      return this.config.selectedGroupName || this._translate('selected');
    } else {
      return name;
    }
  }
  getOptionElementId(option) {
    const optionIndex = this.state.orderedOptions.indexOf(option);
    return `${this._baseId}__listboxoption-${optionIndex}`;
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.listbox) {
      delete this.listbox.dataset[ENHANCED_FLAG$g];
    }
    instances$1.remove(this.listbox, INSTANCE_KEY$i);
    this.listbox = this.store = null;
  }
  get selectContext() {
    return this._selectContext;
  }
  get multiple() {
    return this.config.multiple;
  }
  get groupBy() {
    return this.config.groupBy;
  }
  get selectedFirst() {
    return this.config.selectedFirst;
  }
  get optionName() {
    return this.config.optionName;
  }
  get optionValue() {
    return this.config.optionValue;
  }
  get optionId() {
    return this.config.optionId;
  }
  get optionDisabled() {
    return this.config.optionDisabled;
  }
  get maxSelection() {
    return this.config.maxSelection;
  }
  get options() {
    return this.config.options;
  }
  get controller() {
    return this.config.controller || this.listbox;
  }
  get optionStatusItem() {
    return this.listbox.querySelector(`div.${CLASSES$3.status}`);
  }
}
class Listbox {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$i) || new _ListboxInstance(element, config);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    var _this$_instance;
    (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.updateConfig(config);
  }
  destroy() {
    return this._instance.destroy();
  }
}

function bindFilter(context, inputScope, callback) {
  const eventListeners = new EventListeners();
  let debounceTimeout;
  let lastGetOptionsTick = 0;
  let lastOptionsResponseTick = 0;
  eventListeners.addListener(inputScope, 'input', onInput);
  function unbind() {
    eventListeners.removeListeners();
  }
  function onInput(e) {
    if (context.applyFilter && !context.disabled && !context.readonly) {
      const input = e.target;
      const value = input.value;
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
        debounceTimeout = undefined;
      }
      const delay = context.filterDelay;
      if (delay > 0) {
        debounceTimeout = setTimeout(() => {
          applyFilter(value);
          debounceTimeout = undefined;
        }, delay);
      } else {
        applyFilter(value);
      }
    }
  }
  function applyFilter(filterText) {
    const thisGetOptionsTick = ++lastGetOptionsTick;
    context.selectContext.getOptions(filterText).then(results => {
      if (thisGetOptionsTick < lastOptionsResponseTick) {
        // this response returned out of order. Ignore it
        return;
      }
      lastOptionsResponseTick = thisGetOptionsTick;
      applyResults(results, filterText);
    });
  }
  function applyResults(filteredOptions, filterText) {
    if (callback) {
      callback(filteredOptions, filterText);
    }
  }
  return unbind;
}

function bindSelect(select) {
  const host = select.host;
  select.focused = hasFocus(host);
  const eventListeners = new EventListeners();
  const popupListeners = new EventListeners();
  eventListeners.addListener(host, 'click', ifEnabled(onClick));
  eventListeners.addListener(host, 'mousedown', ifEnabled(onMousedown));
  eventListeners.addListener(host, 'keydown', ifEnabled(onKeydown));
  eventListeners.addListener(host, 'input', ifEnabled(onInput));
  const noop = () => {};
  // these next 2 don't do anything when enabled, just prevent default when enabled 
  eventListeners.addListener(host, 'paste', ifEnabled(noop));
  eventListeners.addListener(host, 'cut', ifEnabled(noop));
  eventListeners.addListener(host, 'focusin', onFocus);
  eventListeners.addListener(host, 'focusout', onBlur);
  const onUnbind = [];
  onUnbind.push(bindFilter(select, host, onFilterApplied));
  const translate = translations(host).t;
  const {
    selectContext
  } = select;
  let state;
  const store = selectContext.store;
  onUnbind.push(store.subscribe(onStateUpdate));
  const findByTyping = getFindByTyping(select);
  initializeSelectionState();
  let ignoreInlineComplete;
  let ignoreBlur = false;
  let unbindListbox;
  function unbind() {
    eventListeners.removeListeners();
    popupListeners.removeListeners();
    onUnbind.forEach(fn => fn());
    if (unbindListbox) {
      unbindListbox();
    }
  }
  function onStateUpdate(newState) {
    const oldState = state;
    state = newState;
    if (oldState) {
      if (oldState.showList !== state.showList) {
        state.showList ? onShowPopup() : onHidePopup();
      }
      if (oldState.selectChangeAction !== state.selectChangeAction) {
        onSelectedOptionsChanged(state.selectChangeAction.type);
      } else if (oldState.selectedOptions !== state.selectedOptions) {
        onSelectedOptionsChanged();
      }
      deriveStatusMessages();
    }
  }
  function ifEnabled(handler) {
    return event => {
      if (!select.disabled && !select.readonly) {
        handler(event);
      } else {
        const isTab = event.type === 'keydown' && normalizeKey(event) === 'Tab';
        if (!isTab) {
          event.preventDefault();
        }
      }
    };
  }
  /////////////////////////////////////////////////
  // selection property initializers and updaters
  async function initializeSelectionState() {
    const {
      options,
      initialValue,
      initialValues,
      value,
      values,
      initialSelectedOptions = [],
      selectedOptions = [],
      noAutoSelect
    } = select;
    const stateSelectedOptions = initialSelectedOptions.length ? initialSelectedOptions : selectedOptions.length ? selectedOptions : [];
    const selectedValue = initialValue ?? value;
    const selectedValues = initialValues !== null && initialValues !== void 0 && initialValues.length ? initialValues : values !== null && values !== void 0 && values.length ? values : [];
    if (selectedValues.length === 0 && selectedValue && !noAutoSelect) {
      selectedValues.push(selectedValue);
    }
    let initialSelection;
    // selectedObjects take precendence over value/values/initialValue/initialValues
    if (stateSelectedOptions.length) {
      initialSelection = toSelectOptions(stateSelectedOptions, select);
    } else if (selectedValues.length) {
      initialSelection = await valuesToSelectOptions(selectedValues);
    } else if (selectedValue === '' && typeof options !== 'function' && options.length && !select.multiple) {
      // if there is an option that is blank, select it
      const blankOption = options.find(o => toSelectOption(o, select).value === '');
      if (blankOption) {
        initialSelection = toSelectOptions([blankOption], select);
      }
    }
    if (initialSelection && initialSelection.length) {
      store.update({
        selectedOptions: initialSelection
      });
    } else if (selectedValue) {
      ensureSingleSelectEditableValue(selectedValue);
    }
  }
  async function onSelectedPropsChanged(prop) {
    const {
      noAutoSelect
    } = select;
    let values;
    let selectedOptions = [];
    let newValue;
    if (prop === 'value') {
      newValue = select.value;
      if (!noAutoSelect) {
        values = [newValue];
      }
    } else if (prop === 'values') {
      values = select.values;
    } else {
      selectedOptions = toSelectOptions(select.selectedOptions, select);
    }
    if (values) {
      selectedOptions = await valuesToSelectOptions(values);
    }
    store.update({
      selectedOptions
    });
    if (prop === 'value' && newValue) {
      ensureSingleSelectEditableValue(newValue);
    }
  }
  function onSelectedOptionsChanged(action) {
    const {
      inputControl,
      multiple,
      selectContext
    } = select;
    const {
      selectedOptions,
      filterText,
      selectChangeAction
    } = state;
    if (inputControl) {
      if (multiple) {
        updateInputValue('');
        if (filterText) {
          // filter was clear, so reset options
          selectContext.getOptions();
        }
      } else if (selectedOptions[0]) {
        updateInputValue(selectedOptions[0].name);
      } else if (action !== 'text-entry') {
        updateInputValue('');
      }
    }
    const changeValues = getChangeEventDetail(action === 'text-entry' ? selectChangeAction.textValue : '');
    select.updateSelectedProps(changeValues);
    // maybe we should always throw event, with action assumed 'api' if not provided?
    if (action) {
      fireChangeEvent(changeValues);
    }
  }
  function ensureSingleSelectEditableValue(value) {
    // Called from both initializeSelectionState and onSelectedPropsChanged.
    // When setting value programmatically for an editable single-select, and the value does not match an existing option, 
    // this logic ensures both input and internal state match the intended value.
    const {
      multiple,
      allowOtherResolved,
      inputControl
    } = select;
    if (!multiple && allowOtherResolved !== 'false' && !state.selectedOptions.length) {
      if (inputControl) {
        updateInputValue(value);
      }
      const changeValues = getChangeEventDetail(value);
      select.updateSelectedProps(changeValues);
    }
  }
  async function valuesToSelectOptions(values) {
    let count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const {
      selectContext: context,
      multiple,
      allowOtherResolved
    } = select;
    const optionsProp = select.options;
    const noOptionsProp = !optionsProp || typeof optionsProp !== 'function' && !optionsProp.length;
    if (noOptionsProp && count <= 5) {
      // initial selected values set before options property is set. Re-try up to 5 times
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(valuesToSelectOptions(values, count + 1));
        });
      });
    }
    const options = context && (await context.getOptions()) || [];
    return values.map(value => {
      let option = options.find(so => so.value === value);
      if (!option && multiple && allowOtherResolved !== 'false') {
        option = toSelectOption(value, select);
        option.other = true;
        option.otherHasBeenSelected = true;
      }
      return option;
    }).filter(Boolean);
  }
  /////////////////////////////////////////////////
  // event handlers
  function onClick(event) {
    const target = event.target;
    const clearButton = select.clearButton;
    if (clearButton && clearButton.contains(target)) {
      onClear();
      return;
    }
    const tags = target.closest('tds-selected-options, .tds-selected-options');
    if (tags) {
      if (state.showList) {
        hideOptionsPopup(false);
      }
    } else {
      toggleOptionsPopup('click');
    }
  }
  function onMousedown(event) {
    const combobox = select.combobox;
    const target = event.target;
    const tags = target.closest('tds-selected-options, .tds-selected-options');
    // looking for a click in the combobox container that
    if (combobox && !tags && target !== combobox && target.contains(combobox)) {
      select.focusCombobox();
      event.preventDefault();
    }
  }
  function onKeydown(event) {
    ignoreInlineComplete = false;
    if (handleClearButtonKeydown(event)) {
      return;
    }
    if (onKeydownCommon(event)) {
      return;
    }
    const key = normalizeKey(event);
    const target = event.target;
    let preventDefault = false;
    switch (key) {
      case 'ArrowDown':
        preventDefault = onArrowDownTogglePopup(event.altKey);
        break;
      case 'ArrowUp':
        if (event.altKey && state.showList) {
          hideOptionsPopup();
          preventDefault = true;
        }
        break;
      case 'ArrowLeft':
        preventDefault = onMoveFocus(target, 'backward');
        break;
      case 'ArrowRight':
        preventDefault = onMoveFocus(target, 'forward');
        break;
      case 'Tab':
        if (!event.altKey && !event.ctrlKey) {
          preventDefault = onTab(event);
        }
        break;
      case 'Backspace':
      case 'Delete':
        preventDefault = onBackspaceDelete(target, key);
        break;
      default:
        preventDefault = isTyping(event) && onTyping(target, key);
    }
    if (preventDefault) {
      event.preventDefault();
    }
  }
  // keydown events to handle for both select and popup
  function onKeydownCommon(event) {
    const target = event.target;
    const key = normalizeKey(event);
    let handled = false;
    switch (key) {
      case 'Enter':
        handled = onEnter(target);
        break;
      case 'Escape':
        handled = onEscape(target);
        break;
      default:
        handled = false;
    }
    if (handled) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    return handled;
  }
  function onArrowDownTogglePopup(altKey) {
    let handled = false;
    if (!state.showList) {
      showOptionsPopup({
        arrowKey: !altKey
      });
      handled = true;
    }
    const popup = select.popup;
    if (popup && popup.matches('[role="dialog"]')) {
      select.focusDialog();
      handled = true;
    }
    return handled;
  }
  function handleClearButtonKeydown(event) {
    const key = normalizeKey(event);
    const target = event.target;
    const clearButton = select.clearButton;
    if (clearButton && clearButton.contains(target)) {
      if (key === 'Enter' || key === ' ') {
        return true;
      } else if (key === 'ArrowLeft') {
        const combobox = select.combobox;
        combobox && combobox.focus();
        return true;
      }
    }
    return false;
  }
  function onMoveFocus(target, direction) {
    const combobox = select.combobox;
    const clearButton = select.clearButton;
    if (combobox && combobox.contains(target)) {
      const input = target.matches('input') ? target : null;
      const selectionPos = input && direction === 'forward' ? input.value.length : 0;
      if (!input || input.selectionStart === input.selectionEnd && input.selectionEnd === selectionPos) {
        if (direction === 'forward' && clearButton) {
          clearButton.focus();
          return true;
        }
        if (direction === 'forward') {
          return select.focusFirstDeselectOption();
        }
        if (direction === 'backward') {
          return select.focusLastDeselectOption();
        }
      }
    }
    if (clearButton && clearButton.contains(target) && direction === 'forward') {
      return select.focusFirstDeselectOption();
    }
    return false;
  }
  function onEnter(target) {
    if (!target.matches('[role="combobox"]')) {
      return false;
    }
    if (select.multiple) {
      if (commitEntryMultiple()) {
        return true;
      }
    } else {
      commitEntrySingle();
    }
    if (state.showList) {
      if (!select.multiple || state.activeIndex < 0) {
        hideOptionsPopup();
        return true;
      }
    } else if (state.orderedOptions.length) {
      showOptionsPopup();
      return true;
    }
    return false;
  }
  function onTab(event) {
    const target = event.target;
    const clearButton = select.clearButton;
    if (event.shiftKey) {
      if (clearButton && clearButton.contains(target)) {
        return false;
      }
      if (onMoveFocus(target, 'backward')) {
        return true;
      }
    }
    if (select.multiple) {
      commitEntryMultiple();
    } else {
      commitEntrySingle();
    }
    hideOptionsPopup(false);
    return false;
  }
  function onEscape(target) {
    if (state.showList && !(target.matches('input[type="search"]') && target.value)) {
      hideOptionsPopup();
      return true;
    }
    return false;
  }
  function onBackspaceDelete(target, key) {
    const {
      inlineComplete
    } = select;
    const input = target === select.inputControl ? target : null;
    ignoreInlineComplete = !!(inlineComplete && input && input.value);
    if (key === 'Backspace' && input && !input.value) {
      hideOptionsPopup();
      select.focusLastDeselectOption();
      return true;
    }
    return false;
  }
  function onTyping(target, char) {
    let preventDefault = false;
    const input = target === select.inputControl ? target : null;
    if (input) {
      const delimiter = select.delimiter || '';
      if (char === ' ' && !input.value) {
        preventDefault = true; // if starting the input with spaces, prevent the typing. (Messes with inline complete)
      } else if (char === delimiter[0]) {
        preventDefault = onDelimiterKeyDown(input);
      }
    } else if (select.filterPlacement === 'withlist') {
      // show the popup and handoff the character typed
      showOptionsPopup({
        filterHandoff: char
      });
      preventDefault = true;
    } else if (!select.inputControl) {
      findByTyping(char); // this will show the list if needed
      const popup = select.popup;
      if (state.showList && popup && popup.matches('[role="dialog"]')) {
        select.focusDialog();
      }
      preventDefault = true;
    }
    return preventDefault;
  }
  function onDelimiterKeyDown(input) {
    const {
      multiple,
      tags
    } = select;
    // all these need to be true to continue
    if (!(multiple && !tags)) {
      return false;
    }
    const selectionAtEnd = !!input && input.selectionEnd === input.value.length;
    if (selectionAtEnd && commitEntryMultiple()) {
      hideOptionsPopup(false);
    }
    // cancel the event regardless of outcome
    return true;
  }
  function onFocus() {
    const alreadyFocused = select.focused;
    // always set focus because focus visual state depends on what actually has focus 
    select.focused = true;
    if (!alreadyFocused) {
      // but only dispacth event when it first receives focus      
      select.sendEvent('tdsFocus');
    }
  }
  function onBlur() {
    if (ignoreBlur) {
      return;
    }
    // if focus does not return to control immediately, hide the popup
    setTimeout(() => {
      const {
        host,
        popup
      } = select;
      const hostHasFocus = hasFocus(host);
      const popupHasFocus = !!popup && hasFocus(popup);
      if (!hostHasFocus && !popupHasFocus) {
        select.focused = false;
        hideOptionsPopup(false);
        select.sendEvent('tdsBlur');
      }
      // reset ignoreBlur in onPopupMousedown timeout rather than here because mousedown will not always
      // result in a blur event. e.g. clicking an element already in focus
    });
  }

  function onPopupMousedown(event) {
    ignoreBlur = true;
    setTimeout(() => {
      ignoreBlur = false;
      let focusOn;
      const dialog = event.target.closest('[role="dialog"]');
      if (dialog) {
        if (!hasFocus(dialog)) {
          // need to keep focus on an element so blur logic will work to close the dialog
          focusOn = dialog.querySelector('[role="listbox"]');
        }
      } else {
        // managed listbox, always keep focus on the select control
        focusOn = select.combobox;
      }
      focusOn && focusOn.focus();
    });
  }
  function onInput(event) {
    const value = event.target.value;
    updateInputSpacerAndPlaceholder();
    if (!select.applyFilter) {
      onInputChanged(value);
    } // otherwise, we'll catch it on the flip side after the filter is applied
  }

  function onFilterApplied(filteredOptions, filterText) {
    onInputChanged(filterText);
    const showList = filteredOptions.length > 0 || !!state.optionsStatus;
    if (state.showList !== showList) {
      toggleOptionsPopup('filter');
    }
  }
  function onInputChanged(inputValue) {
    const {
      multiple,
      inputControl
    } = select;
    if (inputValue) {
      doInlineComplete(inputValue);
    }
    if (!multiple && inputControl) {
      // NOTE: If noAutoSelect and inlineComplete, will fire change event with each key typed even if inline complete results in the same value.
      // Not much different than native text input, though, and too complex to resolve.
      select.selectContext.selectionActions.textEntry(inputControl.value);
    }
    const activeIndex = getStartingActiveIndex(state, multiple);
    if (state.activeIndex !== activeIndex) {
      store.update({
        activeIndex
      });
    }
  }
  function commitEntrySingle() {
    if (state.showList) {
      const {
        updateOption
      } = selectContext.selectionActions;
      const option = state.orderedOptions[state.activeIndex];
      if (option && !isIncluded(option, state.selectedOptions)) {
        updateOption(option);
        return true;
      }
    }
    return false;
  }
  function commitEntryMultiple() {
    const input = select.inputControl;
    const {
      updateOption
    } = select.selectContext.selectionActions;
    const value = input === null || input === void 0 ? void 0 : input.value;
    if (value) {
      const selectedOptions = state.selectedOptions;
      const unselectedOptions = state.orderedOptions.filter(o => !o.other && !isIncluded(o, selectedOptions));
      const exactMatchOption = unselectedOptions[getExactMatchIndex(unselectedOptions, value)];
      updateInputValue('');
      if (exactMatchOption) {
        updateOption(exactMatchOption);
        return true;
      } else if (select.allowOtherResolved === 'true') {
        const alreadySelected = selectedOptions[getExactMatchIndex(selectedOptions, value)];
        if (!alreadySelected) {
          const newOption = toSelectOption(value, select);
          newOption.other = true;
          updateOption(newOption);
          return true;
        }
      }
    }
    return false;
  }
  function onClear() {
    const {
      inputControl
    } = select;
    select.selectContext.selectionActions.clear();
    if (inputControl) {
      // clear action should clear input value. 
      // In case input used ony for filterng and no action is applid, clear the input
      updateInputValue('');
    }
    select.focusCombobox();
    hideOptionsPopup();
  }
  function doInlineComplete(inputValue) {
    const {
      inlineComplete,
      inputControl,
      multiple
    } = select;
    if (inlineComplete && inputControl && !ignoreInlineComplete) {
      const orderedOptions = state.orderedOptions;
      const unselectedOptions = orderedOptions.filter(o => !isIncluded(o, state.selectedOptions));
      let bestMatchOption = multiple ?
      // For multiselect, only inline complete an unselected option 
      unselectedOptions[getBestMatchIndex(unselectedOptions, inputValue)] : orderedOptions[getBestMatchIndex(orderedOptions, inputValue)];
      if (bestMatchOption) {
        const fullValue = bestMatchOption.name;
        const selectionStart = inputControl.selectionStart;
        updateInputValue(fullValue);
        inputControl.setSelectionRange(selectionStart, fullValue.length);
      }
    }
  }
  function fireChangeEvent(changeValues) {
    const detail = {
      ...changeValues,
      selectChangeAction: {
        ...state.selectChangeAction
      }
    };
    select.sendEvent('tdsChange', detail);
  }
  function getChangeEventDetail(textValue) {
    const {
      multiple
    } = select;
    const selectedOptions = state.selectedOptions;
    const values = selectedOptions.map(o => o.value);
    // use first selected option value  if set, otherwise, if single select, use textValue passed in
    const value = selectedOptions[0] ? selectedOptions[0].value : multiple ? '' : textValue || '';
    const selected = selectedOptions.map(o => o.option);
    const otherSelectedOptions = selectedOptions.filter(o => o.other).map(o => o.option);
    return {
      value,
      values,
      selectedOptions: selected,
      otherSelectedOptions
    };
  }
  function updateInputValue(value) {
    const inputControl = select.inputControl;
    // call this function whenever updating the input value because of user action so we can fire the change event
    if (value !== inputControl.value) {
      // why this nonsense? React overrides input value setter, which, in the end, prevents the synthetic onChange event
      // from firing. Going to the native
      const valueDescriptor = typeof HTMLInputElement !== 'undefined' && Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
      const valueSetter = valueDescriptor && valueDescriptor.set;
      if (valueSetter) {
        valueSetter.call(inputControl, value);
      } else {
        /* istanbul ignore next */
        inputControl.value = value;
      }
      updateInputSpacerAndPlaceholder();
    }
  }
  function updateInputSpacerAndPlaceholder() {
    const {
      inputSpacer,
      inputControl,
      placeholder
    } = select;
    if (inputSpacer && inputControl) {
      const inputValue = inputControl.value;
      const values = select.values || [];
      const noPlaceholder = !placeholder || inputValue || values.length > 0;
      inputSpacer.textContent = noPlaceholder ? inputValue : placeholder;
      inputControl.placeholder = noPlaceholder ? '' : placeholder;
    }
  }
  //////////////////////////////////////////////////////////////////
  // manage options popup
  function toggleOptionsPopup(action) {
    if (state.showList) {
      hideOptionsPopup();
    } else {
      // don't refresh list if invoked by filter. The handoff will apply filter later
      // not a big deal with in memory options but prevents an unnecessary call for asynchronous loading of options
      showOptionsPopup({
        refreshList: action !== 'filter'
      });
    }
  }
  async function showOptionsPopup() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      refreshList = true,
      filterHandoff = '',
      arrowKey
    } = params;
    const {
      showList
    } = state;
    if (!showList) {
      if (refreshList) {
        // For asynchronous loads that take > 300ms, a loading status message may need to display in the popup
        // before this call returns. To ensure its seen, deriveStatusMessages() also sets showList:true 
        // when there is a loading message to display.
        await select.selectContext.getOptions(filterHandoff);
      }
      const activeIndex = getStartingActiveIndex(state, arrowKey || select.multiple);
      store.update({
        showList: true,
        activeIndex
      });
    }
  }
  function hideOptionsPopup() {
    let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    selectContext.hideOptionsPopup(focus);
  }
  let hidePopover;
  let resizeObserver;
  let garage;
  function onShowPopup() {
    const {
      host,
      multiple,
      popup
    } = select;
    if (!select.focused) {
      // do not show popup. This may occur on an asynchronous load that returns after the component has lost focus
      store.update({
        showList: false
      });
      return;
    }
    // using getBoundingClientRect().width rather than offsetWidth because the
    // latter rounds causing slight jiggling on retina displays
    if (typeof ResizeObserver !== 'undefined') {
      // in case not defined in unit test
      resizeObserver = new ResizeObserver(() => popup.style.width = `${host.getBoundingClientRect().width}px`);
      resizeObserver.observe(host);
    }
    garage = popup.parentElement;
    if (garage) {
      garage.style.minWidth = `${host.getBoundingClientRect().width}px`;
    }
    hidePopover = createPopover(popup, select.popoverReference, {
      placement: 'bottom-start'
    });
    select.onShowPopup();
    const listbox = popup.matches('[role="listbox"]') ? popup : popup.querySelector('[role="listbox"]');
    unbindListbox = bindListbox({
      listbox,
      multiple,
      selectContext: select.selectContext,
      controller: listbox === popup ? host : listbox
    });
    popupListeners.addListener(popup, 'mousedown', onPopupMousedown);
    popupListeners.addListener(popup, 'focusout', onBlur);
    popupListeners.addListener(popup, 'keydown', e => onKeydownCommon(e));
  }
  function onHidePopup() {
    const {
      multiple,
      popup,
      inputControl
    } = select;
    if (multiple && inputControl) {
      updateInputValue('');
    }
    if (popup && hidePopover) {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = undefined;
      }
      hidePopover();
      hidePopover = undefined;
    }
    popupListeners.removeListeners();
    if (unbindListbox) {
      unbindListbox();
      unbindListbox = undefined;
    }
    select.onHidePopup();
    if (popup) {
      popup.style.removeProperty('width');
    }
    if (garage) {
      garage.style.removeProperty('min-width');
      garage = undefined;
    }
  }
  function deriveStatusMessages() {
    const {
      orderedOptions,
      loading,
      filterText
    } = state;
    const {
      loadingText,
      noOptionsText
    } = select;
    const optionCount = orderedOptions && orderedOptions.length || 0;
    let optionsStatus = '';
    let showList = state.showList;
    if (loading && loadingText !== 'false') {
      optionsStatus = loadingText || translate('optionsLoadingMessage');
      showList = true;
    } else if (filterText && optionCount === 0 && noOptionsText !== 'false') {
      if (select.multiple || select.allowOtherResolved === 'false' || noOptionsText === 'true') {
        const optionsStatusTpl = noOptionsText !== "true" && noOptionsText || translate('noOptionsMessage');
        optionsStatus = interpolate({
          value: filterText
        }, optionsStatusTpl);
      }
    }
    if (optionsStatus !== state.optionsStatus) {
      store.update({
        optionsStatus,
        showList
      });
    }
  }
  return {
    unbind,
    onSelectedPropsChanged,
    updateInputSpacerAndPlaceholder
  };
}

const BUTTON_SELECTOR = 'span[role="button"], tds-tag, button.tds-tag';
function bindSelectedOptions(selectedOptions) {
  const {
    host
  } = selectedOptions;
  const eventListeners = new EventListeners();
  eventListeners.addListener(host, 'focusin', onFocus);
  eventListeners.addListener(host, 'focusout', onBlur);
  eventListeners.addListener(host, 'keydown', onKeydown);
  eventListeners.addListener(host, 'click', onClick);
  eventListeners.addListener(host, 'mousedown', onMousedown);
  eventListeners.addListener(host, 'mouseup', onMouseup);
  eventListeners.addListener(host, 'mouseout', onMouseout);
  let ignoreClickOn;
  return unbind;
  function unbind() {
    eventListeners.removeListeners();
  }
  function onFocus(event) {
    const target = event.target;
    const buttons = Array.from(selectedOptions.host.querySelectorAll(BUTTON_SELECTOR));
    const activeIndex = Math.max(buttons.indexOf(target), 0);
    if (activeIndex !== selectedOptions.activeIndex) {
      selectedOptions.activeIndex = activeIndex;
    }
    const button = buttons[selectedOptions.activeIndex];
    // Because a span button looks like static text and has no visual affordance as being clickable,
    // the intent is to select the text when it receives focus, so it looks like selected text
    // that can be deleted.
    if (selectedOptions.notags && button) {
      selectButton(button);
    }
  }
  function onBlur() {
    setTimeout(() => {
      const host = selectedOptions.host;
      if (host && !hasFocus(selectedOptions.host)) {
        selectedOptions.activeIndex = 0;
        if (typeof window.getSelection !== 'undefined') {
          const selection = window.getSelection();
          const anchor = selection.anchorNode;
          if (anchor && host.contains(anchor)) {
            selection.empty();
          }
        }
      }
    });
  }
  function selectButton(button) {
    let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (typeof window.getSelection !== 'undefined') {
      setTimeout(() => {
        window.getSelection().selectAllChildren(button);
      }, delay);
    }
  }
  function onKeydown(event) {
    ignoreClickOn = undefined;
    const limitTags = selectedOptions.limitTags;
    let length = selectedOptions.getOptions().length;
    if (limitTags > 0) {
      length = Math.min(length, limitTags);
    }
    if (!length) return;
    let activeIndex = selectedOptions.activeIndex;
    const spanButton = event.target.closest('span[role="button"]');
    const key = normalizeKey(event);
    switch (key) {
      case 'Home':
        activeIndex = 0;
        event.preventDefault();
        break;
      case 'End':
        activeIndex = Math.max(length - 1, 0);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        if (activeIndex > 0) activeIndex--;
        event.preventDefault();
        break;
      case 'ArrowRight':
        if (activeIndex < length - 1) {
          activeIndex++;
        } else {
          returnFocus();
        }
        event.preventDefault();
        break;
      case 'Enter':
      case ' ':
        if (spanButton) {
          spanButton.click();
          event.preventDefault();
        }
        return;
      case 'Backspace':
      case 'Delete':
        event.preventDefault();
        if (spanButton) {
          const lastChild = spanButton.matches(':last-child'); // save before click in case element removed on click
          spanButton.click();
          if (lastChild) {
            // if clicking the last span button, should feel like deleting text,
            // so return focus to select element rather than keeping focus in selected options element
            returnFocus();
          }
        }
        return;
    }
    if (activeIndex !== selectedOptions.activeIndex) {
      selectedOptions.activeIndex = activeIndex;
      const button = selectedOptions.host.querySelectorAll(BUTTON_SELECTOR)[activeIndex];
      button && button.focus();
    }
  }
  function onClick(event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (button === ignoreClickOn) {
      // 1) Ignore click on a span button that has just received focus, it will be selected instead
      // 2)  A click could close the popup, which causes the span button selection to collapse, so reselect after a brief timeout
      selectButton(button, 50);
      return;
    }
    if (button) {
      ignoreClickOn = undefined;
      if (button.getAttribute('aria-disabled') === 'true') return;
      const buttons = Array.from(selectedOptions.host.querySelectorAll(BUTTON_SELECTOR));
      const index = buttons.indexOf(button);
      const toBeLength = buttons.length - 1;
      if (toBeLength < 1) {
        returnFocus();
      }
      const selectedOptionGroupData = selectedOptions.getOptions()[index];
      const context = selectedOptionGroupData === null || selectedOptionGroupData === void 0 ? void 0 : selectedOptionGroupData.context;
      const option = selectedOptionGroupData === null || selectedOptionGroupData === void 0 ? void 0 : selectedOptionGroupData.option;
      if (context && option) {
        context.selectionActions.deselectOption(option);
      }
      selectedOptions.sendEvent('tdsRemove', {
        option: option.option
      });
      // when deselecting an option not last in the list, re-rendering may repurpose the same button 
      // for a different option. This change is not registered to the screen reader because focus does not
      // change. So, after a timeout, if the same button as focus, blur, then re-focus on the button 
      // so its new option is announced. This will also reapply the selected apearance for span buttons
      if (hasFocus(button)) {
        let lostFocus = false;
        const onBlur = () => lostFocus = true;
        button.addEventListener('blur', onBlur);
        setTimeout(() => {
          button.removeEventListener('blur', onBlur);
          if (hasFocus(button) && !lostFocus) {
            button.blur();
            setTimeout(() => button.focus(), 50);
          }
        }, 50);
      }
    }
  }
  ////////////////////////////////////////////////////////
  // mouse event handlers
  //
  // The mouse event handlers are intended to prevent an initial click of
  // a span button that does not have focus from deselecting the option
  // The first click sets focus
  // The second click deselects option
  function onMousedown(event) {
    ignoreClickOn = undefined;
    const button = event.target.closest(BUTTON_SELECTOR);
    if (button && !button.matches(':focus') && selectedOptions.notags) {
      ignoreClickOn = button;
    }
  }
  function onMouseup() {
    setTimeout(() => {
      ignoreClickOn = undefined;
    }, 50);
  }
  function onMouseout(event) {
    if (event.target === ignoreClickOn) {
      ignoreClickOn = undefined;
    }
  }
  ////////////////////////////////////////////////////////
  function returnFocus() {
    const returnFocusTo = selectedOptions.returnFocusTo;
    if (returnFocusTo) {
      returnFocusTo.focus();
    }
  }
}
function watchReturnToFocus(returnFocusTo, selectedOptions) {
  const eventListeners = new EventListeners();
  eventListeners.addListener(returnFocusTo, 'focus', checkReturnToState);
  eventListeners.addListener(returnFocusTo, 'blur', checkReturnToState);
  if (returnFocusTo.matches('input')) {
    eventListeners.addListener(returnFocusTo, 'input', checkReturnToState);
    eventListeners.addListener(returnFocusTo, 'change', checkReturnToState);
  }
  checkReturnToState();
  return unwatch;
  function unwatch() {
    eventListeners.removeListeners();
  }
  function checkReturnToState() {
    const value = returnFocusTo.matches('input') ? returnFocusTo.value : '';
    const focused = returnFocusTo.matches(':focus');
    selectedOptions.noLastComma = !focused && !value;
  }
}

/**
 * This is a controller to that aggregates selected options for one or more option selectors (e.g. tds-select) for a single
 * tds-selected-options component. For example, if using a tds-select-options component to list the selections across
 * multiple tds-select components used to select filtering options. Since this logic works for one or more option selectors,
 * it also works for the tds-selected-option component when rendered inside the tds-select component.
 *
 * @param params {
 *   forSelect: SelectReference | NamedSelectReference[]:
 *     - (As SelectReference ) a reference to the one associated option selector , or a space delimited list of one or more ids to the
 *       associated option selectors, or the SelectContext for the component
 *     - An array of NamedSelectReference, each having:
 *       - SelectReference: a refernce to an associated option selector as an HTMLElement of its string id, or the SelectContext for the component
 *       - name: an optional name for each group. When provided, displayed as a prefix to each selected option for that group, Using the multiple filter
 *         example, the name could be the filter category
 *   updateSelectedOptions: (options: SelectedOptionGroupData[]) => void, A callback function to the tds-selected-options component to re-render on updates
 *   orderAsListed: boolean: When true, orders options as listed rather than in the order selected
 *   getSelectContext: (el: HTMLElement) => SelectContext; A callback for resovling the SelectContext for the component.
 *   doc: Document - The document element to query from
 * }
 * @returns an object with 3 functions:
 * - unsub A function to call on wrapup to unsubscribe from the related stores
 * - clear: A convenience function to clear  selections across all option selectors
 * - listenForClear: A function to add a click event to a control for clearing the selections across all option selectors. Parameters are:
 *   - clearControl: An HTMLElement or an id to an HTMLElement to listen to
 *   - currentControl: The currently bound control, if any. The click handler is removed from this if passed
 */
function aggregateSelectionGroups(params) {
  const {
    forSelect,
    updateSelectedOptions,
    orderAsListed,
    doc,
    getSelectContext
  } = params;
  // convert forSelect into an array of NamedSelectReference resolved to an element if needed
  let namedSelect;
  if (Array.isArray(forSelect)) {
    namedSelect = forSelect;
  } else if (typeof forSelect === 'string') {
    // split into unnamed groups. If only one id, will be an array of 1
    namedSelect = forSelect.split(' ').filter(s => s.trim()).map(s => {
      return {
        select: s
      };
    });
  } else {
    namedSelect = [{
      select: forSelect
    }];
  }
  // resolve each namedSelect to its SelectContext (and its actions)
  namedSelect.forEach(namedSelect => {
    let select = namedSelect.select;
    if (typeof select === 'string') {
      try {
        select = doc.getElementById(select);
      } catch {
        /* istanbul ignore next */
        select = null;
      }
    }
    if (select instanceof HTMLElement) {
      // let caller determine how to get SelectContext from an element
      select = getSelectContext(select);
    }
    namedSelect.select = select;
  });
  const groups = namedSelect.filter(namedSelect => !!namedSelect.select).map(namedSelect => {
    const context = namedSelect.select;
    const group = {
      selectedOptions: [],
      name: namedSelect.name,
      context
    };
    return group;
  });
  function update() {
    if (updateSelectedOptions) {
      updateSelectedOptions(flattenSelectionGroupOptions(groups));
    }
  }
  const unsubs = [];
  groups.forEach(group => {
    unsubs.push(subscribeToContextStore(group, orderAsListed, update));
  });
  update();
  return {
    unsub,
    clear,
    listenForClear
  };
  function unsub() {
    while (unsubs.length) {
      unsubs.pop()();
    }
  }
  function clear() {
    namedSelect.forEach(namedSelect => {
      const select = namedSelect.select;
      if (select instanceof SelectContext) {
        select.selectionActions.clear();
      }
    });
  }
  function listenForClear(clearControl, currentControl) {
    if (currentControl) {
      currentControl.removeEventListener('click', clear);
    }
    if (typeof clearControl === 'string') {
      clearControl = doc.getElementById(clearControl);
    }
    if (clearControl instanceof HTMLElement) {
      clearControl.addEventListener('click', clear);
      return clearControl;
    }
    return undefined;
  }
}
function subscribeToContextStore(group, orderAsListed, callback) {
  let lastSelectedOptions;
  return group.context.store.subscribe(s => {
    if (s.selectedOptions !== lastSelectedOptions) {
      group.selectedOptions = orderAsListed ? orderOptionsAsListed(s.selectedOptions, group.context.optionSelector) : s.selectedOptions;
      // only call callback on updates, not on subscribe
      if (lastSelectedOptions) {
        callback();
      }
    }
    lastSelectedOptions = s.selectedOptions;
  });
}
function flattenSelectionGroupOptions(groups) {
  return groups.reduce((arr, group) => {
    group.selectedOptions.forEach(option => {
      arr.push({
        option,
        groupName: group.name,
        context: group.context
      });
    });
    return arr;
  }, []);
}

const BASE_CLASS$4 = 'tds-selected-options';
const ENHANCED_FLAG$f = 'enhancedSelectedOptions';
const INSTANCE_KEY$h = `${NAMESPACE}SelectedOptions`;
const PATTERN_SELECTOR$8 = `.${BASE_CLASS$4}`;
const CLASSES$2 = {
  inline: `${BASE_CLASS$4}--inline`,
  noLastComma: `${BASE_CLASS$4}--no-last-comma`,
  summary: `${BASE_CLASS$4}__summary`
};
const dataAttributesConversions = [{
  names: ['limitTags'],
  convert: 'integer'
}, {
  names: ['options'],
  convert: 'object'
}, {
  names: ['options', 'forSelect'],
  convert: 'json'
}, {
  names: ['prepElement', 'contentRenderer'],
  convert: 'function'
}];
let nextId$8 = 1;
class _SelectedOptionsInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    this._apiConfig = {};
    this._activeIndex = -1;
    this.host = element;
    this._apiConfig = config;
    element.dataset[ENHANCED_FLAG$f] = "true";
    this.clear = this.clear.bind(this);
    const baseId = element.id || `__tds-selected-options-${nextId$8++}`;
    this._removeLabelId = `${baseId}__removeLabel`;
    const unwatch = watchDataAttributeChange(this.host, config => {
      const oldConfig = this._config || {};
      this._config = undefined;
      this.checkConfigChanges(config, oldConfig);
    }, dataAttributesConversions);
    const unbind = bindSelectedOptions(this);
    this.aggregateGroups();
    this.onReturnFocusToChange();
    this.listenForClear();
    this.render();
    this.render = debounce(this.render.bind(this), 0);
    this.onDestroy = [unbind, unwatch];
    instances$1.set(element, INSTANCE_KEY$h, this);
  }
  updateConfig(config) {
    if (this._apiConfig !== config) {
      const oldConfig = this._config || {};
      this._apiConfig = {
        ...this._apiConfig,
        ...config
      };
      this._config = undefined;
      this.checkConfigChanges(config, oldConfig);
    }
  }
  aggregateGroups() {
    this.unsubscribe();
    const config = this.config;
    const forSelect = config.forSelect;
    if (!forSelect) return;
    this._aggregateGroupsReturn = aggregateSelectionGroups({
      forSelect,
      updateSelectedOptions: options => {
        this._selectedOptions = options;
        if (this._rendered) {
          this.render();
        }
      },
      orderAsListed: config.orderAsListed,
      getSelectContext: el => {
        if (!el.matches('.tds-select')) {
          devConsole.error('As of now, only tds-select elements (class="tds-select") can be bound to this component');
          return null;
        }
        return SelectContext.getInstance(el);
      },
      doc: this.host.ownerDocument
    });
  }
  unsubscribe() {
    var _this$_aggregateGroup, _this$_aggregateGroup2;
    const listenForClear = (_this$_aggregateGroup = this._aggregateGroupsReturn) === null || _this$_aggregateGroup === void 0 ? void 0 : _this$_aggregateGroup.listenForClear;
    const clearControl = this._clearControl;
    if (listenForClear && clearControl) {
      listenForClear(undefined, clearControl);
      delete this._clearControl;
    }
    const unsub = (_this$_aggregateGroup2 = this._aggregateGroupsReturn) === null || _this$_aggregateGroup2 === void 0 ? void 0 : _this$_aggregateGroup2.unsub;
    if (unsub) {
      unsub();
      delete this._aggregateGroupsReturn;
    }
  }
  onReturnFocusToChange() {
    const {
      returnFocusTo,
      _unwatchReturnToFocus
    } = this;
    if (_unwatchReturnToFocus) {
      _unwatchReturnToFocus();
    }
    if (returnFocusTo) {
      this._unwatchReturnToFocus = watchReturnToFocus(returnFocusTo, this);
    }
  }
  listenForClear() {
    var _this$_aggregateGroup3;
    const listenForClear = (_this$_aggregateGroup3 = this._aggregateGroupsReturn) === null || _this$_aggregateGroup3 === void 0 ? void 0 : _this$_aggregateGroup3.listenForClear;
    this._clearControl = listenForClear && listenForClear(this.config.clearControl, this._clearControl);
  }
  checkConfigChanges(newConfig, oldConfig) {
    if (newConfig.hasOwnProperty('returnFocusTo') && newConfig.returnFocusTo !== oldConfig.returnFocusTo) {
      this.onReturnFocusToChange();
    }
    if (newConfig.hasOwnProperty('forSelect') && newConfig.forSelect !== oldConfig.forSelect) {
      this.aggregateGroups();
    }
    if (newConfig.hasOwnProperty('orderAsListed') && newConfig.orderAsListed !== oldConfig.orderAsListed) {
      this.aggregateGroups();
    }
    if (newConfig.hasOwnProperty('clearControl') && newConfig.clearControl !== oldConfig.clearControl) {
      this.listenForClear();
    }
    if (this._rendered) {
      if (newConfig.hasOwnProperty('notags') && newConfig.notags !== oldConfig.notags) {
        this._rendered = false; // force a re-render
      }

      this.render();
    }
  }
  get config() {
    return this._config || (this._config = {
      optionName: 'name',
      optionValue: 'value',
      delimiter: ',',
      limitTags: -1,
      ...configFromDataAttributes(this.host, {}, dataAttributesConversions),
      ...(this._apiConfig || {})
    });
  }
  sendEvent(type, detail) {
    return this.host.dispatchEvent(createCustomEvent(type, {
      cancelable: false,
      bubbles: true,
      detail: detail
    }));
  }
  clear() {
    var _this$_aggregateGroup4;
    (_this$_aggregateGroup4 = this._aggregateGroupsReturn) === null || _this$_aggregateGroup4 === void 0 ? void 0 : _this$_aggregateGroup4.clear();
  }
  render() {
    const host = this.host;
    if (!host) return; // instance destroyed before debounce timeout
    const config = this.config;
    let options = this.getOptions();
    const limitTags = config.limitTags;
    this._activeIndex = Math.max(Math.min(this._activeIndex, options.length - 1), 0);
    this._translate = translations(this.host).t;
    const refocusIndex = hasFocus(this.host) ? this._activeIndex : -1;
    let summarizeCount = 0;
    if (limitTags > -1) {
      summarizeCount = options.slice(limitTags).length;
      options = options.slice(0, limitTags);
    }
    if (!this._rendered) {
      while (host.lastChild) {
        host.lastChild.remove();
      }
    }
    const classes = {
      [CLASSES$2.inline]: !!config.inline || !!config.notags,
      [CLASSES$2.noLastComma]: this.noLastComma
    };
    applyClasses(host, classes);
    this.renderDescriber();
    this.renderList(options, summarizeCount);
    if (refocusIndex > -1) {
      const tag = host.querySelectorAll('[role="listitem"] > *')[refocusIndex];
      if (tag) {
        tag.focus();
      }
    }
    this._rendered = true;
  }
  renderDescriber() {
    const host = this.host;
    const removeLabelId = this._removeLabelId;
    let span;
    while (!(span = host.querySelector(`#${removeLabelId}`))) {
      this.host.insertAdjacentHTML('afterbegin', `<span id=${this._removeLabelId} style="display: none"></span>`);
    }
    span.textContent = this._translate('optionTagDescription');
  }
  renderList(options, summarizeCount) {
    var _listitems;
    const config = this.config;
    const {
      notags,
      prepElement,
      contentRenderer,
      optionDisabled,
      inline
    } = config;
    const delimiter = notags ? config.delimiter + ' ' : undefined;
    const dataDelimiter = delimiter ? `data-delimiter="${htmlEncode(delimiter)}"` : '';
    // We want the list's contents to just read the visible label of each tag. But, when the screen reader
    // lands on the button, we want it to read the purpose of the tag/button. To do this,
    // each tag's' aria-describedby is set to a hidden span that reads 'remove'. When screen reader lands
    // on the tag, it will read "<option name>, click or press delete or backspace to remove"
    const host = this.host;
    const activeIndex = this._activeIndex;
    const describer = host.querySelector(`#${this._removeLabelId}`);
    let listEl = host.querySelector('[role="list"]');
    if (!options.length && summarizeCount < 1) {
      listEl && listEl.remove();
      return;
    }
    if (!listEl) {
      describer.insertAdjacentHTML('afterend', `<span role="list"></span>`);
      listEl = host.querySelector('[role="list"]');
    }
    const listitems = Array.from(listEl.querySelectorAll('[role="listitem"]'));
    let summaryListItem;
    if ((_listitems = listitems[listitems.length - 1]) !== null && _listitems !== void 0 && _listitems.matches(`.${CLASSES$2.summary}`)) {
      summaryListItem = listitems.pop();
      summaryListItem.remove();
    }
    while (listitems.length > options.length) {
      listitems.pop().remove();
    }
    options.forEach((flattenedOption, index) => {
      const {
        option,
        groupName
      } = flattenedOption;
      const {
        name,
        shortName
      } = option;
      // selectedOptions is needed to know if option is selected. As it is here, it is of course,
      // so just passing the current option will suffice
      const optDisabled = isDisabled(option, {
        optionDisabled,
        selectedOptions: [option]
      });
      let listitemEl = listitems[index];
      if (!listitemEl) {
        const buttonHTML = notags ? `<span role="button"></span>` : `<button class="tds-tag tds-tag--dismissable"></button>`;
        listEl.insertAdjacentHTML('beforeend', `<span role="listitem" ${dataDelimiter}>${buttonHTML}</span>`);
        listitemEl = listEl.lastElementChild;
      }
      const tagEl = listitemEl.querySelector('span, button');
      let textContent = groupName ? `${groupName}: ` : '';
      textContent += shortName || name;
      const title = shortName && shortName !== name ? name : undefined;
      const classes = {};
      const styles = {};
      const attributes = {
        ['aria-describedby']: this._removeLabelId,
        tabindex: index === activeIndex && !inline ? 0 : -1,
        title
      };
      const data = {
        type: 'tag',
        option: option.option,
        isDisabled: optDisabled,
        groupName: groupName
      };
      if (prepElement && !notags) {
        prepElement(data, classes, styles, attributes);
      }
      const disabled = optDisabled || config.disabled;
      if (notags) {
        attributes['aria-disabled'] = disabled ? 'true' : undefined;
      } else {
        attributes.disabled = disabled ? '' : undefined;
      }
      applyClasses(tagEl, classes);
      applyAttributes(tagEl, attributes);
      applyStyles(tagEl, styles);
      const content = contentRenderer && contentRenderer(data) || textContent;
      applyContent(tagEl, content);
    });
    if (summarizeCount > 0) {
      if (!summaryListItem) {
        listEl.insertAdjacentHTML('beforeend', `<span role="listitem" ${dataDelimiter} class="${CLASSES$2.summary}"></span>`);
        summaryListItem = listEl.lastElementChild;
      }
      listEl.appendChild(summaryListItem);
      const plusMoreTpl = this.config.summarizeTemplate || this._translate('optionsSPluselectedTpl');
      const plusMores = interpolate({
        count: summarizeCount
      }, plusMoreTpl).split(';');
      const plusMore = summarizeCount === 1 && plusMores[1] || plusMores[0];
      summaryListItem.textContent = plusMore;
    }
  }
  focusOnFirst() {
    return this.focusOnEnd(false);
  }
  focusOnLast() {
    return this.focusOnEnd(true);
  }
  focusOnEnd(last) {
    const buttons = this.host.querySelectorAll(`span[role="button"], button.tds-tag`);
    const button = buttons[last ? buttons.length - 1 : 0];
    if (button) {
      button.focus();
      return true;
    }
    return false;
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      this.onDestroy.pop()();
    }
    this.unsubscribe();
    if (this._unwatchReturnToFocus) {
      this._unwatchReturnToFocus();
      delete this._unwatchReturnToFocus;
    }
    if (this.host) {
      delete this.host.dataset[ENHANCED_FLAG$f];
    }
    instances$1.remove(this.host, INSTANCE_KEY$h);
    this.host = null;
  }
  get notags() {
    return this.config.notags;
  }
  get returnFocusTo() {
    return this.config.returnFocusTo;
  }
  get limitTags() {
    return this.config.limitTags;
  }
  getOptions() {
    const selectedOptions = this._selectedOptions;
    if (selectedOptions && selectedOptions.length) {
      return selectedOptions;
    }
    // not bound to any select context, return options property instead
    return (this.config.options || []).map(option => {
      const {
        optionName,
        optionValue,
        optionId
      } = this.config;
      return {
        option: toSelectOption(option, {
          optionName,
          optionValue,
          optionId
        })
      };
    });
  }
  get activeIndex() {
    return this._activeIndex;
  }
  set activeIndex(activeIndex) {
    if (activeIndex !== this._activeIndex) {
      this._activeIndex = activeIndex;
      this.render();
    }
  }
  get noLastComma() {
    return this._noLastComma;
  }
  set noLastComma(b) {
    var _this$host;
    this._noLastComma = b;
    (_this$host = this.host) === null || _this$host === void 0 ? void 0 : _this$host.classList[b ? 'add' : 'remove'](CLASSES$2.noLastComma);
  }
}
class SelectedOptions {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$h) || new _SelectedOptionsInstance(element, config);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    var _this$_instance;
    (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.updateConfig(config);
  }
  focusOnFirst() {
    var _this$_instance2;
    return (_this$_instance2 = this._instance) === null || _this$_instance2 === void 0 ? void 0 : _this$_instance2.focusOnFirst();
  }
  focusOnLast() {
    var _this$_instance3;
    return (_this$_instance3 = this._instance) === null || _this$_instance3 === void 0 ? void 0 : _this$_instance3.focusOnLast();
  }
  clear() {
    var _this$_instance4;
    (_this$_instance4 = this._instance) === null || _this$_instance4 === void 0 ? void 0 : _this$_instance4.clear();
  }
  destroy() {
    var _this$_instance5;
    return (_this$_instance5 = this._instance) === null || _this$_instance5 === void 0 ? void 0 : _this$_instance5.destroy();
  }
}
onDomChanges(`${PATTERN_SELECTOR$8}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$f]) {
    new SelectedOptions(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$f] === "true") {
    new SelectedOptions(element).destroy();
  }
});

function bindSelectDialog(dialog) {
  const unbindFilter = bindFilter(dialog, dialog.host, onFilter);
  const eventListeners = new EventListeners();
  eventListeners.addListener(dialog.host, 'keydown', onKeydown);
  eventListeners.addListener(dialog.host, 'focusin', onFocus);
  const findByTyping = getFindByTyping(dialog);
  return unbind;
  function unbind() {
    unbindFilter();
    eventListeners.removeListeners();
  }
  function onKeydown(event) {
    const target = event.target;
    const key = normalizeKey(event);
    if (target.matches('input') && ['ArrowDown', 'Enter'].includes(key)) {
      event.preventDefault();
      const listbox = dialog.host.querySelector('[role="listbox"]');
      if (listbox) {
        listbox.focus();
      }
      return;
    }
    if (isTyping(event) && key !== ' ') {
      //space is for selecting an option
      const listbox = target.closest('[role="listbox"]');
      const redirectTypingTo = dialog.redirectTypingTo;
      if (listbox && redirectTypingTo) {
        // redirect to search input, typing should continue to input
        // do not prevent default
        redirectTypingTo.value = '';
        redirectTypingTo.focus();
        return;
      }
      if (listbox) {
        findByTyping(key);
        return;
      }
    }
  }
  function onFocus(event) {
    const target = event.target;
    if (target.closest('[data-returnto-trap]')) {
      const context = dialog.selectContext;
      const listbox = dialog.host.querySelector('[role="listbox"]');
      if (!dialog.multiple && event.relatedTarget === listbox) {
        const {
          orderedOptions,
          activeIndex
        } = context.store.get();
        const option = orderedOptions[activeIndex];
        if (option) {
          // if tabbing away from single select listbox, and item is active, select it
          // this is to make dialog consistent with tabbing from listbox
          // same logic as in selectBehavior's commitEntry
          context.selectionActions.updateOption(option);
        }
      }
      context.hideOptionsPopup(true);
    }
  }
  function onFilter() {
    const {
      store,
      state
    } = dialog.selectContext;
    const activeIndex = getStartingActiveIndex(state, dialog.multiple);
    if (state.activeIndex !== activeIndex) {
      store.update({
        activeIndex
      });
    }
  }
}
function getSelectDialogDescriptionText(dialog, translate) {
  const {
    applyFilter,
    multiple,
    selectAll
  } = dialog;
  const description = [applyFilter && translate('selectDialogDescriptionFilter'), selectAll && multiple && translate('selectDialogDescriptionActions')].filter(Boolean).join(` ${translate('and')} `);
  return description ? translate('with') + ' ' + description : '';
}

const ENHANCED_FLAG$e = 'enhancedSelectDialog';
const INSTANCE_KEY$g = `${NAMESPACE}SelectDialog`;
const BASE_CLASS$3 = 'tds-select-dialog';
const CLASSES$1 = {
  filterPanel: `${BASE_CLASS$3}__filter-panel`,
  actions: `${BASE_CLASS$3}__actions`,
  selectAll: `${BASE_CLASS$3}__select-all`,
  clear: `${BASE_CLASS$3}__clear`
};
let nextId$7 = 1;
class _SelectDialogInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    this._updateListbox = true;
    this.onStateUpdate = this.onStateUpdate.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.onClear = this.onClear.bind(this);
    this.host = element;
    this._apiConfig = config;
    element.dataset[ENHANCED_FLAG$e] = "true";
    this._baseId = element.id || `__tds-select-dialog-${nextId$7++}`;
    this._descriptionId = `${this._baseId}__description`;
    const passedContext = this.config.selectContext;
    const context = this._selectContext = passedContext || SelectContext.getInstance(element, this);
    this.store = context.store;
    const unbind = bindSelectDialog(this);
    const unsubscribe = this.store.subscribe(this.onStateUpdate);
    this.onDestroy = [unbind, unsubscribe, () => {
      if (!passedContext) {
        context.destroy();
      }
    }];
    this.render();
    this.render = debounce(this.render.bind(this), 0);
    instances$1.set(element, INSTANCE_KEY$g, this);
  }
  onStateUpdate(state) {
    this.state = state;
    const {
      orderedOptions,
      selectedOptions
    } = state;
    const config = this.config;
    const optionEnabled = option => {
      return !isDisabled(option, {
        optionDisabled: config.optionDisabled,
        maxSelection: config.maxSelection,
        selectedOptions: state.selectedOptions
      });
    };
    const enabledOptions = orderedOptions.filter(optionEnabled);
    const enabledSelectedOptions = selectedOptions.filter(optionEnabled);
    this._someSelected = !!enabledSelectedOptions.length;
    this._allSelected = enabledOptions.length === enabledSelectedOptions.length;
    if (this._rendered) {
      this.render();
    }
  }
  updateConfig(config) {
    if (this._apiConfig !== config) {
      this._apiConfig = {
        ...this._apiConfig,
        ...config
      };
      this._config = undefined;
      this._updateListbox = true;
      if (this._rendered) {
        this.render();
      }
    }
  }
  clearFilter() {
    const {
      searchInput
    } = this;
    if (searchInput) {
      searchInput.value = '';
    }
    this._filterHandoff = '';
  }
  get config() {
    return this._config || (this._config = {
      optionName: 'name',
      optionValue: 'value',
      options: [],
      // only using data attributes for testing as standalone component
      ...configFromDataAttributes(this.host),
      ...this._apiConfig
    });
  }
  set filterHandoff(value) {
    this._filterHandoff = value;
    const {
      searchInput
    } = this;
    if (searchInput) {
      searchInput.value = value;
    }
  }
  render() {
    if (!this.host) return; // instance destroyed before debounce timeout
    const config = this.config;
    this._translate = translations(this.host).t;
    if (!this._rendered) {
      this.host.innerHTML = this.renderHTMLFrame();
    }
    this.renderFilter();
    this.updateList();
    this.updateDescription();
    this.renderActions();
    applyAttributes(this.host, {
      role: "dialog",
      'aria-describedby': this._descriptionId,
      'aria-label': config.label,
      'aria-labelledby': config.labelledby,
      'aria-modal': 'true'
    });
    this._rendered = true;
  }
  renderHTMLFrame() {
    return ['<div tabindex="0" data-returnto-trap></div>', `<div id="${this._descriptionId}" hidden></div>`, `<div id="${this._baseId}__listbox" class="tds-listbox"></div>`, '<div tabindex="0" data-returnto-trap></div>'].join('');
  }
  renderFilter() {
    const {
      host,
      config
    } = this;
    let filterPanel = host.querySelector(`.${CLASSES$1.filterPanel}`);
    if (this.filter) {
      if (!filterPanel) {
        const listbox = host.querySelector('.tds-listbox');
        listbox.insertAdjacentHTML('beforebegin', `<div class="${CLASSES$1.filterPanel}"><input type="search"/></div>`);
        filterPanel = listbox.previousElementSibling;
      }
      const input = filterPanel.querySelector('input');
      input.setAttribute('placeholder', config.searchPlaceholder ?? this._translate('search'));
      input.setAttribute('aria-label', config.searchLabel || this._translate('optionsSearchLabel'));
    } else if (filterPanel) {
      filterPanel.remove();
    }
  }
  updateList() {
    if (this._updateListbox) {
      const config = {
        ...this.config
      };
      if (config.options) {
        delete config.options;
      }
      config.selectContext = this._selectContext;
      config.label = this._translate('listboxLabel');
      new Listbox(this.listbox, config);
      this._updateListbox = false;
    }
  }
  updateDescription() {
    const description = this.host.querySelector(`#${this._descriptionId}`);
    const textContent = getSelectDialogDescriptionText(this, this._translate);
    if (textContent !== description.textContent) {
      description.textContent = textContent;
    }
  }
  renderActions() {
    const {
      host,
      config
    } = this;
    let actionsPanel = host.querySelector(`.${CLASSES$1.actions}`);
    if (config.selectAll && config.multiple) {
      if (!actionsPanel) {
        const listbox = host.querySelector('.tds-listbox');
        listbox.insertAdjacentHTML('afterend', [`<div class="${CLASSES$1.actions}">`, `<button type="button" class="${CLASSES$1.selectAll}"></button>`, `<button type="button" class="${CLASSES$1.clear}"></button>`, '</div>'].join(''));
        actionsPanel = listbox.nextElementSibling;
      }
      const selectAll = host.querySelector(`button.${CLASSES$1.selectAll}`);
      applyAttributes(selectAll, {
        ariaDisabled: this._allSelected ? 'true' : undefined
      });
      selectAll.textContent = config.selectAllLabel || this._translate('selectAll');
      selectAll.onclick = this.onSelectAll;
      const clear = host.querySelector(`button.${CLASSES$1.clear}`);
      applyAttributes(clear, {
        ariaDisabled: this._someSelected ? undefined : 'true'
      });
      clear.textContent = config.clearLabel || this._translate('clear');
      clear.onclick = this.onClear;
    } else if (actionsPanel) {
      actionsPanel.remove();
    }
  }
  onSelectAll() {
    if (!this._allSelected) {
      this.selectContext.selectionActions.selectAll();
    }
  }
  onClear() {
    if (this._someSelected) {
      this.selectContext.selectionActions.clear();
    }
  }
  focus() {
    setTimeout(() => {
      const {
        host,
        searchInput
      } = this;
      if (host) {
        const focusOn = this.filter && this._filterHandoff && searchInput || this.listbox;
        if (focusOn) {
          focusOn.focus();
          if (focusOn === searchInput) {
            focusOn.selectionStart = focusOn.value.length;
          }
        }
      }
    });
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.host) {
      delete this.host.dataset[ENHANCED_FLAG$e];
    }
    instances$1.remove(this.host, INSTANCE_KEY$g);
    this.host = this.store = null;
  }
  get listbox() {
    return this.host.querySelector('.tds-listbox');
  }
  get searchInput() {
    var _this$host;
    return (_this$host = this.host) === null || _this$host === void 0 ? void 0 : _this$host.querySelector(`.${CLASSES$1.filterPanel} input`);
  }
  get redirectTypingTo() {
    return this.searchInput || this._externalSearchInput;
  }
  // many of these config getters are to satisfy SelectContext when this is a standalone component,
  // But, when used as a popup as it normally will be, many will be satisfied by the select component
  get applyFilter() {
    return !!this.config.filter;
  }
  get selectContext() {
    return this._selectContext;
  }
  get filter() {
    return this.config.filter;
  }
  get filterDelay() {
    return this.config.filterDelay;
  }
  get filterPredicate() {
    return this.config.filterPredicate;
  }
  get multiple() {
    return this.config.multiple;
  }
  get selectAll() {
    return this.config.selectAll;
  }
  get optionName() {
    return this.config.optionName;
  }
  get optionValue() {
    return this.config.optionValue;
  }
  get optionDisabled() {
    return this.config.optionDisabled;
  }
  get optionId() {
    return this.config.optionId;
  }
  get options() {
    return this.config.options;
  }
  get groupBy() {
    return this.config.groupBy;
  }
  get selectedFirst() {
    return this.config.selectedFirst;
  }
}
class SelectDialog {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$g) || new _SelectDialogInstance(element, config);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    var _this$_instance;
    (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.updateConfig(config);
  }
  set filterHandoff(value) {
    if (this._instance) {
      this._instance.filterHandoff = value;
    }
  }
  set externalSearchInput(input) {
    if (this._instance) {
      this._instance._externalSearchInput = input;
    }
  }
  focus() {
    var _this$_instance2;
    (_this$_instance2 = this._instance) === null || _this$_instance2 === void 0 ? void 0 : _this$_instance2.focus();
  }
  clearFilter() {
    var _this$_instance3;
    (_this$_instance3 = this._instance) === null || _this$_instance3 === void 0 ? void 0 : _this$_instance3.clearFilter();
  }
  destroy() {
    return this._instance.destroy();
  }
}

const ENHANCED_FLAG$d = 'enhancedSelect';
const INSTANCE_KEY$f = `${NAMESPACE}Select`;
const BASE_CLASS$2 = 'tds-select';
const PATTERN_SELECTOR$7 = `.${BASE_CLASS$2}`;
const CLASSES = {
  wrapper: `${BASE_CLASS$2}__wrapper`,
  fieldInput: `${BASE_CLASS$2}__field-input`,
  fieldInputFocused: `${BASE_CLASS$2}__field-input--focused`,
  fieldInputWihTags: `${BASE_CLASS$2}__field-input--with-tags`,
  fieldInputWihInput: `${BASE_CLASS$2}__field-input--with-input`,
  fieldInputWihClear: `${BASE_CLASS$2}__field-input--with-clear`,
  fieldInputCondensed: `${BASE_CLASS$2}__field-input--condensed`,
  fieldInputDisabled: `${BASE_CLASS$2}__field-input--disabled`,
  fieldInputReadonly: `${BASE_CLASS$2}__field-input--readonly`,
  garage: `${BASE_CLASS$2}__popup-garage`,
  internalLabel: `${BASE_CLASS$2}__internal-label`,
  control: `${BASE_CLASS$2}__control`,
  controlNoWrap: `${BASE_CLASS$2}__control--nowrap`,
  inputControl: `${BASE_CLASS$2}__input-container`,
  inputSpacer: `${BASE_CLASS$2}__input-spacer`,
  clear: `${BASE_CLASS$2}__clear`,
  hiddenInputsContainer: `${BASE_CLASS$2}__hidden-inputs`,
  selectedOptions: 'tds-selected-options',
  selectedOptionsNoMargin: 'tds-selected-options--no-margin'
};
let nextId$6 = 1;
class _SelectInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    element.dataset[ENHANCED_FLAG$d] = "true";
    this.host = element;
    this._apiConfig = config;
    this._baseId = this.host.id || `tds-select-${nextId$6++}`;
    // rather than create a bunch of getters for each config property
    // use a proxy to satisfty both OptionSelector and SelectComponent
    const proxy = new Proxy(this, {
      get(target, prop) {
        // use target (this) 1st so getters take precedence
        return target[prop] ?? target.config[prop];
      }
    });
    const context = this._context = SelectContext.getInstance(element, proxy);
    this.store = context.store;
    const {
      unbind,
      onSelectedPropsChanged,
      updateInputSpacerAndPlaceholder
    } = bindSelect(proxy);
    this._onSelectedPropsChanged = onSelectedPropsChanged;
    this._updateInputSpacerAndPlaceholder = updateInputSpacerAndPlaceholder;
    const unsubscribe = this.store.subscribe(this.onStateUpdate.bind(this));
    const unwatch = watchDataAttributeChange(this.host, config => {
      const selectionPropChanges = this.getSelectionPropChanges(config); // must be called before clearing current configs
      this._config = undefined;
      this._dataConfig = undefined; // config getter will re-generate
      this.applySelectionValuesChanges(selectionPropChanges);
      this.render();
    }, [{
      names: ['values', 'selectedOptions'],
      convert: 'json'
    }]);
    this.onDestroy = [unbind, unsubscribe, unwatch];
    instances$1.set(element, INSTANCE_KEY$f, this);
    this.render();
    this.render = debounce(this.render.bind(this), 0);
  }
  onStateUpdate(state) {
    this.state = state;
    this._rendered && this.render();
  }
  updateConfig(config) {
    let doNotCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (config !== this._apiConfig) {
      const selectionPropChanges = this.getSelectionPropChanges(config); // must be called before clearing current configs
      this._apiConfig = {
        ...this._apiConfig,
        ...config
      };
      this._config = undefined;
      if (!doNotCheck) {
        this.applySelectionValuesChanges(selectionPropChanges);
      }
      this._rendered && this.render();
    }
  }
  getSelectionPropChanges(config) {
    const selectionPropChanges = [];
    const {
      value,
      values,
      selectedOptions
    } = config;
    const {
      value: currValue,
      values: currValues = [],
      selectedOptions: currSelection = [],
      _apiConfig
    } = this;
    if (typeof value !== 'undefined' && value !== currValue) {
      selectionPropChanges.push('value');
    }
    if (typeof values !== 'undefined' && values.toString() !== currValues.toString()) {
      selectionPropChanges.push('values');
    }
    if (typeof selectedOptions !== 'undefined' && JSON.stringify(selectedOptions) !== JSON.stringify(currSelection)) {
      selectionPropChanges.push('selectedOptions');
    }
    // if called from watchDataAttributeChange, clear apiValues so dataConfig takes precedence
    // if called from updateConfig, apiValues will reset anyway
    // apiConfig will be updated when onSelectedPropsChanged is called
    if (_apiConfig && selectionPropChanges.length) {
      delete _apiConfig.value;
      delete _apiConfig.values;
      delete _apiConfig.selectedOptions;
    }
    return selectionPropChanges;
  }
  applySelectionValuesChanges(selectionPropChanges) {
    const onSelectedPropsChanged = this._onSelectedPropsChanged;
    if (onSelectedPropsChanged) {
      selectionPropChanges.forEach(p => onSelectedPropsChanged(p));
    }
  }
  render() {
    if (!this.host) return; // instance destroyed before debounce timeout
    this._translate = translations(this.host).t;
    this._tagsId = undefined;
    const html = this.renderHTMLFrame();
    if (html !== this._lastHTMLFrame) {
      this.destroySelectedOptions();
      this._lastHTMLFrame = html;
      const wrapper = this.host.querySelector(`.${CLASSES.wrapper}`);
      if (wrapper) {
        wrapper.remove();
      }
      this.host.insertAdjacentHTML('beforeend', html);
    }
    this.updateHiddenLabel();
    this.updateFieldInputContainer();
    this.updateStaticControl();
    this.updateCombobox();
    this.updateClearButton();
    this.updateSelectedOptions();
    this.updateLiveRegion();
    this.updateHiddenInputs();
    this.updatePopupGarage();
    this._updateInputSpacerAndPlaceholder();
    this._rendered = true;
  }
  renderHTMLFrame() {
    const html = [`<div class="${CLASSES.wrapper}">`, this.renderTags('outside'), this.renderHiddenLabel(), `<div class="${CLASSES.fieldInput}">`, this.renderTags('inside'), this.renderControl(), this.renderClearButton(), '</div>', '<div aria-live="polite" role="status" class="tds-sr-only"></div>', this.renderHiddenInputs(), `<div class="${CLASSES.garage}"></div>`, '</div>'].filter(Boolean);
    return html.join('');
  }
  renderHiddenLabel() {
    const {
      label,
      labelledby
    } = this.getLabelAttributes();
    if (label && !labelledby) {
      const id = this._labelId = `${this._baseId}__internallabel__`;
      return `<span class="${CLASSES.internalLabel}" id=${id}></span>`;
    }
    this._labelId = '';
    return '';
  }
  renderTags(placement) {
    const {
      config,
      _baseId
    } = this;
    const {
      multiple,
      tags
    } = config;
    if (multiple) {
      if (tags === placement || !tags && placement === 'inside' && this.shouldRenderInput()) {
        const id = this._tagsId = `${_baseId}__deselectTags`;
        return `<div class="${CLASSES.selectedOptions} ${CLASSES.selectedOptionsNoMargin}" id="${id}"></div>`;
      }
    }
    return '';
  }
  renderControl() {
    if (this.shouldRenderInput()) {
      return this.renderInputControl();
    }
    return this.renderStaticControl();
  }
  renderInputControl() {
    return `<div class="${CLASSES.control} ${CLASSES.inputControl}"><span class=${CLASSES.inputSpacer} aria-hidden="true"></span><input role="combobox"/></div>`;
  }
  renderStaticControl() {
    return `<div class="${CLASSES.control}" role="combobox" tabindex="0"></div>`;
  }
  renderClearButton() {
    return this.shouldRenderClear() ? `<button type="button" hidden class="${CLASSES.clear}" tabindex="-1" aria-label=${this._translate('clear')}></button>` : '';
  }
  renderHiddenInputs() {
    return this.config.hiddenInputs ? `<div class="${CLASSES.hiddenInputsContainer}"></div>` : '';
  }
  updateHiddenLabel() {
    const hiddenLabel = this.host.querySelector(`.${CLASSES.wrapper} span.${CLASSES.internalLabel}`);
    if (hiddenLabel) {
      const {
        label
      } = this.getLabelAttributes();
      hiddenLabel.textContent = label;
    }
  }
  updateStaticControl() {
    const control = this.host.querySelector(`div.${CLASSES.control}[role="combobox"]`);
    if (control) {
      applyClasses(control, {
        [CLASSES.controlNoWrap]: !this.config.multiple
      });
    }
  }
  updateFieldInputContainer() {
    const {
      state,
      host
    } = this;
    let showFocused = this._focused;
    const {
      tags,
      disabled,
      readonly
    } = this.config;
    const withInlineTags = tags === 'inside' && state && state.selectedOptions.length > 0;
    const fieldInput = host.querySelector(`.${CLASSES.wrapper} div.${CLASSES.fieldInput}`);
    if (fieldInput) {
      if (showFocused) {
        const activeElement = host.ownerDocument.activeElement;
        showFocused = !(host.contains(activeElement) && !!activeElement.closest('.tds-tag'));
      }
      const fieldInputclasses = {
        [CLASSES.fieldInputFocused]: showFocused,
        [CLASSES.fieldInputWihTags]: withInlineTags,
        [CLASSES.fieldInputWihInput]: this.shouldRenderInput(),
        [CLASSES.fieldInputWihClear]: this.shouldRenderClear(),
        [CLASSES.fieldInputCondensed]: this.condensed,
        [CLASSES.fieldInputDisabled]: disabled,
        [CLASSES.fieldInputReadonly]: readonly
      };
      applyClasses(fieldInput, fieldInputclasses);
    }
  }
  updateSelectedOptions() {
    const {
      config
    } = this;
    const {
      tags
    } = config;
    const selectedOptions = this.selectedOptionsElement;
    if (selectedOptions) {
      const placement = !!selectedOptions.closest(`.${CLASSES.fieldInput}`) ? 'inside' : 'outside';
      applyAttributes(selectedOptions, {
        // set tabindex if "no tags" and placed inside fieldInput container
        tabindex: !tags && placement === 'inside' ? '-1' : undefined
      });
      const soConfig = {
        optionName: config.optionShortName || config.optionName,
        optionValue: config.optionValue,
        optionId: config.optionId,
        optionDisabled: config.optionDisabled,
        forSelect: this.selectContext,
        inline: placement === 'inside',
        limitTags: config.summarizeAfter,
        disabled: config.disabled,
        delimiter: config.delimiter,
        notags: !tags,
        returnFocusTo: this.combobox,
        prepElement: config.prepElement,
        contentRenderer: config.tagContentRenderer,
        orderAsListed: config.orderAsListed
      };
      new SelectedOptions(selectedOptions, soConfig);
    }
  }
  updateCombobox() {
    const {
      config,
      state,
      popup,
      applyFilter
    } = this;
    const {
      disabled,
      multiple,
      inlineComplete,
      tags,
      hiddenInputs,
      name,
      form,
      prepElement,
      maxLength
    } = config;
    const {
      showList
    } = state;
    const combobox = this.combobox;
    const popupType = this.getPopupType();
    let attributes = {
      "aria-controls": popup.id,
      "aria-expanded": `${showList}`,
      "aria-haspopup": popupType,
      "aria-activedescendant": popupType === 'dialog' ? undefined : showList ? state.activeOptionId : '',
      "aria-labelledby": this.getAriaLabelledBy(),
      "aria-describedby": this.getAriaDescribedBy(),
      "aria-disabled": disabled ? `${disabled}` : undefined
    };
    if (combobox.matches('input')) {
      const inputClasses = {};
      const inputStyles = {};
      const otherInputAttributes = {
        autocomplete: 'off',
        autocapitalize: 'off',
        autocorrect: 'off',
        maxlength: maxLength ? `${maxLength}` : undefined,
        spellcheck: 'false',
        name: !hiddenInputs ? name : undefined,
        form: !hiddenInputs ? form : undefined
      };
      if (prepElement) {
        prepElement({
          type: 'input'
        }, inputClasses, inputStyles, otherInputAttributes);
      }
      applyClasses(combobox, inputClasses);
      applyStyles(combobox, inputStyles);
      attributes = {
        ...attributes,
        "aria-autocomplete": getAriaAutocomplete({
          inlineComplete,
          applyFilter
        }),
        ...otherInputAttributes
      };
      if (!combobox.onfocus) {
        const handler = manageInputAutocomplete();
        combobox.onfocus = handler;
        combobox.onblur = handler;
      }
    } else if (!multiple || !tags) {
      combobox.textContent = renderSelectedOptionsList(this, config, state, this._translate);
    }
    applyAttributes(combobox, attributes);
  }
  updateClearButton() {
    const clearButton = this.clearButton;
    if (clearButton) {
      var _this$inputControl;
      const value = this.value || ((_this$inputControl = this.inputControl) === null || _this$inputControl === void 0 ? void 0 : _this$inputControl.value);
      clearButton.hidden = !value;
    }
  }
  updateLiveRegion() {
    const liveRegion = this.host.querySelector(`.${CLASSES.wrapper} div[aria-live]`);
    if (liveRegion) {
      liveRegion.textContent = this.state.optionsStatus || '';
    }
  }
  updateHiddenInputs() {
    const host = this.host;
    const hiddenInputs = host.querySelector(`.${CLASSES.wrapper} div.${CLASSES.hiddenInputsContainer}`);
    if (hiddenInputs) {
      const {
        name,
        form
      } = this.config;
      const values = this.values || [];
      if (!values.length) {
        values.push(this.value || '');
      }
      const inputs = Array.from(hiddenInputs.querySelectorAll('input[type="hidden"]'));
      while (inputs.length > values.length) {
        inputs.pop().remove();
      }
      values.forEach((value, i) => {
        let input = inputs[i];
        if (!input) {
          input = host.ownerDocument.createElement('input');
          input.type = 'hidden';
          hiddenInputs.append(input);
        }
        applyAttributes(input, {
          name,
          form
        });
        input.value = value;
      });
    }
  }
  updatePopupGarage() {
    const {
      popupGarage,
      popup
    } = this;
    if (popupGarage && popup && popup.parentElement !== popupGarage && !this.state.showList) {
      popupGarage.appendChild(popup);
    }
  }
  shouldRenderInput() {
    return this.allowOtherResolved !== 'false' || this.filterPlacement === 'inline';
  }
  shouldRenderClear() {
    const config = this.config;
    return config.clear && !config.disabled && !config.readonly;
  }
  sendEvent(eventType, detail) {
    return this.host.dispatchEvent(createCustomEvent(eventType, {
      cancelable: false,
      bubbles: true,
      detail
    }));
  }
  onShowPopup() {
    const config = this.config;
    const {
      filterText
    } = this.state;
    const popup = this.popup;
    const isListbox = popup.getAttribute('role') === 'listbox';
    const condensedClass = `tds-${isListbox ? 'listbox' : 'select-dialog'}--condensed`;
    popup.classList[this.condensed ? 'add' : 'remove'](condensedClass);
    const Module = isListbox ? Listbox : SelectDialog;
    const popupConfig = {
      ...this.config,
      searchLabel: config.optionsSearchLabel,
      searchPlaceholder: config.optionsSearchPlaceholder
    };
    if (popupConfig.hasOwnProperty('options')) {
      delete popupConfig.options;
    }
    popupConfig.condensed = this.condensed;
    popupConfig.label = this._translate(isListbox ? 'listboxLabel' : 'selectDialogLabel');
    popupConfig.filter = this.filterPlacement === 'withlist';
    const module = new Module(popup, popupConfig);
    const filterHandoff = popupConfig.filter && filterText && filterText.length === 1 ? filterText : '';
    if (!isListbox) {
      module.externalSearchInput = this.inputControl;
      if (filterHandoff) {
        module.filterHandoff = filterHandoff;
        module.focus();
      }
    }
  }
  onHidePopup() {
    const popup = this.popup;
    if ((popup === null || popup === void 0 ? void 0 : popup.getAttribute('role')) === 'dialog') {
      new SelectDialog(popup).clearFilter();
    }
  }
  updateSelectedProps(_ref) {
    let {
      value,
      values,
      selectedOptions
    } = _ref;
    this.updateConfig({
      value,
      values,
      selectedOptions
    }, true);
  }
  focusCombobox() {
    const combobox = this.combobox;
    const inputControl = this.inputControl;
    if (combobox) {
      combobox.focus();
      if (combobox === inputControl) {
        const selectionPos = inputControl.value.length;
        inputControl.selectionStart = selectionPos;
        inputControl.selectionEnd = selectionPos;
      }
    }
  }
  focusDialog() {
    const popup = this.popup;
    if (popup && popup.matches('[role="dialog"]')) {
      new SelectDialog(popup).focus();
    }
  }
  focusFirstDeselectOption() {
    return this._focusEndDeselectOption(false);
  }
  focusLastDeselectOption() {
    return this._focusEndDeselectOption(true);
  }
  _focusEndDeselectOption(last) {
    const selectedOptions = this.selectedOptionsElement;
    const tags = this.config.tags;
    if (selectedOptions && tags !== 'outside' && this.state.selectedOptions.length) {
      const so = new SelectedOptions(selectedOptions);
      return last ? so.focusOnLast() : so.focusOnFirst();
    }
    return false;
  }
  getLabelAttributes() {
    const config = this.config;
    let labelAttributes = {
      label: config.label || '',
      labelledby: config.labelledby || ''
    };
    if (!labelAttributes.label && !labelAttributes.labelledby) {
      const input = this.getChildInput();
      if (input) {
        labelAttributes = getInputLabelAttributes(input);
      }
    }
    if (!labelAttributes.label && !labelAttributes.labelledby) {
      const tdsField = this.host.closest('.tds-field');
      const tdsLabel = tdsField === null || tdsField === void 0 ? void 0 : tdsField.querySelector('.tds-field__label');
      if (tdsLabel) {
        if (tdsLabel.id) {
          labelAttributes.labelledby = tdsLabel.id;
        } else {
          labelAttributes.label = tdsLabel.textContent;
        }
      }
    }
    return labelAttributes;
  }
  getAriaLabelledBy() {
    const ids = [this.getLabelAttributes().labelledby || this._labelId, this._tagsId].filter(Boolean).join(' ').trim();
    return ids || undefined;
  }
  getAriaDescribedBy() {
    let describedby = this.config.describedby;
    if (describedby) {
      return describedby;
    }
    const input = this.getChildInput();
    describedby = input && input.getAttribute('aria-describedby');
    if (!describedby) {
      const tdsField = this.host.closest('.tds-field');
      const tdsHelpText = tdsField === null || tdsField === void 0 ? void 0 : tdsField.querySelector('.tds-field__help-text');
      const tdsMessage = tdsField === null || tdsField === void 0 ? void 0 : tdsField.querySelector('.tds-field__message');
      describedby = [tdsHelpText === null || tdsHelpText === void 0 ? void 0 : tdsHelpText.id, tdsMessage === null || tdsMessage === void 0 ? void 0 : tdsMessage.id].filter(Boolean).join(' ');
    }
    return describedby || '';
  }
  getChildInput() {
    return getChildElements(this.host, 'select, input')[0];
  }
  getPopupType() {
    return getPopupType(this.config.selectAll, this.filterPlacement);
  }
  get config() {
    if (!this._config) {
      if (!this._dataConfig) {
        this._dataConfig = configFromDataAttributes(this.host, {}, [{
          names: ['maxItems', 'filterDelay', 'summarizeAfter', 'maxLength'],
          convert: 'integer'
        }, {
          names: ['allowOther'],
          convert: value => {
            return value === '' ? 'true' : value;
          }
        }, {
          names: ['loadingText', 'noOptionsText'],
          convert: value => {
            // configFromDataAttributes will convert "false" and "true" to boolean. These need to stay strings
            return (value || '').toString();
          }
        }, {
          names: ['options', 'optionDisabled', 'filterPredicate', 'prepElement', 'optionRenderer', 'optionStatusRenderer', 'tagContentRenderer'],
          convert: 'function'
        }, {
          names: ['options', 'values', 'selectedOptions', 'defaultOptions'],
          convert: 'object'
        }, {
          names: ['options', 'values', 'selectedOptions', 'defaultOptions'],
          convert: 'json'
        }]);
      }
      this._config = {
        // defaults
        options: [],
        optionName: 'name',
        optionValue: 'value',
        multiple: false,
        summarizeAfter: -1,
        summarizeFormat: 'over',
        delimiter: ',',
        ...this._dataConfig,
        ...this._apiConfig
      };
    }
    return this._config;
  }
  get condensed() {
    const host = this.host;
    return this.config.condensed ?? !!host.closest('.tds-field--condensed, .tds-select--condensed');
  }
  get applyFilter() {
    return this.filterPlacement === 'inline';
  }
  get options() {
    const {
      options: configOptions,
      optionName,
      optionValue,
      groupBy,
      optionDisabled
    } = this.config;
    if (configOptions && configOptions.length) return configOptions;
    const derived = deriveOptionsFromOptionElements(this.host, optionName, optionValue);
    if (derived) {
      const {
        options,
        useGroupBy,
        useOptionDisabled
      } = derived;
      if (useGroupBy && useGroupBy !== groupBy) {
        this.updateConfig({
          groupBy: useGroupBy
        });
      }
      if (useOptionDisabled && useOptionDisabled !== optionDisabled) {
        this.updateConfig({
          optionDisabled: useOptionDisabled
        });
      }
      return options;
    }
    return [];
  }
  get selectedOptions() {
    const config = this.config;
    const options = config.selectedOptions;
    if (options) return options;
    const {
      optionName,
      optionValue
    } = config;
    const derived = deriveOptionsFromOptionElements(this.host, optionName, optionValue);
    if (derived) {
      return derived.selectedOptions;
    }
    return [];
  }
  set selectedOptions(selectedOptions) {
    this.updateConfig({
      selectedOptions
    });
  }
  get value() {
    return this.config.value ?? '';
  }
  set value(value) {
    this.updateConfig({
      value
    });
  }
  get values() {
    return this.config.values ?? [];
  }
  set values(values) {
    this.updateConfig({
      values
    });
  }
  get selectContext() {
    return this._context;
  }
  get combobox() {
    var _this$host;
    return (_this$host = this.host) === null || _this$host === void 0 ? void 0 : _this$host.querySelector(`.${CLASSES.wrapper} [role="combobox"]`);
  }
  get inputControl() {
    var _this$host2;
    return (_this$host2 = this.host) === null || _this$host2 === void 0 ? void 0 : _this$host2.querySelector(`.${CLASSES.wrapper} input[role="combobox"]`);
  }
  get inputSpacer() {
    var _this$host3;
    return (_this$host3 = this.host) === null || _this$host3 === void 0 ? void 0 : _this$host3.querySelector(`span.${CLASSES.inputSpacer}`);
  }
  get clearButton() {
    var _this$host4;
    return (_this$host4 = this.host) === null || _this$host4 === void 0 ? void 0 : _this$host4.querySelector(`.${CLASSES.wrapper} button.${CLASSES.clear}`);
  }
  get selectedOptionsElement() {
    var _this$host5;
    return (_this$host5 = this.host) === null || _this$host5 === void 0 ? void 0 : _this$host5.querySelector(`.${CLASSES.wrapper} div.${CLASSES.selectedOptions}`);
  }
  get popupGarage() {
    var _this$host6;
    return (_this$host6 = this.host) === null || _this$host6 === void 0 ? void 0 : _this$host6.querySelector(`.${CLASSES.wrapper} div.${CLASSES.garage}`);
  }
  get popoverReference() {
    var _this$host7;
    return (_this$host7 = this.host) === null || _this$host7 === void 0 ? void 0 : _this$host7.querySelector(`.${CLASSES.wrapper} div.${CLASSES.fieldInput}`);
  }
  get popup() {
    const host = this.host;
    const popupRole = this.getPopupType();
    if (!this._popup || this._popup.getAttribute('role') !== popupRole) {
      this._popup && this._popup.remove();
      this.destroyPopup();
      const isListbox = popupRole === 'listbox';
      const popup = this._popup = host.ownerDocument.createElement('div');
      popup.id = `${this._baseId}__popup`;
      const cls = isListbox ? 'tds-listbox' : 'tds-select-dialog';
      popup.classList.add(cls);
      popup.classList.add(`${cls}--popup`);
      popup.setAttribute('role', popupRole);
      const langEl = this.host.closest('[lang]');
      if (langEl) {
        popup.lang = langEl.lang;
      }
      let popupConfig = {
        selectContext: this._context,
        ...this.config,
        options: undefined
      };
      if (isListbox) {
        popupConfig = {
          ...popupConfig,
          controller: host
        };
      }
      const Module = isListbox ? Listbox : SelectDialog;
      new Module(popup, popupConfig);
      const popupGarage = this.popupGarage;
      if (popupGarage) {
        popupGarage.appendChild(popup);
      }
    }
    return this._popup;
  }
  get filterPlacement() {
    const config = this.config;
    return getFilterPlacement(config.filter, config.tags, config.allowOther);
  }
  get allowOtherResolved() {
    return resolveAllowOther(this.config.allowOther);
  }
  get focused() {
    return this._focused;
  }
  set focused(b) {
    this._focused = b;
    this.updateFieldInputContainer();
  }
  destroy() {
    if (this.host) {
      while (this.onDestroy && this.onDestroy.length) {
        const fn = this.onDestroy.pop();
        fn();
      }
      this.destroyPopup();
      this.destroySelectedOptions();
      if (this.host) {
        delete this.host.dataset[ENHANCED_FLAG$d];
      }
      instances$1.remove(this.host, INSTANCE_KEY$f);
      this.host = this.store = null;
    }
  }
  destroyPopup() {
    const popup = this._popup;
    if (popup) {
      const Module = popup.getAttribute('role') === 'listbox' ? Listbox : SelectDialog;
      new Module(popup).destroy();
      delete this._popup;
    }
  }
  destroySelectedOptions() {
    const selectedOptions = this.selectedOptionsElement;
    if (selectedOptions) {
      new SelectedOptions(selectedOptions).destroy();
    }
  }
}
class Select {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$f) || new _SelectInstance(element, config);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    var _this$_instance;
    (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.updateConfig(config);
  }
  get value() {
    var _this$_instance2;
    return (_this$_instance2 = this._instance) === null || _this$_instance2 === void 0 ? void 0 : _this$_instance2.value;
  }
  set value(value) {
    this._instance && (this._instance.value = value);
  }
  get values() {
    var _this$_instance3;
    return (_this$_instance3 = this._instance) === null || _this$_instance3 === void 0 ? void 0 : _this$_instance3.values;
  }
  set values(values) {
    this._instance && (this._instance.values = values);
  }
  get selectedOptions() {
    var _this$_instance4;
    return (_this$_instance4 = this._instance) === null || _this$_instance4 === void 0 ? void 0 : _this$_instance4.selectedOptions;
  }
  set selectedOptions(selectedOptions) {
    this._instance && (this._instance.selectedOptions = selectedOptions);
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`${PATTERN_SELECTOR$7}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$d]) {
    new Select(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$d] === "true") {
    new Select(element).destroy();
  }
});
// todo: make this a utility function
// we have a similar function in WC, isInputLabelled, which uses similar logic but not in this way
function getInputLabelAttributes(input) {
  const doc = input.ownerDocument;
  let label = input.getAttribute('aria-label') || '';
  let labelledby = input.getAttribute('aria-labelledby') || '';
  if (!label && !labelledby) {
    const labelEl = input.id && doc.querySelector(`label[for="${input.id}"]`) || input.closest('label');
    if (labelEl) {
      if (labelEl.id) {
        labelledby = labelEl.id;
      } else {
        label = labelEl.textContent;
      }
    }
  }
  return {
    label,
    labelledby
  };
}
function deriveOptionsFromOptionElements(host) {
  let optionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
  let optionValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  const optionsParent = host && getChildElements(host, 'select, datalist')[0];
  if (optionsParent) {
    const hasGroups = !!optionsParent.querySelector('optgroup');
    let useGroupBy = hasGroups ? 'groupName' : undefined;
    let useOptionDisabled = undefined;
    const selectedOptions = [];
    const optionsEls = Array.from(optionsParent.querySelectorAll('option'));
    const options = optionsEls.map(optionEl => {
      const name = optionEl.textContent.trim() || optionEl.value;
      const value = optionEl.value ?? name;
      const option = {
        [optionValue]: value,
        [optionName]: name
      };
      const optgroup = optionEl.closest('optgroup');
      if (optgroup) {
        option[useGroupBy] = optgroup.label;
      } else if (hasGroups) {
        option[useGroupBy] = ''; // no logical default
      }

      if (optionEl.selected) {
        selectedOptions.push(option);
      }
      if (optionEl.disabled || optgroup && optgroup.disabled) {
        useOptionDisabled = 'disabled';
        option[useOptionDisabled] = true;
      }
      return option;
    });
    return {
      options,
      selectedOptions,
      useGroupBy,
      useOptionDisabled
    };
  }
  return undefined;
}

function bindPagination(pagination) {
  const eventListeners = new EventListeners();
  eventListeners.addListener(pagination.root, 'click', e => {
    const control = e.target.closest('a[data-page],button[data-page]');
    if (control) {
      const page = parseInt(control.dataset.page);
      const action = control.dataset.action;
      const url = control.href;
      const href = control.getAttribute('href') || undefined;
      const prevent = control.getAttribute('aria-disabled') === 'true' || !pagination.sendEvent({
        page,
        url,
        href,
        action
      });
      if (prevent) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });
  const callback = () => {
    pagination.roomForPageControls = calculateRoomForPageControls(pagination);
  };
  const undoWhileEventing = doWhileEventing(window, 'resize', callback, false); // do not run immediately, it will cause a rerender because its async.
  callback(); //run it synchronously instead
  return () => {
    eventListeners.removeListeners();
    undoWhileEventing();
  };
}
// exported for unit test 
const CONTROL_WIDTH = 44;
function calculateRoomForPageControls(pagination) {
  var _pagination$host;
  const container = (_pagination$host = pagination.host) === null || _pagination$host === void 0 ? void 0 : _pagination$host.parentElement;
  // to allow for a buffer, use 90% of client width, divide by (average) control width,
  // then subtract 2 for the previous and next controls
  let nextPrevCount = 2;
  return container ? Math.floor(container.clientWidth * .9 / CONTROL_WIDTH) - nextPrevCount : 0;
}

/**
 * Returns an array of page numbers to render as pagination items including placeholders for gaps in the page list.
 * Works with these properties: page, totalPages, fixedFirstPages, fixedLastPages, maxItems, roomForPageControls
 * @param pagination The pagination component
 * @returns an array pf pages numbers to render with -1 representing placeholders
 */
function getPageNumberList(pagination) {
  const {
    config,
    roomForPageControls
  } = pagination;
  const {
    page,
    totalPages
  } = config;
  const minItems = 5;
  const maxItems = Math.max(Math.min(config.maxItems, roomForPageControls), minItems);
  const pageListSize = totalPages > 0 ? Math.min(maxItems, totalPages) : maxItems;
  const halfOfListSize = Math.floor((pageListSize - 1) / 2);
  let startingPage = Math.max(page - halfOfListSize, 1);
  let endingPage = startingPage + pageListSize - 1;
  if (totalPages > 0 && endingPage > totalPages) {
    endingPage = totalPages;
    startingPage = Math.max(totalPages - pageListSize + 1, 1);
  }
  //build array with startingPage to endingPage
  const pages = [];
  for (let i = startingPage; i <= endingPage; i++) {
    pages.push(i);
  }
  // if list does not start at 1 replace beginning of list with fixed 1st page and placeholder
  if (pages[0] !== 1) {
    pages[0] = 1;
    pages[1] = -1; //use -1 to indicate placeholder
  }
  // if list does end with lastPage, or lastPage is unknown replace end of list with fixed last page and placeholder
  if (totalPages < 1) {
    pages[pages.length - 1] = -1; //use -1 to indicate placeholder
  } else if (pages[pages.length - 1] !== totalPages) {
    pages[pages.length - 1] = totalPages;
    pages[pages.length - 2] = -1; //use -1 to indicate placeholder
  }

  return pages;
}
/**
 * Derives an accessible label for pagination: it's label property and a description in parenthesis
 * to indicate current page and total pages if known. Interpolates '{page}' to page number and '{total}'
 * to total pages or "many" if total pages is not known.
 * @param pagination The pagination component
 * @returns String label
 */
function paginationLabel(pagination) {
  const {
    config,
    translator: t
  } = pagination;
  const {
    page,
    totalPages,
    label,
    descriptionTemplate
  } = config;
  const descrTpl = descriptionTemplate || t('paginationDescr');
  const description = descrTpl.split(/({page}|{total})/).map(s => {
    switch (s) {
      case '{page}':
        return page;
      case '{total}':
        return totalPages > 0 ? totalPages : t("manyText");
      default:
        return s;
    }
  }).join('');
  return htmlEncode(`${label || t('paginationLabel')} (${description})`);
}
/**
 * Derives accessible text for placeholder between to numbers (previous and next)
 * @param previousPage previous page number, defaults to 0
 * @param nextPage next page number, defaults to zero
 * @param translate i18n translation
 * @returns
 */
function paginationPlaceholderText(previousPage, nextPage, translate) {
  const key = previousPage && nextPage ? 'paginationPlaceholderRange' : 'paginationPlaceholderMany';
  const tpl = htmlEncode(translate(key));
  return tpl.split(/({start}|{end})/).map(s => {
    switch (s) {
      case '{start}':
        return (previousPage || 0) + 1;
      case '{end}':
        return nextPage - 1;
      default:
        return s;
    }
  }).join('');
}
/**
 * Derives page link's accessible label. Interpolates '{page}' to the page number. All other
 * text is wraped in an sr-only span element
 * @param page
 * @param pagination
 * @param srOnlyClass
 * @returns
 */
function pageLabel(page, pagination, srOnlyClass) {
  const {
    config,
    translator: t
  } = pagination;
  const pageTpl = htmlEncode(config.pageTemplate || t('paginationPageLabel'));
  return pageTpl.split(/({page})/).map(s => {
    switch (s) {
      case '{page}':
        return page;
      default:
        return s.trim() && `<span class="${srOnlyClass}">${s}</span>`;
    }
  }).join('');
}
/**
 * Gets the href link attribute for page using hrefTemplate. If template is a function, calls the function
 * with the page number and action and uses the string returned as the template
 * @param page
 * @param pagination
 * @returns
 */
function pageHref(page, action, pagination) {
  const {
    config,
    host
  } = pagination;
  let {
    hrefTemplate
  } = config;
  if (!hrefTemplate) {
    devConsole.warn('the property \'href-template\' must be set for the pagination component', host);
    hrefTemplate = '';
  }
  if (typeof hrefTemplate === 'function') {
    hrefTemplate = hrefTemplate(page, action);
  }
  return hrefTemplate.split(/({page})/).map(s => {
    switch (s) {
      case '{page}':
        return page;
      default:
        return s;
    }
  }).join('');
}
/**
 * Derives the previous control's accessible label using config.prevTemplate if set, otherwise the
 * default template from i18n
 * @param page
 * @param pagination
 * @returns
 */
function previousLabel(page, pagination) {
  const {
    config,
    translator: t
  } = pagination;
  return paginationText(page, config.prevTemplate || t('paginationPrevLabel'));
}
/**
 * Derives the next control's accessible label using config.nextTemplate if set, otherwise the
 * default template from i18n
 * @param page
 * @param pagination
 * @returns
 */
function nextLabel(page, pagination) {
  const {
    config,
    translator: t
  } = pagination;
  return paginationText(page, config.nextTemplate || t('paginationNextLabel'));
}
function paginationText(page, tpl) {
  return htmlEncode(tpl).split(/({page})/).map(s => {
    switch (s) {
      case '{page}':
        return page;
      default:
        return s;
    }
  }).join('');
}

const svgFunction = (svgAttributes, innerContents, defaultClass) => {
  return function () {
    let additionalAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const combinedAttributes = {};
    Object.keys(svgAttributes).filter(function (key) {
      return key !== 'xmlns';
    }).forEach(function (key) {
      combinedAttributes[key] = svgAttributes[key];
    });
    if (additionalAttributes) {
      additionalAttributes = 'string' === typeof additionalAttributes ? {
        class: additionalAttributes
      } : additionalAttributes;
      additionalAttributes['class'] = additionalAttributes['class'] || defaultClass;
      Object.keys(additionalAttributes).filter(function (key) {
        return !svgAttributes[key];
      }).forEach(function (key) {
        combinedAttributes[key] = additionalAttributes[key];
      });
    }
    const attributes = Object.keys(combinedAttributes).map(function (key) {
      return key + '="' + combinedAttributes[key] + '"';
    });
    return '<svg ' + attributes.join(' ') + '>' + innerContents + '</svg>';
  };
};

const id$6 = 'arrow-left-1-18';
const attributes$6 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$6 = '<path d="M2.707 9l4.147 4.146a.5.5 0 01-.708.708l-5-5a.5.5 0 010-.708l5-5a.5.5 0 11.708.708L2.707 8H16.5a.5.5 0 110 1H2.707z" fill="currentColor"/>';
const contents$6 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$6 + '</svg>';
const defaultClass$6 = "tds-icon-18";
const svg$6 = /*#__PURE__*/svgFunction(attributes$6, innerContents$6, defaultClass$6);
var arrowLeft1_18 = {
  svg: svg$6,
  id: id$6,
  contents: contents$6,
  innerContents: innerContents$6,
  attributes: attributes$6
};

const id$5 = 'arrow-right-1-18';
const attributes$5 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$5 = '<path d="M15.293 9l-4.147 4.146a.5.5 0 00.708.708l5-5a.5.5 0 000-.708l-5-5a.5.5 0 10-.708.708L15.293 8H1.5a.5.5 0 100 1h13.793z" fill="currentColor"/>';
const contents$5 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$5 + '</svg>';
const defaultClass$5 = "tds-icon-18";
const svg$5 = /*#__PURE__*/svgFunction(attributes$5, innerContents$5, defaultClass$5);
var arrowRight1_18 = {
  svg: svg$5,
  id: id$5,
  contents: contents$5,
  innerContents: innerContents$5,
  attributes: attributes$5
};

const ENHANCED_FLAG$c = 'enhancedPagination';
const INSTANCE_KEY$e = `${NAMESPACE}Pagination`;
const PATTERN_SELECTOR$6 = `.${CSS_NS}pagination`;
class _PaginationInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    this._apiConfig = {};
    this.root = this.host = element;
    element.dataset[ENHANCED_FLAG$c] = "true";
    instances$1.set(element, INSTANCE_KEY$e, this);
    const unwatch = watchDataAttributeChange(element, () => {
      delete this._dataConfig; // config getter will re-generate
      this.render();
    });
    const unbind = bindPagination(this);
    this.onDestroy = [unbind, unwatch];
    this._apiConfig = config;
    this.render();
  }
  sendEvent(detail) {
    const eventInit = {
      cancelable: true,
      bubbles: true,
      detail
    };
    return this.host.dispatchEvent(createCustomEvent('tdsNavigate', eventInit));
  }
  get config() {
    if (!this._config || !this._dataConfig) {
      if (!this._dataConfig) {
        const dataConfig = this._dataConfig = configFromDataAttributes(this.host, {}, [{
          names: ['maxItems', 'page', 'totalPages'],
          convert: 'integer'
        }]);
        convertStringRefs(dataConfig, ['hrefTemplate'], 'function');
      }
      this._config = {
        // defaults
        page: 1,
        totalPages: -1,
        maxItems: 10,
        ...this._dataConfig,
        ...this._apiConfig
      };
    }
    return this._config;
  }
  updateConfig(config) {
    this._apiConfig = config;
    delete this._config;
    this._rendered && this.render();
  }
  get roomForPageControls() {
    return this._roomForPageControls;
  }
  set roomForPageControls(n) {
    if (n !== this._roomForPageControls) {
      this._roomForPageControls = n;
      this._rendered && this.render();
    }
  }
  render() {
    const {
      host
    } = this;
    this.translator = translations(getLang(this.host)).t;
    host.setAttribute('role', this.config.buttons ? 'group' : 'navigation');
    host.setAttribute('aria-label', paginationLabel(this));
    const html = ['<ul>', this.renderPrevious(), this.renderPageItems(), this.renderNext(), '</ul>'].join('');
    host.innerHTML = html;
    this._rendered = true;
  }
  renderPageItems() {
    const {
      config
    } = this;
    const pageList = getPageNumberList(this);
    return pageList.map((page, i) => {
      const ariaCurrent = page === config.page ? config.ariaCurrentType || 'page' : '';
      return `<li${ariaCurrent && ` aria-current="${ariaCurrent}"`}>${this.renderPageItem(page, pageList[i - 1], pageList[i + 1])}</li>`;
    }).join('');
  }
  renderPageItem(page, previousPage, nextPage) {
    if (page === -1) {
      return this.renderPlaceHolder(previousPage, nextPage);
    }
    if (page === this.config.page) {
      return `<span>${page}</span>`;
    }
    return this.renderPageAction(page, previousPage, nextPage);
  }
  renderPlaceHolder(previousPage, nextPage) {
    const srText = paginationPlaceholderText(previousPage, nextPage, this.translator);
    return `<span class="tds-pagination__placeholder"><span aria-hidden="true">...</span><span class="tds-sr-only">${srText}</span></span>`;
  }
  renderPrevious() {
    const {
      page
    } = this.config;
    const prev = Math.max(page - 1, 1);
    const prevDisabled = page === 1 ? 'true' : undefined;
    const lblPrev = previousLabel(prev, this);
    const attributes = [`aria-label="${lblPrev}"`, `title="${lblPrev}"`];
    if (prevDisabled) {
      attributes.push('aria-disabled="true"');
    }
    const innerHTML = arrowLeft1_18.svg({
      "aria-hidden": true,
      focusable: false
    });
    return `<li>${this.renderAction(prev, 'prev', attributes, innerHTML)}</li>`;
  }
  renderNext() {
    const {
      page,
      totalPages
    } = this.config;
    const next = totalPages > 0 ? Math.min(page + 1, totalPages) : page + 1;
    const nextDisabled = page === totalPages ? 'true' : undefined;
    const lblNext = nextLabel(next, this);
    const attributes = [`aria-label="${lblNext}"`, `title="${lblNext}"`];
    if (nextDisabled) {
      attributes.push('aria-disabled="true"');
    }
    const innerHTML = arrowRight1_18.svg({
      "aria-hidden": true,
      focusable: false
    });
    return `<li>${this.renderAction(next, 'next', attributes, innerHTML)}</li>`;
  }
  renderPageAction(page, previousPage, nextPage) {
    const classes = [];
    if (previousPage === -1) {
      classes.push('tds-pagination__first-item');
    }
    if (nextPage === -1) {
      classes.push('tds-pagination__last-item');
    }
    const attributes = classes.length ? [`class="${classes.join(' ')}"`] : [];
    return this.renderAction(page, 'page', attributes, pageLabel(page, this, 'tds-sr-only'));
  }
  renderAction(page, action, attributes, innerHTML) {
    const {
      buttons
    } = this.config;
    const Tag = buttons ? 'button' : 'a';
    if (!buttons) {
      attributes.push(`href="${pageHref(page, action, this)}"`);
    }
    return `<${Tag} ${attributes.join(' ')} data-page="${page}" data-action="${action}">${innerHTML}</${Tag}>`;
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.root) {
      delete this.root.dataset[ENHANCED_FLAG$c];
    }
    instances$1.remove(this.host, INSTANCE_KEY$e);
  }
}
class Pagination {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$e);
    if (!this._instance) {
      this._instance = new _PaginationInstance(element, config);
    } else if (config) {
      this._instance.updateConfig(config);
    }
  }
  get config() {
    var _this$_instance;
    return (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.config;
  }
  updateConfig(config) {
    if (this._instance) {
      this._instance.updateConfig(config);
    }
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`${PATTERN_SELECTOR$6}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$c]) {
    if (element.children.length || element.textContent.trim()) {
      devConsole.warn(`(development-only-warning) The innerHTML of tds-pagination is overwritten when auto-enhanced. If this is not wanted, set 'data-enhanced-pagination="false"'. If it is intentional, be sure 'data-page', 'data-total-pages' and 'data-href-template' are set appropriately.`);
    }
    new Pagination(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$c] === "true") {
    new Pagination(element).destroy();
  }
});

const defaultOptions$1 = {
  focus: true,
  hover: true,
  hoverInDelay: 300,
  hoverOutDelay: 0
};
/**
 * Notifies when the hover and focus state channge for one or more elements. Used for components with popovers (such as tooltips)
 * where the popover is not a child of the controlling element (so focus-within would not apply) and focus and hover state
 * should perist between the two.
 * @param elements {HTMLElement[]} an arrya of elements to watch colllectively. Most likely 2 elements. Could be
 * @param onChange {(state: FocusHoverState) => void} A callback function with the focus/hover state
 * @param options {FocusHoverOptions} options to apply. When not supplied, defaults to `{focus: true, hover: true, hoverInDelay: 300, hoverOffDelay: 0}`
 * @param options.focus {boolean} Manages focus state
 * @param options.hover {boolean} Manages hover state
 * @param options.hoverInDelay {boolean} Delay in ms to wait until reporting hover state. This prevent an immediate notification
 * when the user is just "passing number". Defaults to 300.
 * @param options.hoverOutDelay {number} Delay in milliseconds to wait until reporting end of hover state. Useful if there is a significant
 * gap between the 2 elements and the hover state should persist when passing between them. Defaults to 0.
 * @returns Function to remove all listeners
 */
function onFocusHover(elements, onChange, options) {
  options = {
    ...defaultOptions$1,
    ...(options || {})
  };
  const eventListeners = new EventListeners();
  elements.forEach(el => {
    if (options.focus) {
      eventListeners.addListener(el, 'focusin', onEvent);
      eventListeners.addListener(el, 'focusout', onEvent);
    }
    if (options.hover) {
      eventListeners.addListener(el, 'mouseover', onEvent);
      eventListeners.addListener(el, 'mouseout', onEvent);
    }
  });
  let focusHoverState = getState();
  if (focusHoverState.focus || focusHoverState.hover) {
    onChange(focusHoverState);
  }
  let eventTimeout;
  return function offFocusHover() {
    eventListeners.removeListeners();
  };
  function onEvent(event) {
    if (eventTimeout) {
      clearTimeout(eventTimeout);
    }
    const delay = event.type === 'mouseover' ? options.hoverInDelay : event.type === 'mouseout' ? options.hoverOutDelay : 0;
    eventTimeout = setTimeout(() => {
      eventTimeout = undefined;
      reportChange(getState());
    }, delay);
  }
  function getState() {
    let focus = options.focus ? false : undefined;
    let hover = options.hover ? false : undefined;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i];
      if (options.focus) {
        focus = focus || hasFocus(el);
      }
      if (options.hover) {
        hover = hover || el.matches(':hover');
      }
    }
    return {
      focus,
      hover
    };
  }
  function reportChange(state) {
    if (state.focus !== focusHoverState.focus || state.hover !== focusHoverState.hover) {
      focusHoverState = state;
      onChange(focusHoverState);
    }
  }
}

const ENHANCED_FLAG$b = 'enhancedTooltip';
const INSTANCE_KEY$d = `tdsTooltip`;
const PATTERN_SELECTOR$5 = `.tds-tooltip__container`;
// ??? data-tooltip-toggle? Is this documented anywhere?
class _TooltipInstance {
  constructor(element) {
    this.element = element;
    const tooltip = this.tooltip = element.querySelector(`[role="tooltip"], .tds-tooltip`);
    element.dataset[ENHANCED_FLAG$b] = "true";
    instances$1.set(element, INSTANCE_KEY$d, this);
    if (tooltip) {
      this.offFocusHover = onFocusHover([element, tooltip], this.onFocusHoverChange.bind(this), {
        hoverOutDelay: 100
      });
    }
  }
  onFocusHoverChange(state) {
    if (state.focus || state.hover) {
      this.showTooltip();
    } else {
      this.hideToolip();
    }
  }
  showTooltip() {
    const {
      tooltip,
      endPopover,
      element
    } = this;
    if (tooltip && !endPopover) {
      const position = tooltip.dataset.position || 'top';
      const placementMap = {
        'top-left': 'top-right-center',
        'top-right': 'top-left-center',
        'bottom-left': 'bottom-right-center',
        'bottom-right': 'bottom-left-center'
      };
      const altPlacementsMap = {
        'top': ['top-left-center', 'top-right-center', 'bottom', 'bottom-left-center', 'bottom-right-center'],
        'bottom': ['bottom-left-center', 'bottom-right-center', 'top', 'top-left-center', 'top-right-center']
      };
      tooltip.dataset.position = position;
      const placement = placementMap[position] || position;
      const alternatePlacements = altPlacementsMap[position] || undefined;
      this.endPopover = createPopover(tooltip, element, {
        placement,
        alternatePlacements,
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 100
      });
    }
  }
  hideToolip() {
    const {
      endPopover
    } = this;
    if (endPopover) {
      this.endPopover();
      this.endPopover = undefined;
    }
  }
  destroy() {
    const {
      element,
      offFocusHover
    } = this;
    this.hideToolip();
    if (offFocusHover) {
      offFocusHover();
      delete this.offFocusHover;
    }
    if (element) {
      delete element.dataset[ENHANCED_FLAG$b];
    }
    instances$1.remove(this.element, INSTANCE_KEY$d);
    this.element = null;
  }
}
class Tooltip {
  constructor(element) {
    this._instance = instances$1.get(element, INSTANCE_KEY$d) || new _TooltipInstance(element);
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(PATTERN_SELECTOR$5, function onPatternAdded(element) {
  if (typeof element.dataset[ENHANCED_FLAG$b] !== 'string') {
    new Tooltip(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$b] === "true") {
    new Tooltip(element).destroy();
  }
});

const TRANSITION_END = 'transitionend';
let isBrowser = undefined;
function onTransitionEnd(el, expectedDuration, callback, propertyName) {
  let timeoutId;
  // determining if running in a browser or in a virtual browser like jsdom
  function eventHandler(event) {
    if (event.target === el && (!propertyName || event.propertyName === propertyName)) {
      run();
    }
  }
  function run() {
    clearTimeout(timeoutId);
    el.removeEventListener(TRANSITION_END, eventHandler);
    callback();
  }
  isBrowser = isBrowser === undefined ? /native code/.test(el.addEventListener.toString()) : isBrowser;
  const isUnitTesting = false;
  const delay = isBrowser || isUnitTesting ? expectedDuration + 100 : 0;
  timeoutId = window.setTimeout(run, delay); //in case event never fires
  el.addEventListener(TRANSITION_END, eventHandler);
}
/**
 * Drives basic steps of an animation: prep, set, complete.
 * @param el Drives the basic steps of running an animation: Prep, start, complete
 * @param expectedDuration The expected duration of the animation. Used to determine the setTimeout fallback
 * @param steps Implementation of each animation step
 * @param propertyName The name of the CSS property to listen for the transitionend event of.
 * If not set, calls `complete` on the first tranistionend event received. */
function runAnimation(el, expectedDuration, steps, propertyName) {
  const {
    prep,
    set,
    complete
  } = steps;
  if (prep) {
    prep(el);
  }
  window.setTimeout(() => {
    onTransitionEnd(el, expectedDuration, () => {
      if (complete) {
        complete(el);
      }
    }, propertyName);
    if (set) {
      set(el);
    }
  }, 50);
}

const DISMISS_CLASS = `${CSS_NS}alert__dismiss`;
const DISMISS_DATA_ATTR = `[data-toggle="alert"]`;
function bindAlert(alert) {
  const {
    root
  } = alert;
  const eventListeners = new EventListeners();
  eventListeners.addListener(root, 'click', clickHandler$2(alert));
  eventListeners.addListener(root, 'keydown', onEscape$1(alert));
  const unbind = () => {
    eventListeners.removeListeners();
  };
  return unbind;
}
function close$1(alert, val) {
  const {
    root,
    host,
    store
  } = alert;
  const button = root.querySelector(`.${DISMISS_CLASS}`) || root.querySelector(DISMISS_DATA_ATTR);
  const x = window.pageXOffset;
  const y = window.pageYOffset;
  const focusElm = button && document.querySelector(button.dataset.focus);
  if (alert.sendEvent('alert.dismissed', {
    cancelable: true,
    detail: val
  })) {
    onTransitionEnd(host, 200, () => {
      store.update(v => {
        return {
          ...v,
          hidden: true,
          transitioning: false
        };
      });
      host.style.height = '';
      // the second event is fired to inform the animation is complete after dissmissal button is closed
      alert.sendEvent('alert.dismissComplete', {
        cancelable: false,
        detail: val
      });
    });
    host.style.height = `${host.clientHeight}px`;
    window.setTimeout(() => {
      store.update(v => {
        return {
          ...v,
          hidden: true,
          transitioning: true
        };
      });
    }, 50);
    // manage focus for keyboard users
    if (focusElm && focusElm.focus) {
      focusElm.focus();
    }
    // manage scrolling for screen magnifiers
    window.scroll(x, y);
  }
}
function clickHandler$2(alert) {
  return e => {
    const target = e.target;
    const button = target.closest(`.${DISMISS_CLASS}, ${DISMISS_DATA_ATTR}`);
    if (button) {
      close$1(alert, button.value);
    }
  };
}
function onEscape$1(alert) {
  return e => {
    if (normalizeKey(e) === 'Escape') {
      close$1(alert, "escape");
    }
  };
}

function createStore$4() {
  return store({
    hidden: false,
    transitioning: false
  });
}

// import { CSS_NS } from '../../shared/constants'
const ENHANCED_FLAG$a = 'enhancedAlert';
const ENHANCED_DATA_FLAG$1 = 'data-enhanced-alert';
const INSTANCE_KEY$c = `${NAMESPACE}Alert`;
class _AlertInstance {
  constructor(element) {
    this.onDestroy = [];
    this.root = this.host = element;
    this.store = createStore$4();
    element.dataset[ENHANCED_FLAG$a] = "true";
    const unbind = bindAlert(this);
    this.onStateUpdate = this.onStateUpdate.bind(this);
    const unsubscribe = this.store.subscribe(this.onStateUpdate);
    this.onDestroy = [unbind, unsubscribe];
    instances$1.set(element, INSTANCE_KEY$c, this);
    const links = Array.from(element.querySelectorAll(`a.${DISMISS_CLASS}, a${DISMISS_DATA_ATTR}`));
    const buttons = Array.from(element.querySelectorAll(`.${DISMISS_CLASS}, ${DISMISS_DATA_ATTR}`));
    buttons.forEach(button => button.hidden = false);
    links.forEach(link => link.hidden = true);
  }
  close(val) {
    close$1(this, val);
  }
  onStateUpdate(state) {
    const {
      root
    } = this;
    if (state.hidden) {
      const fadeOutCls = `${CSS_NS}alert--fade-out`;
      if (state.transitioning) {
        root.classList.add(fadeOutCls);
      } else {
        root.classList.remove(fadeOutCls);
        root.hidden = true;
      }
    }
  }
  sendEvent(eventType, eventInit) {
    return this.host.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  destroy() {
    if (this.root) {
      while (this.onDestroy && this.onDestroy.length) {
        const fn = this.onDestroy.pop();
        fn();
      }
      delete this.root.dataset[ENHANCED_FLAG$a];
      instances$1.remove(this.host, INSTANCE_KEY$c);
      this.root = this.host = this.store = null;
    }
  }
}
class Alert {
  constructor(element) {
    this._instance = instances$1.get(element, INSTANCE_KEY$c) || new _AlertInstance(element);
  }
  // public
  close(val) {
    return this._instance.close(val);
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`.${DISMISS_CLASS}, ${DISMISS_DATA_ATTR}`,
// <= watch for buttons that close alerts 
function onDismissableAlertAdded(element) {
  // find the alert parent of element 
  const ALERT_SELECTOR = `[class*="${CSS_NS}alert-"], [class*="${CSS_NS}inline-alert-"]`;
  const alert = element.closest(ALERT_SELECTOR);
  if (alert && !alert.dataset[ENHANCED_FLAG$a]) {
    new Alert(alert);
  }
});
onDomChanges(`[${ENHANCED_DATA_FLAG$1}]`, null, function onAlertRemoved(element) {
  new Alert(element).destroy();
});

const MODAL_OPEN_BODY_CLASS = `${CSS_NS}body--modal-open`;
const MODAL_DISMISS_SELECTOR$1 = `[data-dismiss="modal"]`;
const HIDDEN_BY_ATTR = 'hidden-by-tds-modal';
const EVENTS = {
  OPEN: 'modal.open',
  OPENED: 'modal.opened',
  CLOSE: 'modal.close',
  CLOSED: 'modal.closed'
};
let nextId$5 = 1;
function getTargetParent(moveToEnd) {
  let result;
  if (moveToEnd === "" || moveToEnd === "true") {
    result = document.body;
  }
  if (!!moveToEnd && !result) {
    if (typeof moveToEnd === 'boolean') {
      result = document.body;
    } else if (typeof moveToEnd === 'string') {
      const resultAsId = document.getElementById(moveToEnd);
      result = !!resultAsId ? resultAsId : document.querySelector(moveToEnd);
    } else {
      result = moveToEnd;
    }
  }
  return result;
}
function open(modal) {
  const {
    config,
    host,
    root,
    store,
    state
  } = modal;
  const eventListeners = new EventListeners();
  const {
    moveToEnd
  } = config;
  let uncontainTabFocus = null;
  if (!state.hidden) {
    return modal.cleanUp;
  }
  //target parent element, where the modal will be moved to when opened  
  const moveToParent = getTargetParent(moveToEnd);
  if (!!moveToParent && host.parentNode !== moveToParent) {
    const placeholder = document.createElement('div');
    const placeholderId = `__tds-modal-placeholder-${++nextId$5}`;
    placeholder.id = placeholderId;
    placeholder.innerHTML = "<!--- place holder --->";
    host.parentNode.insertBefore(placeholder, host);
    //move element to the end of the target Element for z index layering    
    moveToParent.appendChild(host);
    let deferredCleanUp;
    window.setTimeout(function () {
      deferredCleanUp = open(modal);
    }, 50); // use timeout after move so animation will work
    return () => {
      if (deferredCleanUp) {
        deferredCleanUp();
        const pH = document.getElementById(placeholderId);
        if (pH && pH.parentNode) {
          if (host.isConnected) {
            pH.parentNode.replaceChild(host, pH);
          } else {
            pH.remove();
          }
        }
      }
    };
  }
  eventListeners.addListener(document, 'focus', _onFocusAway(modal), true);
  eventListeners.addListener(root, 'mousedown', onBackdropClick(modal));
  eventListeners.addListener(root, 'touchstart', onBackdropClick(modal));
  eventListeners.addListener(host, 'click', onDismissModalClick(modal));
  if (host !== root) {
    eventListeners.addListener(root, 'click', onDismissModalClick(modal));
  }
  eventListeners.addListener(document, 'keydown', onEscape(modal));
  window.setTimeout(function () {
    uncontainTabFocus = containTabFocus(host);
    _initialFocus(modal);
  }, 100);
  setBodyModalOpenState(true, modal);
  const tag = uid('');
  hideOutsideNodes(host, tag);
  const unwatchHiddenNodes = watchForHiddenNodes(host, tag);
  const eventInit = {};
  if (config.trigger) {
    eventInit.detail = {
      relatedTarget: config.trigger
    };
  }
  onTransitionEnd(host, 400, () => {
    const {
      state
    } = modal;
    if (state.hidden) {
      return; // in case closed before transition ended
    }

    modal.sendEvent(EVENTS.OPENED, eventInit);
    store.update(v => {
      return {
        ...v,
        transitioning: false
      };
    });
  });
  store.update(v => {
    return {
      ...v,
      hidden: false,
      transitioning: true
    };
  });
  modal.sendEvent(EVENTS.OPEN, eventInit);
  const clearUpEverything = () => {
    eventListeners.removeListeners();
    if (uncontainTabFocus) {
      uncontainTabFocus();
    }
    setBodyModalOpenState(false, modal);
    unhideOutsideNodes(tag);
    unwatchHiddenNodes(tag);
  };
  return clearUpEverything;
}
function close(modal) {
  let val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const {
    host,
    store,
    state
  } = modal;
  if (!state.hidden) {
    const eventInit = {
      cancelable: true,
      detail: val
    };
    if (modal.sendEvent(EVENTS.CLOSE, eventInit)) {
      const {
        config
      } = modal;
      onTransitionEnd(host, 200, () => {
        eventInit.cancelable = false;
        modal.sendEvent(EVENTS.CLOSED, eventInit);
        modal.cleanUp && modal.cleanUp();
        delete modal.cleanUp;
        store.update(v => {
          return {
            ...v,
            transitioning: false
          };
        });
      });
      modal.returnValue = val;
      store.update(v => {
        return {
          ...v,
          hidden: true,
          transitioning: true
        };
      });
      const returnTo = getConfigElement(config.returnTo || config.trigger, document);
      if (returnTo && returnTo.focus) {
        returnTo.focus();
      }
    }
  }
}
//////////////////////////////////////////////////////////////
// event handlers
function onBackdropClick(modal) {
  return e => {
    const {
      config,
      root
    } = modal;
    if (e.type !== 'mousedown' || e.button === 0) {
      if (e.target === root && config.backdropClose) {
        e.preventDefault();
        close(modal, 'backdrop');
      }
    }
  };
}
function onDismissModalClick(modal) {
  return e => {
    const target = e.target;
    const dismiss = target.closest(`${modal.dismissButtonSelector}, ${MODAL_DISMISS_SELECTOR$1}`);
    if (dismiss) {
      close(modal, dismiss.value);
    }
  };
}
function onEscape(modal) {
  return e => {
    const {
      config
    } = modal;
    if (config.escapeClose) {
      switch (e.key || `${e.which}`) {
        case 'Escape':
        case 'Esc':
        case '27':
          close(modal, 'escape');
      }
    }
  };
}
function _onFocusAway(modal) {
  return e => {
    const target = e.target;
    const {
      state
    } = modal;
    if (!state.hidden && !state.transitioning) {
      // if focus leaves the dialog, for instance if clicked on address bar then tab in,
      // return to 1st element
      const {
        host,
        config
      } = modal;
      if (host && target !== host && !host.contains(target) && !config.modeless && !(target !== null && target !== void 0 && target.closest('[data-popover-container]'))) {
        _initialFocus(modal, true);
      }
    }
  };
}
//////////////////////////////////////////////////////
function _initialFocus(modal) {
  let forceFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    config,
    host
  } = modal;
  if (!forceFirst && config.initialFocus === "false") {
    return;
  }
  let initialFocus = !forceFirst && config.initialFocus && getConfigElement(config.initialFocus, host);
  if (!initialFocus) {
    const [firstFocusable, secondFocusable] = getFocusableChildren(host);
    if (firstFocusable) {
      initialFocus = firstFocusable;
      if (firstFocusable.matches(modal.dismissButtonSelector) && secondFocusable) {
        initialFocus = secondFocusable;
      }
    } else {
      initialFocus = host;
    }
  }
  focus(initialFocus, host);
}
function setBodyModalOpenState(open, modal) {
  const body = document.body;
  if (open) {
    createStyleSheet();
    const vScrollBarWidth = window.innerWidth - body.clientWidth;
    if (vScrollBarWidth) {
      body.style.paddingRight = `${vScrollBarWidth}px`;
    }
    document.body.classList.add(MODAL_OPEN_BODY_CLASS);
  } else {
    body.style.removeProperty('padding-right');
    body.classList.remove(MODAL_OPEN_BODY_CLASS);
  }
  preventIOSScroll(open, modal);
}
function preventIOSScroll(open, modal) {
  const {
    host
  } = modal;
  if (open) {
    if (overflowScrollingTouchSupported()) {
      const scrollTop = host.stored_scrollTop = window.pageYOffset || document.body.scrollTop;
      setTimeout(() => {
        document.body.style.top = `-${scrollTop}px`;
      }, 1000);
    }
  } else if (overflowScrollingTouchSupported()) {
    document.body.style.removeProperty("top");
    const scrollToY = host.stored_scrollTop;
    delete host.stored_scrollTop;
    window.scrollTo(window.pageXOffset, scrollToY);
  }
}
/**
 * Creates a stylesheet (first time only) that contains classes to apply to the body element when the modal is open
 * The styles ae intended to prevent scrolling of the body while the modal is open
 */
function createStyleSheet() {
  const id = `__${MODAL_OPEN_BODY_CLASS}`; // use class name as id
  let style = document.getElementById(id);
  if (!style) {
    try {
      style = document.createElement('style');
      style.id = id;
      // WebKit hack :(
      style.appendChild(document.createTextNode(""));
      // need to append element for it to become a CSSStyleSheet
      document.head.appendChild(style);
      const sheet = style.sheet;
      const preventIIOScroll = overflowScrollingTouchSupported() ? `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    ` : '';
      const rule = `.${MODAL_OPEN_BODY_CLASS} {
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      ${preventIIOScroll}
    }`;
      sheet.insertRule(rule, 0);
    } catch (e) {}
  }
}
function overflowScrollingTouchSupported() {
  return window.CSS && CSS.supports && CSS.supports("-webkit-overflow-scrolling: touch");
}
/**
 * Sets aria-hidden to every element outside the modal's ancestry. This is makes the outside
 * elements inaccessibe by screen readers
 */
function hideOutsideNodes(element, tag) {
  const parent = element.parentElement;
  if (!parent || element === document.body) {
    return;
  }
  const siblings = Array.from(element.parentNode.children);
  siblings.filter(sibling => {
    return sibling !== element && !['SCRIPT', 'STYLE'].includes(sibling.tagName) && !sibling.hasAttribute('inert') && sibling.getAttribute('aria-hidden') !== 'true';
  }).forEach(sibling => {
    sibling.setAttribute('aria-hidden', 'true');
    sibling.setAttribute(HIDDEN_BY_ATTR, tag);
  });
  hideOutsideNodes(parent, tag);
}
/**
 * Reverses hideOutsideNodes
 */
function unhideOutsideNodes(tag) {
  let node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  node.querySelectorAll(`[aria-hidden="true"][${HIDDEN_BY_ATTR}="${tag}"]`).forEach(el => {
    el.removeAttribute('aria-hidden');
    el.removeAttribute(HIDDEN_BY_ATTR);
  });
}
/**
 * This is to address an edge case that ocurs (or occcurred) with make a payment in T.com. When
 * the modal shows, a payment panel managed by the make-a-payment billing module is moved into the
 * modal contents, but not before it is "hidden" by hideOutsideNodes. This function watches for child
 * elements added and removes any hidden by hideOutsideNodes.
 */
function watchForHiddenNodes(host, tag) {
  return watchForChanges(host, {
    childList: true,
    subtree: true
  }, records => {
    if (records.filter(record => record.addedNodes && record.addedNodes.length)) {
      unhideOutsideNodes(tag, host);
    }
  });
}

function createStore$3() {
  return store({
    hidden: true,
    transitioning: false
  });
}

const instanceList$1 = [];
const onResize$1 = /*#__PURE__*/debounce(() => {
  instanceList$1.forEach(instance => instance.setShadowEffect());
}, 200);
class ScrollShadowBehavior {
  constructor(scrollShadow) {
    this.scrollShadow = scrollShadow;
    if (!instanceList$1.length) {
      window.addEventListener('resize', onResize$1);
    }
    instanceList$1.push(this);
    this.setShadowEffect();
  }
  setShadowEffect() {
    const {
      scrollShadow
    } = this;
    const {
      scrollpanel
    } = scrollShadow;
    this.pauseWatch();
    const offsets = getShadowOffsets$1(scrollpanel);
    scrollShadow.applyShadowEffect(offsets.x, offsets.y);
    window.setTimeout(() => {
      this.watch();
    }, 100);
  }
  destroy() {
    this.pauseWatch();
    delete this.scrollShadow;
    delete this.unwatchForChanges;
    const ix = instanceList$1.indexOf(this);
    if (ix > -1) {
      instanceList$1.splice(ix, 1);
      if (!instanceList$1.length) {
        window.removeEventListener('resize', onResize$1);
      }
    }
  }
  watch() {
    const scrollpanel = this.scrollShadow && this.scrollShadow.scrollpanel;
    if (scrollpanel) {
      this.unwatchForChanges = watchForChanges(scrollpanel, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
      }, this.setShadowEffect.bind(this));
    }
  }
  pauseWatch() {
    const {
      unwatchForChanges
    } = this;
    if (unwatchForChanges) {
      unwatchForChanges();
    }
  }
}
function getShadowOffsets$1(scrollpanel) {
  let x = false,
    y = false;
  const style = window.getComputedStyle(scrollpanel);
  const borderLeft = style.borderLeftWidth ? parseInt(style.borderLeftWidth) : 0;
  const borderRight = style.borderRightWidth ? parseInt(style.borderRightWidth) : 0;
  const borderTop = style.borderTopWidth ? parseInt(style.borderTopWidth) : 0;
  const borderBottom = style.borderBottomWidth ? parseInt(style.borderBottomWidth) : 0;
  const offsetWidth = scrollpanel.offsetWidth - borderLeft - borderRight;
  const offsetHeight = scrollpanel.offsetHeight - borderTop - borderBottom;
  // only create the shadow effect if no scrollbars are showing but there is overflow
  if (scrollpanel.clientWidth === offsetWidth && scrollpanel.clientHeight === offsetHeight) {
    x = scrollpanel.clientWidth < scrollpanel.scrollWidth;
    y = scrollpanel.clientHeight < scrollpanel.scrollHeight;
  }
  return {
    x,
    y
  };
}
function bindScrollShadow(scrollShadow) {
  const behavior = new ScrollShadowBehavior(scrollShadow);
  return () => {
    behavior.destroy();
  };
}

/**
 * Looks for instances of [data-scroll-shadow="true"] to manage the shadow effect
 * For each scroll panel:
 * - Observes changes to the scrollpanel using watchForChanges
 * - on window.resize events and any observed changes to scrollpanel, positions the shadow
 *
 * The shadow effect is shown only when there are not scrollbars, and their is overflow.
 *
 * To determine if scrollbars exists, the scroll panel's clientWidth is compared to its offsetWidth.
 * If they are the same, then there are no scrollbars
 *
 * The tds-scroll-shadow--x classe is added if there is horizontal overflow; otherwise it is removed
 * The tds-scroll-shadow--y classe is added if there is vertical overflow; otherwise it is removed
 *
 */
const SHADOW_EFFECT_CLASSNAME$1 = `${CSS_NS}scroll-shadow`;
const ON_SCROLL_SHADOW_REMOVED_EVENT = `${NAMESPACE}ScrollShadowRemoved`;
const ENHANCED_FLAG$9 = 'enhancedScrollshadow';
class ScrollShadow {
  constructor(scrollpanel) {
    scrollpanel.dataset[ENHANCED_FLAG$9] = 'true';
    this.scrollpanel = scrollpanel;
    this.unbind = bindScrollShadow(this);
    this._checkDestroy = this._checkDestroy.bind(this);
    document.addEventListener(ON_SCROLL_SHADOW_REMOVED_EVENT, this._checkDestroy);
  }
  destroy() {
    if (this.scrollpanel) {
      delete this.scrollpanel.dataset[ENHANCED_FLAG$9];
      this.unbind && this.unbind();
      document.removeEventListener(ON_SCROLL_SHADOW_REMOVED_EVENT, this._checkDestroy);
      delete this.scrollpanel;
      delete this.unbind;
    }
  }
  _checkDestroy(e) {
    const element = e.detail;
    if (element === this.scrollpanel) {
      this.destroy();
    }
  }
  applyShadowEffect(x, y) {
    const scrollpanel = this.scrollpanel;
    scrollpanel.classList[x ? 'add' : 'remove'](`${SHADOW_EFFECT_CLASSNAME$1}--x`);
    scrollpanel.classList[y ? 'add' : 'remove'](`${SHADOW_EFFECT_CLASSNAME$1}--y`);
  }
}
onDomChanges(`[data-scroll-shadow="true"]`, function onScrollShadowAdded(scrollpanel) {
  if (scrollpanel.dataset[ENHANCED_FLAG$9] !== 'true') {
    new ScrollShadow(scrollpanel);
  }
}, function onScrollShadowRemoved(element) {
  document.dispatchEvent(createCustomEvent(ON_SCROLL_SHADOW_REMOVED_EVENT, {
    detail: element
  }));
});

const MODAL_TRIGGER_ATTR = 'data-trigger-modal';
const ENHANCED_FLAG$8 = 'enhancedModal';
const ENHANCED_DATA_FLAG = 'data-enhanced-modal';
const INSTANCE_KEY$b = `${NAMESPACE}Modal`;
const MODAL_SELECTOR = `.${CSS_NS}modal`;
const MODAL_DISMISS_SELECTOR = `.${CSS_NS}modal__dismiss`;
const MODAL_BODY_SELECTOR = `.${CSS_NS}modal__dialog-body`;
const defaultConfig$5 = {
  backdropClose: true,
  escapeClose: true,
  modeless: false
};
class _ModalInstance {
  constructor(element) {
    this.onDestroy = [];
    this.returnValue = '';
    this.config = {
      ...defaultConfig$5
    };
    this.dismissButtonSelector = MODAL_DISMISS_SELECTOR;
    instances$1.set(element, INSTANCE_KEY$b, this);
    this.root = this.host = element;
    const store = this.store = createStore$3();
    this.onDestroy.push(store.subscribe(this.onStateUpdate.bind(this)));
    const dataConfig = configFromDataAttributes(element);
    const config = {
      backdropClose: !!element.querySelector(MODAL_DISMISS_SELECTOR),
      ...dataConfig
    };
    this.setConfig(config);
    element.dataset[ENHANCED_FLAG$8] = "true";
  }
  open(config) {
    if (config) {
      this.setConfig(config);
    }
    this.cleanUp = open(this);
  }
  close(val) {
    close(this, val);
  }
  onStateUpdate(state) {
    const {
      host,
      root,
      scrollShadow
    } = this;
    const {
      hidden,
      transitioning
    } = state;
    this.state = state;
    host.hidden = hidden;
    host.classList[transitioning ? 'add' : 'remove']('transitioning');
    if (!transitioning) {
      if (hidden) {
        if (scrollShadow) {
          scrollShadow.destroy();
          delete this.scrollShadow;
        }
      } else {
        const body = root.querySelector(MODAL_BODY_SELECTOR);
        if (body) {
          this.scrollShadow = new ScrollShadow(body);
        }
      }
    }
  }
  sendEvent(eventType, eventInit) {
    return this.host.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  setConfig(config) {
    this.config = {
      ...this.config,
      ...(config || {})
    };
  }
  destroy() {
    if (this.host) {
      const {
        onDestroy,
        cleanUp
      } = this;
      while (onDestroy.length) {
        const fn = onDestroy.pop();
        fn();
      }
      if (cleanUp) {
        cleanUp();
        delete this.cleanUp;
      }
      instances$1.remove(this.host, INSTANCE_KEY$b);
      const element = this.host;
      delete element.dataset[ENHANCED_FLAG$8];
      delete this.host;
      delete this.root;
    }
  }
}
/**
 * @description A class to initialize a modal element
 * @class
 * @param {DomElement} element - the dom element
 * @param {config} object - config
 */
class Modal {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$b) || new _ModalInstance(element);
    if (config) {
      this._instance.setConfig(config);
    }
  }
  /**
     * Sets or resets the configuration
     * When resetting, only properties included in the config object will be updated
     * @param {object} config
     */
  setConfig(config) {
    this._instance.setConfig(config);
  }
  /**
   * Opens (shows) the modal
   */
  open(config) {
    this._instance.open(config);
    return this;
  }
  /**
   * Closes the modal
   * @param {*} returnValue The value to set as the returnValue and the value passed in the 'modal.close' event
   */
  close(val) {
    this._instance.close(val);
    return this;
  }
  /**
   * Detaches from the nav element, removes event listeners, and frees resources.
   */
  destroy() {
    return this._instance.destroy();
  }
  /**
   * The returnValue passed to close
   */
  get returnValue() {
    return this._instance.returnValue;
  }
}
onDomChanges(`[${ENHANCED_DATA_FLAG}]`, null, function onModalRemoved(element) {
  new Modal(element).destroy();
});
document.addEventListener('click', function (e) {
  const trigger = e.target.closest(`[${MODAL_TRIGGER_ATTR}]`);
  const modalEl = trigger && getTargetElement(trigger, MODAL_TRIGGER_ATTR);
  if (modalEl && modalEl.matches(MODAL_SELECTOR)) {
    new Modal(modalEl).open({
      trigger: trigger
    });
    if (trigger.tagName === 'A' || trigger.tagName === 'AREA') {
      e.preventDefault();
    }
  }
});

const DTABLE_CLASSNAME$1 = `${CSS_NS}data-table`;
const ROW_CHECKBOX_SELECTOR = 'tbody [data-row-selector="true"] input[type="checkbox"], tbody input[type="checkbox"][data-row-selector="true"]';
const ROW_RADIO_SELECTOR = 'tbody [data-row-selector="true"] input[type="radio"], tbody input[type="radio"][data-row-selector="true"]';
const ROW_TOGGLE_SELECTOR = 'tbody [data-row-selector="true"] button[aria-pressed], tbody button[aria-pressed][data-row-selector="true"]';
const ROW_EXPANDER_DATA_ATTR = 'data-row-expander';
const EXPANSION_ROW_DATA_ATTR = 'data-expansion-row';
const EXPANDED_ROW_CLASS = `${DTABLE_CLASSNAME$1}__row--expanded`;
const ROW_HOVERED_CLASS = `${DTABLE_CLASSNAME$1}__row--hovered`;
const EXPANDING_ROW_CLASS = `${DTABLE_CLASSNAME$1}__row--expanding`;
const COLLAPSING_ROW_CLASS = `${DTABLE_CLASSNAME$1}__row--collapsing`;

/**
 * Indicate whether or not the element is a child of a nested table inside of current table
 * @param el The element in question
 * @param root The root of DataTableComponent
 * @returns True if the element is a child of a nested table; otherwise false
 */
function inNestedTable(el, root) {
  // NOTE: This may have to change when used as a Web Component depending on what root is
  // For now, root is a table, so...
  return root.closest('table') !== el.closest('table');
}
/**
 * Returns all elements that match the query selector that are children of the current
 * table and not of a nested tables
 * @param parent The element to call `querySelectorAll` from. Defaults to `root`.
 * @param selector The query selector
 * @returns An array of elements that match the query that are in nested tables
 */
function getElementsFromThisTable(parent, selector) {
  const immediateTable = parent.closest('table');
  const elements = Array.from(parent.querySelectorAll(selector));
  return elements.filter(element => immediateTable === element.closest('table'));
}
/**
 * Returns an array of all expansion rows adjacent to a row
 * @param tr The expandable row
 */
function getExpansionRows(tr) {
  const rows = [];
  let sibling = tr.nextElementSibling;
  while (sibling && sibling.matches(`[${EXPANSION_ROW_DATA_ATTR}]`)) {
    rows.push(sibling);
    sibling = sibling.nextElementSibling;
  }
  return rows;
}

function bindSorting(dataTable) {
  const {
    root,
    config
  } = dataTable;
  const sortColumn = root.querySelector('thead [aria-sort]');
  if (!sortColumn) return () => {};
  const eventListeners = new EventListeners();
  eventListeners.addListener(root, 'click', onTableSortColumn(dataTable));
  const tableSort = (config.tableSort || '').toLowerCase();
  if (tableSort === "simple") {
    const sortedHeader = root.querySelector('th[aria-sort="ascending"], th[aria-sort="descending"]');
    if (sortedHeader) {
      const ascending = isSortedAscending$1(sortedHeader);
      const colIndex = Array.from(sortedHeader.parentNode.children).indexOf(sortedHeader);
      sortTableBody(dataTable, colIndex, ascending, sortedHeader);
    }
  }
  if (config.sortControl) {
    bindTableSortControl(dataTable, config.sortControl, eventListeners);
  }
  setSortStateDescriber(dataTable);
  return function unbindSorting() {
    eventListeners.removeListeners();
  };
}
////////////////////////////////////// 
// table sorting 
function onTableSortColumn(dataTable) {
  return e => {
    const target = e.target;
    const th = target.closest('th[aria-sort]');
    if (th) {
      const ascending = !isSortedAscending$1(th);
      const colIndex = Array.from(th.parentNode.children).indexOf(th);
      sortTable(dataTable, colIndex, ascending, th);
    }
  };
}
function sortTable(dataTable, colIndex, ascending, th) {
  const {
    config
  } = dataTable;
  switch ((config.tableSort || '').toLowerCase()) {
    case 'simple':
      doSimpleSort(dataTable, colIndex, ascending, th);
      break;
    case 'callback':
      doCallbackSort(dataTable, colIndex, ascending, th);
      break;
    default:
      // defaults to 'event';
      fireSortEvent(dataTable, colIndex, ascending, th, true);
  }
}
function doSimpleSort(dataTable, colIndex, ascending, th) {
  sortTableBody(dataTable, colIndex, ascending, th);
  fireSortEvent(dataTable, colIndex, ascending, th, false);
}
function doCallbackSort(dataTable, colIndex, ascending, th) {
  const {
    config
  } = dataTable;
  const onSortColumn = config && config.onSortColumn;
  if (onSortColumn) {
    const resp = onSortColumn(colIndex, ascending, th);
    const fireEvent = fireSortEvent.bind(this, dataTable, colIndex, ascending, th, false);
    if (resp && 'function' === typeof resp.then) {
      resp.then(fireEvent).catch(() => {});
    } else if (resp !== false) {
      fireEvent();
    }
  } else {
    // treat like tableSort="event"
    fireSortEvent(dataTable, colIndex, ascending, th, true);
  }
}
function fireSortEvent(dataTable, colIndex, ascending, th, cancelable) {
  const eventInit = {
    cancelable: cancelable,
    detail: {
      colIndex,
      ascending,
      th
    }
  };
  if (!cancelable) {
    //when not cancelable, set sort state before event is thrown
    setSortState(dataTable, th, ascending);
  }
  const notPrevented = dataTable.sendEvent('sortbycolumn', eventInit);
  if (cancelable && notPrevented) {
    //when cancelable, set sort state only if event was not prevented
    setSortState(dataTable, th, ascending);
  }
}
function setSortState(dataTable, th, ascending) {
  const headers = th.parentNode.querySelectorAll('th[aria-sort]');
  for (let i = 0; i < headers.length; i++) {
    const hdr = headers[i];
    const state = hdr === th ? ascending ? 'ascending' : 'descending' : 'none';
    hdr.setAttribute('aria-sort', state);
  }
  setSortStateDescriber(dataTable);
}
function sortTableBody(dataTable, colIndex, ascending, th) {
  const {
    root,
    config
  } = dataTable;
  const sortColDataType = th.dataset.sortDataType || '';
  function getSortValue(tr) {
    const cells = getElementsFromThisTable(tr, 'td,th');
    const cell = cells[colIndex];
    let value = cell ? cell.dataset.sortValue || cell.textContent && cell.textContent.trim() : '';
    if (sortColDataType === 'numeric') {
      const sNumeric = value.replace(/[^\d.-]/g, '');
      const numeric = sNumeric ? parseFloat(sNumeric) : 0;
      /* istanbul ignore else */
      if (!isNaN(numeric) && isFinite(numeric)) {
        const inParenthesis = /^\([^\(\)]*\)$/.test(value.trim());
        value = inParenthesis ? -numeric : numeric;
      } else {
        // not sure if this could happen, but...
        value = Number.MAX_VALUE; // sort invalid numerics last
      }
    }

    return value;
  }
  function isRowGroupHeader(tr) {
    return tr.parentNode.firstElementChild === tr && !!tr.querySelector('th:only-child');
  }
  function isDetailRow(tr) {
    return tr.matches(`[${EXPANSION_ROW_DATA_ATTR}]`);
  }
  const tbodies = getElementsFromThisTable(root, 'tbody').map(tbody => {
    const trows = getElementsFromThisTable(tbody, 'tr');
    const rows = trows
    // remove row group headings. These will stay at top of tbody
    .filter(tr => !isRowGroupHeader(tr))
    // separate detail (expandable) rows from the rows to be sorted
    .reduce((rowsToSort, tr) => {
      if (isDetailRow(tr)) {
        // if the row is a detail row, associate it with its summary row above
        if (rowsToSort.length) {
          rowsToSort[rowsToSort.length - 1].detailRows.push(tr);
        }
      } else {
        // add row to sort array
        rowsToSort.push({
          tr,
          sortValue: getSortValue(tr),
          detailRows: []
        });
      }
      return rowsToSort;
    }, []);
    return {
      tbody,
      rows
    };
  });
  tbodies.forEach(tbodyData => {
    const {
      rows,
      tbody
    } = tbodyData;
    rows.sort((row1, row2) => {
      const rowA = ascending ? row1 : row2;
      const rowB = ascending ? row2 : row1;
      const a = rowA.sortValue;
      const b = rowB.sortValue;
      let order;
      if ('function' === typeof config.sortComparer) {
        order = config.sortComparer(a, b, colIndex, rowA.tr, rowB.tr, ascending);
      }
      if (!order && order !== 0) {
        order = sortColDataType === 'numeric' ? a - b : a.localeCompare(b, undefined, {
          sensitivity: 'base',
          numeric: true
        });
      }
      return order;
    });
    rows.forEach(row => {
      const {
        tr,
        detailRows
      } = row;
      tbody.appendChild(tr);
      detailRows.forEach(detailRow => tbody.appendChild(detailRow));
    });
  });
}
function isSortedAscending$1(th) {
  return th.getAttribute('aria-sort') === 'ascending';
}
//////////////////////////////////////////////////
// table sorting external control
//
// TODO: This logic is too specific to core implementation in regards to dropdown configured as menu action
//
function bindTableSortControl(dataTable, sortControlRef, eventListeners) {
  const {
    root
  } = dataTable;
  const sortControl = getSortControl(sortControlRef);
  if (sortControl) {
    const tableSortColumnHandler = e => {
      window.setTimeout(() => {
        if (!e.defaultPrevented) {
          synchControlWithTable(sortControl, dataTable);
        }
      });
    };
    eventListeners.addListener(root, 'sortbycolumn', tableSortColumnHandler);
    const sortControlChangeHandler = getSortControlChangeHandler(sortControl, dataTable);
    const sortHandlerTarget = sortControl.form || sortControl;
    const sortHandlerEventType = sortControl.form ? 'submit' : 'change';
    eventListeners.addListener(sortHandlerTarget, sortHandlerEventType, sortControlChangeHandler);
    if (dataTable.getSortedColumn()) {
      synchControlWithTable(sortControl, dataTable);
    } else if (sortControl.value) {
      synchTableWithControl(sortControl, dataTable);
    }
  }
}
function getSortControlChangeHandler(sortControl, dataTable) {
  if (sortControl.form) {
    return e => {
      e.preventDefault();
      synchTableWithControl(sortControl, dataTable);
    };
  } else if (sortControl.dataset.dropdownMenu === 'true') {
    return e => {
      if (e.isMenuAction) {
        synchTableWithControl(sortControl, dataTable);
      }
    };
  } else {
    return debounce(() => {
      synchTableWithControl(sortControl, dataTable);
    }, 500);
  }
}
function synchControlWithTable(sortControl, dataTable) {
  const sortedColumn = dataTable.getSortedColumn();
  if (sortedColumn) {
    sortControl.value = `${sortedColumn.colIndex}${sortedColumn.ascending ? 'a' : 'd'}`;
  }
}
function synchTableWithControl(sortControl, dataTable) {
  const match = sortControl.value.match(/(^\d+)([ad]$)/);
  if (match) {
    const colIndex = parseInt(match[1]);
    const ascending = match[2] !== 'd';
    dataTable.sortColumn(colIndex, ascending);
  }
}
function getSortControl(sortControl) {
  if ('string' === typeof sortControl) {
    // see if it works as selector
    const controlSelector = sortControl;
    sortControl = document.querySelector(controlSelector);
    if (!sortControl) {
      // try by id
      sortControl = document.getElementById(controlSelector);
    }
  }
  return sortControl;
}
////////////////////////////////////////////////////////////////////// 
// Sort Accessibility - Announcing sort state and column labelling
function setSortStateDescriber(dataTable) {
  const {
    sortStateDescriber,
    config,
    root
  } = dataTable;
  if (!sortStateDescriber) return;
  const liveRegion = sortStateDescriber.closest('[aria-live]');
  // A liveRegion should only be "visible" when announcing. At other times, it should be "hidden" so
  // that it is not read as normal page text as the user moves past the table to the next part of the page.
  // Here, if the liveRegion is hidden, show, then return after a brief timeout to let the change take effect
  if (liveRegion && liveRegion.getAttribute('aria-hidden') === 'true') {
    liveRegion.removeAttribute('aria-hidden');
    window.setTimeout(() => {
      setSortStateDescriber(dataTable);
    }, 100);
    return;
  }
  const sortedColumn = dataTable.getSortedColumn();
  if (config.tableSort || sortedColumn) {
    const translation = translations(getLang(root)).t;
    sortStateDescriber.textContent = getSortedStateDescription(sortedColumn, translation);
    if (liveRegion) {
      if (liveRegion.setHiddenTimeout) {
        window.clearTimeout(liveRegion.setHiddenTimeout);
      }
      // after 5 seconds, hide the live region
      liveRegion.setHiddenTimeout = window.setTimeout(() => {
        liveRegion.setAttribute('aria-hidden', 'true');
        delete liveRegion.setHiddenTimeout;
      }, 5000);
    }
  }
}
function getSortedStateDescription(sortedColumn, t) {
  if (sortedColumn) {
    const {
      ascending,
      th
    } = sortedColumn;
    const columnName = getColumnName(th);
    const DIRECTION_ATTR = ascending ? 'data-ascending-text' : 'data-descending-text';
    const direction = th.getAttribute(DIRECTION_ATTR) || t(ascending ? 'ascending' : 'descending');
    return t('tableSortStateDescription', columnName, direction);
  }
  return t('notSorted');
}
function getColumnName(th) {
  const columnName = th.getAttribute('data-column-name') || th.getAttribute('aria-label') || getLabelledByLabel(th) || th.textContent || '';
  return columnName.trim();
}

function bindRowSelection(dataTable) {
  const {
    root
  } = dataTable;
  const clickHandler = onRowSelection(dataTable);
  root.addEventListener('click', clickHandler);
  setRowSelectionState(dataTable);
  return function unbindRowSelection() {
    root.removeEventListener('click', clickHandler);
  };
}
function onRowSelection(dataTable) {
  return e => {
    const target = e.target;
    if (target.closest("[data-row-selector='true']") && !inNestedTable(target, dataTable.root)) {
      const input = target.closest('input[type="checkbox"], input[type="radio"]');
      const toggle = target.closest('button[aria-pressed="false"]');
      if (input || toggle) {
        if (target.closest('thead')) {
          if (input && input.type === 'checkbox') {
            selectAllRows(dataTable, target.checked);
          }
        } else {
          if (input && input.type === 'radio' || toggle) {
            clearCurrentSelection(dataTable, target);
          }
          if (toggle) {
            toggle.setAttribute('aria-pressed', 'true');
          }
        }
        setRowSelectionState(dataTable);
      }
    }
  };
}
function selectAllRows(dataTable, selectAll) {
  const root = dataTable.root;
  const checkGroup = getElementsFromThisTable(root, ROW_CHECKBOX_SELECTOR);
  checkGroup.forEach(item => item.checked = selectAll);
}
function setRowSelectionState(dataTable) {
  const {
    root,
    config
  } = dataTable;
  const selectorGroup = getElementsFromThisTable(root, [ROW_CHECKBOX_SELECTOR, ROW_RADIO_SELECTOR, ROW_TOGGLE_SELECTOR].join(","));
  let selectedCount = 0;
  selectorGroup.forEach(item => {
    const selected = item.matches('input[type="checkbox"], input[type="radio"]') ? item.checked : item.getAttribute('aria-pressed') === 'true';
    const tr = item.closest('tr');
    if (tr) {
      [tr].concat(getExpansionRows(tr)).forEach(row => {
        row.classList[selected ? 'add' : 'remove'](config.rowSelectedClass);
      });
    }
    if (selected) {
      selectedCount++;
    }
  });
  const selectAllCheck = root.querySelector('thead [data-row-selector="true"] input[type="checkbox"], thead input[type="checkbox"][data-row-selector="true"]');
  if (selectAllCheck && !inNestedTable(selectAllCheck, root)) {
    selectAllCheck.indeterminate = selectedCount && selectedCount !== selectorGroup.length;
    selectAllCheck.checked = selectedCount && selectedCount === selectorGroup.length;
  }
}
function clearCurrentSelection(dataTable, target) {
  const root = dataTable.root;
  const radioGroup = getElementsFromThisTable(root, ROW_RADIO_SELECTOR);
  radioGroup.forEach(item => {
    if (item !== target) {
      item.checked = false;
    }
  });
  const toggleGroup = getElementsFromThisTable(root, ROW_TOGGLE_SELECTOR);
  toggleGroup.forEach(item => {
    if (item !== target) {
      item.setAttribute('aria-pressed', 'false');
    }
  });
}

const TRIGGER_TARGET_ATTRIBUTE = 'data-toggle-collapse';
const TRIGGER_SELECTOR$1 = `[${TRIGGER_TARGET_ATTRIBUTE}]`;
const inTransition = /*#__PURE__*/new WeakMap();
const durations = {
  'fast': '200ms',
  'medium-fast': '300ms',
  'medium': '400ms',
  'medium-slow': '600ms',
  'slow': '1s'
};
const events$1 = {
  collapsing: 'tdsCollapsing',
  collapsed: 'tdsCollapsed',
  expanding: 'tdsExpanding',
  expanded: 'tdsExpanded'
};
const defaultDuration = 'medium-fast';
const defaultConfig$4 = {
  collapsibleDuration: defaultDuration,
  collapsibleNoOpacity: false
};
class Collapsible {
  constructor(el, config) {
    this._config = defaultConfig$4;
    this.el = el;
    this.setConfig(configFromDataAttributes(el));
    if (config) {
      this.setConfig(config);
    }
  }
  setConfig(config) {
    this._config = {
      ...this._config,
      ...config
    };
  }
  toggle(trigger) {
    return doToggle$1(this, !this.isShown(), trigger);
  }
  show() {
    let trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return doToggle$1(this, true, trigger);
  }
  hide() {
    let trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return doToggle$1(this, false, trigger);
  }
  isShown() {
    var _inTransition$get;
    const {
      el
    } = this;
    return el ? ((_inTransition$get = inTransition.get(el)) === null || _inTransition$get === void 0 ? void 0 : _inTransition$get.expanding) ?? !el.hidden : false;
  }
  get transitioning() {
    return !!inTransition.get(this.el);
  }
}
function getTriggers(el) {
  const allTriggers = document.querySelectorAll(TRIGGER_SELECTOR$1);
  return Array.prototype.filter.call(allTriggers, trigger => {
    const elements = getTargetElements(trigger, TRIGGER_TARGET_ATTRIBUTE);
    try {
      return elements.indexOf(el) > -1;
    } catch {
      /* istanbul ignore next */
      return false;
    }
  });
}
function doToggle$1(collapsible, expand, trigger) {
  const eventStart = expand ? events$1.expanding : events$1.collapsing;
  const action = expand ? 'expand' : 'collapse';
  let ret = true;
  if (collapsible.isShown() !== expand) {
    collapsible._triggerBy = trigger;
    if (ret = fireEvent$1(collapsible, eventStart)) {
      toggleCollapsible(collapsible, action);
    }
  }
  return ret;
}
function fireEvent$1(collapsible, type) {
  const trigger = collapsible._triggerBy;
  const event = createCustomEvent(type, {
    cancelable: type === events$1.expanding || type === events$1.collapsing,
    detail: {
      collapsible,
      trigger
    }
  });
  return collapsible.el.dispatchEvent(event);
}
function toggleCollapsible(collapsible, action) {
  const {
    el,
    _config
  } = collapsible;
  const transitioning = inTransition.get(collapsible.el);
  if (transitioning) {
    inTransition.set(el, {
      ...transitioning,
      reverse: true
    });
    return;
  }
  setTriggerAria(collapsible, action === 'expand');
  const show = action !== 'collapse';
  const includeOpacity = !_config.collapsibleNoOpacity;
  const {
    collapsibleDuration
  } = _config;
  const duration = prefersReducedMotion() ? 0 : durationToMilliseconds(collapsibleDuration);
  // if duration is 0, (immediate) do not change height but still fade in/fade out
  const opacityDuration = !includeOpacity ? 0 : duration ? show ? duration : Math.ceil(duration * 1.5) : 200;
  const computedStyles = window.getComputedStyle(el);
  // window.getComputedStyle returns a live object. Save current settings before
  // updates are applied 
  const savedStyles = {
    paddingTop: computedStyles.paddingTop,
    paddingBottom: computedStyles.paddingBottom,
    borderTopWidth: computedStyles.borderTopWidth,
    borderBottomWidth: computedStyles.borderBottomWidth,
    opacity: computedStyles.opacity
  };
  const savedStyleAttr = el.getAttribute('style');
  const borderTop = savedStyles.borderTopWidth ? parseInt(savedStyles.borderTopWidth) : 0;
  const borderBottom = savedStyles.borderBottomWidth ? parseInt(savedStyles.borderBottomWidth) : 0;
  const styleHeight = el.style.height;
  inTransition.set(el, {
    expanding: show,
    reverse: false
  });
  const prep = () => {
    el.style.overflow = 'hidden';
    el.style.transitionProperty = 'all, opacity';
    el.style.transitionTimingFunction = 'ease';
    el.style.visibility = 'visible';
    if (show) {
      el.style.height = '0';
      el.style.paddingTop = '0';
      el.style.paddingBottom = '0';
      el.style.borderTopWidth = '0';
      el.style.borderBottomWidth = '0';
      if (includeOpacity) {
        el.style.opacity = '0';
      }
      el.hidden = false;
    } else {
      el.style.height = `${el.offsetHeight}px`;
    }
  };
  const set = () => {
    el.style.transitionDuration = `${duration}ms, ${opacityDuration}ms`;
    if (show) {
      const paddingTop = savedStyles.paddingTop ? parseInt(savedStyles.paddingTop) : 0;
      const paddingBottom = savedStyles.paddingBottom ? parseInt(savedStyles.paddingBottom) : 0;
      const addedHeight = paddingTop + paddingBottom + borderTop + borderBottom;
      const height = el.scrollHeight + addedHeight;
      el.style.height = styleHeight || `${height}px`;
      el.style.paddingTop = savedStyles.paddingTop;
      el.style.paddingBottom = savedStyles.paddingBottom;
      el.style.borderTopWidth = savedStyles.borderTopWidth;
      el.style.borderBottomWidth = savedStyles.borderBottomWidth;
      if (includeOpacity) {
        el.style.opacity = savedStyles.opacity;
      }
    } else {
      el.style.height = el.style.paddingTop = el.style.paddingBottom = el.style.borderTopWidth = el.style.borderBottomWidth = duration ? '0' : '';
      if (includeOpacity) {
        el.style.opacity = '0';
      }
    }
  };
  const complete = () => {
    var _inTransition$get2;
    if (!show) {
      el.hidden = true;
    }
    if (savedStyleAttr) {
      el.setAttribute('style', savedStyleAttr);
    } else {
      el.removeAttribute('style');
    }
    const reverse = (_inTransition$get2 = inTransition.get(el)) === null || _inTransition$get2 === void 0 ? void 0 : _inTransition$get2.reverse;
    inTransition.delete(el);
    const eventEnd = show ? events$1.expanded : events$1.collapsed;
    fireEvent$1(collapsible, eventEnd);
    if (reverse) {
      toggleCollapsible(collapsible, show ? 'collapse' : 'expand');
    }
  };
  const maxDuration = Math.max(duration, opacityDuration);
  if (maxDuration) {
    runAnimation(el, maxDuration, {
      prep,
      set,
      complete
    }, 'height');
  } else {
    // skip animation
    el.hidden = !show;
    complete();
  }
}
function setTriggerAria(collapsible, show) {
  const {
    _triggerBy
  } = collapsible;
  const triggers = getTriggers(collapsible.el);
  if (_triggerBy && triggers.indexOf(_triggerBy) === -1) {
    triggers.push(_triggerBy);
  }
  triggers.forEach(trigger => {
    trigger.setAttribute('aria-expanded', `${show}`);
  });
}
function durationToMilliseconds(collapsibleDuration) {
  // convert duration to ms to simply toggle logic
  let duration = collapsibleDuration;
  if (typeof collapsibleDuration === 'string') {
    const match = /^(\d*\.?\d*)(s|ms)?$/.exec(durations[collapsibleDuration] || collapsibleDuration);
    if (match) {
      duration = parseFloat(match[1]);
      if (match[2] === 's') {
        duration *= 1000;
      }
    } else {
      duration = durationToMilliseconds(durations[defaultDuration]);
    }
  }
  return duration;
}
let prefersReducedMotionResult = undefined;
function prefersReducedMotion() {
  if (typeof prefersReducedMotionResult === 'undefined') {
    prefersReducedMotionResult = typeof window.matchMedia !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  return prefersReducedMotionResult;
}
/**
 * If an application uses both Core and web components (like the doc site), this logic is called twice because this code
 * is also compiled into the web components library. When this happens, the two event handlers cancel each other breaking
 * collapsible implementation using data configuration. To prevent this from happening, we set a flag on the document object.
 * This is the simlest fix for now. In our next major version, we will consider a better way of preventing this duplicate
 * code overall. For instance, perhaps make @trv-tds/webcomponents dependent on @trv-tds/core.
 *
 * The reason this has not come up before V8 is that it required an application to use both Core and Web Components that use Collapsible and implementing
 * the data attribute configuration. With V8, the navigation is now the web component which uses Collpasible so the problem presents immediately
 */
if (typeof document !== 'undefined' && !document.__tdsCollapsibleRegistered) {
  document.__tdsCollapsibleRegistered = true;
  document.addEventListener('click', e => {
    const target = e.target;
    const trigger = target.closest(TRIGGER_SELECTOR$1);
    const elements = trigger && getTargetElements(trigger, TRIGGER_TARGET_ATTRIBUTE);
    if (elements && elements.length) {
      elements.forEach(el => {
        new Collapsible(el).toggle(trigger);
      });
      if (trigger.matches('a, area')) {
        e.preventDefault();
      }
    }
  });
}

const events = {
  expanding: 'tdsRowExpanding',
  expanded: 'tdsRowExpanded',
  collapsed: 'tdsRowCollapsed',
  collapsing: 'tdsRowCollapsing'
};
const classMap = {
  [events.expanding]: EXPANDING_ROW_CLASS,
  [events.expanded]: EXPANDED_ROW_CLASS,
  [events.collapsing]: COLLAPSING_ROW_CLASS
};
const toggleSelector = `[${ROW_EXPANDER_DATA_ATTR}]`;
function bindRowExpansion(dataTable) {
  const {
    root
  } = dataTable;
  const eventListeners = new EventListeners();
  eventListeners.addListener(root, 'click', event => {
    const button = event.target.closest(toggleSelector);
    /* istanbul ignore else */
    if (button && !inNestedTable(button, root)) {
      toggleRow(button);
    }
  });
  const hoverHandler = onHoverEvent(dataTable);
  eventListeners.addListener(root, 'mouseover', hoverHandler);
  eventListeners.addListener(root, 'mouseout', hoverHandler);
  const unwatchForChanges = watchForChanges(root, {
    childList: true,
    subtree: true
  }, records => {
    onElementsAdded(dataTable, records);
  });
  configureExpansionElements(dataTable);
  return function unbindRowExpansion() {
    eventListeners.removeListeners();
    unwatchForChanges();
  };
}
function toggleRow(toggle) {
  const expand = toggle.getAttribute('aria-expanded') !== 'true';
  const tr = toggle.closest('tr');
  const startEvent = expand ? events.expanding : events.collapsing;
  let lastContent;
  if (fireEvent(tr, startEvent)) {
    const endEvent = expand ? events.expanded : events.collapsed;
    const collapsibles = [];
    const expansionRows = getExpansionRows(tr);
    applyClass(startEvent, tr, expansionRows);
    expansionRows.forEach(row => {
      row.removeAttribute('aria-hidden');
      getExpansionElements(row).forEach(el => {
        collapsibles.push(el);
      });
    });
    collapsibles.forEach(el => {
      if (new Collapsible(el).toggle(toggle)) {
        lastContent = el;
      }
    });
    const finish = () => {
      fireEvent(tr, endEvent);
      applyClass(endEvent, tr, expansionRows);
      if (!expand) {
        expansionRows.forEach(row => {
          row.setAttribute('aria-hidden', 'true');
        });
      }
    };
    if (lastContent) {
      const collapseEvent = expand ? 'tdsExpanded' : 'tdsCollapsed';
      const onEnd = () => {
        lastContent.removeEventListener(collapseEvent, onEnd);
        finish();
      };
      lastContent.addEventListener(collapseEvent, onEnd);
    } else {
      toggle.setAttribute('aria-expanded', `${expand}`);
      finish();
    }
  }
}
function getExpansionElements(expansionRow) {
  const elements = [];
  for (let i = 0; i < expansionRow.children.length; i++) {
    const cell = expansionRow.children[i];
    if (cell.tagName === 'TD') {
      for (let j = 0; j < cell.children.length; j++) {
        elements.push(cell.children[j]);
      }
    }
  }
  return elements;
}
/**
 * Returns an array of an expandable row and its expansion rows
 * @param tr any row in the expansion group
 */
function getExpansionRowGroup(tr) {
  let row = tr;
  while (row && row.matches(`[${EXPANSION_ROW_DATA_ATTR}]`)) {
    row = row.previousElementSibling;
  }
  return row ? [row].concat(getExpansionRows(row)) : [tr];
}
function fireEvent(tr, type) {
  const expansionRows = getExpansionRows(tr);
  const detail = {
    expansionRow: expansionRows.length === 1 ? expansionRows[0] : expansionRows
  };
  return tr.dispatchEvent(createCustomEvent(type, {
    bubbles: true,
    cancelable: type === events.expanding || type === events.collapsing,
    detail
  }));
}
function applyClass(eventType, tr, expansionRows) {
  const classNameKeys = Object.keys(classMap);
  expansionRows.concat([tr]).forEach(row => {
    classNameKeys.forEach(key => {
      const method = key === eventType ? 'add' : 'remove';
      row.classList[method](classMap[key]);
    });
  });
}
function rowForThisTable(el, root) {
  let tr = el && el.closest('tbody > tr');
  while (tr && tr.parentElement && inNestedTable(tr, root)) {
    tr = tr.parentElement.closest('tbody > tr');
  }
  return tr;
}
function onHoverEvent(dataTableComponent) {
  const {
    root
  } = dataTableComponent;
  return event => {
    const tr = rowForThisTable(event.target, root);
    // ignore if moving within same row
    if (tr && tr !== rowForThisTable(event.relatedTarget, root)) {
      const method = event.type === 'mouseover' ? 'add' : 'remove';
      const rows = getExpansionRowGroup(tr);
      // if just one row, not an expansion row group, no need to set hover class
      if (rows.length > 1) {
        rows.forEach(row => row.classList[method](ROW_HOVERED_CLASS));
      }
    }
  };
}
function onElementsAdded(dataTable, records) {
  const selector = `[${ROW_EXPANDER_DATA_ATTR}], [${EXPANSION_ROW_DATA_ATTR}]`;
  const runConfig = !!records.find(record => {
    const {
      addedNodes
    } = record;
    return addedNodes && Array.prototype.find.call(addedNodes, node => {
      return node instanceof Element && node.matches(selector);
    });
  });
  if (runConfig) {
    configureExpansionElements(dataTable);
  }
}
/**
 * Sychronizes the hidden state of expansion row for each row expander toggle in the table
 * @param dataTable - DataTableComponent
 */
function configureExpansionElements(dataTable) {
  const {
    root
  } = dataTable;
  const toggles = root ? Array.from(root.querySelectorAll(toggleSelector)) : [];
  toggles.forEach(toggle => {
    const hidden = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', `${!hidden}`);
    const tr = toggle.closest('tr');
    if (tr) {
      getExpansionRows(tr).forEach(expansionRow => {
        if (hidden) {
          expansionRow.setAttribute('aria-hidden', 'true');
        } else {
          expansionRow.removeAttribute('aria-hidden');
          expansionRow.classList.add(classMap[events.expanded]);
        }
        getExpansionElements(expansionRow).forEach(el => {
          el.hidden = hidden;
        });
      });
      if (!hidden) {
        tr.classList.add(classMap[events.expanded]);
      }
    }
  });
}

function bindDataTable(dataTable) {
  const unbindSorting = bindSorting(dataTable);
  const unbindRowSelection = bindRowSelection(dataTable);
  const unbindRowExpansion = bindRowExpansion(dataTable);
  const unbind = () => {
    unbindSorting();
    unbindRowSelection();
    unbindRowExpansion();
  };
  return unbind;
}

const INSTANCE_KEY$a = `${NAMESPACE}ToggleIcon`;
const ENHANCED_FLAG$7 = 'toggleHasSvg';
const pathML = '<path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>';
// This craziness is to ensure the svg stays put. React applications that are rendered
// server-side will clear the SVG when the icon is "hydrated"
// array of icon/svg pairs to watch and timestamp added
// Didn't want to clutter browser with multiple timeouts per icon
//
// NOTE: MutationObserver (per icon) would be easier to code. Just listen for the removal of
// the SVG. But not sure of the size of MO's. Would creating an MO for each icon add a lot to
// memory? Could create one MO for all icons, but no way (it seems) to disconnect 
// an observer for a specific target when removed. Worth further research.
const watching = [];
let watchingTimeout;
const checkFrequency = 100;
function watch$1(icon, svg) {
  //start the timer when needed
  if (!watchingTimeout) {
    watchingTimeout = setTimeout(check, checkFrequency);
  }
  watching.push({
    icon,
    svg,
    count: 0
  });
}
function check() {
  // check each icon/svg pair in array
  for (let i = watching.length - 1; i > -1; i--) {
    watching[i].count++;
    const {
      icon,
      svg,
      count
    } = watching[i];
    if (svg.parentNode !== icon) {
      icon.appendChild(svg);
      watching.splice(i, 1);
    } else if (count >= 10) {
      // remove after 10 tries
      watching.splice(i, 1);
    }
  }
  // continue if items still in the array
  watchingTimeout = watching.length && typeof window !== 'undefined' ? setTimeout(check, checkFrequency) : undefined;
}
let instanceCount = 0;
let intersectionObserver;
// The transitionstart and transitionend events, which trigger SVG rendering
// do not fire when the toggle icon is hidden and can become out of synch with its toggle state
// This observer will basically detect when the icon becomes hidden or shown and
// re-render the SVG path
// The happy side effect is this fires when the component is removed from the DOM, and will 
// clean itself up by calling instance.destroy(). :)  
function observeIcon(icon) {
  if (!intersectionObserver && typeof IntersectionObserver !== 'undefined') {
    intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const target = entry.target;
        const instance = instances$1.get(target, INSTANCE_KEY$a);
        if (instance) {
          if (target.isConnected) {
            instance.renderSVGPath();
          } else {
            instance.destroy();
          }
        }
      });
    });
  }
  if (intersectionObserver) {
    intersectionObserver.observe(icon);
  }
}
function unobserveIcon(icon) {
  if (intersectionObserver) {
    intersectionObserver.unobserve(icon);
    if (instanceCount === 0) {
      intersectionObserver.disconnect();
      intersectionObserver = undefined;
    }
  }
}
class ToggleIconInstance {
  constructor(icon, config) {
    this._eventListeners = new EventListeners();
    this._transitioning = false;
    if (!ToggleIconInstance._watchStarted) {
      ToggleIconInstance._watchStarted = true;
      ToggleIconInstance.watch();
    }
    instances$1.set(icon, INSTANCE_KEY$a, this);
    instanceCount++;
    icon.dataset[ENHANCED_FLAG$7] = 'pending';
    this.icon = icon;
    this.renderSVGPath = this.renderSVGPath.bind(this);
    this.init(1, config);
  }
  init(count, config) {
    const icon = this.icon;
    if (!icon || count > 10 || typeof window === 'undefined') {
      //destroyed or timedout
      return;
    }
    let svg;
    while (!(svg = icon.querySelector('svg'))) {
      icon.insertAdjacentHTML('beforeend', `<svg>${pathML}</svg>`);
    }
    const lineHeight = parseInt(window.getComputedStyle(svg).lineHeight);
    const size = this._size = parseInt(window.getComputedStyle(svg).width);
    if (isNaN(lineHeight) || isNaN(size)) {
      // CSS has not yet kicked in, try again
      setTimeout(() => this.init(count + 1, config), 100);
      return;
    }
    svg.setAttribute('viewBox', `0 0 ${size} ${size}`);
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');
    const svgClass = config && config.svgClass;
    if (svgClass) {
      svg.classList.add(svgClass);
    }
    const listeners = this._eventListeners;
    listeners.addListener(svg, 'transitionstart', () => {
      this._transitioning = true;
      this.renderSVGPath();
    });
    listeners.addListener(svg, 'transitionend', () => {
      this._transitioning = false;
      this.renderSVGPath();
    });
    icon.dataset[ENHANCED_FLAG$7] = 'true';
    this.renderSVGPath();
    if (ToggleIconInstance._watchTimeout) {
      watch$1(icon, svg);
    }
    observeIcon(icon);
  }
  renderSVGPath() {
    const {
      icon,
      _size
    } = this;
    const svg = icon.querySelector('svg');
    let path;
    while (!(path = icon.querySelector('svg path'))) {
      // IE does not support inner html on SVGElement
      const domParser = new DOMParser();
      const pathDoc = domParser.parseFromString(pathML, 'image/svg+xml');
      svg.appendChild(icon.ownerDocument.importNode(pathDoc.firstChild, true));
    }
    // line-height is between 1px and 101px; see @mixin nav-toggle-icon() in _navigation.scss for explanation
    const pct = (parseFloat(window.getComputedStyle(svg).lineHeight) - 1) / 100;
    const w = _size - 2; //width
    const h = w / 2; //height
    const l = 1; // left
    const c = _size / 2; //center
    const r = l + w; //right
    const t = (_size - h) / 2; // top
    const b = t + h; // bottom
    const coordinates = [[l, t, b], [c, b, t], [r, t, b]];
    const d = coordinates.map(_ref => {
      let [x, y1, y2] = _ref;
      return {
        x,
        y: y1 + (y2 - y1) * pct
      };
    }).reduce((acc, _ref2, i) => {
      let {
        x,
        y
      } = _ref2;
      return acc += `${i ? 'L' : 'M'}${x},${y}`;
    }, '');
    path.setAttribute('d', d);
    path.setAttribute('stroke-width', _size < 18 ? '1' : '2');
    if (this._transitioning) {
      window.requestAnimationFrame(this.renderSVGPath);
    }
  }
  destroy() {
    const {
      icon,
      _eventListeners
    } = this;
    if (icon) {
      instances$1.remove(icon, INSTANCE_KEY$a);
      instanceCount--;
      delete icon.dataset[ENHANCED_FLAG$7];
      delete this.icon;
      unobserveIcon(icon);
    }
    _eventListeners.removeListeners();
    this._transitioning = false;
  }
  static watch() {
    if (typeof window !== 'undefined') {
      // using this approach so it is can be unit tested
      if (ToggleIconInstance._watchTimeout) {
        clearTimeout(ToggleIconInstance._watchTimeout);
      }
      // wait 5 seconds for hydration to complete, then stop adding to watch queue
      ToggleIconInstance._watchTimeout = setTimeout(() => {
        ToggleIconInstance._watchTimeout = undefined;
      }, 5000);
    }
  }
}
ToggleIconInstance._watchStarted = false;

class ToggleIcon {
  constructor(icon) {
    this._instance = instances$1.get(icon, INSTANCE_KEY$a) || new ToggleIconInstance(icon);
  }
  get icon() {
    return this._instance.icon;
  }
  destroy() {
    return this._instance.destroy();
  }
  /**
   * Automatically enhances and destroys elements that match the selector
   * @param selector The selector for the elements to watch for
   */
  static autoEnhance(selector) {
    if (typeof document !== 'undefined') {
      onDomChanges(selector, function onToggleAdded(element) {
        if (!element.closest('label')) {
          new ToggleIcon(element);
        }
      }, function onToggleRemoved(element) {
        if (element.dataset.toggleHasSvg) {
          new ToggleIcon(element).destroy();
        }
      });
    }
  }
}
ToggleIcon.autoEnhance(`.tds-accordion__toggle-icon`);
ToggleIcon.autoEnhance(`.tds-nav__toggle-icon`);

/**
 * ***********************************************************************************
 * ***********************************************************************************
 * NOTE: This is copied directly from legacy. When implemeneted as a web component,
 * consider whether or not some of the logic needs to be split out into a
 * resusable 'behavior' module.
 * ***********************************************************************************
 * ***********************************************************************************
 * Looks for instances of tds-data-table-scrollpanel with [data-scroll-shadow-effect="true"] to manage the shadow effect
 * For each scroll panel:
 * - Wraps panel in tds--scrollpanel-shadow-wrapper element if needed
 * - Observes changes to the scrollpanel using watchForChanges
 * - on window.resize events and any observed changes to scrollpanel, positions the shadow
 *
 * The shadow wrapper is position:relative. It contains a tds-scrollpanel-shadow element which is
 * positioned absolute. The shadow uses a before pseudo-element, also absolutely positioned, to create
 * the shadow effect. tds-scrollpanel-shadow has 2 modifiers: tds-scrollpanel-shadow--x to show
 * left and right shadows, and tds-scrollpanel-shadow--y, to show the top/bottom shadows
 *
 * The shadow effect is shown only when there are not scrollbars, and their is overflow.
 *
 * To determine if scrollbars exists, the scroll panel's clientWidth is compared to its offsetWidth.
 * If they are the same, then there are no scrollbars
 *
 * The tds-scrollpanel-shadow--x classe is added if there is horizontal overflow; otherwise it is removed
 * The tds-scrollpanel-shadow--y classe is added if there is vertical overflow; otherwise it is removed
 *
 * The last step is to see if the scrollpanel wraps a table with sticky rows or columns. If it does
 * it adjusts the top, bottom, left, and right values accordingly so the shadow aligns with the sticky elements
 *
 * For all this to work as intended
 * - The scroll panel cannot have any padding or margins. Shadow placement does not account for this
 * - For tables with sticky headers or footers, either must have just one row
 * - For tables with sticky columns, header columns counts must be the same as the column count for rows.
 *
 * To disable this feature, remove the import line from ../data-table.js. Or, remove
 * [data-scroll-shadow-effect="true"]
 *
 */
const INSTANCE_KEY$9 = `${NAMESPACE}ScrollpanelShadow`;
// const REMOVED_EVENT = 'dataTableScrollpanel:removed';
const SCROLLPANEL_CLASSNAME = `${CSS_NS}data-table-scrollpanel`;
const SHADOW_WRAPPER_CLASSNAME = `${CSS_NS}scrollpanel-shadow-wrapper`;
const SHADOW_EFFECT_CLASSNAME = `${CSS_NS}scrollpanel-shadow`;
const instanceList = [];
const onResize = /*#__PURE__*/debounce(() => {
  instanceList.forEach(instance => instance.setShadowEffect());
}, 200);
class ScrollpanelShadow {
  constructor(scrollpanel) {
    this._private = {
      scrollpanel,
      shadowX: false,
      shadowY: false
    };
    if (!pointerEventsSupported()) {
      // shadow effect blocks pointer event unless pointer-events: none
      // If not supported, don't enable
      return;
    }
    if (!instanceList.length) {
      window.addEventListener('resize', onResize);
    }
    instanceList.push(this);
    // ensure shadow wrapper exists, before calling instances.set()
    getShadowEffectElements(scrollpanel);
    this.setShadowEffect();
    watch(this);
    // must be called after shadow wrapper is created because repositioning table element causes a 'destroy' event
    instances$1.set(scrollpanel, INSTANCE_KEY$9, this);
  }
  setShadowEffect() {
    if (this._private) {
      const {
        scrollpanel
      } = this._private;
      const offsets = getShadowOffsets(scrollpanel);
      positionShadowEffect(scrollpanel, offsets);
    }
  }
  destroy() {
    const {
      scrollpanel,
      unwatchForChanges
    } = this._private;
    delete this._private;
    const ix = instanceList.indexOf(this);
    if (ix > -1) {
      instanceList.splice(ix, 1);
      if (!instanceList.length) {
        window.removeEventListener('resize', onResize);
      }
    }
    if (unwatchForChanges) {
      unwatchForChanges();
    }
    instances$1.remove(scrollpanel, INSTANCE_KEY$9);
  }
  _checkDestroy(element) {
    if (element === this._private.scrollpanel) {
      this.destroy();
    }
  }
}
function getShadowOffsets(scrollpanel) {
  let x = false,
    y = false;
  const style = window.getComputedStyle(scrollpanel);
  const borderLeft = style.borderLeftWidth ? parseInt(style.borderLeftWidth) : 0;
  const borderRight = style.borderRightWidth ? parseInt(style.borderRightWidth) : 0;
  const borderTop = style.borderTopWidth ? parseInt(style.borderTopWidth) : 0;
  const borderBottom = style.borderBottomWidth ? parseInt(style.borderBottomWidth) : 0;
  const offsetWidth = scrollpanel.offsetWidth - borderLeft - borderRight;
  const offsetHeight = scrollpanel.offsetHeight - borderTop - borderBottom;
  // only create the shadow effect if no scrollbars are showing but there is overflow
  if (scrollpanel.clientWidth === offsetWidth && scrollpanel.clientHeight === offsetHeight) {
    x = scrollpanel.clientWidth < scrollpanel.scrollWidth;
    y = scrollpanel.clientHeight < scrollpanel.scrollHeight;
  }
  return {
    x,
    y
  };
}
function positionShadowEffect(scrollpanel, offsets) {
  const {
    x,
    y
  } = offsets;
  const effectElements = getShadowEffectElements(scrollpanel);
  effectElements[0].classList[x ? 'add' : 'remove'](`${SHADOW_EFFECT_CLASSNAME}--x`);
  effectElements[1].classList[y ? 'add' : 'remove'](`${SHADOW_EFFECT_CLASSNAME}--y`);
}
function getShadowEffectElements(scrollpanel) {
  const table = scrollpanel.querySelector('table');
  const shadowEffectsNeeded = table && table.className.indexOf('--sticky') > -1 ? 2 : 1;
  let wrapper = scrollpanel.parentElement;
  if (!wrapper.matches(`.${SHADOW_WRAPPER_CLASSNAME}`)) {
    wrapper = document.createElement('div');
    wrapper.classList.add(SHADOW_WRAPPER_CLASSNAME);
    scrollpanel.parentNode.insertBefore(wrapper, scrollpanel);
    wrapper.appendChild(scrollpanel);
  }
  while (wrapper.querySelectorAll(`.${SHADOW_EFFECT_CLASSNAME}`).length < shadowEffectsNeeded) {
    wrapper.insertAdjacentHTML('afterbegin', `<div class="${SHADOW_EFFECT_CLASSNAME}" aria-hidden="true"></div>`);
  }
  const effectElements = Array.from(wrapper.querySelectorAll(`.${SHADOW_EFFECT_CLASSNAME}`));
  if (effectElements.length === 1) {
    effectElements[1] = effectElements[0];
  }
  if (positionStickySupported()) {
    positionForStickyTable(scrollpanel, effectElements);
  }
  return effectElements;
}
function positionForStickyTable(scrollpanel, shadowEffectElements) {
  let wrapper = scrollpanel.parentElement;
  const table = scrollpanel.querySelector('table');
  let top = 0,
    bottom = 0,
    left = 0,
    right = 0;
  if (table) {
    const className = table.className || '';
    const styleX = shadowEffectElements[0].style;
    const styleY = shadowEffectElements[1].style;
    const currentLeft = styleX.left ? parseInt(styleX.left) : 0;
    const currentRight = styleX.right ? parseInt(styleX.right) : 0;
    const currentTop = styleY.top ? parseInt(styleY.top) : 0;
    const currentBottom = styleY.bottom ? parseInt(styleY.bottom) : 0;
    if (className.indexOf('--sticky-header') > -1) {
      const tbody1 = table.querySelector('tbody:first-of-type');
      top = tbody1 && tbody1.offsetTop || 0;
    }
    if (className.indexOf('--sticky-footer') > -1) {
      const tbody2 = table.querySelector('tbody:last-of-type');
      const tbodyBottom = tbody2 && tbody2.offsetTop + tbody2.offsetHeight || 0;
      bottom = table.clientHeight - tbodyBottom;
    }
    if (className.indexOf('--sticky-firstcol') > -1) {
      const firstCell = table.querySelector('th:first-child,td:first-child');
      left = firstCell && firstCell.offsetWidth;
    }
    if (className.indexOf('--sticky-lastcol') > -1) {
      const lastCell = table.querySelector('th:last-child,td:last-child');
      right = lastCell && lastCell.offsetWidth;
    }
    if (top !== currentTop) {
      styleY.top = `${top}px`;
    }
    if (bottom !== currentBottom) {
      styleY.bottom = `${bottom}px`;
    }
    if (left !== currentLeft) {
      styleX.left = `${left}px`;
    }
    if (right !== currentRight) {
      styleX.right = `${right}px`;
    }
    // THIS IS FIX FOR WHEN SCREEN IS WIDER THAN THE TABLE WIDTH
    // THIS WILL ADJUST THE WIDTH OF THE WRAPPER AND THE
    // SHADOW EFFECT TO BE EQUAL TO THE TABLE WIDTH
    wrapper.style.maxWidth = table.offsetWidth + "px";
    scrollpanel.style.maxWidth = table.offsetWidth + "px";
  }
}
function watch(scrollpanelShadow) {
  const {
    scrollpanel
  } = scrollpanelShadow._private;
  scrollpanelShadow._private.unwatchForChanges = watchForChanges(scrollpanel, {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
  }, scrollpanelShadow.setShadowEffect.bind(scrollpanelShadow));
}
onDomChanges(`.${SCROLLPANEL_CLASSNAME}[data-scroll-shadow-effect="true"]`, function onDataTableAdded(scrollpanel) {
  new ScrollpanelShadow(scrollpanel);
}, function onDataTableRemoved(element) {
  instanceList.forEach(instance => instance._checkDestroy(element));
});

const ENHANCED_FLAG$6 = 'enhancedDataTable';
const ENHANCED_DATA_ATTR = 'data-enhanced-data-table';
const INSTANCE_KEY$8 = `${NAMESPACE}DataTable`;
const DTABLE_CLASSNAME = `${CSS_NS}data-table`;
const ROW_SELECTED_CLASS = `${DTABLE_CLASSNAME}__row--selected`;
const COLUMN_SORT_BUTTON_CLASS = `${DTABLE_CLASSNAME}__sort-col-button`;
const ROW_EXPANDER_TOGGLE_ICON_CLASS = `${DTABLE_CLASSNAME}__row-expander-toggle-icon`;
const ID_PARSER_RX = /\b\S+\b/g;
const defaultConfig$3 = {
  announceSortState: true,
  rowSelectedClass: ROW_SELECTED_CLASS
};
class _DataTableInstance {
  constructor(element) {
    this.config = {};
    this.onDestroy = [];
    element.dataset[ENHANCED_FLAG$6] = "true";
    this.root = this.host = element;
    this.setConfig({
      ...defaultConfig$3,
      ...configFromDataAttributes(element)
    });
    const unbind = bindDataTable(this);
    setColumnSortDescribers(element);
    this.onDestroy = [unbind, clearUnusedSortDescribers];
    instances$1.set(element, INSTANCE_KEY$8, this);
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const announceSortState = this.config.announceSortState;
    convertStringRefs(config, ['onSortColumn', 'sortComparer'], 'function');
    this.config = {
      ...this.config,
      ...config
    };
    if (announceSortState !== this.config.announceSortState) {
      this.sortStateDescriber = getSortStateDescriberElement(this);
    }
  }
  sortColumn(colIndex, ascending) {
    const {
      host
    } = this;
    const th = host && host.querySelectorAll('thead tr:last-child th')[colIndex];
    if (th) {
      if ('undefined' === typeof ascending) {
        ascending = !isSortedAscending(th);
      }
      sortTable(this, colIndex, ascending, th);
    }
  }
  getSortedColumn() {
    const {
      host
    } = this;
    const thead = host && host.querySelector('thead');
    const sortedHeader = thead && thead.querySelector('th[aria-sort="ascending"], th[aria-sort="descending"]');
    if (sortedHeader) {
      return {
        colIndex: Array.from(sortedHeader.parentNode.children).indexOf(sortedHeader),
        ascending: isSortedAscending(sortedHeader),
        th: sortedHeader
      };
    }
    return null;
  }
  sendEvent(eventType, eventInit) {
    return this.host.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.root) {
      delete this.root.dataset[ENHANCED_FLAG$6];
    }
    instances$1.remove(this.host, INSTANCE_KEY$8);
    this.root = this.host = null;
  }
}
function isSortedAscending(th) {
  return th.getAttribute('aria-sort') === 'ascending';
}
let nextSortStateElementId = 1;
function getSortStateDescriberElement(dataTable) {
  const {
    host,
    config
  } = dataTable;
  const {
    announceSortState
  } = config;
  let sortStateEl = null;
  if (announceSortState && !!host.querySelector('th[aria-sort]')) {
    if ('string' === typeof announceSortState) {
      sortStateEl = document.getElementById(announceSortState) || document.querySelector(announceSortState);
    } else if (announceSortState instanceof HTMLElement) {
      sortStateEl = announceSortState;
    }
    if (!sortStateEl) {
      const t = translations(getLang(host)).t;
      // create descriptor in 2 parts.
      // Part 1 is the table caption followed by "is". e.g. "Table 'Policies' is "
      const part1 = t('htmlTableIs', getTableCaption(host));
      // Part 2 is the sort state. e.g. "sorted by Name, ascending"
      const part2 = sortStateEl = document.createElement('span');
      // Part 2 is associated with the table via aria-describedby, so AT will describe the table's sort state
      // without repeating the table caption
      part2.id = `table-sort-describer-${nextSortStateElementId++}`;
      const describedby = `${host.getAttribute('aria-describedby') || ''} ${sortStateEl.id}`.trim();
      host.setAttribute('aria-describedby', describedby);
      // parts 1&2 are combined as a live region after the table, so AT will read this as:
      // "Table 'Policies' is sorted by Name, ascending"
      const liveRegion = document.createElement('span');
      liveRegion.textContent = part1;
      liveRegion.appendChild(part2);
      liveRegion.classList.add(`${CSS_NS}sr-only`);
      liveRegion.setAttribute('aria-live', 'polite');
      // aria-atomic = true means to read the entire live region when sortStateEl changes, not just the updated text
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.setAttribute('aria-hidden', 'true');
      if (host.parentNode) {
        host.parentNode.insertBefore(liveRegion, host.nextElementSibling);
      }
    }
  }
  return sortStateEl;
}
function getTableCaption(table) {
  const caption = table.querySelector('caption');
  let text = caption && caption.textContent && caption.textContent.trim() || getLabelledByLabel(table);
  if (!text) {
    const figure = table.closest('figure');
    const figcaption = figure && figure.querySelector('figcaption');
    text = figcaption && figcaption.textContent && figcaption.textContent.trim();
  }
  return text ? `'${text}'` : '';
}
function setColumnSortDescribers(table) {
  // Only apply to column headers whose label is not configured by aria-label or aria-labelledby.
  // The assumption is if <th> is so labelled, then sort button can have a more meaningful label
  // and would not need aria-describedby
  const sortableHeaders = Array.from(table.querySelectorAll('th[aria-sort]:not([aria-label]):not([aria-labelledby])'));
  sortableHeaders.forEach(th => {
    const SORT_BUTTON_SELECTOR = `.${COLUMN_SORT_BUTTON_CLASS}`;
    const sortButton = th.querySelector(SORT_BUTTON_SELECTOR) || (th.matches(SORT_BUTTON_SELECTOR) ? th : null);
    if (sortButton) {
      const describer = getColumnSortDescriber(getLang(sortButton));
      const describedbyIds = (sortButton.getAttribute('aria-describedby') || '').match(ID_PARSER_RX) || [];
      if (describedbyIds.indexOf(describer.id) === -1) {
        describedbyIds.push(describer.id);
      }
      sortButton.setAttribute('aria-describedby', describedbyIds.join(' '));
    }
  });
}
const columnSortDescribers = {};
let nextElementId = 1;
function getColumnSortDescriber(lang) {
  // creates (if needed) and returns a sort column descriptor for the language passed
  // The descriptor reads: Sorts by this column
  let describer = columnSortDescribers[lang];
  if (!describer) {
    const docLang = getLang(document.body);
    const SORT_DESCR_ID_PFX = 'data-column-sort-button-description';
    // check if added by developer
    const selector = `[id^="${SORT_DESCR_ID_PFX}"]${lang !== docLang ? `[lang="${lang}"]` : ':not([lang])'}`;
    describer = document.querySelector(selector);
    // if not, create it
    if (!describer) {
      describer = document.createElement('span');
      describer.hidden = true;
      describer.id = `${SORT_DESCR_ID_PFX}-${nextElementId++}`;
      describer.textContent = translations(lang).t('sortColumnDescription');
      if (lang !== docLang) {
        describer.lang = lang;
      }
      document.body.appendChild(describer);
      // only track the describers created so we know which to delete
      columnSortDescribers[lang] = describer;
    }
  }
  return describer;
}
function clearUnusedSortDescribers() {
  // called by destroy. Removes any column sort describers created by this module no longer needed
  Object.keys(columnSortDescribers).forEach(key => {
    const describer = columnSortDescribers[key];
    if (!document.querySelector(`[aria-describedby~="${describer.id}"]`)) {
      describer.parentNode.removeChild(describer);
      delete columnSortDescribers[key];
    }
  });
}
class DataTable {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$8) || new _DataTableInstance(element);
    if (config) {
      this.setConfig(config);
    }
  }
  /**
     * Sets or resets the configuration
     * When resetting, only properties included in the config object will be updated
     * @param {object} config
     */
  setConfig(config) {
    this._instance.setConfig(config);
  }
  /**
   * Sort table by column based on its table-sort configuration: simlple, callback, event.
   * If table-sort is not set, simply toggles the column's sort state
   * @param {number} colIndex - The zero-based column index to sort
   * @param {boolean} ascending (optional) Forces an ascending or decending order. If not provided, reverses the current sort order or sorts ascending if not currently sorted.
   */
  sortColumn(colIndex, ascending) {
    this._instance.sortColumn(colIndex, ascending);
  }
  /**
   * Gets the column index and sort state of the currently sorted column
   * @returns {object} If a column is sorted, returns an object with the properties:
   * - colIndex: The zero-based index of the sorted column
   * - acending: true if sorted ascending; otherwise false
   * Returns null if no column is sorted
   */
  getSortedColumn() {
    return this._instance.getSortedColumn();
  }
  /**
   * Detaches from the nav element, removes event listeners, and frees resources.
   */
  destroy() {
    const {
      _instance
    } = this;
    delete this._instance;
    return _instance.destroy();
  }
}
const SORTABLE_TABLE_SELECTOR = 'table[data-table-sort]';
const SORTABLE_TABLE_HEADER_SELECTOR = `table.${DTABLE_CLASSNAME} thead th[aria-sort]`;
const ROW_SELECTION_SELECTOR = '[data-row-selector="true"]';
const ROW_EXPANSION_SELECTOR = `[${ROW_EXPANDER_DATA_ATTR}], [${EXPANSION_ROW_DATA_ATTR}]`;
const tableSelectors = /*#__PURE__*/[SORTABLE_TABLE_SELECTOR, SORTABLE_TABLE_HEADER_SELECTOR, ROW_SELECTION_SELECTOR, ROW_EXPANSION_SELECTOR].join(',');
// Listen for addition of table child elements as well as table so that a table that starts empty
// is enhanced once an enhanceable element is added. For instance, adding an expandable row 
// to an empty table
onDomChanges(tableSelectors, function onDataTableAdded(element) {
  const table = element.closest('table');
  if (table && table.dataset[ENHANCED_FLAG$6] !== "true") {
    new DataTable(table);
  }
});
onDomChanges(`table[${ENHANCED_DATA_ATTR}]`, null, function onDataTableRemove(element) {
  new DataTable(element).destroy();
});
ToggleIcon.autoEnhance(`.${ROW_EXPANDER_TOGGLE_ICON_CLASS}`);

const viewportSmall = 400;
const viewportLarge = 800;
const viewportMedium = 576;
const viewportXLarge = 1024;

function onBreakpoint(breakpoint, callback) {
  let mql;
  if (window.matchMedia) {
    const breakpoints = {
      sm: viewportSmall,
      md: viewportMedium,
      lg: viewportLarge,
      xl: viewportXLarge
    };
    let minWidth = typeof breakpoint === 'string' && breakpoints[breakpoint] || breakpoint;
    if (typeof minWidth === 'string' && /^\d+(px)?$/.test(minWidth)) {
      minWidth = parseInt(minWidth);
    }
    if (typeof minWidth === 'number') {
      minWidth = minWidth / 16 + 'em';
    }
    mql = window.matchMedia(`(min-width: ${minWidth})`);
    mql.addEventListener('change', onChange);
    callback(mql.matches);
  }
  function onChange(event) {
    callback(event.matches);
  }
  return () => {
    if (mql) {
      mql.removeEventListener('change', onChange);
      mql = undefined;
    }
  };
}

const menuSlots = ['nav', 'actions', 'mobile-menu-pre', 'mobile-menu-post', 'mobile-menu-between'];
const menuSlotsSelector = /*#__PURE__*/menuSlots.map(s => `[slot="${s}"]`).join(',');
function bindGlobalHeader(globalHeader) {
  const {
    host,
    root
  } = globalHeader;
  const eventListeners = new EventListeners();
  eventListeners.addListener(host, 'click', onClick);
  eventListeners.addListener(host, 'focusout', onFocusOut);
  eventListeners.addListener(host, 'keydown', onEscape);
  if (root && root !== host) {
    eventListeners.addListener(root, 'click', onClick);
    eventListeners.addListener(root, 'focusout', onFocusOut);
    eventListeners.addListener(root, 'keydown', onEscape);
  }
  eventListeners.addListener(root || host, 'tdsExpanding', onExpandCollapse);
  eventListeners.addListener(root || host, 'tdsExpanded', onExpandCollapse);
  eventListeners.addListener(root || host, 'tdsCollapsing', onExpandCollapse);
  eventListeners.addListener(root || host, 'tdsCollapsed', onExpandCollapse);
  let offBreakpoint;
  let isMobile = false;
  let ghHeight = 0;
  setupVariantListener();
  const undoWhileEventing = doWhileEventing(window, 'resize', () => {
    onResize();
  });
  const unbind = () => {
    eventListeners.removeListeners();
    clearBreakpoint();
    undoWhileEventing();
  };
  return [unbind, onMobileBelowChange];
  function onMobileBelowChange() {
    setupVariantListener();
  }
  function setupVariantListener() {
    clearBreakpoint();
    let mobileBelow = globalHeader.config.mobileBelow;
    if (mobileBelow) {
      offBreakpoint = onBreakpoint(mobileBelow, matches => {
        onMobileBreakpoint(!matches);
      });
    }
  }
  function onMobileBreakpoint(mobile) {
    isMobile = mobile;
    const menuWrapper = globalHeader.menuWrapper;
    const menuToggle = globalHeader.menuToggle;
    if (menuWrapper) {
      menuWrapper.hidden = mobile;
    }
    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
    }
    globalHeader.onMobileBreakpoint(mobile);
  }
  function clearBreakpoint() {
    if (offBreakpoint) {
      offBreakpoint();
      offBreakpoint = undefined;
    }
  }
  function onResize() {
    let centerIdentity = false;
    const idBlock = globalHeader.identityBlock;
    const sibling = idBlock && idBlock.nextElementSibling;
    if (idBlock && sibling && isMobile) {
      const idBottom = idBlock.getBoundingClientRect().bottom;
      const siblingTop = sibling.getBoundingClientRect().top;
      // trim fractions in case of retina display overlaps
      centerIdentity = Math.ceil(siblingTop) >= Math.floor(idBottom);
    }
    globalHeader.centerIdentity(centerIdentity);
    const host = globalHeader.host;
    if (globalHeader.fixed && host) {
      const height = host.offsetHeight;
      if (height !== ghHeight) {
        var _host$ownerDocument;
        ghHeight = height;
        (_host$ownerDocument = host.ownerDocument) === null || _host$ownerDocument === void 0 || (_host$ownerDocument = _host$ownerDocument.documentElement) === null || _host$ownerDocument === void 0 || (_host$ownerDocument = _host$ownerDocument.style) === null || _host$ownerDocument === void 0 ? void 0 : _host$ownerDocument.setProperty('--tds-gh-fixed-height', `${height}px`);
      }
    }
  }
  function onClick(e) {
    const menuToggle = globalHeader.menuToggle;
    if (menuToggle && menuToggle.contains(e.target)) {
      toggleMenu();
    } else {
      const link = e.target.closest('a, tds-button[href], tds-icon-button[href]');
      if (link) {
        toggleMenu(false);
      }
    }
  }
  function onFocusOut() {
    setTimeout(() => {
      const {
        menuToggle,
        menuWrapper,
        host
      } = globalHeader;
      if (menuWrapper && menuToggle && menuToggle.getAttribute('aria-expanded') === 'true') {
        let activeElement = host.ownerDocument.activeElement;
        if (activeElement === host && host.shadowRoot) {
          activeElement = host.shadowRoot.activeElement;
        }
        const containers = [menuToggle, menuWrapper];
        if (host.shadowRoot) {
          host.querySelectorAll(menuSlotsSelector).forEach(el => containers.push(el));
        }
        const noFocus = !activeElement || !containers.find(el => el.contains(activeElement));
        if (noFocus) {
          toggleMenu(false);
        }
      }
      const pairs = globalHeader.expandedPairs;
      pairs.forEach(_ref => {
        let {
          toggle,
          toggled
        } = _ref;
        if (!hasFocus(toggle) && !hasFocus(toggled)) {
          toggle.click();
        }
      });
    });
  }
  function onEscape(e) {
    if (normalizeKey(e) === 'Escape') {
      const target = e.target;
      const menuWrapper = globalHeader.menuWrapper;
      const menuToggle = globalHeader.menuToggle;
      const containers = [menuToggle, menuWrapper];
      if (host.shadowRoot) {
        host.querySelectorAll(menuSlotsSelector).forEach(el => containers.push(el));
      }
      const targetContainer = containers.find(el => el && el.contains(target));
      if (targetContainer) {
        toggleMenu(false);
        e.preventDefault();
        e.stopPropagation();
        if (menuToggle) {
          menuToggle.focus();
        }
      }
    }
  }
  function onExpandCollapse(e) {
    const target = e.target;
    const menuWrapper = globalHeader.menuWrapper;
    if (target === menuWrapper) {
      // See mixin global-header-menu-wrapper-mobile in ./mixins/_globalHeader.scss
      // for explanation of why we add 'tds-expanding' here.
      menuWrapper.classList.toggle('tds-expanding', e.type === 'tdsExpanding');
      menuWrapper.classList.toggle('tds-collapsing', e.type === 'tdsCollapsing');
    }
  }
  function toggleMenu(expand) {
    const menuToggle = globalHeader.menuToggle;
    const menuWrapper = globalHeader.menuWrapper;
    if (isMobile && menuWrapper && (typeof expand === 'undefined' || expand === menuWrapper.hidden)) {
      new Collapsible(menuWrapper).toggle(menuToggle);
    }
  }
}

const navBaseClassName = `tds-nav`;
const NAV_CLASSES = {
  nav: navBaseClassName,
  navList: `${navBaseClassName}__list`,
  navDropdown: `${navBaseClassName}__dropdown`,
  navLink: `${navBaseClassName}__link`,
  navItem: `${navBaseClassName}__item`,
  navItemText: `${navBaseClassName}__item-text`,
  navHeading: `${navBaseClassName}__heading`,
  navToggle: `${navBaseClassName}__toggle`,
  navToggleIcon: `${navBaseClassName}__toggle-icon`,
  navToggleExpandedText: `${navBaseClassName}__toggle--expanded`,
  navToggleCollapsedText: `${navBaseClassName}__toggle--collapsed`,
  navMenuToggle: `${navBaseClassName}__toggle--menu`,
  navMenuToggleText: `${navBaseClassName}__toggle-menu-text`,
  navMenuToggleIcon: `${navBaseClassName}__toggle-menu-icon`,
  navMegaMenu: `${navBaseClassName}__mega-menu`
};
const MENU_TOGGLE_CLASSES = {
  menuToggle: 'tds-menu-toggle',
  menuToggleText: 'tds-menu-toggle__text',
  menuToggleTextExpanded: 'tds-menu-toggle__text--expanded',
  menuToggleIcon: 'tds-menu-toggle__icon'
};

const BASE_CLASS$1 = 'tds-global-header';
const GH_MOBILE_CLASS = `${BASE_CLASS$1}--mobile`;
const WRAPPER_CLS = `${BASE_CLASS$1}__wrapper`;
const MENU_WRAPPER_CLS = `${BASE_CLASS$1}__menu-wrapper`;
const MOBILE_BLOCK_CLS = `${BASE_CLASS$1}__mobile-block`;
const IDENTITY_BLOCK_CLS = `${BASE_CLASS$1}__identity-block`;
const IDENTITY_BLOCK_CENTERED_CLS = `${IDENTITY_BLOCK_CLS}--center`;
const ENHANCED_FLAG$5 = 'enhancedGlobalHeader';
const INSTANCE_KEY$7 = `${NAMESPACE}GlobalHeader`;
class _GlobalHeaderInstance {
  constructor(element) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.onDestroy = [];
    this._apiConfig = {};
    instances$1.set(element, INSTANCE_KEY$7, this);
    this.root = this.host = element;
    this._apiConfig = config;
    element.dataset[ENHANCED_FLAG$5] = "true";
    this.configureMobilBreakpoint();
    const [unbind, onMobileBelowChange] = bindGlobalHeader(this);
    this._onMobileBelowChange = onMobileBelowChange;
    const unwatch = watchDataAttributeChange(element, config => {
      this._dataConfig = undefined;
      if (config && typeof config.mobileBelow !== 'undefined') {
        onMobileBelowChange();
      }
    });
    this.onDestroy = [unbind, unwatch];
  }
  updateConfig(config) {
    if (this._apiConfig !== config) {
      this._apiConfig = {
        ...this._apiConfig,
        ...config
      };
      if (config && typeof config.mobileBelow !== 'undefined') {
        this._onMobileBelowChange && this._onMobileBelowChange();
      }
    }
  }
  get config() {
    return {
      ...(this._dataConfig || (this._dataConfig = configFromDataAttributes(this.host))),
      ...(this._apiConfig || {})
    };
  }
  configureMobilBreakpoint() {
    let mobileBelow = this.config.mobileBelow;
    if (!mobileBelow) {
      mobileBelow = this.deriveMobileBelowFromNav();
    }
    if (mobileBelow) {
      this.configureNav(mobileBelow);
      this.checkAddMenuToggle();
    }
  }
  configureNav(mobileBelow) {
    const host = this.host;
    const nav = host.querySelector('.tds-nav');
    if (nav) {
      const navVariantAt = nav.dataset.variantAt;
      const navVariant = nav.dataset.variant;
      if (navVariantAt !== mobileBelow) {
        if (navVariantAt) {
          devConsole.warn(`TDS nav's 'variantAt' property (${navVariantAt}) does not match global headers 'mobileBelow' property (${mobileBelow}). Nav will be updated to align with global header`);
        }
        nav.dataset.variantAt = mobileBelow;
      }
      if (navVariant !== 'row') {
        if (navVariant) {
          devConsole.warn(`TDS nav's 'variant' property (${navVariant}) should be set to "row" when in the global header. Nav's 'variant' will be updated to "row"`);
        }
        nav.dataset.variant = 'row';
      }
    }
  }
  deriveMobileBelowFromNav() {
    const host = this.host;
    let mobileBelow;
    const nav = host.querySelector('.tds-nav[data-variant-at][data-variant="row"]');
    if (nav && !nav.querySelector(`.${MENU_TOGGLE_CLASSES.menuToggle}`)) {
      mobileBelow = nav.dataset.variantAt;
    }
    if (!mobileBelow) {
      ['sm', 'md', 'lg', 'xl'].forEach(bp => {
        const selector = `.tds-nav--row-${bp}`;
        const nav = host.querySelector(selector);
        if (nav) {
          mobileBelow = bp;
        }
      });
    }
    if (mobileBelow) {
      this.updateConfig({
        mobileBelow
      });
    }
    return mobileBelow;
  }
  checkAddMenuToggle() {
    const host = this.host;
    const menuWrapper = this.menuWrapper;
    let menuToggle = this.menuToggle;
    if (!menuToggle && menuWrapper) {
      // warn?
      menuToggle = host.ownerDocument.createElement('button');
      menuToggle.classList.add(MENU_TOGGLE_CLASSES.menuToggle);
      menuToggle.setAttribute('type', 'button');
      menuToggle.setAttribute('aria-expanded', 'false');
      const wrapper = this.wrapper;
      let mobileBlock = wrapper && wrapper.querySelector(`.${MOBILE_BLOCK_CLS}`);
      if (!mobileBlock) {
        mobileBlock = host.ownerDocument.createElement('div');
        mobileBlock.classList.add(MOBILE_BLOCK_CLS);
        wrapper.insertBefore(mobileBlock, menuWrapper);
      }
      mobileBlock.appendChild(menuToggle);
    }
    if (menuToggle && !menuToggle.innerHTML) {
      const formatter = (text, isSR) => {
        return `<span${isSR ? ' class="tds-sr-only"' : ''}>${text}</span>`;
      };
      const t = translations(host);
      const showMenuTpl = t.html('showMenu');
      const closeMenuTpl = t.html('closeMenu');
      const showMenu = splitTextForScreenReader(showMenuTpl, formatter).join('');
      const closeMenu = splitTextForScreenReader(closeMenuTpl, formatter).join('');
      menuToggle.innerHTML = `
      <span class="${MENU_TOGGLE_CLASSES.menuToggleText}">
        ${showMenu}
      </span>
      <span class="${MENU_TOGGLE_CLASSES.menuToggleTextExpanded}">
        ${closeMenu}
      </span>
      <span class="${MENU_TOGGLE_CLASSES.menuToggleIcon}"></span>
      `;
    }
  }
  onMobileBreakpoint(mobile) {
    if (this.host) {
      applyClasses(this.host, {
        [GH_MOBILE_CLASS]: mobile
      });
      this.host.dispatchEvent(createCustomEvent('tdsMobileBreakpoint', {
        mobile
      }));
    }
  }
  centerIdentity(center) {
    const idBlock = this.identityBlock;
    if (idBlock && idBlock.classList.contains(IDENTITY_BLOCK_CENTERED_CLS) !== center) {
      idBlock.classList[center ? 'add' : 'remove'](IDENTITY_BLOCK_CENTERED_CLS);
    }
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      this.onDestroy.pop()();
    }
    if (this.root) {
      delete this.root.dataset[ENHANCED_FLAG$5];
    }
    instances$1.remove(this.host, INSTANCE_KEY$7);
    this.root = this.host = null;
  }
  get identityBlock() {
    var _this$host;
    return (_this$host = this.host) === null || _this$host === void 0 ? void 0 : _this$host.querySelector(`.${IDENTITY_BLOCK_CLS}`);
  }
  get wrapper() {
    var _this$host2;
    return (_this$host2 = this.host) === null || _this$host2 === void 0 ? void 0 : _this$host2.querySelector(`.${WRAPPER_CLS}`);
  }
  get menuWrapper() {
    const wrapper = this.wrapper;
    return wrapper && wrapper.querySelector(`.${MENU_WRAPPER_CLS}`);
  }
  get menuToggle() {
    const wrapper = this.wrapper;
    let mobileBlock = wrapper && wrapper.querySelector(`.${MOBILE_BLOCK_CLS}`);
    return mobileBlock && mobileBlock.querySelector(`.${MENU_TOGGLE_CLASSES.menuToggle}`);
  }
  get expandedPairs() {
    const expandedItems = Array.from(this.host.querySelectorAll('[aria-expanded="true"]'));
    return expandedItems.map(toggle => {
      let toggled;
      const toggledRef = toggle.dataset.toggleCollapse;
      if (toggledRef) {
        try {
          toggled = document.getElementById(toggledRef) || document.querySelector(toggledRef);
        } catch {} //in case toggledRef is an invalid selector
      }

      return toggled ? {
        toggle,
        toggled
      } : undefined;
    }).filter(Boolean);
  }
  get fixed() {
    var _this$host3;
    return (_this$host3 = this.host) === null || _this$host3 === void 0 ? void 0 : _this$host3.classList.contains('tds-global-header--fixed');
  }
}
class GlobalHeader {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$7) || new _GlobalHeaderInstance(element, config);
    if (config) {
      this.updateConfig(config);
    }
  }
  updateConfig(config) {
    var _this$_instance;
    (_this$_instance = this._instance) === null || _this$_instance === void 0 ? void 0 : _this$_instance.updateConfig(config);
  }
  // public
  // create other proxy methods to the instance
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`.${BASE_CLASS$1} .${MENU_WRAPPER_CLS}`, function onPatternAdded(element) {
  const ghElement = element.closest(`.${BASE_CLASS$1}`);
  if (ghElement && !ghElement.dataset[ENHANCED_FLAG$5]) {
    new GlobalHeader(ghElement);
  }
}, function onPatternRemoved(element) {
  const ghElement = element.closest(`.${BASE_CLASS$1}`);
  if (ghElement && ghElement.dataset[ENHANCED_FLAG$5] === "true") {
    new GlobalHeader(ghElement).destroy();
  }
});

function bindNavigation(navigation) {
  const {
    host,
    root
  } = navigation;
  const eventListeners = new EventListeners();
  eventListeners.addListener(host, 'click', onClick(navigation));
  if (root && root !== host) {
    eventListeners.addListener(root, 'click', onRootClick(navigation));
  }
  eventListeners.addListener(host, 'focusout', onFocusOut(navigation));
  eventListeners.addListener(host, 'keydown', onKeydown(navigation));
  const mouseDownHandler = onDocumentMouseDown(navigation);
  eventListeners.addListener(document, 'mousedown', mouseDownHandler);
  eventListeners.addListener(document, 'touchstart', mouseDownHandler);
  let offBreakpoint;
  setupVariantListener();
  const unbind = () => {
    eventListeners.removeListeners();
    clearBreakpoint();
  };
  return [unbind, setupVariantListener];
  function setupVariantListener() {
    clearBreakpoint();
    const {
      variant,
      variantAt
    } = navigation.config || {};
    if (variantAt) {
      offBreakpoint = onBreakpoint(variantAt, matches => {
        navigation.applyVariant(matches);
        if (navigation.config.variant === 'row') {
          closeTopLevelToggles(navigation, true);
        }
      });
    } else {
      navigation.applyVariant(!!variant);
    }
  }
  function clearBreakpoint() {
    if (offBreakpoint) {
      offBreakpoint();
      offBreakpoint = undefined;
    }
  }
}
function onFocusOut(navigation) {
  return () => {
    setTimeout(() => {
      closeTogglesNotContaining(navigation, navigation.host.ownerDocument.activeElement);
    });
  };
}
function onDocumentMouseDown(navigation) {
  return e => {
    closeTogglesNotContaining(navigation, e.target);
  };
}
function onClick(navigation) {
  return e => {
    const toggle = navigation.getToggleElement(e);
    if (toggle) {
      doToggle(navigation, toggle);
    } else {
      const link = e.target.closest('a, button:not([aria-expanded])');
      if (link) {
        if (navigation.isRowOrientation()) {
          closeTopLevelToggles(navigation);
        }
        const topToggle = navigation.topToggle;
        if (topToggle && isVisible$1(topToggle) && navigation.isToggleExpanded(topToggle)) {
          doToggle(navigation, topToggle);
        }
      }
    }
  };
}
function onRootClick(navigation) {
  return e => {
    const {
      topToggle,
      root
    } = navigation;
    if (topToggle && root.contains(topToggle) && topToggle.contains(e.target)) {
      doToggle(navigation, topToggle);
    }
  };
}
function closeTogglesNotContaining(navigation, referenceElement) {
  const {
    host
  } = navigation;
  if (!referenceElement || !host.contains(referenceElement)) {
    closeTopToggle(navigation);
  }
  if (navigation.isRowOrientation()) {
    navigation.getTopNavItems(true).forEach(topNavItem => {
      const toggle = navigation.getChildToggleElement(topNavItem);
      if (toggle && navigation.isToggleExpanded(toggle) && (!referenceElement || !topNavItem.contains(referenceElement))) {
        doToggle(navigation, toggle);
      }
    });
  }
}
function doToggle(navigation, toggle) {
  let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const navList = navigation.getToggledElement(toggle);
  if (navList) {
    toggleNavList(navList, navigation, toggle, immediate);
  }
}
function toggleNavList(navList, navigation, toggle, immediate) {
  new Collapsible(navList, {
    collapsibleDuration: immediate ? 0 : getToggleDuration(navList, navigation),
    collapsibleNoOpacity: immediate
  }).toggle(toggle);
}
function onKeydown(navigation) {
  return e => {
    if (handleEscape(e, navigation) || handleMiniToggle(e, navigation)) {
      e.preventDefault();
      return;
    }
    if (navigation.isRowOrientation()) {
      rowKeyboardNavigation(e, navigation);
      return;
    }
    navigateNavList(e, getNavList(navigation.host));
  };
}
function handleEscape(e, navigation) {
  const key = normalizeKey(e);
  if (key !== 'Escape') return false;
  if (navigation.isRowOrientation()) {
    const target = e.target;
    const topNavItem = navigation.getTopNavItems(true).find(item => item.contains(target));
    const toggle = topNavItem && navigation.getChildToggleElement(topNavItem);
    const toggled = toggle && navigation.getToggledElement(toggle);
    const navLink = topNavItem && topNavItem.querySelector('a, button:not([aria-expanded])');
    if (toggled && isVisible$1(toggled)) {
      toggleNavList(toggled, navigation, toggle);
      const focusOn = toggle || navLink;
      if (focusOn) {
        focusOn.focus();
      }
      e.stopPropagation();
    }
  } else {
    const topToggle = navigation.topToggle;
    const expanded = topToggle && navigation.isToggleExpanded(topToggle);
    if (expanded && isVisible$1(topToggle)) {
      doToggle(navigation, topToggle);
      topToggle.focus();
      e.stopPropagation();
    }
  }
  return true;
}
function handleMiniToggle(e, navigation) {
  const key = normalizeKey(e);
  const target = e.target;
  if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].includes(key)) {
    const navItem = getClosestNavItem(target);
    const toggle = navItem && navigation.getChildToggleElement(navItem);
    let navLink = toggle && isVisible$1(toggle) && toggle.previousElementSibling;
    if (navLink && navLink.tagName !== 'A') {
      navLink = undefined;
    }
    if (key === 'ArrowRight' || key === 'ArrowLeft') {
      const from = key === 'ArrowRight' ? navLink : toggle;
      const to = key === 'ArrowLeft' ? navLink : toggle;
      if (to && from && to !== from && from.contains(target)) {
        to.focus();
        return true;
      }
    } else if (key === 'ArrowDown' || key === 'ArrowUp') {
      if (toggle && navLink && toggle.contains(target)) {
        const isExpanded = navigation.isToggleExpanded(toggle);
        const shouldBeExpanded = key === 'ArrowDown';
        if (isExpanded !== shouldBeExpanded) {
          doToggle(navigation, toggle);
          return true;
        }
      }
    }
  }
  return false;
}
function rowKeyboardNavigation(e, navigation) {
  const key = normalizeKey(e);
  const keysOfInterest = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'];
  if (!keysOfInterest.includes(key)) return; // don't want to query dom unless needed
  const target = e.target;
  const topNavItems = navigation.getTopNavItems();
  const currentTopNavItem = topNavItems.find(item => item.contains(target));
  const currentNavItem = getClosestNavItem(target);
  if (currentTopNavItem && currentNavItem) {
    if (key === 'ArrowRight' || key === 'ArrowLeft') {
      e.preventDefault();
      const forward = key === 'ArrowRight';
      const currentNavList = getNavListContainer(currentTopNavItem);
      if (navigation.isMegaMenuElement(currentNavItem)) {
        // if in a mega menu, try moving to next/previous column
        if (!moveToNextColumn(getOpenNavItems(currentNavList), forward, currentNavItem)) {
          // if there is no column to move to, return focus to top nav item
          focusOnNavItem(currentTopNavItem);
        }
        return;
      }
      const nextTopNavItem = nextInList(topNavItems, forward, currentTopNavItem, true);
      if (nextTopNavItem) {
        const nextNavList = getNavListContainer(nextTopNavItem);
        // if the nav list is shown for the current top nav item, and traversing to
        // a top nav item with a nav list, show the next nav list
        // NOTE: onFocusOut will close the current nav list
        if (currentNavList && nextNavList && isVisible$1(currentNavList) && !isVisible$1(nextNavList)) {
          const toggleOpen = navigation.getChildToggleElement(nextTopNavItem);
          toggleNavList(nextNavList, navigation, toggleOpen);
        }
      }
    } else if (key === 'ArrowDown' && currentTopNavItem === currentNavItem) {
      // open the top navigation
      openTopNav(currentTopNavItem, navigation);
      e.preventDefault();
    } else if (currentTopNavItem !== currentNavItem) {
      // navigate up/down within the current list
      navigateNavList(e, getNavList(currentTopNavItem));
    }
  }
}
function navigateNavList(e, navList) {
  if (navList && isVisible$1(navList)) {
    const key = normalizeKey(e);
    const target = e.target;
    const navItem = getClosestNavItem(target);
    switch (key) {
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Home':
      case 'End':
        const forward = key === 'ArrowDown' || key === 'Home';
        const startingFrom = key === 'ArrowDown' || key === 'ArrowUp' ? navItem : undefined;
        nextInList(getOpenNavItems(navList), forward, startingFrom);
        e.preventDefault();
        break;
    }
  }
}
function openTopNav(topNavItem, navigation) {
  const navList = getNavListContainer(topNavItem);
  if (navList) {
    if (isVisible$1(navList)) {
      nextInList(getOpenNavItems(navList), true);
    } else {
      const toggle = navigation.getChildToggleElement(topNavItem);
      toggleNavList(navList, navigation, toggle);
      setTimeout(() => {
        nextInList(getOpenNavItems(navList), true);
      }, 200);
    }
  }
}
function nextInList(navItems, forward, currentNavItem, rowLateralMove) {
  const length = navItems.length;
  const index = currentNavItem ? navItems.indexOf(currentNavItem) : forward ? -1 : length;
  const incr = forward ? 1 : -1;
  // Using the modulus formula will cause the index to flip to 0 or the last index
  // this allows the arrow key to flip to the start or end of the list
  // same logic is applied to the for-loop index increment
  const start = (index + incr + length) % length;
  let firstPass = true;
  for (let i = start; firstPass || i !== start; i = (i + incr + length) % length) {
    const item = navItems[i];
    if (isVisible$1(item)) {
      if (rowLateralMove && !forward) {
        const miniToggle = item.querySelector('a + [aria-expanded]');
        if (miniToggle && miniToggle.parentElement === item && !miniToggle.disabled && isVisible$1(miniToggle)) {
          miniToggle.focus();
          return item;
        }
      }
      if (focusOnNavItem(item)) {
        return item;
      }
    }
    firstPass = false;
  }
}
function moveToNextColumn(navItems, forward, currentNavItem) {
  const currNavItemRect = currentNavItem.getBoundingClientRect();
  const currentNavElement = getNavItemFocusElement(currentNavItem);
  const navFocusElements = navItems.map(getNavItemFocusElement).filter(Boolean);
  const length = navFocusElements.length;
  const index = navFocusElements.indexOf(currentNavElement);
  const incr = forward ? 1 : -1;
  const start = forward ? index + 1 : index - 1;
  let navElement;
  let elementRect;
  for (let i = start; i >= 0 && i < length; i += incr) {
    const focusable = navFocusElements[i];
    elementRect = focusable.getBoundingClientRect();
    // NOTE: this logic assumes a gutter between columns
    if (elementRect.left > currNavItemRect.right || elementRect.right < currNavItemRect.left) {
      navElement = focusable;
      break;
    }
  }
  if (navElement && !forward) {
    // find the top element in the previous column
    const start2 = navFocusElements.indexOf(navElement) - 1;
    for (let i = start2; i >= 0; i--) {
      const focusable = navFocusElements[i];
      const itemRect = focusable.getBoundingClientRect();
      if (elementRect.left - itemRect.right > -12) {
        // fudge factor for negative margins, retina displays
        break;
      }
      navElement = focusable;
      elementRect = itemRect;
    }
  }
  if (navElement) {
    navElement.focus();
  }
  return !!navElement;
}
function focusOnNavItem(navItem) {
  const focusable = getNavItemFocusElement(navItem);
  focusable && focusable.focus();
  return !!focusable;
}
function getNavItemFocusElement(navItem) {
  const tags = ['a', 'button', 'tds-nav-toggle[role="button"]'];
  for (let i = 0; i < tags.length; i++) {
    const element = navItem.querySelector(tags[i]);
    if (element && element.closest('tds-nav-item, .tds-nav__item') === navItem && isVisible$1(element) && !element.disabled) {
      return element;
    }
  }
  return undefined;
}
function getToggleDuration(navList, navigation) {
  if (navigation.isRowOrientation() && navigation.isMegaMenuElement(navList)) {
    return 300;
  }
  const items = getOpenNavItems(navList);
  const ITEM_RATE = 88;
  const duration = items.reduce((acc, _, index) => {
    // reduce rate by 10% for each item, Will never get higher than 880
    return acc + ITEM_RATE * 0.9 ** index;
  }, 0);
  return Math.max(Math.round(duration), 300);
}
function getOpenNavItems(navList) {
  const navListSelector = navList.tagName === 'TDS-NAV-LIST' ? 'tds-nav-list' : '.tds-nav__list';
  const navItemSelector = navList.tagName === 'TDS-NAV-LIST' ? 'tds-nav-item' : '.tds-nav__item';
  return Array.from(navList.querySelectorAll(navItemSelector)).filter(item => {
    const parentNavList = item.closest(navListSelector);
    return !!parentNavList && (parentNavList === navList || isVisible$1(parentNavList));
  });
}
function isVisible$1(el) {
  return !!el.clientWidth && !!el.clientHeight;
}
function closeTopToggle(navigation) {
  const topToggle = navigation.topToggle;
  const expanded = topToggle && navigation.isToggleExpanded(topToggle);
  if (expanded && isVisible$1(topToggle)) {
    doToggle(navigation, topToggle);
  }
}
function closeTopLevelToggles(navigation) {
  let immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  navigation.getTopNavItems(true).forEach(item => {
    const toggle = navigation.getChildToggleElement(item);
    if (toggle && navigation.isToggleExpanded(toggle)) {
      doToggle(navigation, toggle, immediate);
    }
  });
}
function getClosestNavItem(el) {
  return el.closest('tds-nav-item, .tds-nav__item');
}
function getNavList(el) {
  return el.querySelector('.tds-nav__list, tds-nav-list');
}
function getNavListContainer(el) {
  let navListContainer = getNavList(el);
  if (navListContainer) {
    // navListContainer is now the tds nav list. Return the ancestor containing the nav list 
    // that is not one of the tds nav elements.  (e.g. mega menu container)
    const navSelectors = 'tds-nav, .tds-nav, tds-nav-list, .tds-nav__list, tds-nav-item, .tds-nav__item';
    while (navListContainer.parentElement && !navListContainer.parentElement.matches(navSelectors)) {
      navListContainer = navListContainer.parentElement;
    }
  }
  return navListContainer;
}

const ENHANCED_FLAG$4 = 'enhancedNavigation';
const INSTANCE_KEY$6 = 'TdsNavigation';
const NAVIGATION_SELECTOR = `.${navBaseClassName}`;
let nextId$4 = 0;
class _NavigationInstance {
  constructor(navigation) {
    this.onDestroy = [];
    this.root = this.host = navigation;
    navigation.dataset[ENHANCED_FLAG$4] = "true";
    this.setVariants();
    enhance(navigation);
    const [unbind, setupVariantListener] = bindNavigation(this);
    this.onDestroy = [unbind, watchDataAttributeChange(navigation, data => {
      if (data.hasOwnProperty('variantAt') || data.hasOwnProperty('variant')) {
        this.setVariants();
        setupVariantListener();
      }
    })];
    instances$1.set(navigation, INSTANCE_KEY$6, this);
  }
  setVariants() {
    const host = this.host;
    let {
      variantAt,
      variant
    } = configFromDataAttributes(host);
    if (!variantAt && !variant) {
      ({
        variantAt,
        variant
      } = this.deriveVariantsFromLegacyClass());
    }
    if (variantAt) {
      if (!variant) {
        devConsole.warn(`data-variant-at is set (${variantAt}) without data-variant.`, host.id);
      }
    }
    this.config = {
      variant,
      variantAt
    };
  }
  deriveVariantsFromLegacyClass() {
    const host = this.host;
    let variantAt = '';
    let variant = '';
    ['sm', 'md', 'lg', 'xl', ''].forEach(bp => {
      ['left', 'row'].forEach(v => {
        const cls = `tds-nav--${v}${bp ? `-${bp}` : ''}`;
        if (host.classList.contains(cls)) {
          variantAt = bp;
          variant = v;
          // ? should it remove the class?
        }
      });
    });

    return {
      variantAt,
      variant
    };
  }
  applyVariant(apply) {
    const {
      variant
    } = this.config;
    const variantNow = apply && variant || 'vertical';
    this.handleViewportChanges(variantNow);
  }
  get topToggle() {
    return Array.from(this.root.childNodes).find(node => node.nodeType === Node.ELEMENT_NODE && node.matches('button[aria-expanded]'));
  }
  getToggleElement(event) {
    return event.target.closest('button[aria-expanded]');
  }
  getChildToggleElement(navItem) {
    let toggle = navItem.querySelector('button[aria-expanded]');
    return toggle && toggle.closest(`.${NAV_CLASSES.navItem}`) === navItem ? toggle : null;
  }
  isToggleExpanded(toggle) {
    return toggle.getAttribute('aria-expanded') === 'true';
  }
  setToggleExpanded(toggle, expanded) {
    toggle.setAttribute('aria-expanded', `${expanded}`);
  }
  getToggledElement(toggle) {
    const navGroupId = toggle.getAttribute('aria-controls');
    return navGroupId && document.getElementById(navGroupId);
  }
  handleViewportChanges(variant) {
    const {
      host,
      topToggle
    } = this;
    const classes = {
      'tds-nav--left': variant === 'left',
      'tds-nav--vertical': variant === 'vertical',
      'tds-nav--row': variant === 'row'
    };
    applyClasses(host, classes);
    if (topToggle) {
      this.setToggleExpanded(topToggle, false);
      const toggled = this.getToggledElement(topToggle);
      if (toggled) {
        toggled.hidden = variant === 'vertical';
      }
    }
    // Mega-menu: show/restore nav lists for toggles that are/were hidden
    // This is specific to toggles are that are replaced with a header when 
    // shown in mega menu
    if (typeof window !== 'undefined') {
      const toggles = host.querySelectorAll(`.${NAV_CLASSES.navMegaMenu} .${NAV_CLASSES.navToggle}`);
      toggles.forEach(toggle => {
        const toggledList = this.getToggledElement(toggle);
        if (toggledList) {
          const toggleDisplay = window.getComputedStyle(toggle).display;
          const showToggled = toggleDisplay === 'none' || this.isToggleExpanded(toggle);
          toggledList.hidden = !showToggled;
        }
      });
    }
  }
  getTopNavItems(withNavList) {
    const navListSelector = `.${NAV_CLASSES.navList}`;
    const navItemSelector = `.${NAV_CLASSES.navItem}`;
    const topNavList = this.host.querySelector(navListSelector);
    return !topNavList ? [] : Array.from(topNavList.querySelectorAll(navItemSelector)).filter(item => item.closest(navListSelector) === topNavList).filter(item => !withNavList || !!item.querySelector(`.${NAV_CLASSES.navList}`));
  }
  isRowOrientation() {
    var _this$host;
    return (_this$host = this.host) === null || _this$host === void 0 ? void 0 : _this$host.classList.contains('tds-nav--row');
  }
  isMegaMenuElement(element) {
    return !!(element && element.closest(`.${NAV_CLASSES.navMegaMenu}`));
  }
  destroy() {
    if (this.root) {
      while (this.onDestroy && this.onDestroy.length) {
        const fn = this.onDestroy.pop();
        fn();
      }
      delete this.root.dataset[ENHANCED_FLAG$4];
      instances$1.remove(this.host, INSTANCE_KEY$6);
      this.root = this.host = null;
    }
  }
}
function enhance(element) {
  // TODO: move checkbox support to legacynavigationsupport.ts
  // const buttonToggleSelector = `button.${NAV_CLASSES.navToggle}, button.${MENU_TOGGLE_CLASSES.menuToggle}`;
  const toggledNavGroups = Array.from(element.querySelectorAll(`.${NAV_CLASSES.navList}`)).map(el => {
    // in the event navList is contained in an intermediate element
    while (el.parentElement && !el.parentElement.matches(`.${NAV_CLASSES.navItem}, .${NAV_CLASSES.navList}, .${NAV_CLASSES.nav}`)) {
      el = el.parentElement;
    }
    return el;
  });
  toggledNavGroups.forEach(navGroup => {
    let checkbox, label, button, dropdown;
    const navGroupParent = navGroup.parentNode;
    const siblings = Array.from(navGroupParent.children);
    for (const node of siblings) {
      if (node.matches('button')) {
        button = node;
      } else if (node.matches('[type="checkbox"]')) {
        checkbox = node;
      } else if (node.matches(`label.${NAV_CLASSES.navToggle}`)) {
        label = node;
      } else if (node.matches(`.${NAV_CLASSES.navDropdown}`)) {
        dropdown = node;
      } else if (node === navGroup) {
        break;
      }
    }
    if (checkbox) {
      navGroupParent.removeChild(checkbox);
    }
    if (label) {
      navGroupParent.removeChild(label);
    }
    if (!button && checkbox) {
      button = createToggleButton(label);
      navGroupParent.insertBefore(button, navGroup);
    }
    if (dropdown) {
      devConsole.warn(`"div.${NAV_CLASSES.navDropdown}" is no longer used to implement a nav dropdown. Removing it from the DOM. Please see v8 migration notes to update your code.`);
      const children = Array.from(dropdown.childNodes);
      for (const child of children) {
        dropdown.parentElement.insertBefore(child, dropdown);
        if (child.nodeType === Node.ELEMENT_NODE && child.matches('.tds-nav__list') && !element.closest('.tds-global-header')) {
          child.classList.add('tds-nav__list--dropdown');
          navGroup = child;
        }
      }
      dropdown.remove();
    }
    if (button) {
      button.hidden = false;
      if (!button.getAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', `${!!checkbox && checkbox.checked}`);
      }
      let navGroupEl = navGroup;
      navGroupEl.hidden = button.getAttribute('aria-expanded') !== 'true';
      if (!button.getAttribute('aria-controls')) {
        if (!navGroup.id) {
          navGroup.id = `${NAV_CLASSES.nav}-group_${++nextId$4}`;
        }
        button.setAttribute('aria-controls', navGroup.id);
      }
      if (button.closest(`.${NAV_CLASSES.navMegaMenu}`) && !button.previousElementSibling) {
        // if this is a toggle without a link in a mega menu, add a header
        // toggles are hidden when shown in a mega menu. Toggles without a link 
        // are replaced with a header
        const navHeader = document.createElement('span');
        navHeader.className = `${NAV_CLASSES.navHeading}`;
        navHeader.innerHTML = button.innerHTML;
        navHeader.querySelectorAll(`.${NAV_CLASSES.navToggleIcon}`).forEach(node => node.remove());
        button.parentElement.insertBefore(navHeader, button);
      }
    }
  });
  adjustMenuToggle(element);
}
function createToggleButton(label) {
  const button = document.createElement('button');
  button.type = 'button';
  button.innerHTML = label.innerHTML;
  const nodes = Array.from(button.querySelectorAll(`.${NAV_CLASSES.navToggleExpandedText}, .${NAV_CLASSES.navToggleCollapsedText}`));
  nodes.forEach(node => node.parentNode.removeChild(node));
  button.className = label.className;
  if (label.getAttribute('aria-label')) {
    button.setAttribute('aria-label', label.getAttribute('aria-label'));
  }
  return button;
}
function adjustMenuToggle(nav) {
  const menuToggle = nav.querySelector(`.${NAV_CLASSES.navMenuToggle}`);
  if (menuToggle && menuToggle.parentElement === nav) {
    const menuText = menuToggle.querySelector(`.${NAV_CLASSES.navMenuToggleText}`);
    const menuIcon = menuToggle.querySelector(`.${NAV_CLASSES.navMenuToggleIcon}`);
    if (menuText && menuIcon) {
      const globalHeader = nav.closest('.tds-global-header');
      if (globalHeader) {
        // if this is part of the global header, just remove toggle. GH will add menu toggle
        const navList = menuToggle.nextElementSibling;
        if (navList) {
          navList.hidden = false;
        }
        menuToggle.remove();
        return;
      }
      devConsole.warn(`${NAV_CLASSES.navMenuToggle} adjusted to align with v8 structure. Please see v8 migration notes to update your code.`);
      menuIcon.parentElement.insertBefore(menuText, menuIcon);
      if (menuText.textContent.toLowerCase() === 'menu') {
        menuText.innerHTML = '<span class="tds-sr-only">Show</span><span>Menu</span>';
      }
      menuText.insertAdjacentHTML('afterend', `<span class="${MENU_TOGGLE_CLASSES.menuToggleTextExpanded}"><span>Close</span><span class="tds-sr-only">menu</span></span>`);
      menuToggle.classList.remove(NAV_CLASSES.navMenuToggle);
      menuToggle.classList.add(MENU_TOGGLE_CLASSES.menuToggle);
      menuText.classList.remove(NAV_CLASSES.navMenuToggleText);
      menuText.classList.add(MENU_TOGGLE_CLASSES.menuToggleText);
      menuIcon.classList.remove(NAV_CLASSES.navMenuToggleIcon);
      menuIcon.classList.add(MENU_TOGGLE_CLASSES.menuToggleIcon);
    }
  }
}
class Navigation {
  constructor(element) {
    this._instance = instances$1.get(element, INSTANCE_KEY$6) || new _NavigationInstance(element);
  }
  destroy() {
    return this._instance.destroy();
  }
}
onDomChanges(`${NAVIGATION_SELECTOR}`, function onNavigationAdded(navigation) {
  if (!navigation.dataset[ENHANCED_FLAG$4]) {
    new Navigation(navigation);
  }
}, function onNavigationRemoved(navigation) {
  if (navigation.dataset[ENHANCED_FLAG$4] === "true") {
    new Navigation(navigation).destroy();
  }
});
ToggleIcon.autoEnhance(`.${NAV_CLASSES.navToggleIcon}`);

const ENHANCED_FLAG$3 = 'enhancedSwitch';
const INSTANCE_KEY$5 = `${NAMESPACE}Switch`;
const PATTERN_SELECTOR$4 = `.${CSS_NS}switch`;
class _SwitchInstance {
  constructor(element) {
    this.onDestroy = [];
    this.root = element;
    element.dataset[ENHANCED_FLAG$3] = "true";
    const eventListeners = new EventListeners();
    eventListeners.addListener(this.root, 'click', clickHandler$1(this.root));
    const unbind = () => {
      eventListeners.removeListeners();
    };
    this.onDestroy = [unbind];
    instances$1.set(element, INSTANCE_KEY$5, this);
  }
  destroy() {
    if (this.root) {
      while (this.onDestroy && this.onDestroy.length) {
        const fn = this.onDestroy.pop();
        fn();
      }
      delete this.root.dataset[ENHANCED_FLAG$3];
      instances$1.remove(this.root, INSTANCE_KEY$5);
      this.root = null;
    }
  }
}
class Switch {
  constructor(element) {
    this._instance = instances$1.get(element, INSTANCE_KEY$5) || new _SwitchInstance(element);
  }
  /**
   * Detaches from the element, removes event listeners, and frees resources.
   */
  destroy() {
    return this._instance.destroy();
  }
}
function clickHandler$1(element) {
  return e => {
    const swtchButton = element.querySelector('button');
    const swtchCheck = element.querySelector('input[type="checkbox"]');
    const target = e.target;
    const offOrOn = target.closest(`.${CSS_NS}switch__label`);
    if (offOrOn) {
      e.preventDefault();
      const pressed = offOrOn.matches(`.${CSS_NS}switch__switch ~ .${CSS_NS}switch__label`);
      if (swtchButton) {
        toggleTheSwitch(swtchButton, pressed);
      } else if (swtchCheck) {
        swtchCheck.checked = pressed;
      }
    } else if (swtchButton && swtchButton.contains(target)) {
      toggleTheSwitch(swtchButton);
    }
  };
}
function toggleTheSwitch(swtch) {
  let pressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : swtch.getAttribute("aria-pressed") !== "true";
  swtch.setAttribute("aria-pressed", `${pressed}`);
}
onDomChanges(`${PATTERN_SELECTOR$4}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$3]) {
    new Switch(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$3] === "true") {
    new Switch(element).destroy();
  }
});

function createStore$2() {
  return store({
    options: []
  });
}

function getRoot(host, el) {
  const selectElement = host.querySelector('select') || el;
  return el === selectElement ? el.parentNode : el;
}
function bindMultiSelect(multiselect) {
  const {
    host,
    el
  } = multiselect;
  const rootElm = hasShadowDom(host) ? host.shadowRoot : getRoot(host, el);
  const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
  const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
  // Add Event Listeners
  const eventListeners = new EventListeners();
  // listeners for managing closing of popup, only in effect when popup is opened
  const closePopupListeners = new EventListeners();
  // control behavior
  eventListeners.addListener(controlElm, 'mousedown', ifEnabled(multiselect, controlClickHandler(rootElm, closePopupListeners)));
  eventListeners.addListener(controlElm, 'keydown', ifEnabled(multiselect, keyDownHandler$1(rootElm, closePopupListeners)));
  // popup behavior
  eventListeners.addListener(popupElm, 'keydown', ifEnabled(multiselect, popupKeyDownHandler(rootElm, closePopupListeners)));
  // checkbox behavior
  eventListeners.addListener(popupElm, 'change', ifEnabled(multiselect, onCheckBoxChange(multiselect)));
  const unbind = () => {
    eventListeners.removeListeners();
    closePopupListeners.removeListeners();
  };
  return unbind;
}
function ifEnabled(multiselect, handler) {
  return event => {
    if (!multiselect.disabled) {
      handler(event);
    }
  };
}
// Dropdown click handler
function controlClickHandler(rootElm, closePopupListeners) {
  return () => {
    if (isMultiselectOpen(rootElm)) hideMultiselect(rootElm, closePopupListeners);else showMultiselect(rootElm, closePopupListeners);
  };
}
// Checkbox change handler
function onCheckBoxChange(multiselect) {
  return event => {
    const checkbox = event.target.closest('input[type="checkbox"]');
    if (checkbox) {
      if (!checkbox.dataset.index) {
        performSelectAll(multiselect, checkbox);
      } else {
        performSelectItem(multiselect, checkbox);
      }
      var options = buildOptionObject(multiselect);
      // setState
      setOptions(options, multiselect.store);
      setIndeterminateState(multiselect);
      updateText(multiselect);
      multiselect.sendEvent('change', {
        detail: {
          multiselect
        }
      });
    }
  };
}
// perform checkbox select item
function performSelectItem(multiselect, checkbox) {
  const {
    el,
    host
  } = multiselect;
  const selectElement = host.querySelector('select') || el;
  const index = parseInt(checkbox.dataset.index);
  const selectedItem = selectElement.options[index]; // selected option
  const selectedRow = checkbox.closest("[role=row]"); // row of checkbox checked
  const checked = checkbox.checked; // sets checkbox true or false,
  // if checkbox checked, increase the count else decrease the count
  selectedItem.selected = checked;
  checked ? selectedRow.classList.add(MULTISELECT_CLASSES.SELECTED) : selectedRow.classList.remove(MULTISELECT_CLASSES.SELECTED);
}
// updates select all checkbox inderminate state
function setIndeterminateState(multiselect) {
  const {
    el,
    host
  } = multiselect;
  const rootElm = hasShadowDom(host) ? host.shadowRoot : getRoot(host, el);
  const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
  var allChkBox = popupElm.querySelector('input[type="checkbox"]:not([data-index])');
  if (allChkBox) {
    const options = getOptions(multiselect);
    const optionsLength = options.length;
    var count = options.filter(option => option.selected).length;
    if (count !== 0 && count !== optionsLength) {
      allChkBox.indeterminate = true;
    }
    if (count === optionsLength) {
      allChkBox.indeterminate = false;
      allChkBox.checked = true;
    } else if (count === 0) {
      allChkBox.indeterminate = false;
      allChkBox.checked = false;
    }
  }
}
// performs Select All click event
function performSelectAll(multiselect, checkbox) {
  const {
    el,
    host
  } = multiselect;
  const rootElm = hasShadowDom(host) ? host.shadowRoot : getRoot(host, el);
  const checked = checkbox.checked;
  const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
  const allChkBox = popupElm.querySelector('input[type="checkbox"]:not([data-index])');
  // select all checkbox state
  allChkBox.indeterminate = false;
  const options = getOptions(multiselect);
  Array.from(options).forEach(option => updateOptions(multiselect, option, checked));
}
// update Items check and selected state
function updateOptions(multiselect, option, checked) {
  const {
    el,
    host
  } = multiselect;
  const rootElm = hasShadowDom(host) ? host.shadowRoot : getRoot(host, el);
  // Updating select option
  var selectElement = host.querySelector('select') || el;
  const selectedItem = selectElement.querySelectorAll('option')[option.index];
  selectedItem.selected = checked;
  // updating multiselect checkboxes
  const checkbox = rootElm.querySelector(`input[type="checkbox"][data-index="${option.index}"]`);
  if (checkbox) {
    checkbox.checked = checked;
    // updating multiselect row
    const selectedRow = checkbox.closest("[role=row]");
    selectedItem.selected = checked;
    checked ? selectedRow.classList.add(MULTISELECT_CLASSES.SELECTED) : selectedRow.classList.remove(MULTISELECT_CLASSES.SELECTED);
  }
}
// once options selected/unselected update text on control div
function updateText(multiselect) {
  const {
    config,
    host,
    el
  } = multiselect;
  const rootElm = hasShadowDom(host) ? host.shadowRoot : getRoot(host, el);
  const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
  const popupElm = rootElm.querySelector('.' + MULTISELECT_CLASSES.POPUP);
  const optionItems = rootElm.querySelectorAll('input[type="checkbox"][data-index]');
  const multiselectRows = popupElm.querySelectorAll('[role=row]');
  const rows = Array.from(multiselectRows); // converting to array
  const activeItems = rows.filter(row => row.classList.contains('selected'));
  const translation = translations(getLang(el)).t;
  let selectedText = '';
  if (activeItems && activeItems.length) {
    const totalItems = optionItems.length; // removing selectAll checkbox
    const configGroupLimit = config.groupLimit; // limit set to group the selected checkboxes
    const selectedOptionCount = activeItems.length;
    if (selectedOptionCount <= configGroupLimit) {
      // adding options as comma delimited text
      selectedText = activeItems.map(item => item.textContent.trim()).join(', ');
    } else if (selectedOptionCount < totalItems) {
      // Hide/Show Badge depending on config
      selectedText = translation("optionsSelected", selectedOptionCount.toString());
    } else {
      // when all items selected   
      selectedText = translation("allOptionsSelected", selectedOptionCount.toString());
    }
  }
  // setting active options text and values
  controlElm.textContent = selectedText;
}
// check if the list is already open
function isMultiselectOpen(rootElm) {
  const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
  return controlElm.getAttribute('aria-expanded') === 'true' ? true : false;
}
// Show Items
function showMultiselect(rootElm, closePopupListeners) {
  const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
  const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
  popupElm.classList.add("expanded");
  controlElm.setAttribute("aria-expanded", "true");
  // add listeners to manage closing of popup
  closePopupListeners.removeListeners();
  const checkClosePopupHandler = checkClosePopup(rootElm.host || rootElm, rootElm, closePopupListeners);
  closePopupListeners.addListener(document, 'mousedown', checkClosePopupHandler);
  closePopupListeners.addListener(document, 'touchstart', checkClosePopupHandler);
  closePopupListeners.addListener(document, 'focusin', checkClosePopupHandler);
  // this one is needed for web component quirks 
  closePopupListeners.addListener(rootElm, 'keydown', onTabAway(rootElm, closePopupListeners));
}
function checkClosePopup(host, rootElm, closePopupListeners) {
  return _ref => {
    let {
      target,
      type
    } = _ref;
    const targetEl = target;
    if (type === 'focusin' && targetEl.hasAttribute('tabindex') && targetEl.contains(host)) {
      // when container has tabindex, it receives focusin event on click. 
      // Ignore, other events should come along to close this.
      return;
    }
    if (!host.contains(targetEl)) {
      hideMultiselect(rootElm, closePopupListeners);
    }
  };
}
function onTabAway(rootElm, closePopupListeners) {
  return e => {
    const key = normalizeKey(e);
    if (key === 'Tab') {
      hideMultiselect(rootElm, closePopupListeners);
    }
  };
}
// Hide Items
function hideMultiselect(rootElm, closePopupListeners) {
  const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
  const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
  popupElm.classList.remove("expanded");
  controlElm.setAttribute("aria-expanded", "false");
  closePopupListeners.removeListeners();
}
function buildOptionObject(multiselect) {
  const {
    host,
    el
  } = multiselect;
  var options = [];
  var selectElement = host.querySelector('select') || el;
  var selectOptions = selectElement ? selectElement.querySelectorAll('option') : null;
  // create option object, which includes both selectElement and 
  // multiselectElement index, value and selected
  if (selectOptions && selectOptions.length) {
    for (let i = 0; i < selectOptions.length; i++) {
      var option = {
        id: selectOptions[i].value || selectOptions[i].getAttribute('value'),
        index: i,
        text: selectOptions[i].textContent,
        selected: !!selectOptions[i].selected,
        value: selectOptions[i].value
      };
      options.push(option);
    }
  }
  return multiselect.options = options;
}
// return all options list
// export function getOptions(multiselect: MultiSelectComponent) {
//   return buildOptionObject(multiselect);
// }
// STORE actions - getters and setters
function getOptions(multiselect) {
  const {
    state,
    store
  } = multiselect;
  if (state === undefined || state.options === undefined || state.options.length === 0) {
    var options = buildOptionObject(multiselect);
    // setState
    setOptions(options, store);
    return options;
  }
  return state.options;
}
function setOptions(options, store) {
  store.update(v => {
    return {
      ...v,
      options
    };
  });
}
// returns only selected options list
function getSelectedOptions(multiselect) {
  var options = buildOptionObject(multiselect);
  return options.filter(option => option.selected);
}
// preselected Items
function initWithConfig(multiselect) {
  // get pre-selected options from client configuration
  const selectedOptions = multiselect.config.selectedOptions || getOptions(multiselect).filter(option => option.selected).map(option => option.id);
  setSelectedOptions(selectedOptions, multiselect);
}
function setSelectedOptions(selectedOptionValues, multiselect) {
  selectedOptionValues = selectedOptionValues ? Array.isArray(selectedOptionValues) ? selectedOptionValues : selectedOptionValues.trim().split(",").map(v => v.trim()).filter(v => !!v) : [];
  const options = [...getOptions(multiselect)];
  options.forEach(option => {
    const selected = selectedOptionValues.includes(option.id);
    option.selected = selected;
    updateOptions(multiselect, option, selected);
  });
  setOptions(options, multiselect.store);
  setIndeterminateState(multiselect);
  updateText(multiselect);
}
// Keyboard Events
// Keydown on input
function keyDownHandler$1(rootElm, closePopupListeners) {
  return event => {
    const key = normalizeKey(event);
    const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
    const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
    switch (key) {
      case "Escape":
        if (isMultiselectOpen(rootElm)) {
          hideMultiselect(rootElm, closePopupListeners);
          controlElm.focus();
          event.preventDefault();
        }
        break;
      case 'Enter':
        if (isMultiselectOpen(rootElm)) {
          hideMultiselect(rootElm, closePopupListeners);
          setActiveRow(getDefaultOption(popupElm));
        } else showMultiselect(rootElm, closePopupListeners);
        event.preventDefault();
        break;
      case 'ArrowDown':
        if (!isMultiselectOpen(rootElm)) {
          showMultiselect(rootElm, closePopupListeners);
        }
        setActiveRow(getDefaultOption(popupElm));
        event.preventDefault();
        break;
    }
  };
}
function popupKeyDownHandler(rootElm, closePopupListeners) {
  return event => {
    const key = normalizeKey(event);
    const controlElm = rootElm.querySelector("." + MULTISELECT_CLASSES.CONTROL);
    const popupElm = rootElm.querySelector("." + MULTISELECT_CLASSES.POPUP);
    switch (key) {
      case "Escape":
      case 'Enter':
        if (isMultiselectOpen(rootElm)) {
          hideMultiselect(rootElm, closePopupListeners);
          controlElm.focus();
          event.preventDefault();
        }
        break;
      case " ":
        const option = getActiveRow(popupElm);
        if (option) option.querySelector('input').click();
        event.preventDefault();
        break;
      case "ArrowUp":
        setActiveRow(getPreviousOption(popupElm));
        event.preventDefault();
        break;
      case "ArrowDown":
        setActiveRow(getNextOption(popupElm));
        event.preventDefault();
        break;
    }
  };
}
// set Active Row
function setActiveRow(option) {
  if (option) {
    option.querySelector('input').focus();
  }
}
// get Active Row
function getActiveRow(popupElm) {
  const focused = popupElm.querySelector('input[type="checkbox"]:focus');
  return focused && focused.closest('[role="row"]');
}
// get default option
function getDefaultOption(popupElm) {
  const selectedOptions = popupElm.querySelectorAll('input[type="checkbox"]:checked');
  if (selectedOptions.length > 0) return selectedOptions[0].closest('[role=row]');
  return popupElm.children[0];
}
// returns the index of active row -- alternative for findIndex
function findRowIndex(row, activeRow) {
  return Array.from(row).map(element => element.id).indexOf(activeRow.id);
}
// get next active row option
function getNextOption(popupElm) {
  const activeRow = getActiveRow(popupElm);
  if (!activeRow) return getDefaultOption(popupElm);
  const row = popupElm.querySelectorAll("[role=row]");
  const row_index = findRowIndex(row, activeRow);
  if (row_index + 1 === row.length) {
    // don't rotate
    return popupElm.children[row.length - 1];
    // this is for rotating selection on key down
    // goes back to select all
    // return listElm.children[0];
  }

  return row[row_index + 1];
}
// get previous Active row option
function getPreviousOption(popupElm) {
  const activeRow = getActiveRow(popupElm);
  if (!activeRow) return getDefaultOption(popupElm);
  const row = popupElm.querySelectorAll("[role=row]");
  const row_index = findRowIndex(row, activeRow);
  if (row_index === 0) {
    // don't rotate
    return popupElm.children[0];
    // this is for rotating selection on key up
    // goes back to last child
    // return listElm.children[row.length - 1];
  }

  return row[row_index - 1];
}

// Default configuration for multiselect
const defaultConfig$2 = {
  groupLimit: 99999999
};
const ENHANCED_FLAG$2 = 'enhancedMultiSelect';
const INSTANCE_KEY$4 = `${NAMESPACE}MultiSelect`;
const PATTERN_SELECTOR$3 = `${CSS_NS}multiselect`;
let nextId$3 = 1;
class _MultiSelectInstance {
  constructor(element, clientConfig) {
    this.config = defaultConfig$2;
    this.onDestroy = [];
    this._disabled = false;
    this.el = this.host = element;
    // create store
    const store = this.store = createStore$2();
    element.dataset[ENHANCED_FLAG$2] = "true";
    // config
    const dataConfig = configFromDataAttributes(this.el);
    this.setConfig({
      ...defaultConfig$2,
      ...dataConfig,
      ...clientConfig
    });
    // create multiselect
    createMultiselect(this);
    const unbind = bindMultiSelect(this);
    const unsubscribe = store.subscribe(this.onStateUpdate.bind(this));
    // initialize multiselect with client configuration
    initWithConfig(this);
    this.watchAttributeChanges();
    this.onDestroy = [unbind, unsubscribe];
    instances$1.set(element, INSTANCE_KEY$4, this);
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const newConfig = {
      ...this.config,
      ...config
    };
    if (newConfig.limitOptions) {
      newConfig.groupLimit = newConfig.limitOptions;
    }
    if (typeof newConfig.groupLimit === 'string') {
      newConfig.groupLimit = parseInt(newConfig.groupLimit);
    }
    this.config = newConfig;
  }
  get _options() {
    return getOptions(this);
  }
  get selectedOptions() {
    return getSelectedOptions(this).map(option => option.id);
  }
  set selectedOptions(options) {
    setSelectedOptions(options, this);
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(value) {
    if (this._disabled !== value) {
      this._disabled = value;
      const {
        host,
        el
      } = this;
      const selectElement = host.querySelector('select') || el;
      const root = el === selectElement ? el.parentNode : el;
      const control = root.querySelector(`.${MULTISELECT_CLASSES.CONTROL}`);
      if (control) {
        if (value) {
          control.setAttribute('aria-disabled', "true");
        } else {
          control.removeAttribute('aria-disabled');
        }
      }
    }
  }
  sendEvent(eventType, eventInit) {
    return this.host.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  watchAttributeChanges() {
    const {
      host,
      el
    } = this;
    const selectElement = host.querySelector('select') || el;
    const attributeFilter = ['disabled', 'aria-disabled'];
    const targets = [host];
    if (selectElement && selectElement !== host) {
      targets.push(selectElement);
    }
    this._unwatchForChanges = watchForChanges(targets, {
      attributes: true,
      attributeFilter
    }, this.syncDisabledProperty.bind(this));
    this.syncDisabledProperty();
  }
  onStateUpdate(state) {
    this.state = state;
  }
  syncDisabledProperty() {
    const {
      host,
      el
    } = this;
    const selectElement = host.querySelector('select') || el;
    const hostDisabled = host.getAttribute('aria-disabled') === 'true';
    const selectDisabled = !!selectElement && (selectElement.disabled || selectElement.getAttribute('aria-disabled') === 'true');
    this.disabled = hostDisabled || selectDisabled;
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this._unwatchForChanges) {
      this._unwatchForChanges();
    }
    if (this.el) {
      delete this.el.dataset[ENHANCED_FLAG$2];
    }
    instances$1.remove(this.host, INSTANCE_KEY$4);
    this.el = this.host = this._unwatchForChanges = null;
  }
}
class MultiSelect {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$4) || new _MultiSelectInstance(element, config);
  }
  getOptions() {
    return this._instance._options;
  }
  getSelectedOptions() {
    return getSelectedOptions(this._instance);
  }
  get selectedOptions() {
    return this._instance.selectedOptions;
  }
  set selectedOptions(options) {
    this._instance.selectedOptions = options;
  }
  get disabled() {
    return this._instance.disabled;
  }
  set disabled(value) {
    this._instance.disabled = value;
  }
  destroy() {
    const {
      _instance
    } = this;
    delete this._instance;
    return _instance.destroy();
  }
}
onDomChanges(`.${PATTERN_SELECTOR$3}-dropdown`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$2]) {
    new MultiSelect(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$2] === "true") {
    new MultiSelect(element).destroy();
  }
});
// Create Multiselect
function createMultiselect(multiselect) {
  const {
    host,
    el,
    config
  } = multiselect;
  const selectElement = host.querySelector('select') || el;
  const id = `${PATTERN_SELECTOR$3}-${nextId$3++}`;
  const label = ariaLabel(el === selectElement ? el.parentElement : el, selectElement.id ? selectElement.id : id);
  const CONTROL_CLASSNAME = MULTISELECT_CLASSES.INPUT + " " + MULTISELECT_CLASSES.CONTROL;
  // Hide <select> element
  selectElement.hidden = true;
  // control markup
  const ariaDisabled = multiselect.disabled ? 'aria-disabled="true"' : '';
  const controlHtml = `
    <div class="${CONTROL_CLASSNAME}" ${label}
      role="combobox" aria-controls="${id}" aria-haspopup="grid"
      aria-autocomplete="none" aria-expanded="false" tabindex="0"></div>
  `;
  // popup markup
  const options = getOptions(multiselect);
  const POPUP_CLASSNAME = MULTISELECT_CLASSES.POPUP;
  const selectAll = config.noSelectAll ? '' : ` <div role="row" id="${id + "_0"}"  class="${MULTISELECT_CLASSES.SELECT_ALL}">
  <div role="gridcell">
    <label class="${MULTISELECT_CLASSES.CHECK}">
      <input class="${MULTISELECT_CLASSES.CHECKBOX}" type="checkbox" value="Select All" tabindex="-1" />
      <span class="${MULTISELECT_CLASSES.CHECKLABEL}">Select All</span>
    </label>
  </div>
</div>`;
  const popupHtml = `
    <div id="${id}" role="grid" aria-multiselectable="true" class="${POPUP_CLASSNAME}" ${ariaDisabled}>
       ${selectAll}

        ${options.map((option, index) => {
    const value = htmlEncode(option.value);
    const text = htmlEncode(option.text);
    return `<div role="row" id="${id + "_" + (index + 1)}">
              <div role="gridcell">
                <label class="${MULTISELECT_CLASSES.CHECK}">
                  <input tabindex="-1" type="checkbox" data-index="${index}"
                  class="${MULTISELECT_CLASSES.CHECKBOX}" value="${value}" data-val="${value}" />
                  <span class="${MULTISELECT_CLASSES.CHECKLABEL}">${text}</span>
                </label>
              </div>
            </div>`;
  }).join("")}
    </div>
  `;
  var wrapper = document.createElement('div');
  wrapper.innerHTML = controlHtml + popupHtml;
  wrapper.className = 'tds-multiselect';
  // insert wrapper right after the <select> element
  if (el === selectElement) el.parentNode.insertBefore(wrapper, el.nextElementSibling);else el.insertBefore(wrapper, selectElement.nextElementSibling);
}
function ariaLabel(el, id) {
  const selectElement = el.querySelector('select');
  const arialabel = selectElement.getAttribute('aria-label');
  if (!arialabel) {
    const ariaLabelledby = selectElement.getAttribute('aria-labelledby');
    if (!ariaLabelledby) {
      const label = document.querySelector(`label[for="${selectElement.id || ''}"]`) || el.querySelector(`label`);
      if (!label) {
        console.error('Label element or [aria-label] or [aria-labelledby] attribute on select element must specified');
        return "";
      }
      const labelId = label.getAttribute('id');
      if (!labelId) {
        const labelFor = label.getAttribute('for');
        if (!labelFor || labelFor === id) {
          const newLabelId = `${id + "_label"}`;
          label.setAttribute('id', `${newLabelId}`);
          return `aria-labelledby="${newLabelId}"`;
        }
        if (selectElement.previousElementSibling.getAttribute('for') !== id) {
          console.error('Correct value in [for] attribute for label');
        }
        return "";
      }
      return `aria-labelledby="${labelId}"`;
    }
    return `aria-labelledby="${ariaLabelledby}"`;
  }
  return `aria-label="${arialabel}"`;
}

const CLICKABLE_IGNORE_SELECTOR = '[data-clickable-ignore]';
function bindClickable(container, clickableEl) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let start, finish;
  const cardFocus = 'tds-clickable-focus';
  const activeClass = config.clickableFocus || cardFocus;
  const onMousedown = () => {
    start = new Date().getTime();
  };
  const onMouseup = e => {
    const target = e.target;
    if (e.button === 0 && clickableEl && !clickableEl.contains(target) && !target.closest(CLICKABLE_IGNORE_SELECTOR)) {
      finish = new Date().getTime();
      if (finish - start < 200) {
        clickableEl.click();
      }
    }
  };
  const onFocusBlur = e => {
    const method = e.target.matches(':focus-visible') ? 'add' : 'remove';
    container.classList[method](activeClass);
  };
  container.addEventListener('mousedown', onMousedown);
  container.addEventListener('mouseup', onMouseup);
  clickableEl.addEventListener('focus', onFocusBlur);
  clickableEl.addEventListener('blur', onFocusBlur);
  return () => {
    container.removeEventListener('mousedown', onMousedown);
    container.removeEventListener('mouseup', onMouseup);
    clickableEl.removeEventListener('focus', onFocusBlur);
    clickableEl.removeEventListener('blur', onFocusBlur);
    container = undefined;
    clickableEl = undefined;
  };
}

const CLICKABLE_ENHANCED_FLAG = 'enhancedClickable';
const CLICKABLE_TARGET_ATTRIBUTE = 'data-clickable';
const CLICKABLE_SELECTOR = `[${CLICKABLE_TARGET_ATTRIBUTE}]`;
class Clickable {
  constructor(el, clickableEl) {
    this.container = el;
    el.dataset[CLICKABLE_ENHANCED_FLAG] = "true";
    if (!!clickableEl) {
      const isString = typeof clickableEl === 'string';
      this.clickElement = isString ? this.container.querySelector(clickableEl) : clickableEl;
    } else {
      this.clickElement = getTargetElement(this.container, CLICKABLE_TARGET_ATTRIBUTE);
    }
    this.config = configFromDataAttributes(el);
    this.unbind = bindClickable(this.container, this.clickElement, this.config);
  }
  destroy() {
    if (this.unbind) {
      this.unbind();
      delete this.container.dataset[CLICKABLE_ENHANCED_FLAG];
      this.container = this.clickElement = this.unbind = undefined;
    }
  }
}
onDomChanges(CLICKABLE_SELECTOR, function onClickableAdded(el) {
  if (el.dataset[CLICKABLE_ENHANCED_FLAG] !== 'true') {
    const clickable = new Clickable(el);
    el.destroyClickable = clickable.destroy.bind(clickable);
  }
}, function onClickableDeleted(el) {
  if (el.dataset[CLICKABLE_ENHANCED_FLAG] === 'true' && typeof el.destroyClickable === 'function') {
    el.destroyClickable();
    delete el.destroyClickable;
  }
});

function createStore$1() {
  let files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return store({
    _tdsFileList: files
  });
}

/**
 * must have the following states:
 * -none (no messaging)
 * -general success (no messaging)
 * -general error (upload failed messaging)
 * -file size error (specific messaging)
 * -file type error (specific messaging)
 * -uploading (no messaging)
 */
const statusCodes = {
  ready: 'uploadReady',
  success: 'success',
  uploading: 'uploading',
  sizeError: 'sizeError',
  typeError: 'typeError',
  uploadError: 'uploadError',
  maxExceededError: 'maxExceededError',
  maxAllowedError: 'maxAllowedError',
  duplicateError: 'duplicateError'
};
//pass in size and unit as a single string, use regex to get size and unit
//returns size from string containing size and unit
function getSizeFromString(str) {
  const regex = /[0-9.]/g;
  const size = str.match(regex).join("");
  return parseFloat(size);
}
//gets the unit (EX: MB) from a string containing size and unit
//If string does not contain unit, or unit is not B, KB, MB, or GB, then default to MB
function getUnitFromString(str) {
  const regex = /[A-Z]/ig;
  const charArray = str && str.match(regex);
  const size = !!charArray ? charArray.join("").toUpperCase() : '';
  const units = ['B', 'KB', 'MB', 'GB'];
  return units.includes(size) ? size : "MB";
}
function validateFile(tdsFile, maxSize, type) {
  let reject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var resultStatus = statusCodes.ready;
  if (!!maxSize) {
    const size = getSizeFromString(maxSize);
    const unit = getUnitFromString(maxSize);
    resultStatus = checkFileSize(tdsFile.file, size, unit);
  }
  if (!!type) {
    const typeResult = checkFileType(tdsFile.file, type, reject);
    resultStatus = typeResult === statusCodes.ready ? resultStatus : typeResult;
  }
  return resultStatus;
}
function checkFileSize(file, maxSize, sizeUnit) {
  const sizeInBytes = getSizeInBytes(maxSize, sizeUnit);
  if (file.size >= sizeInBytes) {
    return statusCodes.sizeError;
  } else {
    return statusCodes.ready;
  }
}
function getSizeInBytes(size) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'B';
  const unitStr = unit.toUpperCase();
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = units.indexOf(unitStr);
  return size * Math.pow(1024, i);
}
// convert the bytes of the file size to human readable file size format
function convertFromBytes(bytes) {
  if (bytes < 1024) return `${bytes}B`;
  const exponent = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, exponent)).toFixed(2) + ' KMGTP'.charAt(exponent) + 'B';
}
function checkFileType(file, types, reject) {
  var matchesTypes = false;
  //file formats can come in the format .ext or type/ext
  //for example png files could be represented as .png or image/png
  for (let i = 0; i < types.length; i++) {
    const type = types[i].trim();
    //if file type is in .ext format
    if (type.startsWith(".")) {
      //to catch the case where there is multiple dots, take text after last dot
      const tempArrA = type.split('.');
      const tempArrB = file.name.split(".");
      const fileExtA = tempArrA[tempArrA.length - 1];
      const fileExtB = tempArrB[tempArrB.length - 1];
      matchesTypes = matchesTypes || fileExtA.toLowerCase() === fileExtB.toLowerCase();
    }
    //follows 'type/ext' pattern, no preprocessing needed just evaluate strings 
    else {
      const regex = /.+?(?=\*)/i;
      const matchedArray = type.match(regex);
      //if type contains *, match everything up until *
      if (type.search(/\*/g) != -1) {
        const strToCheck = !!matchedArray ? matchedArray.join() : '';
        const equalsType = file.type.toLowerCase().startsWith(strToCheck.toLowerCase());
        matchesTypes = matchesTypes || equalsType;
      } else {
        matchesTypes = matchesTypes || type.toLowerCase() === file.type.toLowerCase();
      }
    }
  }
  return matchesTypes && !reject || !matchesTypes && reject ? statusCodes.ready : statusCodes.typeError;
}
function ariaLiveAttributes(ariaLive) {
  let attrs = {};
  switch (ariaLive) {
    case "polite":
      attrs = {
        "role": "status",
        "aria-live": "polite",
        "aria-atomic": "true"
      };
      break;
    case "assertive":
      attrs = {
        "role": "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
      };
      break;
  }
  return attrs;
}
function setAriaLive(el, ariaLive) {
  const attrs = ariaLiveAttributes(ariaLive);
  Object.keys(attrs).forEach(attr => {
    el.setAttribute(attr, attrs[attr]);
  });
}

const id$4 = 'x-1-18';
const attributes$4 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$4 = '<path d="M1.854 1.146L9 8.293l7.146-7.147a.5.5 0 01.638-.057l.07.057a.5.5 0 010 .708L9.707 9l7.147 7.146a.5.5 0 01-.708.708L9 9.707l-7.146 7.147a.5.5 0 01-.638.057l-.07-.057a.5.5 0 010-.708L8.293 9 1.146 1.854a.5.5 0 11.708-.708z" fill="currentColor"/>';
const contents$4 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$4 + '</svg>';
const defaultClass$4 = "tds-icon-18";
const svg$4 = /*#__PURE__*/svgFunction(attributes$4, innerContents$4, defaultClass$4);
var x1_18 = {
  svg: svg$4,
  id: id$4,
  contents: contents$4,
  innerContents: innerContents$4,
  attributes: attributes$4
};

// creates class name for each error alert by error type
function getClassNameByStatusCode(statusCode) {
  if (statusCode == statusCodes.uploadError || statusCode == statusCodes.sizeError || statusCode == statusCodes.typeError) {
    return `${CSS_NS}file--error`;
  } else if (statusCode == statusCodes.success) {
    return `${CSS_NS}file--success`;
  } else if (statusCode == statusCodes.uploading) {
    return `${CSS_NS}file--uploading`;
  }
  return `${CSS_NS}file--ready`;
}
// display error message alert
function displayErrorAlert(fileUpload) {
  const {
    el,
    config,
    state
  } = fileUpload;
  const translateHTML = translations(getLang(el)).html;
  const alert = el.querySelector('.tds-alert--error');
  if (alert) {
    const alerts = alert.querySelector('ul');
    if (!alerts) {
      alert.setAttribute('hidden', 'true');
      alert.setAttribute('aria-hidden', 'true');
    }
  }
  // if alert div is present or show alert message is set true 
  // and also error list is present
  if (state._errorList && state._errorList.length > 0 && (config.showErrorAlert || alert)) {
    const dataFocusId = el.querySelector('input').getAttribute('id');
    const newAlert = document.createElement('div');
    newAlert.className = 'tds-alert--error tds-alert--dismissible';
    newAlert.setAttribute('tabindex', "-1");
    // aria-live = assertive | polite | off, default is polite
    setAriaLive(newAlert, config.alertMessageArialive);
    newAlert.innerHTML = `
      <div class="tds-alert__title">${htmlEncode(state._errorMsg)}</div>
      <ul class="alert-list"></ul>
      <button hidden aria-label="${translateHTML('dismissAlert')}" class="tds-alert__dismiss" data-focus="#${dataFocusId}">
        ${x1_18.svg({
      focusable: false
    })}
      </button>`;
    if (!!alert) el.replaceChild(newAlert, alert);else {
      const filePicker = el.querySelector(`.${FILE_UPLOAD_CLASSES.DROPAREA}`);
      el.insertBefore(newAlert, filePicker);
    }
    var errorText = '';
    state._errorList.forEach(error => {
      errorText += `<li class="alert-list__item">
        ${error.filename ? `<strong>${htmlEncode(error.filename)}</strong>` : ''}
        <span>${htmlEncode(error.message)}</span>
      </li>`;
    });
    const alertArea = newAlert.querySelector('.alert-list');
    alertArea.innerHTML = `${errorText}`;
  } else if (alert) {
    alert.setAttribute('hidden', 'true');
    alert.setAttribute('aria-hidden', 'true');
  }
}
// populating error alert
function populateErrorAlerts(fileUpload, newFile, errorCode, fileCount, listCount) {
  const {
    state,
    config
  } = fileUpload;
  const isMaxError = errorCode === 'maxExceededError' || errorCode === 'maxAllowedError';
  // for max error new file is null
  const {
    name,
    type,
    size
  } = isMaxError ? {
    name: "",
    type: "",
    size: 0
  } : newFile.file;
  const errorList = isMaxError ? [] : state._errorList || [];
  const errorType = `file${errorCode.charAt(0).toUpperCase() + errorCode.slice(1)}Alert`;
  const fileConstraints = {
    filetype: type,
    filecount: fileCount,
    listcount: listCount,
    maxcount: `${config.maxCount}`,
    maxsize: `${config.maxSize}`,
    filesize: `${convertFromBytes(size)}`,
    available: config.maxCount > 1 ? config.maxCount - listCount : -1
  };
  const hasMultipleFiles = errorList.length > 1 ? true : false;
  errorList.push({
    type: errorCode,
    filename: name,
    message: messageFormatter(fileUpload, errorType, hasMultipleFiles, fileConstraints),
    fileconstraints: fileConstraints
  });
  return errorList;
}
function messageFormatter(fileUpload, errorType, hasMultipleFiles, replacements) {
  const {
    el,
    config
  } = fileUpload;
  const translateHTML = translations(getLang(el)).html;
  // handling custom templates if available
  const messageTemplates = config.messageTemplates && config.messageTemplates[errorType];
  const tpl = messageTemplates && messageTemplates !== "" ? messageTemplates : translateHTML(`${errorType}`);
  // handling singular or plural template
  const values = interpolate(replacements, tpl).split(';');
  return hasMultipleFiles && values[1] || values[0];
}

let nextId$2 = 1;
class TdsFileInstance {
  constructor(file, fileUpload) {
    var _fileUpload$config;
    this.id = nextId$2++;
    this._statusMessage = '';
    this._deleteDisposition = '';
    this.fileUpload = fileUpload;
    this.file = file;
    this._allowRemoval = (fileUpload === null || fileUpload === void 0 || (_fileUpload$config = fileUpload.config) === null || _fileUpload$config === void 0 ? void 0 : _fileUpload$config.removeFile) ?? true;
  }
  //holds ref to component
  //status setter that triggers state update/ re-rendering
  get statusCode() {
    return this._statusCode;
  }
  get statusMessage() {
    return this._statusMessage;
  }
  get isInError() {
    if (this._statusCode === statusCodes.typeError || this._statusCode === statusCodes.sizeError || this._statusCode === statusCodes.uploadError || this._statusCode === statusCodes.maxExceededError || this._statusCode === statusCodes.maxAllowedError || this._statusCode === statusCodes.duplicateError) {
      return true;
    } else {
      return false;
    }
  }
  get deleteDisposition() {
    return this._deleteDisposition;
  }
  set deleteDisposition(value) {
    this._deleteDisposition = value;
    this.refreshState();
  }
  get allowRemoval() {
    return this._allowRemoval;
  }
  set allowRemoval(value) {
    this._allowRemoval = value;
    this.refreshState();
  }
  updateStatus(code) {
    let statusMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    this._statusCode = code;
    this._statusMessage = statusMessage;
    this.refreshState();
  }
  refreshState() {
    if (!!this.fileUpload) {
      const {
        store
      } = this.fileUpload;
      store.update(s => {
        return {
          ...s
        };
      });
    }
  }
}

// Getters and Setters
function getFiles(fileUpload) {
  let filterDeleteted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const {
    state
  } = fileUpload;
  return filterDeleteted ? state._tdsFileList.filter(file => !file.deleteDisposition) : [...state._tdsFileList];
}
function setFiles(fileList, store) {
  store.update(s => {
    return {
      ...s,
      _tdsFileList: fileList
    };
  });
}
function setErrorStatus(errorMsg, errorList, store) {
  store.update(s => {
    return {
      ...s,
      _errorMsg: errorMsg,
      _errorList: errorList
    };
  });
}
/**
 * checks if there is maximum allowed or exceed error.
 * @param fileUpload this file upload component
 * @param fileListCount this is the list of the files currently selected by user
 * @param tdsFileListCount this is the list of the files already selected by user
 */
function checkIfMaxErrorCode(maxCount, fileListCount, tdsFileListCount) {
  // Single Fileupload
  if (maxCount === 1) {
    if (fileListCount > 1) return ["maxExceededError", true];
  }
  // Multiple Fileupload
  else {
    const totalFilesCount = tdsFileListCount + fileListCount;
    // 'maxAllowedError' is only valid for Multiple file upload, 
    // Single file upload replaces the exisiting file
    if (tdsFileListCount === maxCount) return ["maxAllowedError", true];
    // tdsFileListCount is the list of files already on the selected list
    // fileListCount is the file list currently selected by user from file dialog
    // check if files selected are above maximum allowed
    else if (totalFilesCount > maxCount) return ["maxExceededError", true];
  }
  return ["", false];
}
/**
 * adds a single file to this instance's file list. Default behavior is to append at the end of list, but an index can be passed in to replace an element in the list.
 * @param fileUpload this file upload component
 * @param fileList this is the list of the selected files
 */
function addFilesToList(fileUpload, fileList) {
  const {
    maxCount
  } = fileUpload.config;
  const {
    store
  } = fileUpload;
  // reset error list on state
  setErrorStatus('', [], store);
  var tdsFileList = getFiles(fileUpload);
  const fileListCount = fileList.length,
    tdsFileListCount = tdsFileList.length;
  const [maxErrorCode, hasMaxErrorCode] = checkIfMaxErrorCode(maxCount, fileListCount, tdsFileListCount);
  var errorList;
  if (hasMaxErrorCode) {
    errorList = populateErrorAlerts(fileUpload, null, maxErrorCode, fileListCount, tdsFileListCount);
  } else {
    const {
      maxSize,
      acceptType,
      rejectType
    } = fileUpload.config;
    const {
      sizeError,
      typeError,
      uploadError
    } = statusCodes;
    // Each selected file from the currently selected list
    // validate, set error status and populate error list for alert
    for (let i = 0; i < fileList.length; i++) {
      const newFile = new TdsFileInstance(fileList[i], fileUpload);
      newFile.updateStatus(validateFile(newFile, maxSize, acceptType ?? rejectType, acceptType ? false : !!rejectType));
      const code = newFile.statusCode;
      // reset errorCode
      let errorCode = "";
      if (code == sizeError || code == typeError || code == uploadError) {
        errorCode = code;
      }
      // check for duplicates
      if (tdsFileListCount) {
        for (let j = 0; j < tdsFileListCount; j++) {
          const {
            name,
            size
          } = tdsFileList[j].file;
          if (name == newFile.file.name && size == newFile.file.size) {
            errorCode = "duplicateError";
            break;
          }
        }
      }
      // If errorCode set add to the errorList array
      if (errorCode !== "") {
        errorList = populateErrorAlerts(fileUpload, newFile, errorCode, fileListCount, tdsFileListCount);
      } else {
        if (maxCount == 1) addFile(fileUpload, newFile, 0); // single file upload
        else addFile(fileUpload, newFile); // multiple file upload
      }
    }
  }
  // update errorMsg and errorList
  if (errorList && errorList.length > 0) {
    // if the errors are maximum allowed or exceeded error, use selected files number to update the error title
    const hasMultipleFiles = (hasMaxErrorCode ? fileList : errorList).length > 1 ? true : false;
    setErrorStatus(`${messageFormatter(fileUpload, 'fileTitleErrorAlert', hasMultipleFiles)}`, errorList, store);
  }
}
/**
 * adds a single file to this instance's file list. Default behavior is to append at the end of list, but an index can be passed in to replace an element in the list.
 * @param fileUpload this file upload component
 * @param file the file that will be added to the end of the file list
 * @param replaceIndex optional argument that, if passed, will replace this index with the new file, instead of appending to the end. Used for replacing the first element when maxCount is 1;
 */
function addFile(fileUpload, newFile, replaceIndex) {
  const tdsFileList = getFiles(fileUpload);
  if (!!replaceIndex || replaceIndex >= 0) {
    tdsFileList[replaceIndex] = newFile;
  } else {
    tdsFileList.push(newFile);
  }
  setFiles(tdsFileList, fileUpload.store);
  //dispatch file added event
  fileUpload.sendEvent('tdsFileAdded', {
    detail: {
      fileAdded: newFile,
      newFileList: getFiles(fileUpload, true)
    }
  });
}
/**
 * Remove a single file to this instance's file list. An index can be passed in to remove an element in the list.
 * File starts with deleteDispoistion = 'deleted', After some seconds, the disposition changes to 'remove'. Then after
 * 1 second (giving the DOM element time to collapse), the file is removed. These transitions occur provided the user does not undo the delete
 * @param fileUpload this file upload component
 * @param file the selected file for removal
 * @param index optional argument that, if passed, will remove file with this index position. Used for removing the first element when maxCount is 1;
 */
async function doFileRemoval(fileUpload, file) {
  var _fileUpload$config$re, _fileUpload$config;
  let index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  const removeHandlerSucceeded = await ((_fileUpload$config$re = (_fileUpload$config = fileUpload.config).removeFileHandler) === null || _fileUpload$config$re === void 0 ? void 0 : _fileUpload$config$re.call(_fileUpload$config, file));
  if (removeHandlerSucceeded !== false) {
    const tdsFileList = getFiles(fileUpload);
    if (file) {
      index = tdsFileList.indexOf(file);
    } else {
      file = tdsFileList[index];
    }
    if (file && index > -1) {
      // prepare for delete file
      file.deleteDisposition = 'remove';
      setFiles(tdsFileList, fileUpload.store);
      // allow for animation before removing
      setTimeout(() => {
        const tdsFileList2 = getFiles(fileUpload);
        const index2 = tdsFileList2.indexOf(file);
        if (index2 > -1 && file.deleteDisposition) {
          tdsFileList2.splice(index2, 1);
          setFiles(tdsFileList2, fileUpload.store);
        }
      }, 1000);
      fileUpload.sendEvent('tdsFileRemoved', {
        detail: {
          fileRemoved: file,
          newFileList: getFiles(fileUpload, true)
        }
      });
    }
    // clear max file allowed and exceeded error message only
    const {
      state,
      store
    } = fileUpload;
    const errorList = state._errorList;
    if (errorList && errorList.length > 0) {
      errorList.forEach((error, index) => {
        if (error.type === 'maxAllowedError' || error.type === 'maxExceededError') {
          errorList.splice(index, 1);
          store.update(s => {
            return {
              ...s,
              _errorList: errorList
            };
          });
        }
      });
    }
    return true;
  }
  return false;
}

const FILE_INPUT_PROP = "input[type='file']";
const FILE_UPLOAD_BUTTON = `[data-trigger="file-upload"], ${FILE_UPLOAD_CLASSES.BUTTON}`;
const FILE_UPLOAD_DROPAREA = `[data-droparea], .${FILE_UPLOAD_CLASSES.DROPAREA}`;
function bindFileUpload(fileUpload) {
  const {
    host,
    el
  } = fileUpload;
  const root = hasShadowDom(host) ? host.shadowRoot : el;
  // event listeners
  const eventListeners = new EventListeners();
  //file picker events
  bindFilePicker(root, fileUpload, eventListeners);
  const unbind = () => eventListeners.removeListeners();
  return unbind;
}
function bindFilePicker(root, fileUpload, eventListeners) {
  //picker elements
  const fileInput = root.querySelector(`${FILE_INPUT_PROP}`);
  const fileButton = root.querySelector(`${FILE_UPLOAD_BUTTON}`);
  const dropArea = root.querySelector(`${FILE_UPLOAD_DROPAREA}`);
  //button click listener
  if (!!fileButton) {
    eventListeners.addListener(fileButton, 'click', fileButtonListener(fileInput));
  }
  //file input listener
  if (!!fileInput) {
    eventListeners.addListener(fileInput, 'change', inputChangeHandler(fileUpload));
  }
  //drag and drop listeners
  if (!!dropArea) {
    eventListeners.addListener(dropArea, 'dragenter', dragEnterHandler);
    eventListeners.addListener(dropArea, 'dragleave', dragLeaveHandler);
    eventListeners.addListener(dropArea, 'dragover', dragOverHandler);
    eventListeners.addListener(dropArea, 'drop', dropHandler(fileUpload));
  }
  // alert dismissed event handler
  eventListeners.addListener(root, 'alert.dismissed', alertDismisHandler(fileUpload));
}
//redirects button click to input to open file explorer
function fileButtonListener(fileInput) {
  return e => {
    e.preventDefault();
    e.stopPropagation();
    fileInput.click();
  };
}
//retrives file list from file input
function inputChangeHandler(fileUpload) {
  return e => {
    const targetInput = e.target;
    const files = targetInput.files;
    addFilesToList(fileUpload, files);
    // clearing the input cache
    targetInput.value = "";
  };
}
//handles behavior when user drags into area
function dragEnterHandler(e) {
  if (e.target === e.currentTarget) {
    this.classList.add('active--drag');
  }
}
//handles behavior when user drags out of area
function dragLeaveHandler(e) {
  if (e.target === e.currentTarget) {
    this.classList.remove('active--drag');
  }
}
//handles behavior when user drags over area
function dragOverHandler(e) {
  e.preventDefault();
  e.stopPropagation();
  this.classList.add('active--drag');
}
//handles behavior when user drops over area
function dropHandler(fileUpload) {
  return e => {
    e.preventDefault();
    e.stopPropagation();
    const dropArea = e.currentTarget;
    dropArea.classList.remove('active--drag');
    const data = e.dataTransfer;
    const files = data.files;
    if (files.length) {
      addFilesToList(fileUpload, files);
    }
  };
}
// reset alert error list when alert is dismissed
function alertDismisHandler(fileUpload) {
  return () => {
    const {
      store
    } = fileUpload;
    store.update(s => {
      return {
        ...s,
        _errorMsg: '',
        _errorList: []
      };
    });
  };
}

const id$3 = 'check-circle-1-18';
const attributes$3 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$3 = '<path d="M9 18A9 9 0 119 0a9 9 0 010 18zm0-1A8 8 0 109 1a8 8 0 000 16zm4.283-11.444a.5.5 0 01.707.707l-6.182 6.181a.5.5 0 01-.707 0l-3.09-3.09a.5.5 0 01.706-.708l2.738 2.738 5.828-5.828z" fill="currentColor"/>';
const contents$3 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$3 + '</svg>';
const defaultClass$3 = "tds-icon-18";
const svg$3 = /*#__PURE__*/svgFunction(attributes$3, innerContents$3, defaultClass$3);
var checkCircle1_18 = {
  svg: svg$3,
  id: id$3,
  contents: contents$3,
  innerContents: innerContents$3,
  attributes: attributes$3
};

const id$2 = 'ban-1-18';
const attributes$2 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$2 = '<path d="M3.708 15A8 8 0 0015 3.707L3.707 14.999zM3 14.291L14.292 3.001A8 8 0 003 14.293zM9 18A9 9 0 119 0a9 9 0 010 18z" fill="currentColor"/>';
const contents$2 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$2 + '</svg>';
const defaultClass$2 = "tds-icon-18";
const svg$2 = /*#__PURE__*/svgFunction(attributes$2, innerContents$2, defaultClass$2);
var ban1_18 = {
  svg: svg$2,
  id: id$2,
  contents: contents$2,
  innerContents: innerContents$2,
  attributes: attributes$2
};

const id$1 = 'trash-bin-1-18';
const attributes$1 = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents$1 = '<path d="M15 7v8.59c0 .782-.61 1.41-1.357 1.41H4.357C3.611 17 3 16.372 3 15.59V7a.5.5 0 00-1 0v8.59C2 16.919 3.052 18 4.357 18h9.286C14.948 18 16 16.918 16 15.59V7a.5.5 0 10-1 0zM5.5 8a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5zM9 8a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6A.5.5 0 019 8zm3.5 0a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5zm-1-8a.5.5 0 01.5.5V3h5a.5.5 0 110 1H1a.5.5 0 010-1h5V.5a.5.5 0 01.5-.5h5zM11 1H7v2h4V1z" fill="currentColor"/>';
const contents$1 = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents$1 + '</svg>';
const defaultClass$1 = "tds-icon-18";
const svg$1 = /*#__PURE__*/svgFunction(attributes$1, innerContents$1, defaultClass$1);
var trashBin1_18 = {
  svg: svg$1,
  id: id$1,
  contents: contents$1,
  innerContents: innerContents$1,
  attributes: attributes$1
};

function setupFileList(fileUpload) {
  const {
    el,
    config
  } = fileUpload;
  const listOutputEl = el.querySelector(`.${FILE_UPLOAD_CLASSES.LIST}`);
  if (!listOutputEl) {
    if (config.showFilelist) {
      const div = document.createElement('div');
      div.classList.add(FILE_UPLOAD_CLASSES.LIST);
      div.innerHTML = `<div class="${FILE_UPLOAD_CLASSES.LIST_TITLE} tds-h5"></div><ol></ol>`;
      el.appendChild(div);
    }
  } else {
    const title = listOutputEl.querySelector(`.${FILE_UPLOAD_CLASSES.LIST_TITLE}`);
    if (title) title.dataset.custom = 'true';
    if (!listOutputEl.querySelector('ol')) {
      listOutputEl.appendChild(document.createElement('ol'));
    }
    config.showFilelist = true;
  }
}
function buildFileList(fileUpload) {
  const {
    el,
    host,
    config
  } = fileUpload;
  const root = hasShadowDom(host) ? host.shadowRoot : el;
  const previewContainer = root.querySelector(`.${FILE_UPLOAD_CLASSES.LIST}`);
  const fileList = !!fileUpload.state ? fileUpload.state._tdsFileList : [];
  const itemsToCollapse = [];
  if (!!previewContainer) {
    previewContainer.hidden = fileList.length === 0;
    previewContainer.setAttribute('aria-hidden', `${fileList.length === 0}`);
    // aria-live = assertive | polite | off, default is polite
    setAriaLive(previewContainer, config.filelistArialive);
    const title = previewContainer.querySelector(`.${FILE_UPLOAD_CLASSES.LIST_TITLE}`);
    const listEl = previewContainer.querySelector('ol');
    if (!title.dataset.custom) {
      title.innerText = messageFormatter(fileUpload, config.asyncUpload ? 'fileAsycUploadTitle' : 'fileSyncUploadTitle', fileList.length > 1);
    }
    // build the file list. 
    // Rather than rewrite the list with each state update, we instead run this logic to ensure existing elements remain in place
    // This is so deleted items that are transitioning out are allowed to completion
    // 1: delete any items no longer in file list
    let listItems = Array.from(listEl.querySelectorAll('li'));
    listItems.forEach(item => {
      const file = fileList.find(f => `${f.id}` === item.dataset.fileId);
      if (!file) {
        listEl.removeChild(item);
      }
    });
    //2: insert files not in list. (NOTE: this logic assumes items are added to the end and order never changes)
    let insertHTML = '';
    listItems = Array.from(listEl.querySelectorAll('li'));
    fileList.forEach(file => {
      const item = listItems.find(item => item.dataset.fileId === `${file.id}`);
      if (!item) {
        insertHTML += `<li class="tds-fileupload__list-element" data-file-id="${file.id}">
          <div class="tds-file">
            <div class="tds-file__detail">
              <span class="${FILE_UPLOAD_CLASSES.FILE_NAME}">${htmlEncode(file.file.name)}</span>
            </div>
          </div>
        </li>`;
      }
    });
    if (insertHTML) {
      listEl.insertAdjacentHTML('beforeend', insertHTML);
    }
    //3: Update elements with current state
    listItems = Array.from(listEl.querySelectorAll('li'));
    listItems.forEach((item, index) => {
      const file = fileList[index];
      updateFileListItem(item, file, fileUpload);
      if (file.deleteDisposition === 'remove') {
        itemsToCollapse.push(item);
      }
    });
    // depends of confirmRemoveFile setup it binds delete event to 
    // confirm dialog delete button or trash icon itself
    if (config.removeFile) bindFileRemove(listEl, fileUpload);
    if (itemsToCollapse.length) {
      requestAnimationFrame(() => {
        itemsToCollapse.forEach(item => {
          const collapsible = new Collapsible(item, {
            collapsibleDuration: 'medium-slow'
          });
          if (!collapsible.transitioning) {
            collapsible.hide();
          }
        });
      });
    }
  }
}
// returns svg icons for error or success statusCode
function statusIconByStatusCode(statusCode) {
  let svgIcon;
  if (statusCode === statusCodes.uploadError) svgIcon = ban1_18.svg({
    focusable: false
  });
  if (statusCode === statusCodes.success) svgIcon = checkCircle1_18.svg({
    focusable: false
  });
  return svgIcon ? `${svgIcon}` : '';
}
function updateFileListItem(item, tdsFile, fileUpload) {
  const {
    el
  } = fileUpload;
  const {
    file: {
      name,
      size
    },
    allowRemoval
  } = tdsFile;
  const {
    t: translate,
    html: translateHTML
  } = translations(getLang(item));
  const fileListEl = item.querySelector('.tds-file');
  fileListEl.className = `tds-file ${getClassNameByStatusCode(tdsFile.statusCode)}`;
  // File Detail:  Size and Error message
  const fileDetail = fileListEl.querySelector(`.${FILE_UPLOAD_CLASSES.FILE_DETAIL}`);
  const statusMessage = (tdsFile.isInError ? tdsFile.statusMessage : '').trim() || `${convertFromBytes(size)}`;
  var fileDetailInfoEl = fileListEl.querySelector(`.${FILE_UPLOAD_CLASSES.FILE_SIZE}`) || fileListEl.querySelector(`.${FILE_UPLOAD_CLASSES.FILE_ERROR_MESSAGE}`);
  if (!fileDetailInfoEl) {
    fileDetailInfoEl = document.createElement('span');
    fileDetail.appendChild(fileDetailInfoEl);
  }
  if (tdsFile.statusCode == statusCodes.uploadError) {
    fileDetailInfoEl.textContent = tdsFile.statusMessage ? tdsFile.statusMessage : translate('fileUploadErrorAlert');
    fileDetailInfoEl.classList.add(FILE_UPLOAD_CLASSES.FILE_ERROR_MESSAGE);
    fileDetailInfoEl.classList.remove(FILE_UPLOAD_CLASSES.FILE_SIZE);
  } else {
    fileDetailInfoEl.textContent = statusMessage;
    fileDetailInfoEl.classList.add(FILE_UPLOAD_CLASSES.FILE_SIZE);
    fileDetailInfoEl.classList.remove(FILE_UPLOAD_CLASSES.FILE_ERROR_MESSAGE);
  }
  // File Status: Success, Error and Loading
  if (tdsFile.statusCode === statusCodes.uploadError || tdsFile.statusCode === statusCodes.success || tdsFile.statusCode === statusCodes.uploading) {
    var fileStatusEl = fileListEl.querySelector('.tds-file--status');
    if (!fileStatusEl) {
      fileStatusEl = document.createElement('div');
      fileStatusEl.className = 'tds-file--status';
    }
    if (tdsFile.statusCode === statusCodes.uploading) {
      const loadingIcon = fileStatusEl.querySelector('.tds-loading-spinner');
      if (!loadingIcon) {
        const loadingTemplate = `
          <div class="tds-loading-spinner tds-loading-spinner--x-small" aria-live="polite" aria-busy="true" role="status">
            <span class="tds-sr-only">${translateHTML('uploadingStarted', tdsFile.file.name)}</span>
          </div>`;
        fileStatusEl.innerHTML = loadingTemplate;
        fileListEl.insertBefore(fileStatusEl, fileDetail);
      }
    } else {
      fileStatusEl.innerHTML = statusIconByStatusCode(tdsFile.statusCode);
      fileListEl.insertBefore(fileStatusEl, fileDetail);
    }
  }
  // File Actions: remove
  if (allowRemoval) {
    const removeFileTemplate = `
    <button class="tds-iconbutton tds-file--delete" data-trigger-modal="#${el.id}--confirm-dialog" aria-label="${translateHTML('remove', name)}">
      ${trashBin1_18.svg({
      focusable: false,
      "class": "tds-iconbutton__icon"
    })}
    </button>`;
    let fileActions = fileListEl.querySelector(`.${FILE_UPLOAD_CLASSES.FILE_ACTIONS}`);
    if (!fileActions) {
      fileActions = document.createElement('div');
      fileActions.className = FILE_UPLOAD_CLASSES.FILE_ACTIONS;
    }
    fileActions.innerHTML = removeFileTemplate;
    fileListEl.appendChild(fileActions);
  } else {
    var _fileListEl$querySele;
    (_fileListEl$querySele = fileListEl.querySelector(`.${FILE_UPLOAD_CLASSES.FILE_ACTIONS}`)) === null || _fileListEl$querySele === void 0 ? void 0 : _fileListEl$querySele.remove();
  }
}
/**
 * binds the delete event to each file from the file list.
 * @param fileUpload this file upload component
 * @param listEl the list of file list
 * @param index optional argument that, if passed, will remove file with this index position. Used for removing the first element when maxCount is 1;
 */
function bindFileRemove(listEl, fileUpload) {
  const {
    confirmRemoveFile
  } = fileUpload.config;
  const {
    _tdsFileList
  } = fileUpload.state;
  const children = listEl.children;
  for (let i = 0; i < children.length; i++) {
    const btnDelete = children[i].querySelector(`.${FILE_UPLOAD_CLASSES.DELETE_BUTTON}`);
    if (btnDelete) {
      btnDelete.addEventListener('click', () => {
        const tdsFile = _tdsFileList[i];
        if (confirmRemoveFile) {
          confirmModalDialog(fileUpload, tdsFile);
        } else {
          doFileRemoval(fileUpload, tdsFile);
        }
      });
    }
  }
}
/**
 * Delete confirmation dialog
 * @param fileUpload this file upload component
 * @param file the selected file for removal
 */
function confirmModalDialog(fileUpload, file) {
  const {
    el
  } = fileUpload;
  const translateHTML = translations(getLang(el)).html;
  const dialog = el.querySelector(`#${el.id}--confirm-dialog`);
  const deleteModalDialog = `
  <div class="tds-modal__dialog-container" aria-describedby="${el.id}--confirm-dialog-description" role="document">
    <div class="tds-modal__dialog-body-content" id="${el.id}--confirm-dialog-description">
      <p>${translateHTML('confirmRemovalOf')} <strong>${htmlEncode(file.file.name)}</strong>?</p>
    </div>
    <div class="tds-modal__dialog-footer">
      <div class="tds-modal__dialog-button-container">
        <div class="tds-modal__dialog-button-layout">
          <button class="tds-button--primary tds-file--delete-confirm" data-dismiss="modal">${translateHTML('remove')}</button>
          <button class="tds-button--secondary" data-dismiss="modal">${translateHTML('cancel')}</button>
        </div>
      </div>
    </div>
  </div>`;
  const confirmDialog = document.createElement('div');
  confirmDialog.setAttribute('id', `${el.id}--confirm-dialog`);
  confirmDialog.setAttribute('class', 'tds-modal tds-modal__dialog--small');
  confirmDialog.setAttribute('hidden', 'true');
  confirmDialog.setAttribute('role', 'dialog');
  confirmDialog.innerHTML = deleteModalDialog;
  const confirmBtn = confirmDialog.querySelector('.tds-file--delete-confirm');
  confirmBtn.addEventListener('click', () => {
    doFileRemoval(fileUpload, file);
  });
  if (!!dialog) el.replaceChild(confirmDialog, dialog);else el.appendChild(confirmDialog);
}

// Default configuration
const defaultConfig$1 = {
  showErrorAlert: true,
  showFilelist: true,
  allowDuplicates: false,
  confirmRemoveFile: false,
  removeFile: true,
  asyncUpload: false,
  filelistArialive: "polite",
  alertMessageArialive: "polite"
};
const ENHANCED_FLAG$1 = 'enhancedFileUpload';
const INSTANCE_KEY$3 = `${NAMESPACE}FileUpload`;
const PATTERN_SELECTOR$2 = `.${CSS_NS}fileupload`;
class _FileUploadInstance {
  constructor(element, clientConfig) {
    this.onDestroy = [];
    // set enhance element
    element.dataset[ENHANCED_FLAG$1] = "true";
    // assign
    this.el = this.host = element;
    //set state
    this.store = createStore$1();
    this.state = {
      _tdsFileList: []
    };
    // ---- Initialize Config ----
    // extract configuration from data attributes on element
    const dataConfig = configFromDataAttributes(this.el);
    convertStringRefs(dataConfig, ['removeFileHandler'], 'function');
    const config = processConfig({
      ...defaultConfig$1,
      ...dataConfig,
      ...clientConfig
    });
    this.setConfig(config);
    setInputAttributes(this.el, this.config);
    // set fileList to true if list div is present
    setupFileList(this);
    // Render function
    this.render();
    // destroy
    const unbind = bindFileUpload(this);
    const unsubscribe = this.store.subscribe(this.onStateUpdate.bind(this));
    this.onDestroy = [unbind, unsubscribe];
    instances$1.set(element, INSTANCE_KEY$3, this);
  }
  setConfig(config) {
    if (config) this.config = {
      ...config
    };
  }
  sendEvent(eventType, eventInit) {
    return this.host.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.el) {
      delete this.el.dataset[ENHANCED_FLAG$1];
    }
    instances$1.remove(this.host, INSTANCE_KEY$3);
    this.el = this.host = null;
  }
  render() {
    if (this.config.showErrorAlert) {
      displayErrorAlert(this);
    }
    if (this.config.showFilelist) {
      buildFileList(this);
    }
  }
  get files() {
    const {
      _tdsFileList
    } = this.state;
    // do not return files to be removed
    return _tdsFileList && _tdsFileList.filter(f => !f.deleteDisposition);
  }
  set files(fileList) {
    this.store.update(() => {
      return {
        _tdsFileList: fileList
      };
    });
  }
  onStateUpdate(state) {
    this.state = state;
    this.render();
  }
}
//handles getting config and preProcessing of values
function processConfig(config) {
  const newConfig = {};
  Object.keys(config).forEach(key => {
    var value = config[key];
    switch (key) {
      case 'maxSize':
        if (typeof value == 'number') value = value.toString();
        break;
      case 'maxCount':
        if (typeof value == 'string') value = parseInt(value);
        break;
      case 'acceptType':
      case 'rejectType':
        if (typeof value == 'string') value = value.split(" ").join("").split(",");
        break;
      case 'showFileList':
      case 'showErrorAlert':
      case 'allowDuplicates':
      case 'removeFile':
      case 'confirmRemoveFile':
        value = value == true;
        break;
      case 'messageTemplates':
        if (typeof value == 'string') {
          value = JSON.parse(value);
        }
    }
    newConfig[key] = value;
  });
  return newConfig;
}
function setInputAttributes(el, config) {
  const fileInput = el.querySelector(`.${FILE_UPLOAD_CLASSES.INPUT}`);
  if (fileInput) {
    if (config.acceptType) {
      fileInput.setAttribute('accept', config.acceptType.toString());
    }
    if (config.maxCount === 1) {
      fileInput.removeAttribute('multiple');
    } else {
      fileInput.setAttribute('multiple', 'true');
    }
  }
}
class FileUpload {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$3) || new _FileUploadInstance(element, config);
  }
  destroy() {
    const {
      _instance
    } = this;
    delete this._instance;
    return _instance.destroy();
  }
  get files() {
    return this._instance.files;
  }
  set files(files) {
    this._instance.files = files;
  }
}
onDomChanges(`${PATTERN_SELECTOR$2}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG$1]) {
    new FileUpload(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG$1] === "true") {
    new FileUpload(element).destroy();
  }
});

const PATTERN_SELECTOR$1 = `${CSS_NS}table-pagination`;
const PAGINATION = {
  SIZE: `${PATTERN_SELECTOR$1}__size`,
  COUNT: `${PATTERN_SELECTOR$1}__count`,
  PAGE: `${PATTERN_SELECTOR$1}__page`,
  PAGE_NUMBER: `${PATTERN_SELECTOR$1}__page-num`,
  LAST_PAGE: `${PATTERN_SELECTOR$1}__page-num--last`,
  PAGE_NAV: `${PATTERN_SELECTOR$1}__page-nav`,
  PREVIOUS_BTN: `${PATTERN_SELECTOR$1}__previous-page`,
  NEXT_BTN: `${PATTERN_SELECTOR$1}__next-page`
};
function bindTablePagination(pagination) {
  const {
    root
  } = pagination;
  // Add Event Listeners
  const eventListeners = new EventListeners();
  eventListeners.addListener(root, 'click', pageNavigationHandler(pagination));
  eventListeners.addListener(root, 'keydown', keyDownHandler(pagination));
  eventListeners.addListener(root, 'change', changeHandler$1(pagination));
  const undoWhile = doWhileEventing(window, 'resize', () => {
    checkStacked(pagination);
  });
  const unbind = () => {
    eventListeners.removeListeners();
    undoWhile();
  };
  return unbind;
}
function keyDownHandler(pagination) {
  return event => {
    const previousBtn = event.target.closest(`.${PAGINATION.PREVIOUS_BTN}`);
    const nextBtn = event.target.closest(`.${PAGINATION.NEXT_BTN}`);
    if (previousBtn || nextBtn) {
      const key = normalizeKey(event);
      switch (key) {
        case 'ArrowLeft':
          event.preventDefault();
          previousButtonHandler(pagination);
          break;
        case 'ArrowRight':
          event.preventDefault();
          nextButtonHandler(pagination);
          break;
      }
    }
  };
}
const pageNavigationHandler = pagination => {
  return event => {
    const previousBtn = event.target.closest(`.${PAGINATION.PREVIOUS_BTN}`);
    const nextBtn = event.target.closest(`.${PAGINATION.NEXT_BTN}`);
    if (previousBtn) {
      previousButtonHandler(pagination);
    } else if (nextBtn) {
      nextButtonHandler(pagination);
    }
  };
};
const previousButtonHandler = pagination => {
  const {
    page
  } = pagination; // page getter
  if (page !== 1) {
    handleSelect(pagination, page - 1);
  }
};
const nextButtonHandler = pagination => {
  const {
    page
  } = pagination;
  if (page !== getTotalPages(pagination)) {
    handleSelect(pagination, page + 1);
  }
};
const changeHandler$1 = pagination => {
  return event => {
    const select = event.target.closest(`.${PAGINATION.SIZE} select`);
    const input = event.target.closest(`.${PAGINATION.PAGE_NUMBER} input`);
    if (input) {
      handlePageNumberChange(pagination, input);
    }
    if (select) {
      handlePageSizeChange(pagination, select);
    }
  };
};
function handleSelect(pagination, page) {
  const totalPages = getTotalPages(pagination);
  let newPage = Math.max(page, 1);
  if (totalPages !== -1) newPage = Math.min(newPage, totalPages);
  if (pagination.page !== newPage) {
    // const { noAutoUpdate } = pagination.config;
    // if (!noAutoUpdate) pagination.page = newPage;
    pageEvent('tdsPageChanged', pagination, {
      page: newPage
    });
  }
  return newPage;
}
// Page number value change event
function handlePageNumberChange(pagination, PAGE_NUMBER_INPUT) {
  const page = parseInt(PAGE_NUMBER_INPUT.value);
  const edittedPage = handleSelect(pagination, isNaN(page) ? 1 : page).toString();
  if (PAGE_NUMBER_INPUT.value !== edittedPage) {
    PAGE_NUMBER_INPUT.value = edittedPage;
  }
}
// Page size value change event
function handlePageSizeChange(pagination, pageOptionSelect) {
  let newPageSize = parseInt(pageOptionSelect.value);
  if (pagination.pageSize !== newPageSize) {
    // const { noAutoUpdate } = pagination.config;
    // if (!noAutoUpdate) {
    //   pagination.pageSize = newPageSize;
    //   pagination.page = 1;
    // }
    pageEvent('tdsPageSizeChanged', pagination, {
      page: 1,
      pageSize: newPageSize
    });
  }
}
// Emits page change event
function pageEvent(eventName, pagination, detail) {
  const {
    page,
    pageSize
  } = pagination;
  pagination.onPaginationUpdate(eventName, {
    page: page,
    pageSize: pageSize,
    userAction: true,
    ...detail
  });
}
function checkStacked(pagination) {
  const {
    root
  } = pagination;
  if (root) {
    // filtering root.childNodes because web component IE polyfill breaks root.children
    const totalWidth = Array.from(root.childNodes).filter(node => node.nodeType === Node.ELEMENT_NODE).reduce((acc, node) => {
      return acc + node.offsetWidth;
    }, 0);
    const stacked = totalWidth > root.clientWidth;
    pagination.stacked = stacked;
  }
}
// export functions
function getTotalPages(pagination) {
  const {
    config
  } = pagination;
  const {
    totalItems,
    pageSize
  } = config;
  return totalItems > 0 ? pageSize ? Math.ceil(totalItems / pageSize) : 1 : -1;
}
function calculatePageInputWidth(pagination) {
  const {
    root,
    config
  } = pagination;
  const totalPages = getTotalPages(pagination);
  const PAGE_NUMBER_INPUT = root.querySelector(`.${PAGINATION.PAGE_NUMBER} > input`);
  if (PAGE_NUMBER_INPUT) {
    // if total items are unknown, set width for 3 digits by default
    PAGE_NUMBER_INPUT.style.width = 2 + (config.totalItems > 0 ? totalPages.toString().length : 3) * 0.7 + "rem";
  }
}

const ENHANCED_FLAG = 'enhancedTablePagination';
const INSTANCE_KEY$2 = `${NAMESPACE}table-pagination`;
const PATTERN_SELECTOR = `${CSS_NS}table-pagination`;
const STACKED_CLASS = `${CSS_NS}table-pagination--stacked`;
let nextId$1 = 0;
// Default configuration for multiselect
const defaultConfig = {
  page: 1,
  pageSize: 10,
  showRecordsDetail: false,
  totalItems: 0
};
class _TablePaginationInstance {
  constructor(element) {
    this.onDestroy = [];
    this._stacked = false;
    this.root = this.host = element;
    this.id = element.id || `__tds-table-pagination-${++nextId$1}`;
    element.dataset[ENHANCED_FLAG] = "true";
    this._translation = translations(element).t;
    this._setAriaLabel = !element.hasAttribute('aria-label');
    if (!element.hasAttribute('role')) {
      element.setAttribute('role', 'group');
    }
    // ---- Initialize Config ----
    // extract configuration from data attributes on element
    const dataConfig = configFromDataAttributes(this.root);
    this.setConfig({
      ...defaultConfig,
      ...dataConfig
    });
    this.render();
    this.updatePagination();
    const unbind = bindTablePagination(this);
    const unwatch = watchDataAttributeChange(element, this.setConfig.bind(this));
    this.onDestroy = [unbind, unwatch];
    this.updatePagination = debounce(this.updatePagination.bind(this), 0);
    instances$1.set(element, INSTANCE_KEY$2, this);
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    config = this.processConfig(config);
    if (this.config) {
      const {
        page: oldPage,
        pageSize: oldPageSize
      } = this.config;
      this.config = {
        ...this.config,
        ...config
      };
      const {
        page,
        pageSize
      } = this.config;
      this.updatePagination(config);
      if (!this._ignoreConfigUpdate) {
        const eventName = pageSize !== oldPageSize ? 'tdsPageSizeChanged' : page !== oldPage ? 'tdsPageChanged' : '';
        if (eventName) {
          this.onPaginationUpdate(eventName, {
            page,
            pageSize,
            userAction: false
          });
        }
      }
    } else {
      this.config = config;
    }
  }
  // getters and setters
  // get and set page
  get page() {
    return this.config.page;
  }
  set page(page) {
    this.setConfig({
      page
    });
  }
  // get and set pageSize
  get pageSize() {
    return this.config.pageSize;
  }
  set pageSize(pageSize) {
    this.setConfig({
      pageSize
    });
  }
  // get and set pageSizeOptions
  get pageSizeOptions() {
    return this.config.pageSizeOptions;
  }
  set pageSizeOptions(pageSizeOptions) {
    this.setConfig({
      pageSizeOptions
    });
  }
  // get and set showRecordsDetail
  get showRecordsDetail() {
    return this.config.showRecordsDetail;
  }
  set showRecordsDetail(showRecordsDetail) {
    this.setConfig({
      showRecordsDetail
    });
  }
  // get and set totalItems
  get totalItems() {
    return this.config.totalItems;
  }
  set totalItems(totalItems) {
    this.setConfig({
      totalItems
    });
  }
  // get and set page template
  get pageTemplate() {
    return this.config.pageTemplate;
  }
  set pageTemplate(pageTemplate) {
    this.setConfig({
      pageTemplate
    });
  }
  // get and set page size template
  get pageSizeTemplate() {
    return this.config.pageSizeTemplate;
  }
  set pageSizeTemplate(pageSizeTemplate) {
    this.setConfig({
      pageSizeTemplate
    });
  }
  // get and set records template
  get recordsTemplate() {
    return this.config.recordsTemplate;
  }
  set recordsTemplate(recordsTemplate) {
    this.setConfig({
      recordsTemplate
    });
  }
  get noAutoUpdate() {
    return this.config.noAutoUpdate;
  }
  get stacked() {
    return this._stacked;
  }
  set stacked(stacked) {
    if (this._stacked !== stacked) {
      this._stacked = stacked;
      this.root.classList[stacked ? 'add' : 'remove'](STACKED_CLASS);
    }
  }
  get _pageTpl() {
    return this.config.pageTemplate || this._translation(this.totalItems === 0 ? 'pageX' : 'pageXofY');
  }
  get _pageSizeTpl() {
    return this.config.pageSizeTemplate || this._translation('rowPerPageText');
  }
  get _recordsTpl() {
    return this.config.recordsTemplate || this._translation(this.totalItems === 0 ? "showingRecordsTextWithoutTotal" : "showingRecordsText");
  }
  onPaginationUpdate(eventType, detail) {
    if (!this.noAutoUpdate && detail.userAction) {
      this._ignoreConfigUpdate = true;
      this.page = detail.page;
      this.pageSize = detail.pageSize;
      this._ignoreConfigUpdate = false;
    }
    return this.host.dispatchEvent(createCustomEvent(eventType, {
      detail
    }));
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.root) {
      delete this.root.dataset[ENHANCED_FLAG];
    }
    instances$1.remove(this.host, INSTANCE_KEY$2);
    this.root = this.host = null;
  }
  //handles getting config and preProcessing of values
  processConfig(config) {
    const newConfig = {};
    Object.keys(config).forEach(key => {
      var value = config[key];
      switch (key) {
        case 'page':
        case 'pageSize':
        case 'totalItems':
          if (typeof value == 'string') value = value !== "" ? parseInt(value) : 0;
          if (typeof value == 'boolean') value = 0;
          break;
        case 'pageSizeOptions':
          if (typeof value == 'string' && value !== "") value = value.split(',');
          value = value && value.map(arr => {
            if (typeof arr === 'string') {
              arr = arr.trim();
              const result = /\D/.test(arr);
              arr = result ? arr : parseInt(arr);
            }
            return arr;
          });
          break;
        case 'showRecordsDetail':
          if (typeof value == 'string') {
            value = value === 'true' || value === "" ? true : value === 'false' ? false : value;
          }
      }
      newConfig[key] = value;
    });
    return newConfig;
  }
  //=================================
  // RENDER SECTION
  //================================
  render() {
    this.root.setAttribute('id', this.id); // setting up id
    this.initPageSize();
    this.renderPageSize();
    this.renderPageCount();
    this.renderPage();
  }
  initPageSize() {
    const {
      root,
      config,
      pageSize
    } = this;
    const {
      pageSizeOptions
    } = config;
    let newPageSize = pageSize;
    const PAGE_SIZE_SELECT = root.querySelector(`.${PAGINATION.SIZE} select`);
    if (PAGE_SIZE_SELECT && !isNaN(parseInt(PAGE_SIZE_SELECT.value))) {
      newPageSize = parseInt(PAGE_SIZE_SELECT.value);
    }
    // pageSizeOptions: string | (string | number)[], newPageSize: number
    // check for typeof pageSizeOptions is not string is required 
    // to check [Array].include(number)
    else if (pageSizeOptions && typeof pageSizeOptions !== 'string' && !pageSizeOptions.includes(newPageSize)) {
      newPageSize = pageSizeOptions[0];
    }
    if (this.pageSize !== newPageSize) this.pageSize = newPageSize;
  }
  /*
   * <span class="page-size"></span>
  */
  renderPageSize() {
    const {
      root,
      config
    } = this;
    let PAGE_SIZE = root.querySelector(`.${PAGINATION.SIZE}`);
    // if page_size element doesn't exist but the data config is setup
    const {
      pageSizeOptions
    } = config;
    if (pageSizeOptions && pageSizeOptions.length > 1) {
      if (!PAGE_SIZE) {
        PAGE_SIZE = document.createElement('label');
        PAGE_SIZE.setAttribute('class', PAGINATION.SIZE);
      }
      const html = PAGE_SIZE.innerHTML.trim();
      PAGE_SIZE.innerHTML = (html !== "" ? html : htmlEncode(this._pageSizeTpl)).replace("{size}", `<select></select>`);
      root.insertBefore(PAGE_SIZE, root.firstChild);
    }
  }
  /*
   * <span class="page-count"></span>
  */
  renderPageCount() {
    const {
      config,
      root
    } = this;
    let PAGE_COUNT = root.querySelector(`.${PAGINATION.COUNT}`);
    // if page_count doesn't exist or the config to display label is not setup
    if (!PAGE_COUNT && config.showRecordsDetail) {
      PAGE_COUNT = document.createElement('span');
      PAGE_COUNT.setAttribute('class', `${PAGINATION.COUNT}`);
      // if page_size exists insert after that else treat as first element
      const PAGE_SIZE = root.querySelector(`.${PAGINATION.SIZE}`);
      if (PAGE_SIZE) {
        root.insertBefore(PAGE_COUNT, PAGE_SIZE.nextElementSibling);
      } else {
        root.insertBefore(PAGE_COUNT, root.firstChild);
      }
    }
    if (config.showRecordsDetail) {
      const html = PAGE_COUNT.innerHTML.trim();
      this._renderedPageCount = !html;
      PAGE_COUNT.innerHTML = this.renderPageCountHTML(html);
    }
  }
  renderPageCountHTML(html) {
    return (html ? html : htmlEncode(this._recordsTpl)).replace("{start}", `<span data-items-start></span>`).replace("{end}", `<span data-items-end></span>`).replace("{total}", `<span data-items-total></span>`);
  }
  /*
   * <span class="page">
   *  <span class="page-numbers"></span>
   *  <span class="page-nav"></span>
   * </span>
  */
  renderPage() {
    const {
      page,
      root,
      totalItems,
      _translation: translation
    } = this;
    const totalPages = getTotalPages(this);
    // Pagination -- Main
    let PAGE = root.querySelector(`.${PAGINATION.PAGE}`);
    // if page element is not exists create it, add to root as last child
    if (!PAGE) {
      PAGE = document.createElement('span');
      PAGE.setAttribute('class', PAGINATION.PAGE);
      root.appendChild(PAGE);
    }
    // Pagination -- Page number select dropdown
    let PAGE_NUMBER = PAGE.querySelector(`.${PAGINATION.PAGE_NUMBER}`);
    // if page_number element doesn't exits create it and add to page element
    // then add page number select dropdown, if exists just add it
    if (!PAGE_NUMBER) {
      PAGE_NUMBER = document.createElement('label');
      PAGE_NUMBER.setAttribute('class', PAGINATION.PAGE_NUMBER);
      PAGE.insertBefore(PAGE_NUMBER, PAGE.lastChild);
    }
    const html = PAGE_NUMBER.innerHTML.trim();
    this._renderedPage = !html;
    PAGE_NUMBER.innerHTML = (html !== "" ? html : htmlEncode(this._pageTpl)).replace('{page}', `<input type="number" min="1" />`).replace("{total}", `<span data-total-pages></span>`);
    // Pagination -- Navigation
    let PAGE_NAV = PAGE.querySelector(`.${PAGINATION.PAGE_NAV}`);
    const prevState = page === 1 ? 'true' : 'false';
    const nextState = totalItems > 0 && page > totalPages - 1 ? 'true' : 'false';
    // if page navigation doesn't exist create it and add it else do nothing
    if (!PAGE_NAV) {
      PAGE_NAV = document.createElement('span');
      PAGE_NAV.setAttribute('class', PAGINATION.PAGE_NAV);
      const previousLabel = htmlEncode(translation('previousLabel'));
      const nextLabel = htmlEncode(translation('nextLabel'));
      PAGE_NAV.innerHTML = `
        <button aria-label="${previousLabel}" 
          type="button" class="${PAGINATION.PREVIOUS_BTN}" aria-disabled="${prevState}">
          ${arrowLeft1_18.svg()}
        </button>
        <button aria-label="${nextLabel}" 
          type="button" class="${PAGINATION.NEXT_BTN}" aria-disabled="${nextState}">
          ${arrowRight1_18.svg()}
        </button>
      `;
      PAGE.insertBefore(PAGE_NAV, PAGE_NUMBER.nextElementSibling);
    }
    // calculate the width of page number with initial page number value
    calculatePageInputWidth(this);
  }
  // =================================
  // UPDATE SECTION
  // =================================
  updatePagination() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config;
    this.updatePageSizeSelect(config);
    this.updatePageCount(config);
    this.updatePageNumber();
    this.updateAriaLabel();
  }
  updatePageSizeSelect(config) {
    const {
      root,
      pageSize
    } = this;
    const {
      pageSizeOptions
    } = config;
    if (typeof pageSizeOptions !== 'undefined') {
      if (pageSizeOptions && pageSizeOptions.length > 0) {
        let PAGE_SIZE_SELECT = root.querySelector(`.${PAGINATION.SIZE} select`);
        // If the data attribute is updated dynamically after the initial load
        // there needs to render page-size-options when it is not loaded already
        if (!PAGE_SIZE_SELECT) {
          this.renderPageSize();
          PAGE_SIZE_SELECT = root.querySelector(`.${PAGINATION.SIZE} select`);
        }
        // Either initializing or options have changed. (Re)Render the option elements here.  
        let options = "";
        for (let index = 0; index < pageSizeOptions.length; index++) {
          const option = pageSizeOptions[index];
          // for pageSizeOptions: [100, 500, 1000, "All"];
          const value = typeof option === "string" ? 0 : option;
          options += `<option value="${value}" ${pageSize === value ? 'selected' : ''}>${htmlEncode(option.toString())}</option>`;
        }
        PAGE_SIZE_SELECT.innerHTML = options;
      } else {
        // If pageSizeOptions is changed to null || undefined || "", it removes the element from DOM
        const PAGE_SIZE = root.querySelector(`.${PAGINATION.SIZE}`);
        if (PAGE_SIZE) PAGE_SIZE.remove();
      }
    }
  }
  updatePageCount(config) {
    const {
      page,
      pageSize,
      totalItems,
      root,
      _translation: translation,
      _renderedPageCount
    } = this;
    // updating showing Records Label
    let PAGE_COUNT = root.querySelector(`.${PAGINATION.COUNT}`);
    if (config.showRecordsDetail === true && !PAGE_COUNT) {
      // add count element if it doesn't exists 
      this.renderPageCount();
      PAGE_COUNT = root.querySelector(`.${PAGINATION.COUNT}`);
    } else if (config.showRecordsDetail === false && PAGE_COUNT) {
      // remove count element if it exists 
      PAGE_COUNT.remove();
      PAGE_COUNT = null;
    }
    if (PAGE_COUNT) {
      let itemsStart = PAGE_COUNT.querySelector('[data-items-start]');
      let itemsEnd = PAGE_COUNT.querySelector('[data-items-end]');
      let itemsTotal = PAGE_COUNT.querySelector('[data-items-total]');
      const start = (page - 1) * pageSize + 1;
      const end = Math.min(start + pageSize - 1, totalItems === 0 ? start + pageSize - 1 : totalItems);
      if (!itemsTotal && totalItems > 0 && _renderedPageCount) {
        PAGE_COUNT.innerHTML = this.renderPageCountHTML();
        itemsStart = PAGE_COUNT.querySelector('[data-items-start]');
        itemsEnd = PAGE_COUNT.querySelector('[data-items-end]');
        itemsTotal = PAGE_COUNT.querySelector('[data-items-total]');
      }
      if (itemsStart) {
        itemsStart.textContent = start.toString();
      }
      if (itemsEnd) {
        itemsEnd.textContent = end === 0 ? translation("all") : end.toString();
      }
      if (itemsTotal) {
        itemsTotal.textContent = totalItems === 0 ? translation("manyText") : totalItems.toString();
      }
    }
  }
  updatePageNumber() {
    const {
      root,
      page,
      totalItems,
      _translation: translation,
      _renderedPage
    } = this;
    const totalPages = getTotalPages(this);
    // Page Number Input
    const PAGE_NUMBER_INPUT = root.querySelector(`.${PAGINATION.PAGE_NUMBER} input`);
    if (PAGE_NUMBER_INPUT) {
      if (PAGE_NUMBER_INPUT.value !== page.toString()) {
        PAGE_NUMBER_INPUT.value = page.toString();
      }
      const maxValue = parseInt(PAGE_NUMBER_INPUT.max);
      if (maxValue !== totalPages) {
        if (totalItems > 0) {
          PAGE_NUMBER_INPUT.max = totalPages.toString();
        }
      }
      calculatePageInputWidth(this);
    }
    const PAGE_TOTAL = root.querySelector(`.${PAGINATION.PAGE_NUMBER} [data-total-pages]`);
    if (PAGE_TOTAL) {
      PAGE_TOTAL.textContent = totalPages === 0 ? translation("manyText") : totalPages.toString();
    } else if (totalPages > 0 && _renderedPage) {
      this.reRenderTotalPages(totalPages);
    }
    // update navigation buttons
    const previousBtn = root.querySelector(`.${PAGINATION.PREVIOUS_BTN}`);
    const nextBtn = root.querySelector(`.${PAGINATION.NEXT_BTN}`);
    // previous button - first page or second page and above
    if (previousBtn) {
      page > 1 ? previousBtn.removeAttribute('aria-disabled') : previousBtn.setAttribute('aria-disabled', 'true');
    }
    // next button - last page and below or last page
    if (nextBtn) {
      page < totalPages || totalPages === 0 ? nextBtn.removeAttribute('aria-disabled') : nextBtn.setAttribute('aria-disabled', 'true');
    }
  }
  reRenderTotalPages(totalPages) {
    // re-renders the page section to include total pages. Here, we need to maintain the exising input element because
    // listeners have already been added to it in bindPagination
    const {
      root,
      _pageTpl
    } = this;
    const PAGE_NUMBER = root.querySelector(`.${PAGINATION.PAGE_NUMBER}`);
    const PAGE_NUMBER_INPUT = PAGE_NUMBER && PAGE_NUMBER.querySelector('input');
    if (PAGE_NUMBER_INPUT && _pageTpl && _pageTpl.indexOf('{total}') > -1) {
      const html = htmlEncode(_pageTpl).replace("{total}", `<span data-total-pages>${totalPages}</span>`);
      const parts = html.split(/({page})/).map(s => {
        if (s === '{page}') {
          return PAGE_NUMBER_INPUT;
        }
        const span = document.createElement('span');
        span.innerHTML = s;
        return span;
      });
      PAGE_NUMBER.innerHTML = '';
      parts.forEach(part => PAGE_NUMBER.appendChild(part));
    }
  }
  updateAriaLabel() {
    if (this._setAriaLabel) {
      const {
        page,
        pageSize,
        showRecordsDetail,
        pageSizeOptions,
        _translation: translation,
        totalItems,
        host
      } = this;
      const totalPages = getTotalPages(this);
      const start = (page - 1) * pageSize + 1;
      const end = Math.min(start + pageSize - 1, totalItems === 0 ? start + pageSize - 1 : totalItems);
      const parts = [this._pageTpl.replace('{page}', page.toString()).replace('{total}', totalPages > 0 ? totalPages.toString() : translation("manyText"))];
      if (showRecordsDetail) {
        parts.push(this._recordsTpl.replace('{start}', start.toString()).replace('{end}', end.toString()).replace('{total}', totalItems === 0 ? translation("manyText") : totalItems.toString()));
      }
      if (pageSizeOptions && pageSizeOptions.length) {
        parts.push(this._pageSizeTpl.replace('{size}', pageSize.toString()));
      }
      host.setAttribute('aria-label', parts.join(', '));
    }
  }
}
class TablePagination {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY$2) || new _TablePaginationInstance(element);
    if (config) this.setConfig(config);
  }
  setConfig(config) {
    this._instance.setConfig(config);
  }
  get page() {
    return this._instance.page;
  }
  set page(value) {
    this._instance.page = value;
  }
  get pageSize() {
    return this._instance.pageSize;
  }
  set pageSize(value) {
    this._instance.pageSize = value;
  }
  get pageSizeOptions() {
    return this._instance.pageSizeOptions;
  }
  set pageSizeOptions(value) {
    this._instance.pageSizeOptions = value;
  }
  get showRecordsDetail() {
    return this._instance.showRecordsDetail;
  }
  set showRecordsDetail(value) {
    this._instance.showRecordsDetail = value;
  }
  get totalItems() {
    return this._instance.totalItems;
  }
  set totalItems(value) {
    this._instance.totalItems = value;
  }
  get pageTemplate() {
    return this._instance.pageTemplate;
  }
  set pageTemplate(value) {
    this._instance.pageTemplate = value;
  }
  get pageSizeTemplate() {
    return this._instance.pageSizeTemplate;
  }
  set pageSizeTemplate(value) {
    this._instance.pageSizeTemplate = value;
  }
  get recordsTemplate() {
    return this._instance.recordsTemplate;
  }
  set recordsTemplate(value) {
    this._instance.recordsTemplate = value;
  }
  get noAutoUpdate() {
    return this._instance.noAutoUpdate;
  }
  destroy() {
    const {
      _instance
    } = this;
    delete this._instance;
    return _instance.destroy();
  }
}
onDomChanges(`.${PATTERN_SELECTOR}`, function onPatternAdded(element) {
  if (!element.dataset[ENHANCED_FLAG]) {
    new TablePagination(element);
  }
}, function onPatternRemoved(element) {
  if (element.dataset[ENHANCED_FLAG] === "true") {
    new TablePagination(element).destroy();
  }
});

function createStore(el, cycle) {
  let hourValue = '',
    minuteValue = '',
    periodValue = '';
  if (el) {
    const inputs = el.querySelectorAll('input[data-time-part]');
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      const value = input.value;
      switch (input.dataset.timePart) {
        case 'hour':
          hourValue = value;
          break;
        case 'minute':
          minuteValue = value;
          break;
        case 'period':
          periodValue = value;
          break;
      }
    }
    if (!hourValue && !minuteValue && !periodValue) {
      // see if it it initialized using a hidden element
      const hiddenInput = el.querySelector('input[type="hidden"]');
      if (hiddenInput && hiddenInput.value && cycle) {
        const {
          parts: {
            hour12,
            hour24,
            minute,
            period
          }
        } = parseTime(hiddenInput.value);
        hourValue = cycle === '12' ? hour12 : hour24;
        minuteValue = minute;
        periodValue = cycle === '12' ? period : '';
      }
    }
  }
  return store({
    hourValue,
    minuteValue,
    periodValue,
    dialogOpenState: 'closed',
    onDialogClose: [],
    hasFocus: false
  });
}

const TRIGGER_SELECTOR = '[data-trigger="dialog"]';
const TimeParts = {
  Hour: 'hour',
  Minute: 'minute',
  Period: 'period'
};
const PART_ATTR = 'data-time-part';

function generateOptions(cycle, minuteIncrement) {
  const increment = isNaN(minuteIncrement) || minuteIncrement > 30 || minuteIncrement < 1 ? 1 : minuteIncrement;
  const getMinutes = increment => {
    const minutes = [];
    for (let i = 0; i < 60; i = i + increment) {
      minutes.push(to2Digits$1(i));
    }
    return minutes;
  };
  return [new Array(parseInt(cycle, 10)).fill(undefined).map((_, i) => to2Digits$1(cycle === '12' ? i + 1 : i)), getMinutes(increment), cycle === '12' ? ['AM', 'PM'] : []];
}
function getValueAsDate(timeInput, state) {
  var _parseTime;
  const {
    cycle
  } = timeInput;
  const {
    hourValue,
    minuteValue,
    periodValue
  } = state ?? timeInput.state;
  return hourValue && minuteValue && (cycle === '24' || periodValue) ? (_parseTime = parseTime(`${hourValue}:${minuteValue}${periodValue}`)) === null || _parseTime === void 0 ? void 0 : _parseTime.date : null;
}
function getValue(timeInput, state) {
  const date = getValueAsDate(timeInput, state);
  if (date) {
    return new Intl.DateTimeFormat(getLang(timeInput.el), {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).format(date);
  }
  return getDisplayValue(timeInput, state);
}
function getDisplayValue(timeInput, state) {
  const {
    hourValue,
    minuteValue,
    periodValue
  } = state ?? timeInput.state;
  const {
    cycle
  } = timeInput;
  return hourValue || minuteValue || cycle === '12' && periodValue ? `${hourValue}:${minuteValue}${cycle === '12' && periodValue ? ` ${periodValue}` : ''}` : '';
}
function getValidityState(timeInput, value) {
  const {
    config: {
      min,
      max,
      required,
      restrictMinutes,
      minuteIncrement
    },
    dialog,
    cycle
  } = timeInput;
  return getTimeValidity(value, {
    min,
    max,
    required,
    minuteIncrement: dialog && restrictMinutes ? minuteIncrement : -1,
    cycle
  });
}

const directionMap = {
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right'
};
function moveFocus(el, direction) {
  let next;
  if (direction === 'up' || direction === 'down') {
    next = el[direction === 'up' ? 'previousElementSibling' : 'nextElementSibling'];
  } else {
    const nextParentSibling = el.parentElement[direction === 'left' ? 'previousElementSibling' : 'nextElementSibling'];
    next = (nextParentSibling === null || nextParentSibling === void 0 ? void 0 : nextParentSibling.tagName) === 'UL' ? nextParentSibling.querySelector('[tabindex="0"]') : null;
  }
  if (next) {
    maintainScrollVisibility(next, next.parentElement, true);
    next.focus({
      preventScroll: true
    });
  }
  return next;
}
function updateTimePart(el, store) {
  const part = el.parentElement.dataset.part;
  store.update(state => {
    const newState = {
      ...state
    };
    newState[`${part}Value`] = el.innerHTML;
    newState.changeMethod = 'dialog';
    return newState;
  });
}
function keydownHandler$1(timePicker) {
  const {
    store
  } = timePicker;
  return event => {
    const key = normalizeKey(event);
    const {
      target
    } = event;
    if (target instanceof Element) {
      if (target.tagName === 'LI') {
        const direction = directionMap[key];
        if (direction) {
          event.preventDefault();
          const next = moveFocus(target, direction);
          if (next) updateTimePart(next, store);
        }
      }
    }
  };
}
function clickHandler(timePicker) {
  const {
    store
  } = timePicker;
  return event => {
    const {
      target
    } = event;
    if (target instanceof Element) {
      if (target.tagName === 'LI') {
        updateTimePart(target, store);
      }
    }
  };
}
function makeClosestMinuteFocusable(list, value) {
  const childrenArr = Array.from(list.children);
  const diffs = childrenArr.map(child => Math.abs(parseInt(child.innerHTML, 10) - (parseInt(value, 10) || 0)));
  const lowest = Math.min(...diffs);
  childrenArr.forEach((child, i) => {
    if (i === diffs.indexOf(lowest)) {
      child.setAttribute('tabindex', '0');
    }
  });
}
function updateActiveOption(el, part, value, className) {
  const list = el.querySelector(`[data-part="${part}"]`);
  if (list) {
    const item = Array.from(list.children).find(child => child.innerHTML === value);
    const currentActive = list.querySelector('[tabindex="0"]');
    currentActive === null || currentActive === void 0 ? void 0 : currentActive.classList.remove(className);
    currentActive === null || currentActive === void 0 ? void 0 : currentActive.setAttribute('tabindex', '-1');
    currentActive === null || currentActive === void 0 ? void 0 : currentActive.setAttribute('aria-selected', 'false');
    if (item) {
      item.setAttribute('tabindex', '0');
      item.classList.add(className);
      item.setAttribute('aria-selected', 'true');
    } else {
      if (part === TimeParts.Minute) {
        makeClosestMinuteFocusable(list, value);
      } else {
        list.firstElementChild.setAttribute('tabindex', '0');
      }
    }
  }
}
function focusOnFirstList(el, store) {
  const lists = hasShadowDom(el) ? el.shadowRoot.querySelectorAll('ul') : el.querySelectorAll('ul');
  const activeItems = Array.from(lists).map(list => list.querySelector('[aria-selected="true"]'));
  const itemToFocus = activeItems[0] ?? lists[0].querySelector(`[tabindex="0"]`);
  activeItems.forEach(item => {
    if (item) maintainScrollVisibility(item, item.parentElement, true, true);
  });
  itemToFocus === null || itemToFocus === void 0 ? void 0 : itemToFocus.focus({
    preventScroll: true
  });
  updateTimePart(itemToFocus, store);
}
function bindTimePicker(timePicker) {
  const {
    el
  } = timePicker;
  const eventListeners = new EventListeners();
  eventListeners.addListener(el, 'keydown', keydownHandler$1(timePicker));
  eventListeners.addListener(el, 'click', clickHandler(timePicker));
  return () => {
    eventListeners.removeListeners();
  };
}

const TIME_FORMAT_HINT_SELECTOR = `[data-time-format-label]:not([data-time-format-label="done"])`;
const DIALOG_ANIM_TIMING = 200; // this should match $a-dialog-transition-duration in time-input.yml
/////////////////////////////////////////////////////
// - exports
function bindTimeInput(timeInput) {
  const {
    el,
    store,
    dialog
  } = timeInput;
  const inputs = getInputs(timeInput);
  inputs.forEach(input => {
    if (input.dataset.timePart === TimeParts.Period && timeInput.cycle === '24') {
      input.hidden = true;
    }
  });
  setFormatHints(timeInput);
  getA11ySpan(timeInput);
  const eventListeners = new EventListeners();
  eventListeners.addListener(el, 'paste', pasteHandler(timeInput));
  eventListeners.addListener(el, 'input', inputHandler(timeInput, inputs));
  eventListeners.addListener(el, 'change', changeHandler(timeInput, inputs));
  eventListeners.addListener(el, 'keydown', keydownHandler(timeInput));
  eventListeners.addListener(el, 'keyup', keyupHandler(timeInput));
  eventListeners.addListener(el, 'focusin', focusHandler(timeInput));
  const manageFocusState = debounce(() => {
    setFocusState(timeInput);
  }, 100, false);
  eventListeners.addListener(el, 'focusin', manageFocusState);
  eventListeners.addListener(el, 'focusout', manageFocusState);
  const trigger = getDialogTrigger(timeInput);
  if (trigger) {
    eventListeners.addListener(trigger, 'click', triggerHandler(timeInput));
  }
  eventListeners.addListener(document, 'click', documentClickHandler(timeInput));
  if (dialog) {
    eventListeners.addListener(dialog, 'keydown', dialogKeydownHandler(timeInput));
    eventListeners.addListener(dialog, 'focusin', manageFocusState);
    eventListeners.addListener(dialog, 'focusout', manageFocusState);
    // stop propagation of these events to prevent loss focus handlers when used as editable table cell editor
    eventListeners.addListener(dialog, 'mousedown', stopPropagation);
    eventListeners.addListener(dialog, 'touchstart', stopPropagation);
    eventListeners.addListener(dialog, 'click', stopPropagation);
  }
  const unsubscribe = store.subscribe(onStateUpdate(timeInput));
  const hiddenInput = getHiddenInput(timeInput);
  if (hiddenInput && !hiddenInput.value) {
    syncHiddenRelatedElements(timeInput);
  }
  const unbind = () => {
    eventListeners.removeListeners();
    unsubscribe();
    timeInput.state.onDialogClose.forEach(f => f());
    timeInput.store.update(state => ({
      ...state,
      onDialogClose: []
    }));
  };
  return unbind;
}
function setDateValue(value, timeInput) {
  setValue(value, timeInput, 'api');
}
///////////////////////////////////////////////////////////
// - internal functions
function setValue(value, timeInput, changeMethod) {
  const {
    cycle,
    store
  } = timeInput;
  let hourValue = '';
  let minuteValue = '';
  let periodValue = '';
  let valid = false;
  if (value instanceof Date) {
    if (cycle === '12') {
      if (value.getHours() === 0 || value.getHours() > 12) {
        hourValue = to2Digits$1(Math.abs(value.getHours() - 12));
      }
      periodValue = value.getHours() >= 12 ? 'PM' : 'AM';
    } else {
      hourValue = to2Digits$1(value.getHours());
    }
    minuteValue = to2Digits$1(value.getMinutes());
    valid = true;
  } else {
    const parsed = parseTime(value);
    if (parsed !== null && parsed !== void 0 && parsed.parts) {
      const {
        parts: {
          hour12,
          hour24,
          minute,
          period
        }
      } = parsed;
      hourValue = cycle === '12' ? hour12 : hour24;
      minuteValue = minute;
      periodValue = cycle === '12' ? period : '';
      valid = !!(hourValue || minuteValue || periodValue);
    }
  }
  store.update(state => ({
    ...state,
    hourValue,
    minuteValue,
    periodValue,
    changeMethod
  }));
  return valid;
}
function setFormatHints(timeInput) {
  const hintLabels = document.querySelectorAll(TIME_FORMAT_HINT_SELECTOR);
  for (let i = 0; i < hintLabels.length; i++) {
    const hintLabel = hintLabels[i];
    hintLabel.innerText = `(--:--${timeInput.cycle === '12' ? ' --' : ''})`;
    hintLabel.setAttribute('aria-label', `hour minute${timeInput.cycle === '12' ? ' AM PM' : ''}`);
    hintLabel.setAttribute('data-time-format-label', 'done');
  }
}
function getHiddenInput(timeInput) {
  const {
    el,
    host
  } = timeInput;
  const selector = 'input[type="hidden"]';
  return el.querySelector(selector) ?? (host === null || host === void 0 ? void 0 : host.querySelector(selector));
}
function getA11ySpan(timeInput) {
  const container = timeInput.el;
  let a11ySpan = container.querySelector(`[data-a11y="true"]`);
  if (!a11ySpan) {
    a11ySpan = document.createElement('span');
    a11ySpan.setAttribute('aria-live', 'assertive');
    a11ySpan.dataset.a11y = 'true';
    a11ySpan.classList.add(`${CSS_NS}sr-only`);
    container.appendChild(a11ySpan);
  }
  return a11ySpan;
}
////////////////////////////////////////////////
// - calendar actions
function toggleDialog(timeInput) {
  if (isDialogOpenState(timeInput, 'opened')) {
    closeDialog(timeInput);
  }
  if (isDialogOpenState(timeInput, 'closed')) {
    openDialog(timeInput);
  }
}
function openDialog(timeInput) {
  const {
    store
  } = timeInput;
  if (!isDialogOpenState(timeInput, 'opened', 'opening')) {
    // Setting dialogOpenState to 'ready-open' puts the calendar in a state
    // ready to transition open. As there is no other reference this state
    // in the code, this may be unclear. It basically makes the calendar "not closed"
    // which effectively changes the CSS display from 'none' to 'block' but keeps
    // visibility to hidden.
    store.update(v => {
      return {
        ...v,
        dialogOpenState: 'ready-open'
      };
    });
    // timeout is used to let 'display:block' establish before transitioning from hidden to visible
    setTimeout(() => {
      store.update(v => {
        return {
          ...v,
          dialogOpenState: 'opening'
        };
      });
      setTimeout(() => {
        store.update(state => ({
          ...state,
          dialogOpenState: 'opened'
        }));
      }, DIALOG_ANIM_TIMING);
    }, 50);
  }
}
function closeDialog(timeInput) {
  const {
    store
  } = timeInput;
  if (isDialogOpenState(timeInput, 'opened')) {
    store.update(v => {
      return {
        ...v,
        dialogOpenState: 'closing'
      };
    });
    setTimeout(() => {
      store.update(state => ({
        ...state,
        dialogOpenState: 'closed'
      }));
    }, DIALOG_ANIM_TIMING);
  }
}
function onDialogReadyOpen(timeInput) {
  const {
    dialog,
    el,
    store
  } = timeInput;
  const destroyPopover = createPopover(dialog, el, {
    transitionEnterTimeout: 0,
    transitionLeaveTimeout: 0,
    placement: 'bottom-start'
  });
  store.update(state => ({
    ...state,
    onDialogClose: [...state.onDialogClose, destroyPopover],
    previousHour: state.hourValue,
    previousMinute: state.minuteValue,
    previousPeriod: state.periodValue
  }));
}
function onDialogOpening(timeInput) {
  focusOnFirstList(timeInput.dialog, timeInput.store);
}
function onDialogOpened(timeInput) {
  const uncontainTabFocus = containTabFocus(timeInput.dialog);
  timeInput.store.update(state => ({
    ...state,
    onDialogClose: [...state.onDialogClose, uncontainTabFocus]
  }));
}
function onDialogClosing(timeInput) {
  const trigger = getDialogTrigger(timeInput);
  if (trigger) {
    const {
      dialog
    } = timeInput;
    let focusedEl = dialog.querySelector(':focus');
    if (!focusedEl && hasShadowDom(dialog)) {
      focusedEl = dialog.shadowRoot.querySelector(':focus');
    }
    // only focus on trigger if focus is inside dialog
    if (focusedEl) {
      trigger.focus();
    }
  }
}
function onDialogClosed(timeInput) {
  const {
    store,
    state
  } = timeInput;
  state.onDialogClose.forEach(f => f());
  store.update(state => ({
    ...state,
    onDialogClose: []
  }));
}
function getDialogTrigger(timeInput) {
  return timeInput.el.querySelector(TRIGGER_SELECTOR);
}
//////////////////////////////////////////////////
// - event handlers
function inputHandler(timeInput, inputs) {
  return event => {
    if (event.target instanceof HTMLInputElement && inputs.indexOf(event.target) > -1) {
      applyTimeInputUpdate(timeInput);
    }
  };
}
function changeHandler(timeInput, inputs) {
  return event => {
    if (event.target instanceof HTMLInputElement && inputs.indexOf(event.target) > -1) {
      const input = event.target;
      const state = timeInput.state;
      const value = input.value;
      const resolvedValue = value && input.dataset.timePart !== TimeParts.Period ? to2Digits$1(value) : value;
      if (resolvedValue !== value) {
        input.value = resolvedValue;
      }
      if (state[`${input.dataset.timePart}Value`] !== resolvedValue) {
        applyTimeInputUpdate(timeInput);
      }
    }
  };
}
function keydownHandler(timeInput) {
  return event => {
    const {
      target
    } = event;
    if (target instanceof HTMLInputElement) {
      const key = normalizeKey(event);
      const inputs = getInputs(timeInput);
      const inputIX = inputs.indexOf(target);
      if (inputIX > -1 && !target.disabled && !target.readOnly && !(target.getAttribute('aria-disabled') === 'true') && !(target.getAttribute('aria-readonly') === 'true')) {
        const nextInput = inputs[inputIX + 1];
        const prevInput = inputs[inputIX - 1];
        switch (key) {
          case ':':
            event.preventDefault();
            if (target === inputs[0] && target.value.length && target.selectionStart === target.value.length) {
              if (nextInput) {
                nextInput.focus();
                nextInput.select();
              }
            }
            break;
          case 'ArrowLeft':
            if (prevInput && target.selectionStart === 0) {
              prevInput.focus();
              prevInput.selectionStart = prevInput.value.length;
              event.preventDefault();
            }
            break;
          case 'ArrowRight':
            if (nextInput && target.selectionStart === target.value.length) {
              nextInput.focus();
              nextInput.selectionStart = 0;
              event.preventDefault();
            }
            break;
          case 'ArrowUp':
          case 'ArrowDown':
          case 'Home':
          case 'End':
            event.preventDefault();
            if (target.dataset.timePart !== TimeParts.Period) {
              incrementTimeField(key, target, timeInput);
            }
            break;
          case 'Backspace':
            //if backspacing from 2nd or 3rd empty input, shift focus to previous input
            if (prevInput && target.value.length === 0) {
              prevInput.focus();
              prevInput.selectionStart = prevInput.value.length;
              // by not preventing default, backspace will continue at start of previous field
            }

            break;
          default:
            {
              if (isTyping(event)) {
                if (target.dataset.timePart !== TimeParts.Period && !key.match(/\d/)) {
                  event.preventDefault();
                }
                if (target.dataset.timePart === TimeParts.Period) {
                  if (!key.match(/A|P/i)) {
                    event.preventDefault();
                  } else {
                    event.preventDefault();
                    target.value = key.match(/A/i) ? 'AM' : 'PM';
                    applyTimeInputUpdate(timeInput);
                  }
                }
              }
            }
        }
      }
    }
  };
}
function resetValue(timeInput) {
  timeInput.store.update(state => ({
    ...state,
    hourValue: state.previousHour,
    minuteValue: state.previousMinute,
    periodValue: state.previousPeriod
  }));
}
function dialogKeydownHandler(timeInput) {
  return event => {
    const key = normalizeKey(event);
    if (key === 'Enter' || key === ' ' || key === 'Escape') {
      closeDialog(timeInput);
    }
    if (key === 'Escape') {
      resetValue(timeInput);
      event.stopPropagation();
    }
  };
}
function incrementTimeField(key, input, timeInput) {
  let inputValue = input.value ? parseInt(input.value, 10) : timeInput.cycle === '12' ? 0 : -1;
  let maxValue;
  let minValue;
  if (input.dataset.timePart === TimeParts.Hour) {
    if (timeInput.cycle === '12') {
      maxValue = 12;
      minValue = 1;
    } else {
      maxValue = 23;
      minValue = 0;
    }
  }
  if (input.dataset.timePart === TimeParts.Minute) {
    minValue = 0;
    maxValue = 59;
  }
  switch (key) {
    case 'ArrowUp':
      if (inputValue < maxValue) {
        inputValue++;
      }
      break;
    case 'ArrowDown':
      if (inputValue > minValue) {
        inputValue--;
      }
      break;
    case 'Home':
      inputValue = minValue;
      break;
    case 'End':
      inputValue = maxValue;
      break;
  }
  const value = !isNaN(inputValue) ? to2Digits$1(inputValue) : '';
  if (value !== input.value) {
    input.value = value;
    applyTimeInputUpdate(timeInput);
  }
}
function applyTimeInputUpdate(timeInput) {
  const {
    store
  } = timeInput;
  const inputs = getInputs(timeInput);
  const updates = {};
  inputs.forEach(input => updates[`${input.dataset.timePart}Value`] = input.value.trim());
  store.update(v => {
    return {
      ...v,
      ...updates,
      changeMethod: 'input'
    };
  });
}
function keyupHandler(timeInput) {
  return event => {
    const target = event.target;
    const inputs = getInputs(timeInput);
    const inputIX = inputs.indexOf(target);
    const key = normalizeKey(event);
    if (inputIX > -1) {
      const nextInput = inputs[inputIX + 1];
      if (key.match(/\d/) && target.selectionStart === target.maxLength && nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  };
}
function triggerHandler(timeInput) {
  return () => {
    const trigger = getDialogTrigger(timeInput);
    if (trigger && !trigger.closest('[aria-disabled="true"]')) {
      toggleDialog(timeInput);
    }
  };
}
function onStateUpdate(timeInput) {
  let prevState = null;
  return state => {
    const oldState = prevState;
    prevState = state;
    onDateUpdate(timeInput, state, oldState);
    onDialogUpdate(timeInput, state, oldState);
  };
}
function onDateUpdate(timeInput, state, oldState) {
  const events = [];
  if (oldState) {
    const {
      hourValue = '',
      minuteValue = '',
      periodValue = ''
    } = state;
    const {
      hourValue: oldHour = '',
      minuteValue: oldMinute = '',
      periodValue: oldPeriod = ''
    } = oldState;
    if (hourValue === oldHour && minuteValue === oldMinute && periodValue === oldPeriod) {
      return;
    }
    syncHiddenRelatedElements(timeInput, state);
    const changeMethod = state.changeMethod || 'api';
    events.push(['change', {
      detail: {
        timeInput: timeInput,
        changeMethod
      }
    }]);
    const validity = getValidityState(timeInput, getDisplayValue(timeInput, state));
    const oldValidity = getValidityState(timeInput, getDisplayValue(timeInput, oldState));
    const props = Object.keys(validity).concat(Object.keys(oldValidity));
    const changed = props.find(prop => oldValidity[prop] !== validity[prop]);
    if (changed) {
      events.push([validity.valid ? 'valid' : 'invalid', {
        detail: {
          validity: validity
        }
      }]);
    }
    events.forEach(_ref => {
      let [type, eventInit] = _ref;
      timeInput.sendEvent(type, eventInit);
    });
  }
}
function onDialogUpdate(timeInput, state, oldState) {
  if (oldState && oldState.dialogOpenState !== state.dialogOpenState) {
    let eventType;
    switch (state.dialogOpenState) {
      case 'ready-open':
        onDialogReadyOpen(timeInput);
        break;
      case 'opening':
        eventType = 'dialogopening';
        onDialogOpening(timeInput);
        break;
      case 'opened':
        eventType = 'dialogopened';
        onDialogOpened(timeInput);
        break;
      case 'closing':
        eventType = 'dialogclosing';
        onDialogClosing(timeInput);
        break;
      case 'closed':
        eventType = 'dialogclosed';
        onDialogClosed(timeInput);
        break;
    }
    if (eventType) {
      timeInput.sendEvent(eventType);
    }
  }
}
function pasteHandler(timeInput) {
  return event => {
    if (event.target instanceof HTMLInputElement) {
      const {
        target
      } = event;
      const inputs = getInputs(timeInput);
      const order = inputs.indexOf(target);
      if (order === 0 && !target.disabled && !target.readOnly && !(target.getAttribute('aria-disabled') === 'true') && !(target.getAttribute('aria-readonly') === 'true')) {
        if (event.clipboardData) {
          event.preventDefault();
          const text = event.clipboardData.getData('text');
          setTimeout(() => {
            const valid = setValue(text, timeInput, 'paste');
            // if valid date, focus on end of date, else focus on beginning
            const focusOn = valid ? inputs[2] : inputs[0];
            focusOn.focus();
            const cursorPos = valid ? focusOn.maxLength || focusOn.value.length : 0;
            focusOn.setSelectionRange(cursorPos, cursorPos);
          }, 0);
        }
      } else if (order > -1) {
        event.preventDefault();
      }
    }
  };
}
function focusHandler(timeInput) {
  // todo: needed if we have contrain focus and document click handler?
  return _ref2 => {
    let {
      target
    } = _ref2;
    if (isDialogOpenState(timeInput, 'opening', 'opened')) {
      const inputs = getInputs(timeInput);
      if (inputs.indexOf(target) > -1) {
        closeDialog(timeInput);
      }
    }
  };
}
function documentClickHandler(timeInput) {
  /**
   * Checks for clicks outside of the date input component to close the calendar
   * Checks inside the component handled by next handler
   */
  return event => {
    const {
      target
    } = event;
    if (isDialogOpenState(timeInput, 'opened')) {
      if (!timeInput.el.contains(target) && !timeInput.dialog.contains(target)) {
        closeDialog(timeInput);
      }
    }
  };
}
function syncHiddenRelatedElements(timeInput, state) {
  const hiddenInput = getHiddenInput(timeInput);
  if (hiddenInput) {
    hiddenInput.value = getValue(timeInput, state);
  }
  const a11ySpan = getA11ySpan(timeInput);
  if (a11ySpan) {
    const date = getValueAsDate(timeInput, state);
    a11ySpan.innerText = date ? Intl.DateTimeFormat(getLang(timeInput.el), {
      hourCycle: timeInput.cycle === '12' ? 'h12' : 'h23',
      timeStyle: 'short'
    }).format(date) : '';
  }
}
function isDialogOpenState(timeInput) {
  const {
    state
  } = timeInput;
  for (var _len = arguments.length, openState = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    openState[_key - 1] = arguments[_key];
  }
  const result = openState.find(s => s === state.dialogOpenState);
  return !!result;
}
////////////////////////////////////////////////
// - Helper functions
function getInputs(timeInput) {
  return Array.from(timeInput.el.querySelectorAll(`[${PART_ATTR}="${TimeParts.Hour}"],[${PART_ATTR}="${TimeParts.Minute}"],[${PART_ATTR}="${TimeParts.Period}"]`));
}
function setFocusState(timeInput) {
  const {
    dialog,
    state,
    store,
    el
  } = timeInput;
  let focusedEl = el.querySelector(':focus');
  if (!focusedEl && dialog) {
    const dialogRoot = hasShadowDom(dialog) ? dialog.shadowRoot : dialog;
    focusedEl = dialogRoot.querySelector(':focus');
  }
  const hasFocus = !!focusedEl;
  if (hasFocus !== state.hasFocus) {
    const eventType = hasFocus ? 'tdsFocus' : 'tdsBlur';
    timeInput.sendEvent(eventType, {
      cancelable: false,
      bubbles: true
    });
    store.update({
      hasFocus
    });
  }
}
function stopPropagation(event) {
  event.stopPropagation();
}

const BASE_CLASS = `${CSS_NS}time-picker`;
const LIST_CLASS = `${BASE_CLASS}__list`;
const ITEM_CLASS = `${LIST_CLASS}-item`;
const INSTANCE_KEY$1 = `${NAMESPACE}TimePicker`;
const ACTIVE_CLASS = `${LIST_CLASS}-item--active`;
class _TimePickerInstance {
  constructor(element, config, store) {
    this.onDestroy = [];
    this.el = element;
    this.config = config;
    this.store = store ?? createStore();
    instances$1.set(this.el, INSTANCE_KEY$1, this);
    this.render();
    this.onDestroy.push(this.store.subscribe(this.onStateUpdate.bind(this)));
    this.onDestroy.push(bindTimePicker(this));
  }
  onStateUpdate(state) {
    const {
      hourValue,
      minuteValue,
      periodValue
    } = state;
    updateActiveOption(this.el, TimeParts.Hour, hourValue, ACTIVE_CLASS);
    updateActiveOption(this.el, TimeParts.Minute, minuteValue, ACTIVE_CLASS);
    updateActiveOption(this.el, TimeParts.Period, periodValue, ACTIVE_CLASS);
  }
  render() {
    const {
      t
    } = translations(this.el);
    const options = generateOptions(this.config.cycle, this.config.minuteIncrement);
    this.el.classList.add(BASE_CLASS);
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-label', t('timePicker'));
    options.forEach((set, i) => {
      if (set.length) {
        const list = document.createElement('ul');
        const part = Object.values(TimeParts)[i];
        list.classList.add(LIST_CLASS);
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-label', t(part));
        list.dataset.part = part;
        set.forEach((option, i) => {
          const item = document.createElement('li');
          item.classList.add(ITEM_CLASS);
          item.innerHTML = option;
          item.setAttribute('tabindex', i === 0 ? '0' : '-1');
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          if (option[0] === '0') item.setAttribute('aria-label', option[1]);
          list.appendChild(item);
        });
        this.el.appendChild(list);
      }
    });
  }
  focus() {
    focusOnFirstList(this.el, this.store);
  }
  destroy() {
    while (this.onDestroy.length) {
      this.onDestroy.pop()();
    }
    instances$1.remove(this.el, INSTANCE_KEY$1);
    this.el = this.store = this.config = null;
  }
}
class TimePicker {
  constructor(element, config, store) {
    this._instance = instances$1.get(element, INSTANCE_KEY$1) || new _TimePickerInstance(element, config, store);
  }
  focus() {
    this._instance.focus();
  }
  destroy() {
    if (this._instance) {
      this._instance.destroy();
      delete this._instance;
    }
  }
}

const DIALOG_CLASS = `${CSS_NS}time-picker`;
const TIME_INPUT_CLASS = `${CSS_NS}time-input`;
const WITH_DIALOG_CLASS = `${TIME_INPUT_CLASS}--with-dialog`;
const HAS_FOCUS_CLASS = `${TIME_INPUT_CLASS}--focus-within`;
const INSTANCE_KEY = `${NAMESPACE}TimeInput`;
let nextId = 1;
class _TimeInputInstance {
  constructor(element) {
    this.onDestroy = [];
    this.el = element;
    this.setConfig(configFromDataAttributes(element, {}, [{
      names: ['minuteIncrement'],
      convert: 'integer'
    }]));
    this.store = createStore(element, this.cycle);
    element.dataset.enhancedTime = 'true';
    // it is important that subscribe occurs before bind so that, when behavior throws a change event
    // when the store updates, this module will have the current state when calling get value or valueAsDate
    const unsubscribe = this.store.subscribe(this.onStateUpdate.bind(this));
    const unbind = bindTimeInput(this);
    this.onDestroy = [unbind, unsubscribe];
    instances$1.set(element, INSTANCE_KEY, this);
    const trigger = element.querySelector(TRIGGER_SELECTOR);
    if (trigger) {
      trigger.hidden = false;
      element.classList.add(WITH_DIALOG_CLASS);
    }
    const dialogEl = trigger && getTargetElement(trigger) || element.querySelector(`.${DIALOG_CLASS}`);
    if (dialogEl) {
      dialogEl.hidden = true;
    }
  }
  get dialog() {
    return this._dialog || (this._dialog = getDialogElement(this));
  }
  get cycle() {
    return this.config.useLocaleCycle ? getLocale(this.el).hourCycle : !!this.el.querySelector(`[${PART_ATTR}=${TimeParts.Period}]`) ? '12' : '24';
  }
  setConfig() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const currentConfig = this.config || {};
    this.config = this.configureRequired({
      ...currentConfig,
      ...config
    });
  }
  configureRequired(config) {
    const inputs = Array.from(this.el.querySelectorAll(`[${PART_ATTR}]`));
    // this logic accounts for required being set to false afterwards
    // assuming if any input is required, the date is required. Not getting into complexity of only some inputs required
    const required = typeof config.required === 'boolean' ? config.required : !!inputs.find(input => input.required);
    inputs.forEach(input => input.required = required);
    return {
      ...config,
      required
    };
  }
  get value() {
    return getValue(this);
  }
  set value(value) {
    setDateValue(value || '', this);
  }
  get valueAsDate() {
    return getValueAsDate(this);
  }
  get isValid() {
    return getValidityState(this, getDisplayValue(this)).valid;
  }
  get validity() {
    return getValidityState(this, getDisplayValue(this));
  }
  toReadableTime() {
    return this.valueAsDate ? new Intl.DateTimeFormat(getLang(this.el), {
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: this.cycle === '12' ? 'h12' : 'h23'
    }).format(this.valueAsDate) : null;
  }
  onStateUpdate(state) {
    const {
      el
    } = this;
    const prevState = this.state;
    this.state = state;
    const trigger = this.el.querySelector(TRIGGER_SELECTOR);
    const dialog = this.dialog;
    if (dialog) {
      dialog.hidden = state.dialogOpenState === 'closed';
      dialog.dataset.dialogOpenState = state.dialogOpenState;
    }
    const expanded = `${state.dialogOpenState === 'opening' || state.dialogOpenState === 'opened'}`;
    if (trigger) {
      if (expanded !== trigger.getAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', expanded);
      }
    }
    el.classList[state.hasFocus ? 'add' : 'remove'](HAS_FOCUS_CLASS);
    const parts = Object.values(TimeParts);
    parts.forEach(part => {
      const input = el.querySelector(`[${PART_ATTR}="${part}"]`);
      const value = state[`${part}Value`];
      const prevValue = prevState === null || prevState === void 0 ? void 0 : prevState[`${part}Value`];
      if (value !== prevValue && input && input.value !== value) {
        input.value = value;
      }
    });
    const validity = getValidityState(this, getDisplayValue(this));
    const validityErrors = Object.keys(validity).filter(key => key !== 'valid' && validity[key]).join();
    if (validityErrors) {
      el.dataset.validity = validityErrors;
    } else {
      el.removeAttribute('data-validity');
    }
  }
  sendEvent(eventType, eventInit) {
    return this.el.dispatchEvent(createCustomEvent(eventType, eventInit));
  }
  destroy() {
    while (this.onDestroy && this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.el) {
      delete this.el.dataset.enhancedTime;
    }
    instances$1.remove(this.el, INSTANCE_KEY);
    this.el = this.state = this.store = this._dialog = this.config = null;
  }
}
/////////////////////////////////////////////////////////////////
// - helper functions
function getDialogElement(timeInput) {
  const container = timeInput.el;
  let dialogEl = null;
  let trigger = container.querySelector(TRIGGER_SELECTOR);
  if (trigger) {
    dialogEl = getTargetElement(trigger) || container.querySelector(`.${DIALOG_CLASS}`);
    if (!dialogEl) {
      dialogEl = document.createElement('div');
      new TimePicker(dialogEl, {
        cycle: timeInput.cycle,
        minuteIncrement: timeInput.config.minuteIncrement
      }, timeInput.store);
      container.appendChild(dialogEl);
    }
    if (!dialogEl.id) {
      dialogEl.id = container.id ? `${container.id}__${DIALOG_CLASS}` : `${DIALOG_CLASS}-${nextId++}`;
    }
    trigger.setAttribute('aria-controls', dialogEl.id);
    dialogEl.hidden = true;
  }
  return dialogEl;
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////
onDomChanges(`.${TIME_INPUT_CLASS}`, function onTimeInputAdded(element) {
  if (!element.dataset.enhancedTime) {
    new _TimeInputInstance(element);
  }
}, function onTimeInputRemoved(element) {
  if (element.dataset.enhancedTime === 'true') {
    new TimeInput(element).destroy();
  }
});
// ////////////////////////////////////////////////////////////////////////////////////////////////////////
class TimeInput {
  constructor(element, config) {
    this._instance = instances$1.get(element, INSTANCE_KEY) || new _TimeInputInstance(element);
    if (config) {
      this.setConfig(config);
    }
  }
  setConfig(config) {
    this._instance.setConfig(config);
  }
  get value() {
    return this._instance.value;
  }
  set value(date) {
    this._instance.value = date;
  }
  get valueAsDate() {
    return this._instance.valueAsDate;
  }
  get isValid() {
    return this._instance.isValid;
  }
  get validity() {
    return this._instance.validity;
  }
  toReadableTime() {
    return this._instance.toReadableTime();
  }
  destroy() {
    if (this._instance) {
      this._instance.destroy();
      delete this._instance;
    }
  }
}

const EDIT_MODE_SELECTOR = 'table[data-edit-mode]';
const CELL_EDITABLE_ATTR = 'data-editable';
const COLUMN_EDITABLE_ATTR = 'data-editable';
const CELL_CONTENT_BKUP_ATTR = 'data-cell-content-backup';
const EDIT_PANEL_ATTR = 'data-cell-editor-panel';
const EDIT_CONTROL_CONTAINER_ATTR = 'data-cell-editor-control-container';
const EDIT_PANEL_MESSAGE_CLASS = 'tds-cell-editor__message';
const EDIT_PANEL_BASE_ID = '__tds-cell-editor-';
const EDITOR_HAS_FOCUS_ATTR = 'data-editor-has-focus';
const EDIT_VALUE_ATTR = 'data-edit-value';
const CELL_IN_ERROR_ATTR = 'data-in-error';
const ROW_EDIT_ACTION_ATTR = 'data-row-edit-action';
const ROW_EDIT_ACTIONS_ATTR = 'data-row-edit-actions';
// these probably should be independent of editing
const DATA_TABLE_COLUMN_ROW_PROP_ATTR = 'data-row-property';
const DATA_TABLE_ROW_ID_ATTR = 'data-row-id';

/**
 * Manages the display of error messages as tooltips. The intent is to only show one error
 * message at a time when a cell in error is "activated", meaning if is focused or hovered
 * only.
 * When a cell in error is "activated", hides current error message if application, then shows error message.
 * When an error message is shown, uses the 'onFocusHover' utility to detect when both cell and error message
 * are no longer "active" and hides the popover.
 *
 * In the original implementation, it was possible for 2 error messages to appear at once when one cell had
 * focus and another cell was hovered. This implementation only allows one error message to be shown at a time.
 * Additionally, if a cell in error has focus, and its error message is hidden when another cell in error is
 * hovered, the error message for the cell in focus will not be shown, even though it still has focus,
 * until it is hovered over.
 * @param table The table element to monitor
 * @returns A function to remove listeners
 */
const CHECK_POPOVER_STATE_EVENT = '__tdsCheckErrorPopover__';
const manageErrorPopovers = table => {
  let destroyPopover;
  let popoverCell;
  let offFocusHover;
  const eventListeners = new EventListeners();
  eventListeners.addListener(table, 'mouseover', onHoverFocusIn);
  eventListeners.addListener(table, 'focusin', onHoverFocusIn);
  eventListeners.addListener(table, CHECK_POPOVER_STATE_EVENT, checkPopoverState);
  return function endManageErrorPopovers() {
    hidePopover();
    eventListeners.removeListeners();
  };
  function onHoverFocusIn(_ref) {
    let {
      target,
      type
    } = _ref;
    const cell = target.closest(`td[${CELL_IN_ERROR_ATTR}],th[${CELL_IN_ERROR_ATTR}]`);
    if (cell && cell !== popoverCell) {
      const delay = type === 'mouseover' ? 300 : 0;
      setTimeout(() => {
        // checking cell again popoverCell again because could have changed during timeout
        if (cell !== popoverCell && (cell.matches(':hover') || hasFocus(cell))) {
          hidePopover();
          showPopover(cell);
        }
      }, delay);
    }
  }
  function checkPopoverState() {
    const cellsInError = Array.from(table.querySelectorAll(`td[${CELL_IN_ERROR_ATTR}],th[${CELL_IN_ERROR_ATTR}]`));
    const focusedCellInError = cellsInError.find(cell => hasFocus(cell)) ||
    //give focused element priority
    cellsInError.find(cell => cell.matches(':hover'));
    if (focusedCellInError) {
      if (focusedCellInError !== popoverCell) {
        hidePopover();
        showPopover(focusedCellInError);
      }
    } else {
      hidePopover();
    }
  }
  function showPopover(cell) {
    const errorMessagePanel = cell.querySelector(`.${EDIT_PANEL_MESSAGE_CLASS}`);
    if (errorMessagePanel) {
      popoverCell = cell;
      destroyPopover = createPopover(errorMessagePanel, cell, {
        placement: 'bottom-left-center',
        alternatePlacements: ['bottom-right-center', 'top-left-center', 'top-right-center'],
        transitionLeaveTimeout: 100
      });
      offFocusHover = onFocusHover([cell, errorMessagePanel], _ref2 => {
        let {
          focus,
          hover
        } = _ref2;
        if (!focus && !hover && cell === popoverCell) {
          hidePopover();
        }
      }, {
        hoverOutDelay: 100
      });
    }
  }
  function hidePopover() {
    destroyPopover && destroyPopover();
    offFocusHover && offFocusHover();
    destroyPopover = offFocusHover = popoverCell = undefined;
  }
};
const checkErrorPopover = table => {
  if (table) {
    // allow post event activity to complete first
    setTimeout(() => table.dispatchEvent(new CustomEvent(CHECK_POPOVER_STATE_EVENT, {
      cancelable: true,
      bubbles: false
    })));
  }
};

/**
 * Gets the virtual col index for the cell, which is the sum of the colspans of its previous siblings.
 * For instance, if cell is the third cell, and the first cell spans 2 columns, and the second spans 1,
 * then the column index of the third cell would be 3, not 2
 * @param cell The cell to return the index of
 * @returns The column index of cell
 */
function getColumnIndex(cell) {
  const row = cell.closest('tr');
  return getChildElements(row).reduce((acc, sibling) => sibling.cellIndex < cell.cellIndex ? acc + sibling.colSpan : acc, 0);
}
/**
 * Gets the table header for the cell. Manages complex tabls where cells or header cells span multiple columns
 * @param cell The cell to return the header of
 * @returns the column header cell for the cell
 */
function getColumnHeader(cell) {
  const table = cell.closest('table');
  const headerCells = table && Array.from(table.querySelectorAll('thead > tr > *')).filter(h => h.closest('table') === table);
  const colIndex = getColumnIndex(cell);
  let headerColIndex = 0;
  return headerCells.find(h => {
    if (headerColIndex <= colIndex && headerColIndex + h.colSpan > colIndex) {
      return true;
    }
    headerColIndex += h.colSpan;
    return false;
  });
}
function cellToTextValue(cell) {
  let value = cell.getAttribute(EDIT_VALUE_ATTR);
  if (value === null) {
    value = Array.from(cell.childNodes).filter(node => !(node.nodeType === Node.ELEMENT_NODE && node.matches(`[${EDIT_PANEL_ATTR}]`))).map(node => {
      return node.textContent.trim();
    }).filter(Boolean).join(' ').trim();
  }
  return value;
}
function textToCellNodes(cell, value, displayValue) {
  let controlContainer = cell.querySelector(`[${EDIT_PANEL_ATTR}]`);
  const elements = getChildElements(cell).filter(el => el !== controlContainer && !el.matches('br'));
  const el = elements.length === 1 ? elements[0] : cell;
  // remove all nodes except control container
  Array.from(el.childNodes).forEach(node => {
    if (node !== controlContainer) {
      el.removeChild(node);
    }
  });
  if (value !== displayValue) {
    cell.setAttribute(EDIT_VALUE_ATTR, value);
  }
  controlContainer = el.querySelector(`[${EDIT_PANEL_ATTR}]`);
  const node = cell.ownerDocument.createTextNode(displayValue.toString());
  el.insertBefore(node, controlContainer);
}
function isEditableRow(row) {
  const selectors = [`tbody > tr[data-row-expansion]`, `tbody > tr.expansion-row`].join(',');
  return !row.matches(selectors) && !isRowGroupHeaderRow(row);
}
function isRowGroupHeaderRow(row) {
  const rowGroupHeader = row.querySelector('tr:first-child > th:only-child');
  return !!rowGroupHeader && rowGroupHeader.closest('tr') === row;
}
let announceTimeout;
/**
 * Announces a message to screen reader users. This is useful to audibly augment a visual cue such as
 * a loading indicator. If needed, adds a visually hidden aria-live region to the document,
 * then update its content with the message. Removes the content after 10 seconds
 *
 * NOTE: This would be a useful utitlity in general and not just for editable table. If made
 * more general, make ARIA_LIVE_REGION_ID a more general id.
 *
 * @param message The message to announce
 * @param documentElement an element from which to derive the document used to create the element
 */
function announce(message, documentElement) {
  if (announceTimeout) {
    clearTimeout(announceTimeout);
  }
  getAriaLiveRegion(documentElement ? documentElement.ownerDocument : document, region => {
    region.textContent = message;
    // clear the message after a few seconds
    announceTimeout = setTimeout(() => {
      region.textContent = '';
      announceTimeout = undefined;
    }, 10000);
  });
}
function getAriaLiveRegion(doc, callback) {
  const ARIA_LIVE_REGION_ID = "tds-editable-table__aria-live-region__b3c2ac";
  let region = doc.getElementById(ARIA_LIVE_REGION_ID);
  if (region) {
    callback(region);
  } else {
    region = doc.createElement('div');
    region.id = ARIA_LIVE_REGION_ID;
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.setAttribute('role', 'status');
    visuallyHide(region);
    doc.body.appendChild(region);
    // place element on page before setting content so it will be read by screen reader
    setTimeout(() => callback(region), 50);
  }
}

function makeGrid(table) {
  table.setAttribute('role', 'grid');
  // if cell already tabbable, start with that
  const startingCell = table.querySelector('tbody > tr > [tabindex="0"]') || table.querySelector('tbody > tr > *');
  start(startingCell);
  function start(activeCell, focus, navigateTo) {
    table.addEventListener('keydown', onKeydown);
    table.addEventListener('mousedown', onMousedown);
    if (activeCell) {
      let startingCell;
      switch (navigateTo) {
        case 'previous':
        case 'next':
          startingCell = getNextEditableCell(activeCell, navigateTo === 'next') || activeCell;
          break;
        case 'up':
        case 'down':
          startingCell = getAdjacentColumnCell(activeCell, navigateTo === 'up') || activeCell;
          break;
        default:
          startingCell = activeCell;
      }
      makeFocusable(startingCell, table);
      if (focus) {
        startingCell.focus();
      }
    }
  }
  function stop() {
    clearFocusable(table);
    table.removeEventListener('keydown', onKeydown);
    table.removeEventListener('mousedown', onMousedown);
  }
  function onKeydown(event) {
    const targetEl = event.target;
    const control = targetEl.closest('input, select, textarea'); // refine as needed
    if (control) {
      return;
    }
    const cell = targetEl.closest('td,th');
    if (cell && cell.closest('table') === table) {
      let nextCell;
      const key = normalizeKey(event);
      switch (key) {
        case 'ArrowLeft':
        case 'ArrowRight':
          nextCell = getAdjacentRowCell(cell, key === 'ArrowRight');
          break;
        case 'ArrowUp':
        case 'ArrowDown':
          nextCell = getAdjacentColumnCell(cell, key === 'ArrowUp');
          break;
        case 'Home':
        case 'End':
          nextCell = event.ctrlKey ? getEndCellEndRow(table, key === 'Home') : nextCell = getEndCell(cell.closest('tr'), key === 'Home');
          break;
        // case 'Tab':
        // Tabbbing to editable cells prevents tabbing into row action buttons or any other focusable element not in an editable cell 
        // But, it sure feels like it tab should navigate editable cells. Until we figure it out...
        // nextCell = getNextEditableCell(cell, !event.shiftKey);
        // break;
      }

      if (nextCell && nextCell !== cell) {
        event.preventDefault();
        makeFocusable(nextCell, table);
        nextCell.focus();
      }
    }
  }
  function onMousedown(event) {
    if (event.button == 0) {
      const targetEl = event.target;
      // todo: May need to ensure interactive element in cell not being touched. 
      // However, seems focus and click event continues to the interactive element anyway,
      // so ignore for now  
      const cell = targetEl.closest('tbody td,tbody th');
      if (cell && cell.closest('table') === table && !cell.matches(':focus')) {
        makeFocusable(cell, table);
        cell.focus();
      }
    }
  }
  return {
    resume: start,
    stop
  };
}
/**
 * Gets to the first or last visible cell in the table
 * @param table The table to check
 * @param first If true, gets the first cell; otherwise the last
 * @returns The first or last visible cell in the table
 */
function getEndCellEndRow(table, first) {
  let endCell;
  let endRow = table.querySelector(`tbody > tr${first ? ':first-child' : ':last-child'}`);
  while (endRow && !endCell) {
    endCell = getEndCell(endRow, first);
  }
  return endCell;
}
/**
 * Gets the first or last visible cell in a row
 * @param row The row
 * @param first If true, gets the first cell; otherwise the last
 * @returns The first or last visible cell in the row
 */
function getEndCell(row, first) {
  let endCell = first ? row.firstElementChild : row.lastElementChild;
  while (endCell && !isVisible(endCell)) {
    endCell = first ? endCell.nextElementSibling : endCell.previousElementSibling;
  }
  return endCell;
}
/**
 *  Gets the next or previous visible cell in a row for a given cell
 * @param cell The cell to start from
 * @param forward If true, gets the next visible cell; otherwise the previous
 * @returns The next or previous visible cell in a row
 */
function getAdjacentRowCell(cell, forward) {
  let nextCell = cell;
  while (nextCell) {
    nextCell = forward ? nextCell.nextElementSibling : nextCell.previousElementSibling;
    if (nextCell && isVisible(nextCell)) {
      break;
    }
  }
  return nextCell;
}
/**
 * Gets the next visible cell above or below a given cell
 * @param cell The cell to start from
 * @param above If true, gets the cell above; otherwise gets the cell below
 * @returns  the next visible cell above or below a given cell
 */
function getAdjacentColumnCell(cell, above) {
  const cellColIndex = getColumnIndex(cell);
  let row = cell.closest('tr');
  let nextCell;
  while (row && !nextCell) {
    let colIndex = 0;
    row = above ? row.previousElementSibling : row.nextElementSibling;
    if (row) {
      const rowCells = getChildElements(row);
      // find the first cell in the row that overlaps the given cell
      nextCell = rowCells.find(rowCell => {
        if (colIndex <= cellColIndex && colIndex + rowCell.colSpan > cellColIndex && isVisible(rowCell)) {
          return true;
        }
        colIndex += rowCell.colSpan;
        return false;
      });
    }
  }
  return nextCell;
}
function getNextEditableCell(cell, forward) {
  let nextEditableCell;
  let row = cell.closest('tr');
  let referenceCell = cell;
  while (referenceCell && !nextEditableCell) {
    let nextCell = forward ? referenceCell.nextElementSibling : referenceCell.previousElementSibling;
    if (!nextCell) {
      row = forward ? row.nextElementSibling : row.previousElementSibling;
      nextCell = row && (forward ? row.firstElementChild : row.lastElementChild);
    }
    if (nextCell && nextCell.getAttribute(CELL_EDITABLE_ATTR) === 'true') {
      nextEditableCell = nextCell;
    }
    referenceCell = nextCell;
  }
  return nextEditableCell;
}
/**
 * Clears existing focusable cell(s) and makes current cell focusable
 * @param cell
 * @param table
 */
function makeFocusable(cell, table) {
  if (cell.tabIndex !== 0) {
    clearFocusable(table);
    cell.tabIndex = 0;
  }
}
/**
 * Clears existing focusable cell(s)
 * @param table
 */
function clearFocusable(table) {
  Array.from(table.querySelectorAll('tbody > tr > [tabindex="0"]')).filter(focusableCell => focusableCell.closest('table') === table) // ignore nested tables
  .forEach(focusableCell => focusableCell.tabIndex = -1);
}
function isVisible(el) {
  return el.offsetHeight && el.offsetWidth;
}

var EndEditSaveAction;
(function (EndEditSaveAction) {
  EndEditSaveAction[EndEditSaveAction["No"] = 0] = "No";
  EndEditSaveAction[EndEditSaveAction["Yes"] = 1] = "Yes";
  EndEditSaveAction[EndEditSaveAction["IfChanged"] = 2] = "IfChanged";
})(EndEditSaveAction || (EndEditSaveAction = {}));
function bindEditing(editableDataTable) {
  const table = editableDataTable.table;
  const beginEditListeners = new EventListeners();
  const endEditListeners = new EventListeners();
  let startingEditCell;
  let editing = false;
  const unwatchForChanges = watchForChanges(table, {
    childList: true,
    subtree: true
  }, () => setCellEditableStates(table));
  setCellEditableStates(table);
  const {
    stop: stopGrid,
    resume: resumeGrid
  } = makeGrid(table);
  const endManageErrorPopovers = manageErrorPopovers(table);
  beginEditHandlers();
  function beginEditHandlers() {
    beginEditListeners.addListener(table, 'keydown', beginEditKeydownHandler);
    beginEditListeners.addListener(table, 'mousedown', onMousedownBeginEditHandler, {
      capture: true
    });
    beginEditListeners.addListener(table, 'touchstart', onMousedownBeginEditHandler, {
      capture: true,
      passive: true
    });
    // beginEditListeners.addListener(document, 'paste', beginEditPasteHandler) // not 100%
    if (editableDataTable.editMode === 'row') {
      beginEditListeners.addListener(table, 'click', beginEditClickHandler);
    }
  }
  function endEditHandlers() {
    endEditListeners.addListener(table, 'keydown', endEditKeyHandler);
    endEditListeners.addListener(table, 'click', endEditButtonClick);
    endEditListeners.addListener(document, 'mousedown', endEditMouseHandler);
    endEditListeners.addListener(document, 'touchstart', endEditMouseHandler, {
      passive: true
    });
  }
  function beginEditClickHandler(event) {
    const targetEl = event.target;
    const actionEl = targetEl.closest(`[${ROW_EDIT_ACTION_ATTR}]`);
    const row = actionEl && actionEl.closest('tr');
    if (row) {
      switch (actionEl.getAttribute(ROW_EDIT_ACTION_ATTR)) {
        case 'edit':
          startRowEdit(row, 'edit-row');
          break;
        case 'delete':
          deleteRow(row, 'delete-row');
          break;
      }
    }
  }
  function beginEditKeydownHandler(event) {
    let startAction = false;
    let initialValue;
    let action = normalizeKey(event);
    let preventDefault = false;
    switch (action) {
      case 'Enter':
      case 'Backspace':
      case 'Delete':
      case 'F2':
        const {
          ctrlKey,
          metaKey,
          altKey,
          shiftKey
        } = event;
        startAction = !(ctrlKey || metaKey || altKey || shiftKey);
        preventDefault = true;
        break;
      default:
        if (isTyping(event)) {
          // initialValue is set to the character typed. But the event is not cancelled
          // the cell editor should know whether to apply the character when initializing
          // or to initialize the component blank and let the key press continue to the component
          initialValue = action;
          action = 'typing';
          startAction = true;
        }
    }
    if (startAction) {
      const targetEl = event.target;
      let cell = targetEl.closest(`[${CELL_EDITABLE_ATTR}='true']`);
      if (!cell && editableDataTable.editMode === 'row' && action === 'Enter') {
        const row = targetEl.closest('tr');
        cell = row && row.querySelector(`[${CELL_EDITABLE_ATTR}='true']`);
      }
      if (cell) {
        if (preventDefault) {
          event.preventDefault();
        }
        startEditMode(cell, action, initialValue);
      }
    }
  }
  // Not working 100%. Not clear why. Paste event only fires for the cell when the cell was clicked to receive focus
  // When keyboard used, paste event is fired at the document level, even though cell clearly has focus
  // function beginEditPasteHandler(event: ClipboardEvent) {
  //   const targetEl = event.target as Element;
  //   const cell = targetEl.closest(`[${CELL_EDITABLE_ATTR}='true']`) as HTMLTableCellElement;
  //   if (cell) {
  //     const clipboardData = event.clipboardData || (window as any).clipboardData;
  //     if (clipboardData) {
  //       event.preventDefault();
  //       const text = clipboardData.getData('text');
  //       startEditMode(cell, 'paste', text);
  //     }
  //   }
  // }
  function onMousedownBeginEditHandler(event) {
    const targetEl = event.target;
    // if the cell already has focus on mousedown, initiate edit
    // this will act as a 'dblclick' and prevent selection of text that dblclick causes
    // delayed click will also initiate editing, but this is common 
    let cell = targetEl.closest(`[${CELL_EDITABLE_ATTR}]:focus`);
    if (cell && cell.getAttribute(CELL_EDITABLE_ATTR) !== 'true' && editableDataTable.editMode === 'row') {
      const row = targetEl.closest('tr');
      cell = row && row.querySelector(`[${CELL_EDITABLE_ATTR}='true']`);
    }
    if (cell && cell.getAttribute(CELL_EDITABLE_ATTR) === 'true') {
      event.preventDefault();
      event.stopPropagation();
      startEditMode(cell, 'dblclick');
    }
  }
  function endEditKeyHandler(event) {
    //todo: active cell may not be accurate
    const activeCell = event.target.closest(`[${CELL_EDITABLE_ATTR}='true']`);
    let saveAction;
    const key = normalizeKey(event);
    let navigateTo;
    switch (key) {
      case 'Enter':
        if (!event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey && activeCell) {
          saveAction = EndEditSaveAction.Yes;
          navigateTo = 'down';
        }
        break;
      case 'Escape':
        saveAction = EndEditSaveAction.No;
        break;
      case 'Tab':
        if (editableDataTable.isTabbingAway(event)) {
          saveAction = EndEditSaveAction.IfChanged;
          navigateTo = event.shiftKey ? 'previous' : 'next';
        }
        break;
    }
    if (typeof saveAction !== 'undefined') {
      event.preventDefault();
      endEditMode(key, saveAction, activeCell, true, navigateTo);
    }
  }
  function endEditMouseHandler(event) {
    if (editableDataTable.isClickOutside(event)) {
      let activeCell;
      const targetEl = event.target;
      let focus = false;
      if (table.contains(targetEl)) {
        //todo: active cell may not be accurate
        activeCell = targetEl.closest(`tbody [${CELL_EDITABLE_ATTR}='true']`);
        focus = !!activeCell;
      }
      if (!activeCell) {
        //reset to first cell
        activeCell = table.querySelector('tbody > tr > *');
      }
      endEditMode('ClickAway', EndEditSaveAction.IfChanged, activeCell, focus);
    }
  }
  function endEditButtonClick(event) {
    const targetEl = event.target;
    const saveButton = targetEl.closest(`[${ROW_EDIT_ACTION_ATTR}="save"]`);
    const cancelButton = targetEl.closest(`[${ROW_EDIT_ACTION_ATTR}="cancel"]`);
    if (saveButton || cancelButton) {
      // todo: need to account for row editing
      const activeCell = targetEl.closest(`[${CELL_EDITABLE_ATTR}='true']`);
      const action = saveButton ? 'save-button' : 'cancel-button';
      const saveAction = saveButton ? EndEditSaveAction.Yes : EndEditSaveAction.No;
      endEditMode(action, saveAction, activeCell, !!activeCell);
    }
  }
  function startEditMode(cell, action, initialValue) {
    if (editing) {
      endEditMode('api', EndEditSaveAction.No, null, false);
    }
    switch (action) {
      case 'Backspace':
      case 'Delete':
        initialValue = '';
        break;
    }
    const data = editableDataTable.editMode === 'row' ? editableDataTable.getRowData(cell) : editableDataTable.getCellData(cell);
    let allow = true;
    const eventType = editableDataTable.editMode === 'row' ? 'tdsRowEditStart' : 'tdsCellEditStart';
    allow = editableDataTable.sendEvent(eventType, {
      action,
      data
    });
    if (allow) {
      editing = true;
      stopGrid();
      beginEditListeners.removeListeners();
      // this was originally wrapped in timeout. By removing timeout, the key press started 
      // in the cell is sent to the editor instead. This works especially nice for select
      // where typing can be used to select element in the list
      startingEditCell = cell;
      editableDataTable.beginEditing(cell, initialValue, action);
      endEditHandlers();
      const eventType2 = editableDataTable.editMode === 'row' ? 'tdsRowEditStarted' : 'tdsCellEditStarted';
      editableDataTable.sendEvent(eventType2, {
        action,
        data
      });
      if (editableDataTable.editMode === 'row') {
        const message = getRowEditingAnnouncement(cell.closest('tr'));
        announce(message, table);
      }
    }
  }
  function endEditMode(action, saveAction, activeCell, focus, navigateTo) {
    activeCell = activeCell || startingEditCell;
    const eventType = editableDataTable.editMode === 'row' ? 'tdsRowEditEnd' : 'tdsCellEditEnd';
    const data = editableDataTable.editMode === 'row' ? editableDataTable.getRowData(startingEditCell) : editableDataTable.getCellData(startingEditCell);
    const save = saveAction === EndEditSaveAction.Yes || saveAction === EndEditSaveAction.IfChanged && editableDataTable.hasChanged();
    const allow = editableDataTable.sendEvent(eventType, {
      action,
      cancelled: !save,
      data
    });
    if (allow) {
      return editableDataTable.endEditing(save).then(ended => {
        if (ended) {
          var _editableDataTable$ta;
          editing = false;
          endEditListeners.removeListeners();
          beginEditHandlers();
          resumeGrid(activeCell, focus, navigateTo);
          if ((_editableDataTable$ta = editableDataTable.table) !== null && _editableDataTable$ta !== void 0 && _editableDataTable$ta.isConnected) {
            const eventType2 = editableDataTable.editMode === 'row' ? 'tdsRowEditEnded' : 'tdsCellEditEnded';
            const data2 = editableDataTable.editMode === 'row' ? editableDataTable.getRowData(startingEditCell) : editableDataTable.getCellData(startingEditCell);
            const updates = save ? editableDataTable.getUpdatesApplied() : undefined;
            editableDataTable.sendEvent(eventType2, {
              action,
              cancelled: !save,
              data: data2,
              updates
            });
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  }
  function startCellEdit(cell) {
    cell.setAttribute(CELL_EDITABLE_ATTR, 'true');
    startEditMode(cell, 'api');
  }
  function startRowEdit(row) {
    let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
    if (editableDataTable.editMode === 'row') {
      const startingCell = row && row.querySelector(`[${CELL_EDITABLE_ATTR}="true"]`);
      if (startingCell) {
        startEditMode(startingCell, action);
      }
    }
  }
  function endEdit(save) {
    return editing ? endEditMode('api', save ? EndEditSaveAction.Yes : EndEditSaveAction.No, null, false) : Promise.resolve();
  }
  function deleteRow(row, action) {
    const data = editableDataTable.getRowData(row);
    if (editableDataTable.sendEvent('tdsRowDelete', {
      action,
      data
    })) {
      Promise.resolve(editableDataTable.deleteRow(data)).then(ok => {
        if (ok) {
          editableDataTable.sendEvent('tdsRowDeleted', {
            action,
            data
          });
        }
      });
    }
  }
  function unbind() {
    stopGrid();
    beginEditListeners.removeListeners();
    endEditListeners.removeListeners();
    unwatchForChanges();
    endManageErrorPopovers();
    clearCellDescribers(table);
  }
  return {
    unbind,
    startCellEdit,
    startRowEdit,
    endEdit
  };
}
function setCellEditableStates(table) {
  const cells = Array.from(table.querySelectorAll(`tbody > tr > :not([${CELL_EDITABLE_ATTR}])`));
  const [editableDescriber, noneditableDescriber] = getCellDescribers(table);
  cells.filter(cell => cell.closest('table') === table).filter(cell => {
    const row = cell.closest('tr');
    return !!row && isEditableRow(row);
  }).forEach(cell => {
    const column = getColumnHeader(cell);
    const isEditable = !!column && column.hasAttribute(COLUMN_EDITABLE_ATTR) && ['', 'true'].indexOf(column.getAttribute(COLUMN_EDITABLE_ATTR).toLowerCase()) > -1;
    cell.setAttribute(CELL_EDITABLE_ATTR, `${isEditable}`);
    cell.setAttribute('role', 'gridcell');
    cell.setAttribute('aria-readonly', `${!isEditable}`);
    const describedBy = (cell.getAttribute('aria-describedby') || '') + ' ' + (isEditable ? editableDescriber.id : noneditableDescriber.id);
    cell.setAttribute('aria-describedby', describedBy.trim());
  });
}
const EDITABLE_DESCRIBER_ID = "__tds-editable-cell-describer__";
const NONEDITABLE_DESCRIBER_ID = "__tds-noneditable-cell-describer__";
function getCellDescribers(table) {
  const translation = translations(table).t;
  return [getDescriber(EDITABLE_DESCRIBER_ID, translation("editable"), table), getDescriber(NONEDITABLE_DESCRIBER_ID, translation("readonly"), table)];
}
function clearCellDescribers(table) {
  [EDITABLE_DESCRIBER_ID, NONEDITABLE_DESCRIBER_ID].forEach(id => {
    const describer = table.ownerDocument.getElementById(id);
    if (describer && !table.ownerDocument.querySelector(`[aria-describedby~="${id}"]`)) {
      describer.parentNode.removeChild(describer);
    }
  });
}
function getDescriber(id, content, table) {
  let describer = table.ownerDocument.getElementById(id);
  if (!describer) {
    describer = table.ownerDocument.createElement('span');
    describer.id = id;
    describer.hidden = true;
    describer.style.display = "none";
    describer.textContent = content;
    table.ownerDocument.body.appendChild(describer);
  }
  return describer;
}
function getRowEditingAnnouncement(row) {
  const lang = getLang(row);
  const translation = translations(lang).t;
  const rowIndex = row.getAttribute('aria-rowindex') || (row.rowIndex + 1).toString();
  const columnIndexes = getChildElements(row, `[${CELL_EDITABLE_ATTR}="true"]`).map(cell => {
    return cell.getAttribute('aria-colindex') || (cell.cellIndex + 1).toString();
  });
  const columnList = typeof Intl.ListFormat === 'undefined' ? columnIndexes.join(',') : new Intl.ListFormat(lang, {
    style: 'long',
    type: 'conjunction'
  }).format(columnIndexes);
  const saveAction = row.querySelector(`[${ROW_EDIT_ACTION_ATTR}="save"]`);
  const actionCell = saveAction && saveAction.closest('td,th');
  const messages = [translation('nowEditingRow', rowIndex), translation(columnIndexes.length > -1 ? 'rowColumnsEditable' : 'rowColumnEditable', columnList)];
  if (actionCell) {
    const actionCellIndex = actionCell.getAttribute('aria-colindex') || (actionCell.cellIndex + 1).toString();
    messages.push(translation('rowActionsColumn', actionCellIndex));
  }
  const announcement = messages.join('. ');
  return announcement;
}

class AbstractCellEditor {
  constructor() {
    this.reportUpdate = this.reportUpdate.bind(this);
    this.reportFocusChange = this.reportFocusChange.bind(this);
  }
  render(_) {
    throw new Error('render(cellData: CellEditorRenderData) must be implemented');
  }
  focus() {
    if (this.editorElement && this.editorElement.focus) {
      this.editorElement.focus();
    }
  }
  getValue() {
    throw new Error('getValue() must be implemented');
  }
  setValue(_) {
    throw new Error('setValue() must be implemented');
  }
  getDisplayValue() {
    return this.getValue();
  }
  onUpdate(callback) {
    this.onUpdateCallback = callback;
  }
  onFocusChange(callback) {
    this.onFocusChangeCallback = callback;
  }
  reportUpdate() {
    this.onUpdateCallback && this.onUpdateCallback(this);
  }
  reportFocusChange(focused) {
    this.onFocusChangeCallback && this.onFocusChangeCallback(focused);
  }
}

class CellValidatorChain {
  constructor(validators) {
    this._validators = [];
    this._validators = validators;
  }
  validate(cellData) {
    return this.runValidation(cellData, 0);
  }
  runValidation(cellData, index) {
    const validator = this._validators[index];
    if (!validator || cellData.errorMessage) {
      return Promise.resolve(cellData);
    }
    return Promise.resolve(validator.validate(cellData)).then(result => {
      return this.runValidation(result, index + 1);
    });
  }
}

const id = 'x-circle-1-18';
const attributes = {
  "width": "18",
  "height": "18",
  "viewBox": "0 0 18 18",
  "xmlns": "http://www.w3.org/2000/svg"
};
const innerContents = '<path d="M9.707 9l2.737 2.737a.5.5 0 01-.707.707L9 9.707l-2.737 2.737a.5.5 0 01-.707-.707L8.293 9 5.556 6.263a.5.5 0 11.707-.707L9 8.293l2.737-2.737a.5.5 0 01.707.707L9.707 9zM9 18A9 9 0 119 0a9 9 0 010 18zm0-1A8 8 0 109 1a8 8 0 000 16z" fill="currentColor"/>';
const contents = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' + innerContents + '</svg>';
const defaultClass = "tds-icon-18";
const svg = /*#__PURE__*/svgFunction(attributes, innerContents, defaultClass);
var xCircle1_18 = {
  svg,
  id,
  contents,
  innerContents,
  attributes
};

const errorStateMap = /*#__PURE__*/new WeakMap();
class EditModeManager {
  constructor(startingCell, editableDataTable) {
    this.validationHasRun = false;
    this.cellValidities = [];
    this.savingInProgress = false;
    /**
     * This function is passed with the tdsEditCellValuesUpdate event detail. It allows develop to change editor options
     * for other cell when an update occurs. Think a dropdown that is dependent on the value of another column   *
     * @param columnName The name of the column whose editor is to be updated
     * @param options The new options
     */
    this.setCellEditorOptions = (columnName, options) => {
      const editor = this.cellEditors.find(editor => editor.cellData.columnName === columnName);
      const editorComponent = editor && editor.cellEditorComponent;
      if (editorComponent && editorComponent.setOptions) {
        editorComponent.setOptions(options);
      }
    };
    /* istanbul ignore next */
    if (typeof Promise === 'undefined') {
      throw new Error('Editable Data Table requires the implementation of Promise');
    }
    this.updateCellValue = this.updateCellValue.bind(this);
    this.setCellEditorOptions = this.setCellEditorOptions.bind(this);
    this.startingCell = startingCell;
    this.editableDataTable = editableDataTable;
    this.rowData = editableDataTable.getRowData(this.startingCell);
    const cells = editableDataTable.editMode === 'row' ? getChildElements(startingCell.parentElement, `[${CELL_EDITABLE_ATTR}="true"]`) : [startingCell];
    this.cellEditors = cells.map(cell => new CellEditor(cell, editableDataTable, this));
    this.editCellValues = this.cellEditors.reduce((acc, cellEditor) => {
      const cellValue = editableDataTable.getCellValue(cellEditor.cell);
      acc[cellEditor.cellData.columnName] = cellValue;
      return acc;
    }, {});
    this.fireEditCellValuesUpdateEvent();
  }
  begin(initialValue, action) {
    const {
      startingCell,
      editableDataTable,
      editCellValues
    } = this;
    this.cellEditors && this.cellEditors.forEach(editor => {
      if (editor.cell === startingCell) {
        editor.begin(editCellValues, true, initialValue, action);
      } else {
        editor.begin(editCellValues, false);
      }
    });
    if (editableDataTable.editMode === 'row') {
      const row = startingCell.parentElement;
      row.dataset.editing = '';
      this.renderEndRowEditingButtons(row);
    }
  }
  end(save) {
    if (save) {
      return this.savingInProgress ? Promise.resolve(false) : this.save();
    } else {
      this.endEditing(false);
      return Promise.resolve(true);
    }
  }
  save() {
    this.savingInProgress = true;
    this.cellValidities = [];
    return this.validateCells().then(cellValidationDataItems => {
      const isValid = !cellValidationDataItems.find(data => !!data.errorMessage);
      return isValid && this.processRowUpdate(cellValidationDataItems);
    }).then(valid => {
      var _this$editableDataTab;
      const isConnected = (_this$editableDataTab = this.editableDataTable.table) === null || _this$editableDataTab === void 0 ? void 0 : _this$editableDataTab.isConnected;
      const endEditing = valid || this.getValidationMode() === 'passive' || !isConnected;
      if (endEditing) {
        this.endEditing(isConnected); // commit only if still connected
      }

      this.reconcileCellValidities();
      this.validationHasRun = true;
      return endEditing;
    }).finally(() => this.savingInProgress = false);
  }
  hasChanged() {
    return !!this.cellEditors.find(cellEditor => cellEditor.isDirty());
  }
  validateCells() {
    const cellEditors = this.cellEditors || [];
    return Promise.all(cellEditors.map(cellEditor => cellEditor.validate()));
  }
  processRowUpdate(cellValidationDataItems) {
    const rowUpdates = this.getRowUpdates(cellValidationDataItems);
    const {
      editableDataTable
    } = this;
    const cellValidationData = cellValidationDataItems[0];
    const rowData = {
      rowId: cellValidationData.rowId,
      rowIndex: cellValidationData.rowIndex,
      rowGroupIndex: cellValidationData.rowGroupIndex,
      row: cellValidationData.row,
      rowItem: cellValidationData.rowItem
    };
    this.showBusy();
    return editableDataTable.processRowUpdate(rowData, rowUpdates).then(validations => this.processRowValidations(validations || [], rowData)).catch(err => {
      console.error(err);
      console.error(err.stack);
      // todo: do something with the error message 
      return false;
    }).finally(() => {
      this.hideBusy();
    });
  }
  getRowUpdates(cellValidationDataItems) {
    const {
      editableDataTable
    } = this;
    return cellValidationDataItems.reduce((acc, cellValidationData) => {
      const {
        newValue,
        displayValue,
        cell
      } = cellValidationData;
      const valueSetter = editableDataTable.getValueSetter(cell);
      const rowUpdate = valueSetter ? valueSetter(cellValidationData, newValue, displayValue) : {
        [cellValidationData.columnName]: newValue
      };
      return {
        ...acc,
        ...rowUpdate
      };
    }, {});
  }
  processRowValidations(validations, rowData) {
    validations.forEach(validation => {
      // for each validation object, find matching editor and update cell validation data
      // NOTE: There is one shortcoming here specific to cell edit mode. If this cell has a validation error
      // because of the value in another cell in this row, if the user goes to that other cell to correct the 
      // error, the validation error in this cell will not be cleared. For example, say that Cell A is in error
      // because its value is invalid for the US state entered in Cell B in this row. If instead of updating
      // Cell A to correct the error, the user goes to Cell B and changes the US state so that Cell A is no longer 
      // invalid, Cell A's error will not clear because it is not part of the edit session with Cell B.
      // For now, if this scenario exists, the app should use the row edit mode instead of the cell edit mode so all
      // cells are part of the same editing session. (Phew!)  
      const editor = this.cellEditors.find(_ref => {
        let {
          validationCellData
        } = _ref;
        return !!validationCellData && validationCellData.columnName === validation.columnName;
      });
      if (editor) {
        editor.updateValidationData(validation);
      }
      if (validation.errorMessage) {
        this.updateValidity(validation.columnName, rowData.rowId, rowData.rowGroupIndex, 'customError');
      }
    });
    // return true if no validation errors
    const columnsInError = validations.filter(validation => !!validation.errorMessage).map(validation => validation.columnName);
    const valid = !columnsInError.length;
    const messageId = valid ? 'updatesComplete' : columnsInError.length > 1 ? 'updatesCompleteWithErrors' : 'updatesCompleteWithOneError';
    const message = translations(rowData.row).t(messageId, columnsInError.join(','));
    announce(message, rowData.row);
    return valid;
  }
  endEditing(commit) {
    const {
      editableDataTable,
      startingCell
    } = this;
    const cellEditors = this.cellEditors || [];
    cellEditors.forEach(editor => {
      commit ? editor.commit() : editor.cancel();
    });
    this.cellEditors = [];
    if (editableDataTable.editMode === 'row') {
      startingCell.parentElement.removeAttribute('data-editing');
    }
  }
  getValidationMode() {
    const {
      editableDataTable
    } = this;
    const {
      editMode,
      editValidationMode
    } = editableDataTable;
    return editValidationMode || (editMode === 'row' ? 'assertive' : 'passive');
  }
  isClickOutside(event) {
    const {
      cellEditors,
      startingCell
    } = this;
    const el = event.target;
    const selector = [`[${ROW_EDIT_ACTION_ATTR}="save"]`, `[${ROW_EDIT_ACTION_ATTR}="cancel"]`].join(',');
    const rowActions = startingCell.parentNode && Array.from(startingCell.parentNode.querySelectorAll(selector)) || [];
    const elements = [...cellEditors.map(cellEditor => cellEditor.cell), ...rowActions];
    return !elements.find(element => element && element.contains(el)) && !this.isClickingScrollpanel(el);
  }
  isClickingScrollpanel(target) {
    const table = this.editableDataTable.table;
    if (table && table.parentElement === target) {
      const styles = window.getComputedStyle(target);
      // return true if target is table's parent and parent is scrollable
      return styles.overflow === 'auto' || styles.overflow === 'scroll' || styles.overflowX === 'auto' || styles.overflowX === 'scroll' || styles.overflowY === 'auto' || styles.overflowY === 'scroll';
    }
    return false;
  }
  isTabbingAway(event) {
    const {
      cellEditors,
      startingCell
    } = this;
    const cells = (cellEditors || []).map(ce => ce.cell);
    // assume cells are in dom order
    let endEl = event.shiftKey ? cells[0] : cells[cells.length - 1];
    if (!event.shiftKey) {
      const selector = [`[${ROW_EDIT_ACTION_ATTR}="save"]`, `[${ROW_EDIT_ACTION_ATTR}="cancel"]`].map(s => s + ':not([tabindex="0"])').join(',');
      const actionButtons = startingCell.parentNode && startingCell.parentNode.querySelectorAll(selector);
      if (actionButtons && actionButtons.length) {
        const lastButton = actionButtons[actionButtons.length - 1];
        if (endEl.compareDocumentPosition(lastButton) === Node.DOCUMENT_POSITION_FOLLOWING) {
          endEl = lastButton;
        }
      }
    }
    return !!endEl && endEl.contains(event.target);
  }
  onCellEditorUpdate(cellEditor, value) {
    this.editCellValues[cellEditor.cellData.columnName] = value;
    this.fireEditCellValuesUpdateEvent(cellEditor);
  }
  // collects validity states of each cell to be reconciled at end of validation 
  updateValidity(columnName, rowId, rowGroupIndex, errorReason) {
    const cellValidities = this.cellValidities;
    let cellValidity = cellValidities.find(cv => cv.columnName === columnName && cv.rowId === rowId && cv.rowGroupIndex === rowGroupIndex);
    if (!cellValidity) {
      cellValidity = {
        columnName,
        rowId,
        rowGroupIndex,
        validity: {}
      };
      cellValidities.push(cellValidity);
    }
    cellValidity.validity = {};
    if (errorReason) {
      cellValidity.validity = {
        [errorReason]: true
      };
    }
    if (!this.savingInProgress) {
      this.reconcileCellValidities();
    }
  }
  reconcileCellValidities() {
    const {
      editableDataTable
    } = this;
    const edtValidity = editableDataTable.getValidity();
    const cellValidities = (this.cellValidities || []).filter(v => {
      // return only invalid columns
      const props = Object.keys(v.validity);
      return !!props.find(prop => !!v.validity[prop]);
    });
    const edtCellValidities = edtValidity.cellValidities || [];
    let changed = cellValidities.length !== edtCellValidities.length;
    if (!changed) {
      // array size is the same, see if the columns are the same
      cellValidities.forEach(cellValidity => {
        const edtCellValidity = edtCellValidities.find(edtv => edtv.columnName === cellValidity.columnName && edtv.rowId === cellValidity.rowId && cellValidity.rowGroupIndex === edtv.rowGroupIndex);
        if (edtCellValidity) {
          // same column found, see if validity has changed
          const props = [...Object.keys(edtCellValidity.validity), ...Object.keys(cellValidity.validity)];
          const cellChanged = !!props.find(prop => !!edtCellValidity.validity[prop] !== !!cellValidity.validity[prop]);
          if (cellChanged) {
            changed = true;
          }
        } else {
          changed = true;
        }
      });
    }
    if (changed) {
      const valid = cellValidities.length === 0;
      const updatedEdtValidity = {
        valid,
        cellValidities: [...cellValidities]
      };
      editableDataTable.setValidity(updatedEdtValidity);
      editableDataTable.sendEvent(valid ? 'tdsValid' : 'tdsInvalid', updatedEdtValidity);
    }
  }
  renderEndRowEditingButtons(row) {
    const editAction = row.querySelector(`[${ROW_EDIT_ACTION_ATTR}="edit"]`);
    const saveAction = row.querySelector(`[${ROW_EDIT_ACTION_ATTR}="save"]`);
    const cancelAction = row.querySelector(`[${ROW_EDIT_ACTION_ATTR}="cancel"]`);
    if (!saveAction || !cancelAction) {
      const translateHTML = translations(row).html;
      const saveLabel = translateHTML('save');
      const cancelLabel = translateHTML('cancel');
      let container = row.querySelector(`[${ROW_EDIT_ACTIONS_ATTR}]`);
      if (!container) {
        let action = saveAction || cancelAction || editAction;
        container = action && action.parentElement;
      }
      if (container) {
        if (!saveAction) {
          const saveHTML = `<button type="button" data-row-edit-action="save" class="tds-editable-table_row-action" aria-label="${saveLabel}" title="${saveLabel}">${checkCircle1_18.svg({
            focusable: false
          })}</button>`;
          container.insertAdjacentHTML('beforeend', saveHTML);
        }
        if (!cancelAction) {
          const cancelHTML = `<button type="button" data-row-edit-action="cancel" class="tds-editable-table_row-action" aria-label="${cancelLabel}" title="${cancelLabel}">${xCircle1_18.svg({
            focusable: false
          })}</button>`;
          container.insertAdjacentHTML('beforeend', cancelHTML);
        }
      }
    }
  }
  fireEditCellValuesUpdateEvent(cellEditor) {
    const {
      editCellValues,
      editableDataTable,
      rowData,
      setCellEditorOptions,
      updateCellValue
    } = this;
    const columnName = cellEditor && cellEditor.cellData.columnName;
    editableDataTable.sendEvent('tdsEditCellValuesUpdate', {
      rowData,
      editCellValues,
      columnName,
      updateCellValue,
      setCellEditorOptions
    });
  }
  /**
   * This function is passed with the tdsEditCellValuesUpdate event detail. It allows develop to change other cell values
   * when an update occurs. Think a dropdown that is dependent on the value of another column
   * @param columnName The name of the column to update
   * @param value The value to set
   */
  updateCellValue(columnName, value) {
    this.editCellValues = {
      ...this.editCellValues,
      [columnName]: value
    };
    const editor = this.cellEditors.find(editor => editor.cellData.columnName === columnName);
    const editorComponent = editor && editor.cellEditorComponent;
    if (editorComponent) {
      editorComponent.setValue(value);
    }
    if (this.validationHasRun) {
      this.validateCells();
    }
  }
  showBusy() {
    this.hideBusy(); // this will cancel any timeout in progress
    this.showBusyTimeout = setTimeout(() => {
      const {
        cellEditors,
        editableDataTable
      } = this;
      let el = cellEditors[0].cell;
      const table = el.closest('table');
      if (editableDataTable.editMode === 'row') {
        el = el.closest('tr');
      }
      const rect = this.calculateBusyOverlayRect(el, table);
      const div = this.showBusyOverlay = el.ownerDocument.createElement('div');
      div.classList.add('tds-editable-table__showBusyOverlay');
      div.style.top = `${rect.top}px`;
      div.style.left = `${rect.left}px`;
      div.style.width = `${rect.width}px`;
      div.style.height = `${rect.height}px`;
      div.innerHTML = `<span></span><div aria-live="polite" aria-atomic="true"></div>`;
      table.parentNode.insertBefore(div, table.nextSibling);
      const translate = translations(table.parentElement).t;
      const message = translate('applyingUpdates');
      announce(message, table);
    }, 300);
  }
  hideBusy() {
    const {
      showBusyTimeout,
      showBusyOverlay
    } = this;
    if (showBusyTimeout) {
      clearTimeout(showBusyTimeout);
    }
    if (showBusyOverlay && showBusyOverlay.parentNode) {
      showBusyOverlay.parentNode.removeChild(showBusyOverlay);
    }
    this.showBusyTimeout = undefined;
    this.showBusyOverlay = undefined;
  }
  calculateBusyOverlayRect(el, table) {
    const tableOffsetParent = table && table.offsetParent;
    let top = 0;
    let left = 0;
    let width = 0;
    let height = 0;
    if (tableOffsetParent) {
      let offsetEl = el;
      do {
        top += offsetEl.offsetTop;
        left += offsetEl.offsetLeft;
        offsetEl = offsetEl.offsetParent;
        if (offsetEl && offsetEl !== tableOffsetParent) {
          top -= offsetEl.scrollTop;
          left -= offsetEl.scrollLeft;
        }
      } while (offsetEl && offsetEl !== tableOffsetParent);
      width = el.offsetWidth - 1;
      height = el.offsetHeight - 1;
    }
    return {
      top,
      left,
      width,
      height
    };
  }
}
class CellEditor {
  constructor(cell, editableDataTable, editModeManager) {
    this.renderState = {};
    this.validateOnUpdate = false;
    this.cell = cell;
    this.editableDataTable = editableDataTable;
    this.editModeManager = editModeManager;
    this.cellData = editableDataTable.getCellData(cell);
    this.cellEditorComponent = editableDataTable.getCellEditorComponent(cell);
    this.validators = editableDataTable.getCellValidators(cell);
  }
  begin(editCellValues, focus, initialValue, action) {
    const {
      cell,
      cellData,
      editableDataTable,
      cellEditorComponent,
      validators
    } = this;
    this.wasUpdated = false;
    this.backup();
    cell.dataset.editing = '';
    const renderState = {
      inEditMode: true,
      editMode: editableDataTable.editMode
    };
    const errorState = errorStateMap.get(cell);
    if (errorState) {
      renderState.errorMessage = errorState.errorMessage;
      this.validateOnUpdate = true;
    }
    this.render(renderState);
    const cellValue = this.startingValue = errorState ? errorState.value : editableDataTable.getCellValue(cell);
    const controlContainer = cell.querySelector(`[${EDIT_CONTROL_CONTAINER_ATTR}]`);
    cellEditorComponent.onUpdate(this.onUpdate.bind(this));
    cellEditorComponent.render({
      ...cellData,
      cellValue,
      editCellValues,
      container: controlContainer,
      initialValue,
      action,
      validators
    });
    if (typeof initialValue !== 'undefined' && cellEditorComponent.getValue() !== cellValue) {
      // treat as if initial value was typed in, which it was
      this.onUpdate();
    }
    if (cellEditorComponent instanceof AbstractCellEditor) {
      const editorElement = cellEditorComponent.editorElement;
      if (editableDataTable.onCellEditorCreated && editorElement) {
        editableDataTable.onCellEditorCreated(editorElement, cellData);
      }
    }
    if (focus) {
      cellEditorComponent.focus();
    }
  }
  validate() {
    const {
      cell,
      cellEditorComponent,
      validators,
      editableDataTable,
      editModeManager
    } = this;
    const newValue = cellEditorComponent.getValue();
    const displayValue = cellEditorComponent.getDisplayValue && cellEditorComponent.getDisplayValue();
    const cellData = {
      ...editableDataTable.getCellData(cell),
      newValue,
      enteredValue: newValue,
      displayValue
    };
    this.validateOnUpdate = true;
    return new CellValidatorChain(validators).validate(cellData).then(validationCellData => {
      this.validationCellData = validationCellData;
      if (validationCellData.errorMessage !== this.renderState.errorMessage) {
        this.render({
          errorMessage: validationCellData.errorMessage
        });
      }
      // if errorMessage set but not errorReason, assume it was from a custom validator
      const errorReason = validationCellData.errorReason || validationCellData.errorMessage && 'customError' || undefined;
      editModeManager.updateValidity(cellData.columnName, cellData.rowId, cellData.rowGroupIndex, errorReason);
      return validationCellData;
    });
  }
  commit() {
    const {
      cell,
      editableDataTable
    } = this;
    cell.removeAttribute('data-editing');
    cell.removeAttribute(EDITOR_HAS_FOCUS_ATTR);
    this.restore(); // restore 1st so data is placed in correct element
    const cellData = this.validationCellData;
    this.render({
      inEditMode: false
    });
    editableDataTable.setCellValue(cell, cellData.newValue, cellData.displayValue);
    if (cellData.errorMessage) {
      errorStateMap.set(cell, {
        value: cellData.newValue,
        errorMessage: cellData.errorMessage
      });
    } else {
      errorStateMap.delete(cell);
    }
  }
  cancel() {
    const {
      cell
    } = this;
    cell.removeAttribute('data-editing');
    cell.removeAttribute(EDITOR_HAS_FOCUS_ATTR);
    const errorState = errorStateMap.get(cell);
    this.render({
      inEditMode: false,
      errorMessage: errorState && errorState.errorMessage
    });
    this.restore();
  }
  isDirty() {
    return this.wasUpdated || this.cellEditorComponent.getValue() != this.startingValue; // '!=' insted of '!==' is intentional
  }

  onUpdate() {
    this.wasUpdated = true;
    const value = this.cellEditorComponent.getValue();
    this.editModeManager.onCellEditorUpdate(this, value);
    if (this.validateOnUpdate) {
      this.validate();
    }
  }
  onCellEditorFocusChange(focused) {
    const cell = this.cell;
    if (cell) {
      if (focused) {
        cell.setAttribute(EDITOR_HAS_FOCUS_ATTR, '');
      } else {
        cell.removeAttribute(EDITOR_HAS_FOCUS_ATTR);
      }
    }
  }
  updateValidationData(rowValidation) {
    const {
      validationCellData
    } = this;
    this.validationCellData = {
      ...validationCellData,
      displayValue: rowValidation.newValue || validationCellData.displayValue,
      ...rowValidation
    };
    if (rowValidation.errorMessage !== this.renderState.errorMessage) {
      this.render({
        errorMessage: rowValidation.errorMessage
      });
    }
  }
  backup() {
    const {
      cell
    } = this;
    let backupDiv = cell.querySelector(`[${CELL_CONTENT_BKUP_ATTR}]`);
    if (!backupDiv) {
      // should never really exist
      backupDiv = cell.ownerDocument.createElement('div');
      backupDiv.setAttribute(CELL_CONTENT_BKUP_ATTR, '');
      backupDiv.setAttribute('aria-hidden', 'true'); // shouldn't be needed as element is hidden, but just in case
      Array.from(cell.childNodes).filter(node => !(node.nodeType === Node.ELEMENT_NODE && node.matches(`[${EDIT_PANEL_ATTR}]`))).forEach(node => backupDiv.appendChild(node));
      cell.insertBefore(backupDiv, cell.firstChild);
    }
  }
  restore() {
    const {
      cell
    } = this;
    const backupDiv = cell.querySelector(`[${CELL_CONTENT_BKUP_ATTR}]`);
    if (backupDiv) {
      Array.from(backupDiv.childNodes).forEach(node => cell.insertBefore(node, backupDiv));
      cell.removeChild(backupDiv);
    }
  }
  render(updates) {
    this.renderState = {
      ...this.renderState,
      ...updates
    };
    const {
      cell
    } = this;
    const {
      errorMessage,
      inEditMode
    } = this.renderState;
    if (errorMessage) {
      cell.setAttribute(CELL_IN_ERROR_ATTR, '');
    } else {
      cell.removeAttribute(CELL_IN_ERROR_ATTR);
    }
    let editorPanel = cell.querySelector(`[${EDIT_PANEL_ATTR}]`);
    if (inEditMode || errorMessage) {
      if (!editorPanel) {
        editorPanel = cell.ownerDocument.createElement('div');
        editorPanel.id = uid(EDIT_PANEL_BASE_ID);
        editorPanel.setAttribute(EDIT_PANEL_ATTR, '');
        cell.appendChild(editorPanel);
        cell.removeAttribute('aria-describedby');
      }
    } else if (editorPanel) {
      editorPanel.parentNode.removeChild(editorPanel);
      editorPanel = null;
    }
    if (editorPanel) {
      const errorMessagePanelId = `${editorPanel.id}__message-panel`;
      let editorControlContainer = editorPanel.querySelector(`[${EDIT_CONTROL_CONTAINER_ATTR}]`);
      let editorMessageContainer = cell.ownerDocument.getElementById(errorMessagePanelId);
      if (!editorControlContainer && inEditMode) {
        editorControlContainer = cell.ownerDocument.createElement('div');
        editorControlContainer.setAttribute(EDIT_CONTROL_CONTAINER_ATTR, '');
        editorPanel.appendChild(editorControlContainer);
      } else if (editorControlContainer && !inEditMode) {
        editorPanel.removeChild(editorControlContainer);
      }
      // always show error message so aria-live content will be anounced.
      if (!editorMessageContainer) {
        editorMessageContainer = cell.ownerDocument.createElement('div');
        editorMessageContainer.id = errorMessagePanelId;
        cell.setAttribute('aria-describedby', errorMessagePanelId);
        editorMessageContainer.setAttribute('role', 'alert');
        editorMessageContainer.setAttribute('aria-live', 'assertive');
        editorMessageContainer.setAttribute('aria-atomic', 'true');
        editorMessageContainer.classList.add(EDIT_PANEL_MESSAGE_CLASS);
        editorPanel.appendChild(editorMessageContainer);
      }
      editorMessageContainer.textContent = errorMessage || '';
    }
  }
}

class CheckboxCellEditor extends AbstractCellEditor {
  constructor(options) {
    super();
    const [yes, no] = buildCheckboxOptions(options);
    this.yes = yes;
    this.no = no;
  }
  render(_ref) {
    let {
      cell,
      cellValue,
      initialValue,
      container,
      columnHeader
    } = _ref;
    const {
      yes
    } = this;
    const label = cell.ownerDocument.createElement('label');
    label.classList.add('tds-data-table__cellEditor--checkbox');
    label.innerHTML = `
      <input type="checkbox"/>
      <span class="tds-data-table__cellEditor--checkbox-icon"></span>
    `;
    const input = this.editorElement = label.querySelector('input');
    let checked = cellValue === yes.value || !!yes.value && yes.value.toString() === cellValue;
    if (initialValue && yes.label) {
      // NOTE: The intention here is to let user type the first letter of the Yes|true value to set it to true 
      checked = initialValue.toLowerCase()[0] === yes.label.toLowerCase()[0];
    } else if (initialValue === '') {
      checked = false;
    }
    input.checked = checked;
    input.addEventListener('click', this.reportUpdate);
    input.setAttribute('aria-label', columnHeader);
    container.appendChild(label);
  }
  getValue() {
    const {
      editorElement
    } = this;
    const checked = !!editorElement && editorElement.checked;
    return checked ? this.yes.value : this.no.value;
  }
  setValue(value) {
    const {
      editorElement
    } = this;
    if (editorElement) {
      editorElement.checked = this.yes.value == value;
    }
  }
  getDisplayValue() {
    const {
      editorElement,
      yes,
      no
    } = this;
    const checked = editorElement ? editorElement.checked : false;
    return checked ? yes.label : no.label;
  }
}
function buildCheckboxOptions(options) {
  if (!options) {
    return [{
      value: true,
      label: 'True'
    }, {
      value: false,
      label: 'False'
    }];
  }
  try {
    let yesNoOptions = typeof options === 'string' ? JSON.parse(options) : options;
    let valid = Array.isArray(yesNoOptions) && yesNoOptions.length == 2;
    if (valid) {
      yesNoOptions = yesNoOptions.map((option, index) => {
        option = typeof option === 'string' ? {
          value: index === 0,
          label: option
        } : option;
        valid = valid && option.hasOwnProperty('value') && option.hasOwnProperty('label');
        return option;
      });
    }
    if (valid) {
      return yesNoOptions;
    }
  } catch {}
  throw new Error(`editor options are not in a valid format for checkbox: ${options}`);
}

class SelectCellEditor extends AbstractCellEditor {
  constructor(options) {
    super();
    this._options = options;
  }
  render(data) {
    const {
      cell,
      cellValue,
      container,
      columnHeader,
      validators
    } = data;
    const options = this.getSelectOptions();
    const select = this.editorElement = cell.ownerDocument.createElement('select');
    select.setAttribute('aria-label', columnHeader);
    let initValue = '';
    this.renderOptions(select, options);
    options.forEach(_ref => {
      let {
        value,
        label
      } = _ref;
      if (value === cellValue) {
        initValue = value;
      } else if (label === cellValue && !initValue) {
        initValue = value;
      }
    });
    select.value = initValue;
    select.addEventListener('change', this.reportUpdate);
    container.appendChild(select);
    if (validators) {
      validators.forEach(validator => {
        if (validator.type === 'required') {
          select.required = true;
        }
      });
    }
  }
  setOptions(options) {
    this._options = options;
    const editorElement = this.editorElement;
    if (editorElement) {
      const currentValue = editorElement.value;
      let resetValue = '';
      const options = this.getSelectOptions();
      this.renderOptions(editorElement, this.getSelectOptions());
      options.forEach(_ref2 => {
        let {
          value
        } = _ref2;
        if (value === currentValue) {
          resetValue = value;
        }
      });
      editorElement.value = resetValue;
    }
  }
  renderOptions(select, options) {
    while (select.lastChild) {
      select.removeChild(select.lastChild);
    }
    options.forEach(_ref3 => {
      let {
        value,
        label
      } = _ref3;
      const option = select.ownerDocument.createElement('option');
      option.value = value;
      option.textContent = label;
      select.appendChild(option);
    });
  }
  getValue() {
    const {
      editorElement
    } = this;
    return editorElement ? editorElement.value : '';
  }
  setValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const editorElement = this.editorElement;
    if (editorElement) {
      editorElement.value = value.toString();
    }
  }
  getDisplayValue() {
    const {
      editorElement,
      _selectOptions
    } = this;
    let value = editorElement ? editorElement.value : '';
    const selectedOption = _selectOptions.find(o => o.value === value);
    return selectedOption ? selectedOption.label : value;
  }
  getSelectOptions() {
    let options = this._options;
    if (typeof options === 'string') {
      options = JSON.parse(options);
    }
    if (options && typeof options === 'object' && !Array.isArray(options)) {
      options = Object.keys(options).map(key => {
        return {
          value: key,
          label: options[key].toString()
        };
      });
    }
    if (Array.isArray(options)) {
      options = options.map(option => {
        return typeof option === 'string' ? {
          value: option,
          label: option
        } : option;
      });
    }
    return this._selectOptions = options;
  }
}

class TextAreaCellEditor extends AbstractCellEditor {
  render(_ref) {
    let {
      cell,
      cellValue,
      initialValue,
      action,
      container,
      columnHeader,
      validators
    } = _ref;
    const textarea = this.editorElement = cell.ownerDocument.createElement('textarea');
    textarea.setAttribute('aria-label', columnHeader);
    container.appendChild(textarea);
    textarea.value = typeof initialValue === 'undefined' ? cellValue : action === 'typing' ? '' : initialValue;
    textarea.addEventListener('input', this.reportUpdate);
    if (validators) {
      validators.forEach(validator => {
        const options = validator.options;
        switch (validator.type) {
          case 'required':
            textarea.required = true;
            break;
          case 'length':
            configureLength$1(textarea, options);
            break;
        }
      });
    }
  }
  getValue() {
    const {
      editorElement: editorElement
    } = this;
    return editorElement ? editorElement.value : '';
  }
  setValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const editorElement = this.editorElement;
    if (editorElement) {
      editorElement.value = value.toString();
    }
  }
}
// DRY opportunity: Copied from TextInputCellEditor
function configureLength$1(textarea, options) {
  const {
    max,
    min,
    restrict,
    noconfigure
  } = options;
  if (!noconfigure) {
    if (typeof max !== 'undefined' && restrict) {
      textarea.maxLength = max;
    }
    if (typeof min !== 'undefined') {
      textarea.minLength = min;
    }
  }
}

const expressions = {
  integer: /^\d*$/,
  decimal: /^-?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9]*)?$/,
  uscurrency: /^-?\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9]{0,2})?$/,
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
};

class TextInputCellEditor extends AbstractCellEditor {
  constructor() {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'text';
    super();
    this._type = type;
  }
  render(_ref) {
    let {
      cell,
      cellValue,
      initialValue,
      action,
      container,
      columnHeader,
      validators
    } = _ref;
    const input = this.editorElement = cell.ownerDocument.createElement('input');
    input.type = this._type;
    input.setAttribute('aria-label', columnHeader);
    container.appendChild(input);
    input.value = typeof initialValue === 'undefined' ? cellValue : action === 'typing' ? '' : initialValue;
    input.addEventListener('input', this.reportUpdate);
    if (validators) {
      validators.forEach(validator => {
        const options = validator.options;
        switch (validator.type) {
          case 'required':
            input.required = true;
            break;
          case 'range':
            configureRange(input, options);
            break;
          case 'pattern':
            configurePattern(input, options);
            break;
          case 'length':
            configureLength(input, options);
            break;
        }
      });
    }
  }
  getValue() {
    const {
      editorElement: editorElement
    } = this;
    return editorElement ? editorElement.value : '';
  }
  setValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const editorElement = this.editorElement;
    if (editorElement) {
      editorElement.value = value.toString();
    }
  }
}
function configureRange(input, options) {
  const {
    min,
    max,
    noconfigure
  } = options;
  if (!noconfigure) {
    if (typeof min !== 'undefined' || typeof max !== 'undefined') {
      const type = typeof min === 'number' || typeof max === 'number' ? 'number' : 'date';
      input.type = type;
    }
    if (typeof min !== 'undefined') {
      input.min = min;
    }
    if (typeof max !== 'undefined') {
      input.max = max;
    }
  }
}
function configurePattern(input, options) {
  const {
    pattern,
    noconfigure
  } = options;
  if (!noconfigure) {
    let inputPattern = typeof pattern === 'string' ? expressions[pattern] || pattern : pattern;
    if (inputPattern instanceof RegExp) {
      inputPattern = inputPattern.toString();
      inputPattern = inputPattern.substring(1, inputPattern.length - 1);
    }
    if (inputPattern) {
      input.pattern = inputPattern;
    }
  }
}
function configureLength(input, options) {
  const {
    max,
    min,
    restrict,
    noconfigure
  } = options;
  if (!noconfigure) {
    if (typeof max !== 'undefined' && restrict) {
      input.maxLength = max;
    }
    if (typeof min !== 'undefined') {
      input.minLength = min;
    }
  }
}

function cellEditorFactory(config) {
  const control = config.editorControl;
  const options = config.editorOptions;
  let editor;
  switch (control) {
    case 'select':
      editor = new SelectCellEditor(parseOptions(options, control));
      break;
    case 'integer':
      editor = new TextInputCellEditor('number');
      break;
    case 'checkbox':
      editor = new CheckboxCellEditor(parseOptions(options || ['', ''], control));
      break;
    case 'textarea':
      editor = new TextAreaCellEditor();
      break;
  }
  return editor || new TextInputCellEditor();
}
function parseOptions(options, control) {
  try {
    const parsed = typeof options === 'string' ? JSON.parse(options) : options;
    if (typeof parsed === 'object') {
      return parsed;
    }
  } catch {
    throw new Error(`editor options are not in a valid format for ${control}: ${options}`);
  }
}

const defaultPreset = 'mm/dd/yyyy';
class DateFormatter {
  constructor(options) {
    const defaultOptions = {
      preset: defaultPreset
    };
    this.options = options || defaultOptions;
  }
  format(value, locale) {
    if (!value) {
      return '';
    }
    const {
      preset
    } = this.options;
    const presetMap = {
      'm/d/yy': {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit'
      },
      'm/d/yyyy': {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric'
      },
      'mm/dd/yy': {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit'
      },
      'mm/dd/yyyy': {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      },
      'shortmonth': {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      },
      'longmonth': {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }
    };
    let formatOptions = presetMap[preset] || {};
    ['weekday', 'year', 'month', 'day'].forEach(key => {
      if (this.options[key]) {
        formatOptions[key] = this.options[key];
      }
    });
    if (Object.keys(formatOptions).length === 0) {
      formatOptions = presetMap[defaultPreset];
    }
    let date;
    if (typeof value === 'string') {
      // todo: invalid strings like -44- parse as a valid date, (See validator)
      date = parseDate(value, locale);
    } else if (typeof value === 'number') {
      date = new Date(value);
    } else {
      date = value;
    }
    // if date is null, it's an invalid date. Return value as is.
    return date ? new Intl.DateTimeFormat(locale || 'default', formatOptions).format(date) : value.toString();
  }
}

class DateCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const {
      convert,
      format,
      message
    } = this._options;
    const locale = getLang(cellData.cell);
    const config = configureDates(this._options, locale);
    let newValue = (cellData.newValue === 0 ? 0 : cellData.newValue || '').toString().trim();
    if (newValue === '') {
      return cellData;
    }
    if (typeof cellData.newValue === 'string') {
      const parts = newValue.split('-');
      if (parts.length > 1) {
        let validISO = parts.length === 3;
        validISO = validISO && /^\d{4}$/.test(parts[0]);
        validISO = validISO && /^\d{1,2}$/.test(parts[1]);
        validISO = validISO && /^\d{1,2}$/.test(parts[2]);
        if (validISO) {
          // parseDate should recognize 1 digit numbers but it does not at the moment
          newValue = parts.map((part, i) => {
            return i === 0 ? part : `00${part}`.slice(-2);
          }).join('-');
        } else {
          return {
            ...cellData,
            errorMessage: message,
            errorReason: 'badInput'
          };
        }
      }
    }
    const date = parseDate(newValue, locale);
    const validity = getDateValidity(config, date, date ? toISODate(date) : newValue);
    if (validity.valid) {
      const displayValue = format ? this.format(date, cellData.cell) : cellData.displayValue;
      return {
        ...cellData,
        newValue: convert ? toISODate(date) : cellData.newValue,
        displayValue
      };
    }
    const errorReason = validity.rangeOverflow ? 'rangeOverflow' : validity.rangeUnderflow ? 'rangeUnderflow' : validity.unavailable ? 'unavailable' : 'badInput';
    return {
      ...cellData,
      errorMessage: message,
      errorReason
    };
  }
  format(value, cell) {
    const {
      preset,
      weekday,
      month,
      day,
      year
    } = this._options;
    const formatter = new DateFormatter({
      preset,
      weekday,
      month,
      day,
      year
    });
    return formatter.format(value, !checkFlag(cell, 'useBrowserLocale') ? getLang(cell) : window.navigator.language);
  }
  get type() {
    return 'date';
  }
  get options() {
    return this._options;
  }
}

class LengthCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const {
      min,
      max,
      message
    } = this._options;
    const newValue = (cellData.newValue || '').toString().trim();
    let errorReason;
    if (min && newValue.length && newValue.length < min) {
      errorReason = 'tooShort';
    } else if (max && newValue.length > max) {
      errorReason = 'tooLong';
    }
    return errorReason ? {
      ...cellData,
      errorMessage: message,
      errorReason
    } : cellData;
  }
  get type() {
    return 'length';
  }
  get options() {
    return this._options;
  }
}

const defaultOptions = {
  decimals: 0
};
class NumberFormatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = {
      ...defaultOptions,
      ...options
    };
  }
  format(value, locale) {
    if (!value && value !== 0) {
      return '';
    }
    const {
      decimals,
      currency,
      noseparator
    } = this.options;
    const formatOptions = {
      useGrouping: !noseparator,
      maximumFractionDigits: decimals || 0,
      minimumFractionDigits: decimals || 0
    };
    if (currency) {
      formatOptions.style = 'currency';
      formatOptions.currency = currency;
    }
    if (typeof value === 'string') {
      const rx = expressions.decimal;
      if (!rx.test(value)) {
        return value;
      }
      value = parseFloat(value);
    }
    return new Intl.NumberFormat(locale, formatOptions).format(value);
  }
}

class NumberCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const {
      format,
      message,
      convert
    } = this._options;
    let newValue = (cellData.newValue === 0 ? 0 : cellData.newValue || '').toString().trim();
    newValue = this.validateCurrency(newValue);
    newValue = this.validateDecimals(newValue);
    if (newValue !== null) {
      const displayValue = format && newValue !== '' ? this.format(newValue, cellData.cell) : cellData.displayValue;
      return {
        ...cellData,
        newValue: convert ? newValue : cellData.newValue,
        displayValue
      };
    }
    return {
      ...cellData,
      errorMessage: message,
      errorReason: 'badInput'
    };
  }
  validateCurrency(value) {
    const {
      currency
    } = this._options;
    if (value && currency) {
      switch (currency.toUpperCase()) {
        case 'USD':
          const rx = expressions.uscurrency;
          return rx.test(value) ? value.replace(/\$/g, '') : null;
      }
    }
    return value;
  }
  validateDecimals(value) {
    const {
      decimals
    } = this._options;
    let decPos = -1;
    if (value) {
      const rx = expressions.decimal;
      if (!rx.test(value)) {
        return null;
      }
      decPos = value.indexOf('.');
      if (typeof decimals !== 'undefined') {
        if (decPos > -1) {
          const decimalPlaces = value.length - decPos - 1;
          if (decimals > 0) {
            if (decimalPlaces > decimals) {
              return null;
            }
          } else {
            return null;
          }
        }
      }
    }
    let returnValue = value;
    if (returnValue) {
      returnValue = returnValue.replace(/[^\d.-]/g, '');
      returnValue = decPos > -1 ? parseFloat(returnValue) : parseInt(returnValue);
    }
    return returnValue;
  }
  format(value, cell) {
    const {
      currency,
      decimals
    } = this._options;
    const formatter = new NumberFormatter({
      currency: currency ? 'USD' : undefined,
      decimals
    });
    return formatter.format(value, getLang(cell));
  }
  get type() {
    return 'number';
  }
  get options() {
    return this._options;
  }
}

class PatternCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const {
      pattern,
      message
    } = this._options;
    const regExp = typeof pattern === 'string' ? expressions[pattern] || new RegExp(pattern) : pattern;
    const newValue = (cellData.newValue === 0 ? 0 : cellData.newValue || '').toString().trim();
    if (newValue && !regExp.test(newValue)) {
      return {
        ...cellData,
        errorMessage: message,
        errorReason: 'patternMismatch'
      };
    }
    return cellData;
  }
  get type() {
    return 'pattern';
  }
  get options() {
    return this._options;
  }
}

class RangeCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const {
      min,
      max,
      message
    } = this._options;
    let errorReason;
    let newValue = cellData.newValue;
    if (typeof newValue === 'string') {
      newValue = newValue.trim();
    }
    if (newValue !== '') {
      if (typeof newValue === 'string') {
        newValue = parseFloat(newValue);
      }
      if (!isNaN(newValue)) {
        if (typeof min !== 'undefined' && newValue < min) {
          errorReason = 'rangeUnderflow';
        } else if (typeof max !== 'undefined' && newValue > max) {
          errorReason = 'rangeOverflow';
        }
      }
    }
    return errorReason ? {
      ...cellData,
      errorMessage: message,
      errorReason
    } : cellData;
  }
  get type() {
    return 'range';
  }
  get options() {
    return this._options;
  }
}

class RequiredCellValidator {
  constructor(options) {
    this._options = typeof options === 'string' ? {
      message: options,
      noconfigure: false
    } : {
      ...options
    };
  }
  validate(cellData) {
    const newValue = (cellData.newValue === 0 ? 0 : cellData.newValue || '').toString().trim();
    return newValue.length ? cellData : {
      ...cellData,
      errorMessage: this._options.message,
      errorReason: 'valueMissing'
    };
  }
  get type() {
    return 'required';
  }
  get options() {
    return this._options;
  }
}

class TimeFormatter {
  constructor(options) {
    this.options = options || {};
  }
  format(value, locale) {
    if (!value) {
      return '';
    }
    const {
      hourCycle,
      hour2Digit
    } = this.options;
    let date;
    if (typeof value === 'string') {
      var _parseTime;
      // todo: invalid strings like -44- parse as a valid date, (See validator)
      date = (_parseTime = parseTime(value)) === null || _parseTime === void 0 ? void 0 : _parseTime.date;
    } else if (typeof value === 'number') {
      date = new Date(value);
    } else {
      date = value;
    }
    const formatOptions = {
      hour: hour2Digit ? '2-digit' : 'numeric',
      minute: '2-digit'
    };
    if (hourCycle) {
      //should be able to just set hourCycle, but this formats midnight as 24:00
      formatOptions.hourCycle = hourCycle === '12' ? 'h12' : 'h23';
    }
    // if date is null, it's an invalid date. Return value as is.
    return date ? new Intl.DateTimeFormat(locale || 'default', formatOptions).format(date) : value.toString();
  }
}

class TimeCellValidator {
  constructor(options) {
    this._options = options;
  }
  validate(cellData) {
    const options = this._options;
    const {
      convert,
      format,
      message
    } = options;
    let newValue = (cellData.newValue === 0 ? '0' : cellData.newValue || '').trim();
    if (newValue === '') {
      return cellData;
    }
    const validity = getTimeValidity(newValue, options);
    if (validity.valid) {
      const displayValue = format ? this.format(newValue, cellData.cell) : cellData.displayValue;
      newValue = convert ? new TimeFormatter({
        hourCycle: '24'
      }).format(newValue) : cellData.newValue;
      return {
        ...cellData,
        newValue,
        displayValue
      };
    }
    const errorReason = validity.rangeOverflow ? 'rangeOverflow' : validity.rangeUnderflow ? 'rangeUnderflow' : 'badInput';
    return {
      ...cellData,
      errorMessage: message,
      errorReason
    };
  }
  format(value, cell) {
    const {
      hourCycle,
      hour2Digit
    } = this._options;
    const formatter = new TimeFormatter({
      hourCycle,
      hour2Digit
    });
    return formatter.format(value, !checkFlag(cell, 'useBrowserLocale') ? getLang(cell) : window.navigator.language);
  }
  get type() {
    return 'time';
  }
  get options() {
    return this._options;
  }
}

const validatorsMap = [['required', RequiredCellValidator], ['pattern', PatternCellValidator], ['length', LengthCellValidator], ['number', NumberCellValidator], ['date', DateCellValidator], ['time', TimeCellValidator], ['range', RangeCellValidator]];
function validatorsFactory(config) {
  const validators = [];
  validatorsMap.forEach(_ref => {
    let [name] = _ref;
    const validatorOptions = config[name];
    if (validatorOptions) {
      const validator = validatorFactory(name, validatorOptions);
      if (validator) {
        validators.push(validator);
      }
    }
  });
  return validators;
}
function validatorFactory(type, options) {
  let validator;
  const validatorEntry = validatorsMap.find(_ref2 => {
    let [name] = _ref2;
    return name === type;
  });
  if (validatorEntry) {
    const Validator = validatorEntry[1];
    if (typeof options === 'string' && options.length && options[0].match(/\"|{|\[/)) {
      try {
        options = JSON.parse(options);
      } catch {
        throw new Error(`Validators options for ${type} are not valid: ${options}`);
      }
    }
    if (options) {
      validator = new Validator(options);
    }
  }
  return validator;
}

class DateInputCellEditor extends AbstractCellEditor {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    if (options && typeof options === 'string') {
      try {
        options = JSON.parse(options);
      } catch {
        throw Error('Invalid DateInputCellEditorOptions options' + options);
      }
    }
    this.options = options;
  }
  focus() {
    const {
      editorElement
    } = this;
    const input = editorElement && editorElement.querySelector('input[data-date-part]');
    if (input) {
      input.focus();
      input.select();
    }
  }
  render(_ref) {
    let {
      cell,
      cellValue,
      initialValue,
      action,
      container,
      columnHeader,
      validators
    } = _ref;
    const {
      nopicker,
      notoday
    } = this.options;
    const {
      dateFormat
    } = getLocale(cell);
    const lang = translations(getLang(cell)).language;
    const datePartMap = {
      'YYYY': {
        part: 'year',
        label: lang.year,
        value: ''
      },
      'MM': {
        part: 'month',
        label: lang.month,
        value: ''
      },
      'DD': {
        part: 'day',
        label: lang.day,
        value: ''
      }
    };
    // if typing, set value to empty string as the key press will continue to the input element
    const valueToParse = typeof initialValue === 'undefined' ? cellValue : action === 'typing' ? '' : initialValue;
    const values = this.toDatePartArray(valueToParse, dateFormat);
    datePartMap.YYYY.value = values[0] || '';
    datePartMap.MM.value = values[1] || '';
    datePartMap.DD.value = values[2] || '';
    const dateParts = dateFormat.split('/').map(part => {
      const entry = datePartMap[part];
      const value = entry.value;
      // we initialize each input rather than the hidden input so that, when focused, the input's value is in place
      // and the text selected. If we used the hidden input to initialize, the input field is initialized after
      // focus is called and the input field will not be selected.
      return `
      <span class="tds-date-input__date-part">
        <input type="text" inputmode="numeric" pattern="\\d*" placeholder="${part.toLowerCase()}" maxlength="${part.length}"
          data-date-part="${entry.part}" aria-label="${htmlEncode(entry.label)}" ${value ? `value="${htmlEncode(value)}"` : ''}/>
        </span>`;
    });
    const trigger = nopicker ? '' : `
    <button class="tds-date-input__trigger" aria-expanded="false" type="button" data-trigger="calendar"
    aria-label="${htmlEncode(lang.calendar)}" hidden></button>`;
    const dateValidator = validators && validators.find(v => v.type === 'date');
    let dataConfig = dateValidator ? configureValidator(dateValidator.options || {}) : '';
    dataConfig += ' data-optimized-popover';
    if (notoday) {
      dataConfig += ' data-no-today';
    }
    const html = `
    <div class="tds-date-input tds-editable-table__cell-editor" role="group" ${cell.lang ? `lang=${cell.lang}` : ''} ${dataConfig}>
      ${dateParts.join('')}
      ${trigger}
      <input type="hidden"/>
    </div>`;
    container.innerHTML = html;
    const dateInput = this.editorElement = container.querySelector('div.tds-date-input');
    dateInput.setAttribute('aria-label', columnHeader);
    dateInput.addEventListener('tdsChange', this.reportUpdate);
    dateInput.addEventListener('tdsFocus', () => {
      this.reportFocusChange(true);
    });
    dateInput.addEventListener('tdsBlur', () => {
      this.reportFocusChange(false);
    });
    dateInput.addEventListener('keydown', this.onTabKey.bind(this));
  }
  getValue() {
    const {
      editorElement
    } = this;
    const input = editorElement && editorElement.querySelector('input[type="hidden"]');
    return input ? input.value : '';
  }
  setValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const {
      editorElement
    } = this;
    if (editorElement) {
      new DateInput(editorElement).value = value;
    }
  }
  getDisplayValue() {
    // this is mainly for displaying an invalid date. When the date is valid, and a formatter is involved,
    // the formatter will format it correctly 
    const {
      editorElement
    } = this;
    const inputs = editorElement ? Array.from(editorElement.querySelectorAll('input[data-date-part]')) : [];
    const displayValue = inputs.map(input => input.value).join('/');
    return displayValue === '//' ? '' // no input values entered
    : displayValue;
  }
  toDatePartArray(value, format) {
    const dblDashRx = /^([^-]*)-([^-]*)-([^-]*)$/;
    value = value instanceof Date ? toISODate(value) : value.toString();
    if (value && !value.match(dblDashRx)) {
      const date = parseDate(value, format);
      value = date ? toISODate(date) : '';
    }
    return value.split('-');
  }
  onTabKey(event) {
    const key = normalizeKey(event);
    if (key === 'Tab') {
      const dateInput = this.editorElement;
      const controls = dateInput.querySelectorAll('input[data-date-part], button[data-trigger="calendar"]');
      const endControl = event.shiftKey ? controls[0] : controls[controls.length - 1];
      if (event.target !== endControl) {
        event.stopPropagation();
      }
    }
  }
}
function configureValidator(options) {
  let {
    max,
    min,
    disabledDates
  } = options;
  if (min instanceof Date) {
    min = toISODate(min);
  }
  if (max instanceof Date) {
    max = toISODate(max);
  }
  if (typeof disabledDates === 'object') {
    disabledDates = JSON.stringify(disabledDates);
  }
  let dataConfig = [];
  if (min) {
    dataConfig.push(`data-min="${min}"`);
  }
  if (max) {
    dataConfig.push(`data-max="${max}"`);
  }
  if (disabledDates) {
    dataConfig.push(`data-disabled-dates='${disabledDates}'`); // use sinle quote in case it is JSON
  }

  return dataConfig.join(' ');
}

class TimeInputCellEditor extends AbstractCellEditor {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    if (options && typeof options === 'string') {
      try {
        options = JSON.parse(options);
      } catch {
        throw Error('Invalid TimeInputCellEditorOptions options ' + options);
      }
    }
    this.options = options;
  }
  focus() {
    const {
      editorElement
    } = this;
    const input = editorElement && editorElement.querySelector('input[data-time-part]');
    if (input) {
      input.focus();
      input.select();
    }
  }
  render(_ref) {
    let {
      cell,
      cellValue,
      initialValue,
      action,
      container,
      columnHeader
    } = _ref;
    const {
      minuteIncrement,
      hourCycle,
      nopicker
    } = this.options;
    const lang = translations(getLang(cell)).language;
    const timeParts = [{
      part: 'hour',
      label: lang.hour,
      inputmode: 'numeric',
      pattern: '\\d*'
    }, {
      part: 'minute',
      label: lang.minute,
      inputmode: 'numeric',
      pattern: '\\d*'
    }];
    if (hourCycle !== '24') {
      timeParts.push({
        part: 'period',
        label: lang.period,
        pattern: 'AM|PM'
      });
    }
    const timeInputs = timeParts.map(entry => {
      const {
        part,
        label,
        pattern,
        inputmode
      } = entry;
      // we initialize each input rather than the hidden input so that, when focused, the input's value is in place
      // and the text selected. If we used the hidden input to initialize, the input field is initialized after
      // focus is called and the input field will not be selected.
      return `
      <span class="tds-time-input__time-part">
        <input 
          type="text" 
          ${inputmode ? 'inputmode="numeric"' : ''} 
          pattern="${pattern}" 
          placeholder="--" 
          maxlength="2" 
          data-time-part="${part}" 
          aria-label="${label}" 
          autocomplete="off" />
      </span>`;
    });
    const trigger = nopicker ? '' : `<button 
        class="tds-time-input__trigger" 
        aria-expanded="false" 
        type="button" 
        data-trigger="dialog" 
        aria-label="${htmlEncode(lang.toggleTimePicker)}" 
      >
      </button>`;
    // const dateValidator = validators && validators.find(v => v.type === 'date');
    let dataConfig = '';
    // let dataConfig =  dateValidator ? configureValidator(dateValidator.options || {}) : '';
    if (minuteIncrement) {
      dataConfig += ` data-minute-increment=${minuteIncrement}`;
    }
    if (!hourCycle) {
      dataConfig += ` data-use-locale-cycle`;
    }
    const html = `
    <div class="tds-time-input tds-editable-table__cell-editor" role="group" aria-label="${columnHeader}" ${cell.lang ? `lang=${cell.lang}` : ''} ${dataConfig}>
      ${timeInputs.join('')}
      ${trigger}
      <input type="hidden"/>
    </div>`;
    container.innerHTML = html;
    const timeInput = this.editorElement = container.querySelector('div.tds-time-input');
    timeInput.addEventListener('tdsChange', this.reportUpdate);
    timeInput.addEventListener('tdsFocus', () => {
      this.reportFocusChange(true);
    });
    timeInput.addEventListener('tdsBlur', () => {
      this.reportFocusChange(false);
    });
    timeInput.addEventListener('keydown', this.onTabKey.bind(this));
    // if typing, set value to empty string as the key press will continue to the input element
    const value = typeof initialValue === 'undefined' ? cellValue : action === 'typing' ? '' : initialValue;
    if (value) {
      this.setValue(value);
    }
  }
  getValue() {
    const {
      editorElement
    } = this;
    const input = editorElement && editorElement.querySelector('input[type="hidden"]');
    return input ? input.value : '';
  }
  setValue() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const {
      editorElement
    } = this;
    if (editorElement) {
      new TimeInput(editorElement).value = value;
    }
  }
  getDisplayValue() {
    // this is mainly for displaying an invalid time. When the time is valid, and a formatter is involved,
    // the formatter will format it correctly 
    const {
      editorElement
    } = this;
    const inputs = editorElement ? Array.from(editorElement.querySelectorAll('input[data-time-part]')) : [];
    if (inputs.length === 0) return '';
    let displayValue = inputs[0].value + ':' + inputs[1].value;
    if (inputs[2] && inputs[2].value) {
      displayValue += ' ' + inputs[2].value;
    }
    return displayValue === ':' ? '' // no input values entered
    : displayValue;
  }
  onTabKey(event) {
    const key = normalizeKey(event);
    if (key === 'Tab') {
      const timeInput = this.editorElement;
      const controls = Array.from(timeInput.querySelectorAll('input[data-time-part], button[data-trigger]')).filter(el => !el.hidden);
      const endControl = event.shiftKey ? controls[0] : controls[controls.length - 1];
      if (event.target !== endControl) {
        event.stopPropagation();
      }
    }
  }
}

const instances = /*#__PURE__*/new WeakMap();
const ENHANCED_EDITABLE_FLAG = 'enhancedEditableDataTable';
const ENHANCED_EDITABLE_DATA_ATTR = 'data-enhanced-editable-data-table';
class _EditableDataTableInstance {
  constructor(element) {
    this.onDestroy = [];
    element.dataset[ENHANCED_EDITABLE_FLAG] = "true";
    this.table = element;
    this.validity = {
      valid: true,
      cellValidities: []
    };
    const {
      unbind,
      startCellEdit,
      startRowEdit
    } = bindEditing(this);
    this.onDestroy = [unbind];
    this.startCellEdit = startCellEdit;
    this.startRowEdit = startRowEdit;
    instances.set(element, this);
  }
  get editMode() {
    const {
      table
    } = this;
    return table && table.dataset.editMode || 'cell';
  }
  set editMode(mode) {
    const {
      table
    } = this;
    if (mode) {
      table.dataset.editMode = mode;
    } else {
      table.removeAttribute('data-edit-mode');
    }
  }
  get editValidationMode() {
    const {
      table
    } = this;
    return table && table.dataset.editValidationMode || '';
  }
  set editValidationMode(mode) {
    const {
      table
    } = this;
    if (mode) {
      table.dataset.editValidationMode = mode;
    } else {
      table.removeAttribute('data-edit-validation-mode');
    }
  }
  sendEvent(eventType, detail) {
    checkErrorPopover(this.table);
    return this.table.dispatchEvent(createCustomEvent(eventType, {
      cancelable: true,
      bubbles: true,
      detail
    }));
  }
  getCellValue(cell, cellData) {
    let value = this.valueGetter && this.valueGetter(cellData || this.getCellData(cell));
    if (value === null || typeof value === 'undefined') {
      value = cellToTextValue(cell);
    }
    return value;
  }
  setCellValue(cell, value) {
    let displayValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : value;
    textToCellNodes(cell, value, displayValue);
  }
  getValueSetter() {
    return null;
  }
  processRowUpdate(rowData, rowUpdates) {
    const {
      applyRowUpdate
    } = this;
    this._lastRowUpdatesApplied = rowUpdates;
    try {
      return Promise.resolve(applyRowUpdate ? applyRowUpdate(rowData, rowUpdates) : []);
    } catch (err) {
      return Promise.reject(err);
    }
  }
  getCellEditorComponent(cell) {
    const column = getColumnHeader(cell);
    const columnName = column && column.getAttribute(DATA_TABLE_COLUMN_ROW_PROP_ATTR) || getColumnIndex(cell).toString();
    const cellEditor = this.cellEditors && this.cellEditors[columnName] || {};
    const editorControl = cellEditor.editorControl || cell.dataset.editorControl || column.dataset.editorControl;
    const editorOptions = cellEditor.editorOptions || cell.dataset.editorOptions || column.dataset.editorOptions;
    let editor;
    switch (editorControl) {
      case 'custom':
        editor = this.getCustomCellEditor(this.getCellData(cell));
        break;
      case 'date':
        editor = new DateInputCellEditor(editorOptions);
        break;
      case 'time':
        editor = new TimeInputCellEditor(editorOptions);
        break;
    }
    return editor || cellEditorFactory({
      editorControl,
      editorOptions
    });
  }
  getCustomCellEditor(cellData) {
    let {
      customCellEditor
    } = this;
    if (typeof customCellEditor === 'function') {
      customCellEditor = customCellEditor(cellData);
    }
    return customCellEditor;
  }
  getCellValidators(cell) {
    const column = getColumnHeader(cell);
    const dataset = {
      ...column.dataset,
      ...cell.dataset
    };
    const prefix = 'validator';
    const config = Object.keys(dataset).reduce((acc, key) => {
      const name = key.toLowerCase();
      if (name.indexOf(prefix) === 0) {
        acc[name.substring(prefix.length)] = dataset[key];
      }
      return acc;
    }, {});
    const validators = validatorsFactory(config);
    if (this.cellValidator) {
      validators.push(this.cellValidator);
    }
    return validators;
  }
  getCellData(cell) {
    const row = cell.closest('tr');
    const columnIndex = getColumnIndex(cell);
    const colHdr = getColumnHeader(cell);
    const columnHeader = colHdr && (colHdr.getAttribute('aria-label') || getLabelledByLabel(colHdr) || colHdr.textContent.trim()) || '';
    const columnName = colHdr && colHdr.getAttribute(DATA_TABLE_COLUMN_ROW_PROP_ATTR) || columnIndex.toString();
    return {
      ...this.getRowData(row),
      columnName,
      columnIndex,
      columnHeader,
      cell
    };
  }
  getRowData(rowEl) {
    const row = rowEl.closest('tr');
    let rowGroupIndex = -1;
    // check if row groups are involved
    const tbody = row.closest('tbody');
    const firstRow = tbody.firstElementChild;
    const tbodies = getChildElements(tbody.parentElement, 'tbody');
    if (tbodies.length && isRowGroupHeaderRow(firstRow)) {
      rowGroupIndex = tbodies.indexOf(tbody);
    }
    const rows = (row ? getChildElements(row.parentElement) : []).filter(row => isEditableRow(row));
    const rowIndex = rows.indexOf(row);
    const rowId = row && row.getAttribute(DATA_TABLE_ROW_ID_ATTR) || rowIndex.toString();
    const rowItem = this.getRowItemFromRow(row, rowId);
    return {
      rowId,
      rowIndex,
      rowGroupIndex,
      row,
      rowItem
    };
  }
  getRowItemFromRow(row, rowId) {
    const cells = getChildElements(row);
    return cells.reduce((acc, cell) => {
      const colHdr = getColumnHeader(cell);
      const columnName = colHdr && colHdr.getAttribute(DATA_TABLE_COLUMN_ROW_PROP_ATTR) || getColumnIndex(cell).toString();
      acc[columnName] = cellToTextValue(cell);
      return acc;
    }, {
      rowId: rowId
    });
  }
  getValidity() {
    return this.validity;
  }
  setValidity(validity) {
    this.validity = validity;
  }
  deleteRow(rowData) {
    const {
      applyRowDelete
    } = this;
    return Promise.resolve(applyRowDelete ? applyRowDelete(rowData) : true).then(ok => {
      const {
        row
      } = rowData;
      if (ok && row.parentNode) {
        row.parentNode.removeChild(row);
      }
      return ok;
    });
  }
  beginEditing(startingCell, initialValue, action) {
    this._lastRowUpdatesApplied = undefined;
    const mgr = this.editModeManager = new EditModeManager(startingCell, this);
    mgr.begin(initialValue, action);
  }
  endEditing(save) {
    const {
      editModeManager
    } = this;
    return editModeManager ? editModeManager.end(save).then(ended => {
      if (ended) {
        delete this.editModeManager;
      }
      return ended;
    }) : Promise.resolve(true);
  }
  hasChanged() {
    const {
      editModeManager
    } = this;
    return !!editModeManager && editModeManager.hasChanged();
  }
  getUpdatesApplied() {
    return this._lastRowUpdatesApplied;
  }
  isClickOutside(event) {
    const {
      editModeManager
    } = this;
    return !!editModeManager && editModeManager.isClickOutside(event);
  }
  isTabbingAway(event) {
    const {
      editModeManager
    } = this;
    return !!editModeManager && editModeManager.isTabbingAway(event);
  }
  destroy() {
    while (this.onDestroy.length) {
      const fn = this.onDestroy.pop();
      fn();
    }
    if (this.table) {
      delete this.table.dataset[ENHANCED_EDITABLE_FLAG];
    }
    instances.delete(this.table);
    this.table = null;
  }
}
class EditableDataTable {
  constructor(element) {
    this._instance = instances.get(element) || new _EditableDataTableInstance(element);
  }
  get editMode() {
    return this._instance && this._instance.editMode;
  }
  set editMode(mode) {
    this._instance && (this._instance.editMode = mode);
  }
  get editValidationMode() {
    return this._instance && this._instance.editValidationMode;
  }
  set editValidationMode(mode) {
    this._instance && (this._instance.editValidationMode = mode);
  }
  get customCellEditor() {
    return this._instance && this._instance.customCellEditor;
  }
  set customCellEditor(editor) {
    this._instance && (this._instance.customCellEditor = editor);
  }
  get valueGetter() {
    return this._instance && this._instance.valueGetter;
  }
  set valueGetter(getter) {
    this._instance && (this._instance.valueGetter = getter);
  }
  get cellValidator() {
    return this._instance && this._instance.cellValidator;
  }
  set cellValidator(validator) {
    this._instance && (this._instance.cellValidator = validator);
  }
  get applyRowUpdate() {
    return this._instance && this._instance.applyRowUpdate;
  }
  set applyRowUpdate(applyRowUpdate) {
    this._instance && (this._instance.applyRowUpdate = applyRowUpdate);
  }
  get applyRowDelete() {
    return this._instance && this._instance.applyRowDelete;
  }
  set applyRowDelete(applyRowDelete) {
    this._instance && (this._instance.applyRowDelete = applyRowDelete);
  }
  get validity() {
    return this._instance && this._instance.getValidity();
  }
  configureCellEditor(columnName, editorControl, editorOptions) {
    const {
      _instance
    } = this;
    if (_instance) {
      const cellEditors = _instance.cellEditors || {};
      _instance.cellEditors = {
        ...cellEditors,
        [columnName]: {
          editorControl,
          editorOptions
        }
      };
    }
  }
  onCellEditorCreated(callback) {
    this._instance && (this._instance.onCellEditorCreated = callback);
  }
  /**
   * Initiates cell editing for the cell.
   * @param cell The cell to put into edit mode
   */
  startCellEdit(cell) {
    this._instance && this._instance.startCellEdit(cell);
  }
  /**
   * Initiates cell editing for the row. Edit mode must be 'row'.
   * @param row The row to put into edit mode
   */
  startRowEdit(row) {
    this._instance && this._instance.startRowEdit(row);
  }
  deleteRow(row) {
    const {
      _instance
    } = this;
    return Promise.resolve(!!_instance && _instance.deleteRow(_instance.getRowData(row)));
  }
  /**
   * Detaches from the nav element, removes event listeners, and frees resources.
   */
  destroy() {
    const {
      _instance
    } = this;
    delete this._instance;
    return _instance.destroy();
  }
}
onDomChanges(EDIT_MODE_SELECTOR, function onDataTableAdded(element) {
  const table = element.closest('table');
  if (table && table.dataset[ENHANCED_EDITABLE_FLAG] !== "true") {
    new EditableDataTable(table);
  }
});
onDomChanges(`table[${ENHANCED_EDITABLE_DATA_ATTR}]`, null, function onDataTableRemove(element) {
  new EditableDataTable(element).destroy();
});

export { Alert, Clickable, Collapsible, Combobox, DataTable, DateInput, DropdownMenu, EditableDataTable, FileUpload, GlobalHeader, Listbox, Modal, MultiSelect, Navigation, Pagination, ScrollShadow, Select, SelectDialog, SelectedOptions, Switch, TablePagination, TimeInput, ToggleIcon, Tooltip, createPopover, resumeAutoEnhance };
//# sourceMappingURL=tds.esm.js.map
